import * as Kx from "react";
import C, { Children as Px, isValidElement as wi, cloneElement as Ei, createContext as Rp, useContext as Bp, useReducer as _p, useState as va, useEffect as iu, Fragment as Fp } from "react";
import co from "react-dom";
var dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ua(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Dx(n) {
  if (n.__esModule)
    return n;
  var e = n.default;
  if (typeof e == "function") {
    var o = function a() {
      return this instanceof a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    o.prototype = e.prototype;
  } else
    o = {};
  return Object.defineProperty(o, "__esModule", { value: !0 }), Object.keys(n).forEach(function(a) {
    var i = Object.getOwnPropertyDescriptor(n, a);
    Object.defineProperty(o, a, i.get ? i : {
      enumerable: !0,
      get: function() {
        return n[a];
      }
    });
  }), o;
}
var kl = { exports: {} }, Aa = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rf;
function Lx() {
  if (Rf)
    return Aa;
  Rf = 1;
  var n = C, e = 60103;
  if (Aa.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var o = Symbol.for;
    e = o("react.element"), Aa.Fragment = o("react.fragment");
  }
  var a = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(u, A, b) {
    var h, m = {}, E = null, y = null;
    b !== void 0 && (E = "" + b), A.key !== void 0 && (E = "" + A.key), A.ref !== void 0 && (y = A.ref);
    for (h in A)
      i.call(A, h) && !s.hasOwnProperty(h) && (m[h] = A[h]);
    if (u && u.defaultProps)
      for (h in A = u.defaultProps, A)
        m[h] === void 0 && (m[h] = A[h]);
    return { $$typeof: e, type: u, key: E, ref: y, props: m, _owner: a.current };
  }
  return Aa.jsx = c, Aa.jsxs = c, Aa;
}
var kc = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bf;
function Nx() {
  return Bf || (Bf = 1, function(n) {
    process.env.NODE_ENV !== "production" && function() {
      var e = C, o = 60103, a = 60106;
      n.Fragment = 60107;
      var i = 60108, s = 60114, c = 60109, u = 60110, A = 60112, b = 60113, h = 60120, m = 60115, E = 60116, y = 60121, k = 60122, w = 60117, _ = 60129, O = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var F = Symbol.for;
        o = F("react.element"), a = F("react.portal"), n.Fragment = F("react.fragment"), i = F("react.strict_mode"), s = F("react.profiler"), c = F("react.provider"), u = F("react.context"), A = F("react.forward_ref"), b = F("react.suspense"), h = F("react.suspense_list"), m = F("react.memo"), E = F("react.lazy"), y = F("react.block"), k = F("react.server.block"), w = F("react.fundamental"), F("react.scope"), F("react.opaque.id"), _ = F("react.debug_trace_mode"), F("react.offscreen"), O = F("react.legacy_hidden");
      }
      var P = typeof Symbol == "function" && Symbol.iterator, M = "@@iterator";
      function B(K) {
        if (K === null || typeof K != "object")
          return null;
        var te = P && K[P] || K[M];
        return typeof te == "function" ? te : null;
      }
      var D = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function H(K) {
        {
          for (var te = arguments.length, Z = new Array(te > 1 ? te - 1 : 0), Re = 1; Re < te; Re++)
            Z[Re - 1] = arguments[Re];
          X("error", K, Z);
        }
      }
      function X(K, te, Z) {
        {
          var Re = D.ReactDebugCurrentFrame, qe = "";
          if (q) {
            var Ve = $(q.type), Ne = q._owner;
            qe += Be(Ve, q._source, Ne && $(Ne.type));
          }
          qe += Re.getStackAddendum(), qe !== "" && (te += "%s", Z = Z.concat([qe]));
          var Ue = Z.map(function(yn) {
            return "" + yn;
          });
          Ue.unshift("Warning: " + te), Function.prototype.apply.call(console[K], console, Ue);
        }
      }
      var ce = !1;
      function Ae(K) {
        return !!(typeof K == "string" || typeof K == "function" || K === n.Fragment || K === s || K === _ || K === i || K === b || K === h || K === O || ce || typeof K == "object" && K !== null && (K.$$typeof === E || K.$$typeof === m || K.$$typeof === c || K.$$typeof === u || K.$$typeof === A || K.$$typeof === w || K.$$typeof === y || K[0] === k));
      }
      var se = /^(.*)[\\\/]/;
      function Be(K, te, Z) {
        var Re = "";
        if (te) {
          var qe = te.fileName, Ve = qe.replace(se, "");
          if (/^index\./.test(Ve)) {
            var Ne = qe.match(se);
            if (Ne) {
              var Ue = Ne[1];
              if (Ue) {
                var yn = Ue.replace(se, "");
                Ve = yn + "/" + Ve;
              }
            }
          }
          Re = " (at " + Ve + ":" + te.lineNumber + ")";
        } else
          Z && (Re = " (created by " + Z + ")");
        return `
    in ` + (K || "Unknown") + Re;
      }
      var Pe = 1;
      function ne(K) {
        return K._status === Pe ? K._result : null;
      }
      function J(K, te, Z) {
        var Re = te.displayName || te.name || "";
        return K.displayName || (Re !== "" ? Z + "(" + Re + ")" : Z);
      }
      function $(K) {
        if (K == null)
          return null;
        if (typeof K.tag == "number" && H("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof K == "function")
          return K.displayName || K.name || null;
        if (typeof K == "string")
          return K;
        switch (K) {
          case n.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case b:
            return "Suspense";
          case h:
            return "SuspenseList";
        }
        if (typeof K == "object")
          switch (K.$$typeof) {
            case u:
              return "Context.Consumer";
            case c:
              return "Context.Provider";
            case A:
              return J(K, K.render, "ForwardRef");
            case m:
              return $(K.type);
            case y:
              return $(K.render);
            case E: {
              var te = K, Z = ne(te);
              if (Z)
                return $(Z);
              break;
            }
          }
        return null;
      }
      var z = {};
      D.ReactDebugCurrentFrame;
      var q = null;
      function de(K) {
        q = K;
      }
      function U(K, te, Z, Re, qe) {
        {
          var Ve = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Ne in K)
            if (Ve(K, Ne)) {
              var Ue = void 0;
              try {
                if (typeof K[Ne] != "function") {
                  var yn = Error((Re || "React class") + ": " + Z + " type `" + Ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof K[Ne] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw yn.name = "Invariant Violation", yn;
                }
                Ue = K[Ne](te, Ne, Re, Z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (jn) {
                Ue = jn;
              }
              Ue && !(Ue instanceof Error) && (de(qe), H("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Re || "React class", Z, Ne, typeof Ue), de(null)), Ue instanceof Error && !(Ue.message in z) && (z[Ue.message] = !0, de(qe), H("Failed %s type: %s", Z, Ue.message), de(null));
            }
        }
      }
      var L = D.ReactCurrentOwner, oe = Object.prototype.hasOwnProperty, re = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ie, fe, ae;
      ae = {};
      function be(K) {
        if (oe.call(K, "ref")) {
          var te = Object.getOwnPropertyDescriptor(K, "ref").get;
          if (te && te.isReactWarning)
            return !1;
        }
        return K.ref !== void 0;
      }
      function pe(K) {
        if (oe.call(K, "key")) {
          var te = Object.getOwnPropertyDescriptor(K, "key").get;
          if (te && te.isReactWarning)
            return !1;
        }
        return K.key !== void 0;
      }
      function le(K, te) {
        if (typeof K.ref == "string" && L.current && te && L.current.stateNode !== te) {
          var Z = $(L.current.type);
          ae[Z] || (H('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(L.current.type), K.ref), ae[Z] = !0);
        }
      }
      function me(K, te) {
        {
          var Z = function() {
            ie || (ie = !0, H("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
          };
          Z.isReactWarning = !0, Object.defineProperty(K, "key", {
            get: Z,
            configurable: !0
          });
        }
      }
      function ge(K, te) {
        {
          var Z = function() {
            fe || (fe = !0, H("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
          };
          Z.isReactWarning = !0, Object.defineProperty(K, "ref", {
            get: Z,
            configurable: !0
          });
        }
      }
      var G = function(K, te, Z, Re, qe, Ve, Ne) {
        var Ue = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: o,
          // Built-in properties that belong on the element
          type: K,
          key: te,
          ref: Z,
          props: Ne,
          // Record the component responsible for creating this element.
          _owner: Ve
        };
        return Ue._store = {}, Object.defineProperty(Ue._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Ue, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Re
        }), Object.defineProperty(Ue, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: qe
        }), Object.freeze && (Object.freeze(Ue.props), Object.freeze(Ue)), Ue;
      };
      function _e(K, te, Z, Re, qe) {
        {
          var Ve, Ne = {}, Ue = null, yn = null;
          Z !== void 0 && (Ue = "" + Z), pe(te) && (Ue = "" + te.key), be(te) && (yn = te.ref, le(te, qe));
          for (Ve in te)
            oe.call(te, Ve) && !re.hasOwnProperty(Ve) && (Ne[Ve] = te[Ve]);
          if (K && K.defaultProps) {
            var jn = K.defaultProps;
            for (Ve in jn)
              Ne[Ve] === void 0 && (Ne[Ve] = jn[Ve]);
          }
          if (Ue || yn) {
            var Jn = typeof K == "function" ? K.displayName || K.name || "Unknown" : K;
            Ue && me(Ne, Jn), yn && ge(Ne, Jn);
          }
          return G(K, Ue, yn, qe, Re, L.current, Ne);
        }
      }
      var we = D.ReactCurrentOwner;
      D.ReactDebugCurrentFrame;
      function He(K) {
        q = K;
      }
      var nn;
      nn = !1;
      function Ze(K) {
        return typeof K == "object" && K !== null && K.$$typeof === o;
      }
      function Un() {
        {
          if (we.current) {
            var K = $(we.current.type);
            if (K)
              return `

Check the render method of \`` + K + "`.";
          }
          return "";
        }
      }
      function Mn(K) {
        {
          if (K !== void 0) {
            var te = K.fileName.replace(/^.*[\\\/]/, ""), Z = K.lineNumber;
            return `

Check your code at ` + te + ":" + Z + ".";
          }
          return "";
        }
      }
      var Sn = {};
      function an(K) {
        {
          var te = Un();
          if (!te) {
            var Z = typeof K == "string" ? K : K.displayName || K.name;
            Z && (te = `

Check the top-level render call using <` + Z + ">.");
          }
          return te;
        }
      }
      function pn(K, te) {
        {
          if (!K._store || K._store.validated || K.key != null)
            return;
          K._store.validated = !0;
          var Z = an(te);
          if (Sn[Z])
            return;
          Sn[Z] = !0;
          var Re = "";
          K && K._owner && K._owner !== we.current && (Re = " It was passed a child from " + $(K._owner.type) + "."), He(K), H('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Z, Re), He(null);
        }
      }
      function Xe(K, te) {
        {
          if (typeof K != "object")
            return;
          if (Array.isArray(K))
            for (var Z = 0; Z < K.length; Z++) {
              var Re = K[Z];
              Ze(Re) && pn(Re, te);
            }
          else if (Ze(K))
            K._store && (K._store.validated = !0);
          else if (K) {
            var qe = B(K);
            if (typeof qe == "function" && qe !== K.entries)
              for (var Ve = qe.call(K), Ne; !(Ne = Ve.next()).done; )
                Ze(Ne.value) && pn(Ne.value, te);
          }
        }
      }
      function An(K) {
        {
          var te = K.type;
          if (te == null || typeof te == "string")
            return;
          var Z;
          if (typeof te == "function")
            Z = te.propTypes;
          else if (typeof te == "object" && (te.$$typeof === A || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          te.$$typeof === m))
            Z = te.propTypes;
          else
            return;
          if (Z) {
            var Re = $(te);
            U(Z, K.props, "prop", Re, K);
          } else if (te.PropTypes !== void 0 && !nn) {
            nn = !0;
            var qe = $(te);
            H("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", qe || "Unknown");
          }
          typeof te.getDefaultProps == "function" && !te.getDefaultProps.isReactClassApproved && H("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Fn(K) {
        {
          for (var te = Object.keys(K.props), Z = 0; Z < te.length; Z++) {
            var Re = te[Z];
            if (Re !== "children" && Re !== "key") {
              He(K), H("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Re), He(null);
              break;
            }
          }
          K.ref !== null && (He(K), H("Invalid attribute `ref` supplied to `React.Fragment`."), He(null));
        }
      }
      function Eo(K, te, Z, Re, qe, Ve) {
        {
          var Ne = Ae(K);
          if (!Ne) {
            var Ue = "";
            (K === void 0 || typeof K == "object" && K !== null && Object.keys(K).length === 0) && (Ue += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var yn = Mn(qe);
            yn ? Ue += yn : Ue += Un();
            var jn;
            K === null ? jn = "null" : Array.isArray(K) ? jn = "array" : K !== void 0 && K.$$typeof === o ? (jn = "<" + ($(K.type) || "Unknown") + " />", Ue = " Did you accidentally export a JSX literal instead of a component?") : jn = typeof K, H("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", jn, Ue);
          }
          var Jn = _e(K, te, Z, qe, Ve);
          if (Jn == null)
            return Jn;
          if (Ne) {
            var fn = te.children;
            if (fn !== void 0)
              if (Re)
                if (Array.isArray(fn)) {
                  for (var xt = 0; xt < fn.length; xt++)
                    Xe(fn[xt], K);
                  Object.freeze && Object.freeze(fn);
                } else
                  H("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Xe(fn, K);
          }
          return K === n.Fragment ? Fn(Jn) : An(Jn), Jn;
        }
      }
      function ko(K, te, Z) {
        return Eo(K, te, Z, !0);
      }
      function Rn(K, te, Z) {
        return Eo(K, te, Z, !1);
      }
      var Zn = Rn, To = ko;
      n.jsx = Zn, n.jsxs = To;
    }();
  }(kc)), kc;
}
process.env.NODE_ENV === "production" ? kl.exports = Lx() : kl.exports = Nx();
var p = kl.exports;
const Mx = {
  config: {}
};
function jx(n = Mx, e) {
  switch (e.type) {
    case "ADD_CONFIG":
      return {
        ...n,
        config: e.payload.config
      };
    case "UPDATE_STATUS":
      return {
        ...n,
        status: e.payload.status
      };
    default:
      return n;
  }
}
var $x = {
  black: "#000",
  white: "#fff"
};
const _i = $x;
var Sc = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Rc = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, Bc = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, _c = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Fc = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Ic = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Qx = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
const su = Qx;
function cu(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (n < e || n > o) && console.error("Material-UI: the value provided ".concat(n, " is out of range [").concat(e, ", ").concat(o, "].")), Math.min(Math.max(e, n), o);
}
function Hx(n) {
  n = n.substr(1);
  var e = new RegExp(".{1,".concat(n.length / 3, "}"), "g"), o = n.match(e);
  return o && o[0].length === 1 && (o = o.map(function(a) {
    return a + a;
  })), o ? "rgb(".concat(o.map(function(a) {
    return parseInt(a, 16);
  }).join(", "), ")") : "";
}
function Vx(n) {
  n = Qt(n);
  var e = n, o = e.values, a = o[0], i = o[1] / 100, s = o[2] / 100, c = i * Math.min(s, 1 - s), u = function(m) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (m + a / 30) % 12;
    return s - c * Math.max(Math.min(E - 3, 9 - E, 1), -1);
  }, A = "rgb", b = [Math.round(u(0) * 255), Math.round(u(8) * 255), Math.round(u(4) * 255)];
  return n.type === "hsla" && (A += "a", b.push(o[3])), qi({
    type: A,
    values: b
  });
}
function Qt(n) {
  if (n.type)
    return n;
  if (n.charAt(0) === "#")
    return Qt(Hx(n));
  var e = n.indexOf("("), o = n.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(o) === -1)
    throw new Error(["Material-UI: unsupported `".concat(n, "` color."), "We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()."].join(`
`));
  var a = n.substring(e + 1, n.length - 1).split(",");
  return a = a.map(function(i) {
    return parseFloat(i);
  }), {
    type: o,
    values: a
  };
}
function qi(n) {
  var e = n.type, o = n.values;
  return e.indexOf("rgb") !== -1 ? o = o.map(function(a, i) {
    return i < 3 ? parseInt(a, 10) : a;
  }) : e.indexOf("hsl") !== -1 && (o[1] = "".concat(o[1], "%"), o[2] = "".concat(o[2], "%")), "".concat(e, "(").concat(o.join(", "), ")");
}
function _f(n, e) {
  var o = Sl(n), a = Sl(e);
  return (Math.max(o, a) + 0.05) / (Math.min(o, a) + 0.05);
}
function Sl(n) {
  n = Qt(n);
  var e = n.type === "hsl" ? Qt(Vx(n)).values : n.values;
  return e = e.map(function(o) {
    return o /= 255, o <= 0.03928 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
}
function qx(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.15;
  return Sl(n) > 0.5 ? lu(n, e) : uu(n, e);
}
function ro(n, e) {
  return n = Qt(n), e = cu(e), (n.type === "rgb" || n.type === "hsl") && (n.type += "a"), n.values[3] = e, qi(n);
}
function lu(n, e) {
  if (n = Qt(n), e = cu(e), n.type.indexOf("hsl") !== -1)
    n.values[2] *= 1 - e;
  else if (n.type.indexOf("rgb") !== -1)
    for (var o = 0; o < 3; o += 1)
      n.values[o] *= 1 - e;
  return qi(n);
}
function uu(n, e) {
  if (n = Qt(n), e = cu(e), n.type.indexOf("hsl") !== -1)
    n.values[2] += (100 - n.values[2]) * e;
  else if (n.type.indexOf("rgb") !== -1)
    for (var o = 0; o < 3; o += 1)
      n.values[o] += (255 - n.values[o]) * e;
  return qi(n);
}
function zo(n) {
  "@babel/helpers - typeof";
  return zo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zo(n);
}
function Wx(n, e) {
  if (zo(n) != "object" || !n)
    return n;
  var o = n[Symbol.toPrimitive];
  if (o !== void 0) {
    var a = o.call(n, e || "default");
    if (zo(a) != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Ip(n) {
  var e = Wx(n, "string");
  return zo(e) == "symbol" ? e : String(e);
}
function tn(n, e, o) {
  return e = Ip(e), e in n ? Object.defineProperty(n, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = o, n;
}
function Wi(n, e) {
  if (n == null)
    return {};
  var o = {}, a = Object.keys(n), i, s;
  for (s = 0; s < a.length; s++)
    i = a[s], !(e.indexOf(i) >= 0) && (o[i] = n[i]);
  return o;
}
function xe(n, e) {
  if (n == null)
    return {};
  var o = Wi(n, e), a, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      a = s[i], !(e.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(n, a) && (o[a] = n[a]);
  }
  return o;
}
function xo(n, e) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function() {
    return n.apply(void 0, arguments) || e.apply(void 0, arguments);
  };
}
function j() {
  return j = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
    }
    return n;
  }, j.apply(this, arguments);
}
function Tc(n) {
  return n && zo(n) === "object" && n.constructor === Object;
}
function Ht(n, e) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, a = o.clone ? j({}, n) : n;
  return Tc(n) && Tc(e) && Object.keys(e).forEach(function(i) {
    i !== "__proto__" && (Tc(e[i]) && i in n ? a[i] = Ht(n[i], e[i], o) : a[i] = e[i]);
  }), a;
}
var Rl = { exports: {} }, gi = { exports: {} }, ze = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ff;
function Yx() {
  if (Ff)
    return ze;
  Ff = 1;
  var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, o = n ? Symbol.for("react.portal") : 60106, a = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, c = n ? Symbol.for("react.provider") : 60109, u = n ? Symbol.for("react.context") : 60110, A = n ? Symbol.for("react.async_mode") : 60111, b = n ? Symbol.for("react.concurrent_mode") : 60111, h = n ? Symbol.for("react.forward_ref") : 60112, m = n ? Symbol.for("react.suspense") : 60113, E = n ? Symbol.for("react.suspense_list") : 60120, y = n ? Symbol.for("react.memo") : 60115, k = n ? Symbol.for("react.lazy") : 60116, w = n ? Symbol.for("react.block") : 60121, _ = n ? Symbol.for("react.fundamental") : 60117, O = n ? Symbol.for("react.responder") : 60118, F = n ? Symbol.for("react.scope") : 60119;
  function P(B) {
    if (typeof B == "object" && B !== null) {
      var D = B.$$typeof;
      switch (D) {
        case e:
          switch (B = B.type, B) {
            case A:
            case b:
            case a:
            case s:
            case i:
            case m:
              return B;
            default:
              switch (B = B && B.$$typeof, B) {
                case u:
                case h:
                case k:
                case y:
                case c:
                  return B;
                default:
                  return D;
              }
          }
        case o:
          return D;
      }
    }
  }
  function M(B) {
    return P(B) === b;
  }
  return ze.AsyncMode = A, ze.ConcurrentMode = b, ze.ContextConsumer = u, ze.ContextProvider = c, ze.Element = e, ze.ForwardRef = h, ze.Fragment = a, ze.Lazy = k, ze.Memo = y, ze.Portal = o, ze.Profiler = s, ze.StrictMode = i, ze.Suspense = m, ze.isAsyncMode = function(B) {
    return M(B) || P(B) === A;
  }, ze.isConcurrentMode = M, ze.isContextConsumer = function(B) {
    return P(B) === u;
  }, ze.isContextProvider = function(B) {
    return P(B) === c;
  }, ze.isElement = function(B) {
    return typeof B == "object" && B !== null && B.$$typeof === e;
  }, ze.isForwardRef = function(B) {
    return P(B) === h;
  }, ze.isFragment = function(B) {
    return P(B) === a;
  }, ze.isLazy = function(B) {
    return P(B) === k;
  }, ze.isMemo = function(B) {
    return P(B) === y;
  }, ze.isPortal = function(B) {
    return P(B) === o;
  }, ze.isProfiler = function(B) {
    return P(B) === s;
  }, ze.isStrictMode = function(B) {
    return P(B) === i;
  }, ze.isSuspense = function(B) {
    return P(B) === m;
  }, ze.isValidElementType = function(B) {
    return typeof B == "string" || typeof B == "function" || B === a || B === b || B === s || B === i || B === m || B === E || typeof B == "object" && B !== null && (B.$$typeof === k || B.$$typeof === y || B.$$typeof === c || B.$$typeof === u || B.$$typeof === h || B.$$typeof === _ || B.$$typeof === O || B.$$typeof === F || B.$$typeof === w);
  }, ze.typeOf = P, ze;
}
var Ge = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var If;
function zx() {
  return If || (If = 1, process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, o = n ? Symbol.for("react.portal") : 60106, a = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, c = n ? Symbol.for("react.provider") : 60109, u = n ? Symbol.for("react.context") : 60110, A = n ? Symbol.for("react.async_mode") : 60111, b = n ? Symbol.for("react.concurrent_mode") : 60111, h = n ? Symbol.for("react.forward_ref") : 60112, m = n ? Symbol.for("react.suspense") : 60113, E = n ? Symbol.for("react.suspense_list") : 60120, y = n ? Symbol.for("react.memo") : 60115, k = n ? Symbol.for("react.lazy") : 60116, w = n ? Symbol.for("react.block") : 60121, _ = n ? Symbol.for("react.fundamental") : 60117, O = n ? Symbol.for("react.responder") : 60118, F = n ? Symbol.for("react.scope") : 60119;
    function P(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === a || G === b || G === s || G === i || G === m || G === E || typeof G == "object" && G !== null && (G.$$typeof === k || G.$$typeof === y || G.$$typeof === c || G.$$typeof === u || G.$$typeof === h || G.$$typeof === _ || G.$$typeof === O || G.$$typeof === F || G.$$typeof === w);
    }
    function M(G) {
      if (typeof G == "object" && G !== null) {
        var _e = G.$$typeof;
        switch (_e) {
          case e:
            var we = G.type;
            switch (we) {
              case A:
              case b:
              case a:
              case s:
              case i:
              case m:
                return we;
              default:
                var He = we && we.$$typeof;
                switch (He) {
                  case u:
                  case h:
                  case k:
                  case y:
                  case c:
                    return He;
                  default:
                    return _e;
                }
            }
          case o:
            return _e;
        }
      }
    }
    var B = A, D = b, H = u, X = c, ce = e, Ae = h, se = a, Be = k, Pe = y, ne = o, J = s, $ = i, z = m, q = !1;
    function de(G) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(G) || M(G) === A;
    }
    function U(G) {
      return M(G) === b;
    }
    function L(G) {
      return M(G) === u;
    }
    function oe(G) {
      return M(G) === c;
    }
    function re(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function ie(G) {
      return M(G) === h;
    }
    function fe(G) {
      return M(G) === a;
    }
    function ae(G) {
      return M(G) === k;
    }
    function be(G) {
      return M(G) === y;
    }
    function pe(G) {
      return M(G) === o;
    }
    function le(G) {
      return M(G) === s;
    }
    function me(G) {
      return M(G) === i;
    }
    function ge(G) {
      return M(G) === m;
    }
    Ge.AsyncMode = B, Ge.ConcurrentMode = D, Ge.ContextConsumer = H, Ge.ContextProvider = X, Ge.Element = ce, Ge.ForwardRef = Ae, Ge.Fragment = se, Ge.Lazy = Be, Ge.Memo = Pe, Ge.Portal = ne, Ge.Profiler = J, Ge.StrictMode = $, Ge.Suspense = z, Ge.isAsyncMode = de, Ge.isConcurrentMode = U, Ge.isContextConsumer = L, Ge.isContextProvider = oe, Ge.isElement = re, Ge.isForwardRef = ie, Ge.isFragment = fe, Ge.isLazy = ae, Ge.isMemo = be, Ge.isPortal = pe, Ge.isProfiler = le, Ge.isStrictMode = me, Ge.isSuspense = ge, Ge.isValidElementType = P, Ge.typeOf = M;
  }()), Ge;
}
var Tf;
function Yi() {
  return Tf || (Tf = 1, process.env.NODE_ENV === "production" ? gi.exports = Yx() : gi.exports = zx()), gi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Oc, Of;
function Gx() {
  if (Of)
    return Oc;
  Of = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function a(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var c = {}, u = 0; u < 10; u++)
        c["_" + String.fromCharCode(u)] = u;
      var A = Object.getOwnPropertyNames(c).map(function(h) {
        return c[h];
      });
      if (A.join("") !== "0123456789")
        return !1;
      var b = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        b[h] = h;
      }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Oc = i() ? Object.assign : function(s, c) {
    for (var u, A = a(s), b, h = 1; h < arguments.length; h++) {
      u = Object(arguments[h]);
      for (var m in u)
        e.call(u, m) && (A[m] = u[m]);
      if (n) {
        b = n(u);
        for (var E = 0; E < b.length; E++)
          o.call(u, b[E]) && (A[b[E]] = u[b[E]]);
      }
    }
    return A;
  }, Oc;
}
var Uc, Uf;
function Au() {
  if (Uf)
    return Uc;
  Uf = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Uc = n, Uc;
}
var Kc, Kf;
function Tp() {
  return Kf || (Kf = 1, Kc = Function.call.bind(Object.prototype.hasOwnProperty)), Kc;
}
var Pc, Pf;
function Zx() {
  if (Pf)
    return Pc;
  Pf = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Au(), o = {}, a = Tp();
    n = function(s) {
      var c = "Warning: " + s;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function i(s, c, u, A, b) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in s)
        if (a(s, h)) {
          var m;
          try {
            if (typeof s[h] != "function") {
              var E = Error(
                (A || "React class") + ": " + u + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            m = s[h](c, h, A, u, null, e);
          } catch (k) {
            m = k;
          }
          if (m && !(m instanceof Error) && n(
            (A || "React class") + ": type specification of " + u + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in o)) {
            o[m.message] = !0;
            var y = b ? b() : "";
            n(
              "Failed " + u + " type: " + m.message + (y ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, Pc = i, Pc;
}
var Dc, Df;
function Jx() {
  if (Df)
    return Dc;
  Df = 1;
  var n = Yi(), e = Gx(), o = Au(), a = Tp(), i = Zx(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(u) {
    var A = "Warning: " + u;
    typeof console < "u" && console.error(A);
    try {
      throw new Error(A);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return Dc = function(u, A) {
    var b = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function m(U) {
      var L = U && (b && U[b] || U[h]);
      if (typeof L == "function")
        return L;
    }
    var E = "<<anonymous>>", y = {
      array: O("array"),
      bigint: O("bigint"),
      bool: O("boolean"),
      func: O("function"),
      number: O("number"),
      object: O("object"),
      string: O("string"),
      symbol: O("symbol"),
      any: F(),
      arrayOf: P,
      element: M(),
      elementType: B(),
      instanceOf: D,
      node: Ae(),
      objectOf: X,
      oneOf: H,
      oneOfType: ce,
      shape: Be,
      exact: Pe
    };
    function k(U, L) {
      return U === L ? U !== 0 || 1 / U === 1 / L : U !== U && L !== L;
    }
    function w(U, L) {
      this.message = U, this.data = L && typeof L == "object" ? L : {}, this.stack = "";
    }
    w.prototype = Error.prototype;
    function _(U) {
      if (process.env.NODE_ENV !== "production")
        var L = {}, oe = 0;
      function re(fe, ae, be, pe, le, me, ge) {
        if (pe = pe || E, me = me || be, ge !== o) {
          if (A) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var _e = pe + ":" + be;
            !L[_e] && // Avoid spamming the console because they are often not actionable except for lib authors
            oe < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + me + "` prop on `" + pe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), L[_e] = !0, oe++);
          }
        }
        return ae[be] == null ? fe ? ae[be] === null ? new w("The " + le + " `" + me + "` is marked as required " + ("in `" + pe + "`, but its value is `null`.")) : new w("The " + le + " `" + me + "` is marked as required in " + ("`" + pe + "`, but its value is `undefined`.")) : null : U(ae, be, pe, le, me);
      }
      var ie = re.bind(null, !1);
      return ie.isRequired = re.bind(null, !0), ie;
    }
    function O(U) {
      function L(oe, re, ie, fe, ae, be) {
        var pe = oe[re], le = $(pe);
        if (le !== U) {
          var me = z(pe);
          return new w(
            "Invalid " + fe + " `" + ae + "` of type " + ("`" + me + "` supplied to `" + ie + "`, expected ") + ("`" + U + "`."),
            { expectedType: U }
          );
        }
        return null;
      }
      return _(L);
    }
    function F() {
      return _(c);
    }
    function P(U) {
      function L(oe, re, ie, fe, ae) {
        if (typeof U != "function")
          return new w("Property `" + ae + "` of component `" + ie + "` has invalid PropType notation inside arrayOf.");
        var be = oe[re];
        if (!Array.isArray(be)) {
          var pe = $(be);
          return new w("Invalid " + fe + " `" + ae + "` of type " + ("`" + pe + "` supplied to `" + ie + "`, expected an array."));
        }
        for (var le = 0; le < be.length; le++) {
          var me = U(be, le, ie, fe, ae + "[" + le + "]", o);
          if (me instanceof Error)
            return me;
        }
        return null;
      }
      return _(L);
    }
    function M() {
      function U(L, oe, re, ie, fe) {
        var ae = L[oe];
        if (!u(ae)) {
          var be = $(ae);
          return new w("Invalid " + ie + " `" + fe + "` of type " + ("`" + be + "` supplied to `" + re + "`, expected a single ReactElement."));
        }
        return null;
      }
      return _(U);
    }
    function B() {
      function U(L, oe, re, ie, fe) {
        var ae = L[oe];
        if (!n.isValidElementType(ae)) {
          var be = $(ae);
          return new w("Invalid " + ie + " `" + fe + "` of type " + ("`" + be + "` supplied to `" + re + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return _(U);
    }
    function D(U) {
      function L(oe, re, ie, fe, ae) {
        if (!(oe[re] instanceof U)) {
          var be = U.name || E, pe = de(oe[re]);
          return new w("Invalid " + fe + " `" + ae + "` of type " + ("`" + pe + "` supplied to `" + ie + "`, expected ") + ("instance of `" + be + "`."));
        }
        return null;
      }
      return _(L);
    }
    function H(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), c;
      function L(oe, re, ie, fe, ae) {
        for (var be = oe[re], pe = 0; pe < U.length; pe++)
          if (k(be, U[pe]))
            return null;
        var le = JSON.stringify(U, function(ge, G) {
          var _e = z(G);
          return _e === "symbol" ? String(G) : G;
        });
        return new w("Invalid " + fe + " `" + ae + "` of value `" + String(be) + "` " + ("supplied to `" + ie + "`, expected one of " + le + "."));
      }
      return _(L);
    }
    function X(U) {
      function L(oe, re, ie, fe, ae) {
        if (typeof U != "function")
          return new w("Property `" + ae + "` of component `" + ie + "` has invalid PropType notation inside objectOf.");
        var be = oe[re], pe = $(be);
        if (pe !== "object")
          return new w("Invalid " + fe + " `" + ae + "` of type " + ("`" + pe + "` supplied to `" + ie + "`, expected an object."));
        for (var le in be)
          if (a(be, le)) {
            var me = U(be, le, ie, fe, ae + "." + le, o);
            if (me instanceof Error)
              return me;
          }
        return null;
      }
      return _(L);
    }
    function ce(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var L = 0; L < U.length; L++) {
        var oe = U[L];
        if (typeof oe != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(oe) + " at index " + L + "."
          ), c;
      }
      function re(ie, fe, ae, be, pe) {
        for (var le = [], me = 0; me < U.length; me++) {
          var ge = U[me], G = ge(ie, fe, ae, be, pe, o);
          if (G == null)
            return null;
          G.data && a(G.data, "expectedType") && le.push(G.data.expectedType);
        }
        var _e = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
        return new w("Invalid " + be + " `" + pe + "` supplied to " + ("`" + ae + "`" + _e + "."));
      }
      return _(re);
    }
    function Ae() {
      function U(L, oe, re, ie, fe) {
        return ne(L[oe]) ? null : new w("Invalid " + ie + " `" + fe + "` supplied to " + ("`" + re + "`, expected a ReactNode."));
      }
      return _(U);
    }
    function se(U, L, oe, re, ie) {
      return new w(
        (U || "React class") + ": " + L + " type `" + oe + "." + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ie + "`."
      );
    }
    function Be(U) {
      function L(oe, re, ie, fe, ae) {
        var be = oe[re], pe = $(be);
        if (pe !== "object")
          return new w("Invalid " + fe + " `" + ae + "` of type `" + pe + "` " + ("supplied to `" + ie + "`, expected `object`."));
        for (var le in U) {
          var me = U[le];
          if (typeof me != "function")
            return se(ie, fe, ae, le, z(me));
          var ge = me(be, le, ie, fe, ae + "." + le, o);
          if (ge)
            return ge;
        }
        return null;
      }
      return _(L);
    }
    function Pe(U) {
      function L(oe, re, ie, fe, ae) {
        var be = oe[re], pe = $(be);
        if (pe !== "object")
          return new w("Invalid " + fe + " `" + ae + "` of type `" + pe + "` " + ("supplied to `" + ie + "`, expected `object`."));
        var le = e({}, oe[re], U);
        for (var me in le) {
          var ge = U[me];
          if (a(U, me) && typeof ge != "function")
            return se(ie, fe, ae, me, z(ge));
          if (!ge)
            return new w(
              "Invalid " + fe + " `" + ae + "` key `" + me + "` supplied to `" + ie + "`.\nBad object: " + JSON.stringify(oe[re], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(U), null, "  ")
            );
          var G = ge(be, me, ie, fe, ae + "." + me, o);
          if (G)
            return G;
        }
        return null;
      }
      return _(L);
    }
    function ne(U) {
      switch (typeof U) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !U;
        case "object":
          if (Array.isArray(U))
            return U.every(ne);
          if (U === null || u(U))
            return !0;
          var L = m(U);
          if (L) {
            var oe = L.call(U), re;
            if (L !== U.entries) {
              for (; !(re = oe.next()).done; )
                if (!ne(re.value))
                  return !1;
            } else
              for (; !(re = oe.next()).done; ) {
                var ie = re.value;
                if (ie && !ne(ie[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function J(U, L) {
      return U === "symbol" ? !0 : L ? L["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && L instanceof Symbol : !1;
    }
    function $(U) {
      var L = typeof U;
      return Array.isArray(U) ? "array" : U instanceof RegExp ? "object" : J(L, U) ? "symbol" : L;
    }
    function z(U) {
      if (typeof U > "u" || U === null)
        return "" + U;
      var L = $(U);
      if (L === "object") {
        if (U instanceof Date)
          return "date";
        if (U instanceof RegExp)
          return "regexp";
      }
      return L;
    }
    function q(U) {
      var L = z(U);
      switch (L) {
        case "array":
        case "object":
          return "an " + L;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + L;
        default:
          return L;
      }
    }
    function de(U) {
      return !U.constructor || !U.constructor.name ? E : U.constructor.name;
    }
    return y.checkPropTypes = i, y.resetWarningCache = i.resetWarningCache, y.PropTypes = y, y;
  }, Dc;
}
var Lc, Lf;
function Xx() {
  if (Lf)
    return Lc;
  Lf = 1;
  var n = Au();
  function e() {
  }
  function o() {
  }
  return o.resetWarningCache = e, Lc = function() {
    function a(c, u, A, b, h, m) {
      if (m !== n) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    a.isRequired = a;
    function i() {
      return a;
    }
    var s = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: i,
      element: a,
      elementType: a,
      instanceOf: i,
      node: a,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: o,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, Lc;
}
if (process.env.NODE_ENV !== "production") {
  var eC = Yi(), nC = !0;
  Rl.exports = Jx()(eC.isElement, nC);
} else
  Rl.exports = Xx()();
var Op = Rl.exports;
const f = /* @__PURE__ */ Ua(Op);
function oC(n) {
  var e = n.prototype, o = e === void 0 ? {} : e;
  return !!o.isReactComponent;
}
function Up(n, e, o, a, i) {
  var s = n[e], c = i || e;
  if (s == null)
    return null;
  var u, A = s.type;
  return typeof A == "function" && !oC(A) && (u = "Did you accidentally use a plain function component for an element instead?"), u !== void 0 ? new Error("Invalid ".concat(a, " `").concat(c, "` supplied to `").concat(o, "`. ") + "Expected an element that can hold a ref. ".concat(u, " ") + "For more information see https://mui.com/r/caveat-with-refs-guide") : null;
}
var Kp = xo(f.element, Up);
Kp.isRequired = xo(f.element.isRequired, Up);
const Pp = Kp;
function tC(n) {
  var e = n.prototype, o = e === void 0 ? {} : e;
  return !!o.isReactComponent;
}
function aC(n, e, o, a, i) {
  var s = n[e], c = i || e;
  if (s == null)
    return null;
  var u;
  return typeof s == "function" && !tC(s) && (u = "Did you accidentally provide a plain function component instead?"), u !== void 0 ? new Error("Invalid ".concat(a, " `").concat(c, "` supplied to `").concat(o, "`. ") + "Expected an element type that can hold a ref. ".concat(u, " ") + "For more information see https://mui.com/r/caveat-with-refs-guide") : null;
}
const du = xo(Op.elementType, aC);
var rC = "exact-prop: ​";
function vr(n) {
  return process.env.NODE_ENV === "production" ? n : j({}, n, tn({}, rC, function(e) {
    var o = Object.keys(e).filter(function(a) {
      return !n.hasOwnProperty(a);
    });
    return o.length > 0 ? new Error("The following props are not supported: ".concat(o.map(function(a) {
      return "`".concat(a, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}
var Bl = Yi(), iC = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function sC(n) {
  var e = "".concat(n).match(iC), o = e && e[1];
  return o || "";
}
function Dp(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return n.displayName || n.name || sC(n) || e;
}
function Nf(n, e, o) {
  var a = Dp(e);
  return n.displayName || (a !== "" ? "".concat(o, "(").concat(a, ")") : o);
}
function jt(n) {
  if (n != null) {
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return Dp(n, "Component");
    if (zo(n) === "object")
      switch (n.$$typeof) {
        case Bl.ForwardRef:
          return Nf(n, n.render, "ForwardRef");
        case Bl.Memo:
          return Nf(n, n.type, "memo");
        default:
          return;
      }
  }
}
var cC = f.oneOfType([f.func, f.object]);
const Fi = cC;
var On = ["xs", "sm", "md", "lg", "xl"];
function lC(n) {
  var e = n.values, o = e === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : e, a = n.unit, i = a === void 0 ? "px" : a, s = n.step, c = s === void 0 ? 5 : s, u = xe(n, ["values", "unit", "step"]);
  function A(y) {
    var k = typeof o[y] == "number" ? o[y] : y;
    return "@media (min-width:".concat(k).concat(i, ")");
  }
  function b(y) {
    var k = On.indexOf(y) + 1, w = o[On[k]];
    if (k === On.length)
      return A("xs");
    var _ = typeof w == "number" && k > 0 ? w : y;
    return "@media (max-width:".concat(_ - c / 100).concat(i, ")");
  }
  function h(y, k) {
    var w = On.indexOf(k);
    return w === On.length - 1 ? A(y) : "@media (min-width:".concat(typeof o[y] == "number" ? o[y] : y).concat(i, ") and ") + "(max-width:".concat((w !== -1 && typeof o[On[w + 1]] == "number" ? o[On[w + 1]] : k) - c / 100).concat(i, ")");
  }
  function m(y) {
    return h(y, y);
  }
  function E(y) {
    return o[y];
  }
  return j({
    keys: On,
    values: o,
    up: A,
    down: b,
    between: h,
    only: m,
    width: E
  }, u);
}
function uC(n, e, o) {
  var a;
  return j({
    gutters: function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return j({
        paddingLeft: e(2),
        paddingRight: e(2)
      }, s, tn({}, n.up("sm"), j({
        paddingLeft: e(3),
        paddingRight: e(3)
      }, s[n.up("sm")])));
    },
    toolbar: (a = {
      minHeight: 56
    }, tn(a, "".concat(n.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), tn(a, n.up("sm"), {
      minHeight: 64
    }), a)
  }, o);
}
var Mf = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _i.white,
    default: su[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)"
  }
}, Nc = {
  text: {
    primary: _i.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: su[800],
    default: "#303030"
  },
  action: {
    active: _i.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)"
  }
};
function jf(n, e, o, a) {
  n[e] || (n.hasOwnProperty(o) ? n[e] = n[o] : e === "light" ? n.light = uu(n.main, a) : e === "dark" && (n.dark = lu(n.main, a * 1.5)));
}
function AC(n) {
  var e = n.primary, o = e === void 0 ? {
    light: Bc[300],
    main: Bc[500],
    dark: Bc[700]
  } : e, a = n.secondary, i = a === void 0 ? {
    light: Rc.A200,
    main: Rc.A400,
    dark: Rc.A700
  } : a, s = n.error, c = s === void 0 ? {
    light: Sc[300],
    main: Sc[500],
    dark: Sc[700]
  } : s, u = n.warning, A = u === void 0 ? {
    light: Ic[300],
    main: Ic[500],
    dark: Ic[700]
  } : u, b = n.info, h = b === void 0 ? {
    light: _c[300],
    main: _c[500],
    dark: _c[700]
  } : b, m = n.success, E = m === void 0 ? {
    light: Fc[300],
    main: Fc[500],
    dark: Fc[700]
  } : m, y = n.type, k = y === void 0 ? "light" : y, w = n.contrastThreshold, _ = w === void 0 ? 3 : w, O = n.tonalOffset, F = O === void 0 ? 0.2 : O, P = xe(n, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function M(X) {
    if (!X)
      throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(X, ")."));
    var ce = _f(X, Nc.text.primary) >= _ ? Nc.text.primary : Mf.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var Ae = _f(X, ce);
      Ae < 3 && console.error(["Material-UI: the contrast ratio of ".concat(Ae, ":1 for ").concat(ce, " on ").concat(X), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return ce;
  }
  function B(X) {
    var ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, Ae = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, se = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if (X = j({}, X), !X.main && X[ce] && (X.main = X[ce]), process.env.NODE_ENV !== "production" && !X.main)
      throw new Error(["Material-UI: the color provided to augmentColor(color) is invalid.", "The color object needs to have a `main` property or a `".concat(ce, "` property.")].join(`
`));
    return jf(X, "light", Ae, F), jf(X, "dark", se, F), X.contrastText || (X.contrastText = M(X.main)), X;
  }
  var D = {
    dark: Nc,
    light: Mf
  };
  process.env.NODE_ENV !== "production" && (D[k] || console.error("Material-UI: the palette type `".concat(k, "` is not supported.")));
  var H = Ht(j({
    // A collection of common colors.
    common: _i,
    // The palette type, can be light or dark.
    type: k,
    // The colors used to represent primary interface elements for a user.
    primary: B(o),
    // The colors used to represent secondary interface elements for a user.
    secondary: B(i, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: B(c),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: B(A),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: B(h),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: B(E),
    // The grey colors.
    grey: su,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: _,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: M,
    // Generate a rich color object.
    augmentColor: B,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: F
  }, D[k]), P);
  return H;
}
function $f(n) {
  return Math.round(n * 1e5) / 1e5;
}
var Qf = {
  textTransform: "uppercase"
}, Hf = '"Roboto", "Helvetica", "Arial", sans-serif';
function dC(n, e) {
  var o = typeof e == "function" ? e(n) : e, a = o.fontFamily, i = a === void 0 ? Hf : a, s = o.fontSize, c = s === void 0 ? 14 : s, u = o.fontWeightLight, A = u === void 0 ? 300 : u, b = o.fontWeightRegular, h = b === void 0 ? 400 : b, m = o.fontWeightMedium, E = m === void 0 ? 500 : m, y = o.fontWeightBold, k = y === void 0 ? 700 : y, w = o.htmlFontSize, _ = w === void 0 ? 16 : w, O = o.allVariants, F = o.pxToRem, P = xe(o, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  process.env.NODE_ENV !== "production" && (typeof c != "number" && console.error("Material-UI: `fontSize` is required to be a number."), typeof _ != "number" && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var M = c / 14, B = F || function(X) {
    return "".concat(X / _ * M, "rem");
  }, D = function(ce, Ae, se, Be, Pe) {
    return j({
      fontFamily: i,
      fontWeight: ce,
      fontSize: B(Ae),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: se
    }, i === Hf ? {
      letterSpacing: "".concat($f(Be / Ae), "em")
    } : {}, {}, Pe, {}, O);
  }, H = {
    h1: D(A, 96, 1.167, -1.5),
    h2: D(A, 60, 1.2, -0.5),
    h3: D(h, 48, 1.167, 0),
    h4: D(h, 34, 1.235, 0.25),
    h5: D(h, 24, 1.334, 0),
    h6: D(E, 20, 1.6, 0.15),
    subtitle1: D(h, 16, 1.75, 0.15),
    subtitle2: D(E, 14, 1.57, 0.1),
    body1: D(h, 16, 1.5, 0.15),
    body2: D(h, 14, 1.43, 0.15),
    button: D(E, 14, 1.75, 0.4, Qf),
    caption: D(h, 12, 1.66, 0.4),
    overline: D(h, 12, 2.66, 1, Qf)
  };
  return Ht(j({
    htmlFontSize: _,
    pxToRem: B,
    round: $f,
    // TODO To remove in v5?
    fontFamily: i,
    fontSize: c,
    fontWeightLight: A,
    fontWeightRegular: h,
    fontWeightMedium: E,
    fontWeightBold: k
  }, H), P, {
    clone: !1
    // No need to clone deep
  });
}
var fC = 0.2, bC = 0.14, pC = 0.12;
function un() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(fC, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(bC, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(pC, ")")].join(",");
}
var hC = ["none", un(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), un(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), un(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), un(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), un(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), un(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), un(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), un(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), un(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), un(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), un(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), un(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), un(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), un(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), un(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), un(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), un(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), un(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), un(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), un(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), un(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), un(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), un(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), un(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const gC = hC;
var mC = {
  borderRadius: 4
};
const vC = mC;
var Vf;
function yC() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (n.mui)
    return n;
  var e;
  typeof n == "function" ? e = n : (process.env.NODE_ENV !== "production" && typeof n != "number" && console.error(["Material-UI: the `theme.spacing` value (".concat(n, ") is invalid."), "It should be a number or a function."].join(`
`)), e = function(i) {
    return process.env.NODE_ENV !== "production" && typeof i != "number" && console.error("Expected spacing argument to be a number, got ".concat(i)), n * i;
  });
  var o = function() {
    for (var i = arguments.length, s = new Array(i), c = 0; c < i; c++)
      s[c] = arguments[c];
    return process.env.NODE_ENV !== "production" && (s.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(s.length))), s.length === 0 ? e(1) : s.length === 1 ? e(s[0]) : s.map(function(u) {
      var A = e(u);
      return typeof A == "number" ? "".concat(A, "px") : A;
    }).join(" ");
  };
  return Object.defineProperty(o, "unit", {
    get: function() {
      return process.env.NODE_ENV !== "production" && ((!Vf || process.env.NODE_ENV === "test") && console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join(`
`)), Vf = !0), n;
    }
  }), o.mui = !0, o;
}
var qf = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Ea = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Wf(n) {
  return "".concat(Math.round(n), "ms");
}
const xC = {
  easing: qf,
  duration: Ea,
  create: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.duration, i = a === void 0 ? Ea.standard : a, s = o.easing, c = s === void 0 ? qf.easeInOut : s, u = o.delay, A = u === void 0 ? 0 : u, b = xe(o, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var h = function(y) {
        return typeof y == "string";
      }, m = function(y) {
        return !isNaN(parseFloat(y));
      };
      !h(e) && !Array.isArray(e) && console.error('Material-UI: argument "props" must be a string or Array.'), !m(i) && !h(i) && console.error('Material-UI: argument "duration" must be a number or a string but found '.concat(i, ".")), h(c) || console.error('Material-UI: argument "easing" must be a string.'), !m(A) && !h(A) && console.error('Material-UI: argument "delay" must be a number or a string.'), Object.keys(b).length !== 0 && console.error("Material-UI: unrecognized argument(s) [".concat(Object.keys(b).join(","), "]"));
    }
    return (Array.isArray(e) ? e : [e]).map(function(E) {
      return "".concat(E, " ").concat(typeof i == "string" ? i : Wf(i), " ").concat(c, " ").concat(typeof A == "string" ? A : Wf(A));
    }).join(",");
  },
  getAutoHeightDuration: function(e) {
    if (!e)
      return 0;
    var o = e / 36;
    return Math.round((4 + 15 * Math.pow(o, 0.25) + o / 5) * 10);
  }
};
var CC = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const Lp = CC;
function fu() {
  for (var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = n.breakpoints, o = e === void 0 ? {} : e, a = n.mixins, i = a === void 0 ? {} : a, s = n.palette, c = s === void 0 ? {} : s, u = n.spacing, A = n.typography, b = A === void 0 ? {} : A, h = xe(n, ["breakpoints", "mixins", "palette", "spacing", "typography"]), m = AC(c), E = lC(o), y = yC(u), k = Ht({
    breakpoints: E,
    direction: "ltr",
    mixins: uC(E, y, i),
    overrides: {},
    // Inject custom styles
    palette: m,
    props: {},
    // Provide default props
    shadows: gC,
    typography: dC(m, b),
    spacing: y,
    shape: vC,
    transitions: xC,
    zIndex: Lp
  }, h), w = arguments.length, _ = new Array(w > 1 ? w - 1 : 0), O = 1; O < w; O++)
    _[O - 1] = arguments[O];
  if (k = _.reduce(function(M, B) {
    return Ht(M, B);
  }, k), process.env.NODE_ENV !== "production") {
    var F = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"], P = function M(B, D) {
      var H = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, X;
      for (X in B) {
        var ce = B[X];
        H === 1 ? X.indexOf("Mui") === 0 && ce && M(ce, X, H + 1) : F.indexOf(X) !== -1 && Object.keys(ce).length > 0 && (process.env.NODE_ENV !== "production" && console.error(["Material-UI: the `".concat(D, "` component increases ") + "the CSS specificity of the `".concat(X, "` internal state."), "You can not override it like this: ", JSON.stringify(B, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
          root: tn({}, "&$".concat(X), ce)
        }, null, 2), "", "https://material-ui.com/r/pseudo-classes-guide"].join(`
`)), B[X] = {});
      }
    };
    P(k.overrides);
  }
  return k;
}
var wC = typeof Symbol == "function" && Symbol.for;
const Np = wC ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var EC = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function kC() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = n.disableGlobal, o = e === void 0 ? !1 : e, a = n.productionPrefix, i = a === void 0 ? "jss" : a, s = n.seed, c = s === void 0 ? "" : s, u = c === "" ? "" : "".concat(c, "-"), A = 0, b = function() {
    return A += 1, process.env.NODE_ENV !== "production" && A >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), A;
  };
  return function(h, m) {
    var E = m.options.name;
    if (E && E.indexOf("Mui") === 0 && !m.options.link && !o) {
      if (EC.indexOf(h.key) !== -1)
        return "Mui-".concat(h.key);
      var y = "".concat(u).concat(E, "-").concat(h.key);
      return !m.options.theme[Np] || c !== "" ? y : "".concat(y, "-").concat(b());
    }
    if (process.env.NODE_ENV === "production")
      return "".concat(u).concat(i).concat(b());
    var k = "".concat(h.key, "-").concat(b());
    return m.options.classNamePrefix ? "".concat(u).concat(m.options.classNamePrefix, "-").concat(k) : "".concat(u).concat(k);
  };
}
function zi(n) {
  var e = n.theme, o = n.name, a = n.props;
  if (!e || !e.props || !e.props[o])
    return a;
  var i = e.props[o], s;
  for (s in i)
    a[s] === void 0 && (a[s] = i[s]);
  return a;
}
var SC = process.env.NODE_ENV === "production";
function Co(n, e) {
  if (!SC) {
    if (n)
      return;
    var o = "Warning: " + e;
    typeof console < "u" && console.warn(o);
    try {
      throw Error(o);
    } catch {
    }
  }
}
var Yf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
  return typeof n;
} : function(n) {
  return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
}, yr = (typeof window > "u" ? "undefined" : Yf(window)) === "object" && (typeof document > "u" ? "undefined" : Yf(document)) === "object" && document.nodeType === 9;
function zf(n, e) {
  for (var o = 0; o < e.length; o++) {
    var a = e[o];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, Ip(a.key), a);
  }
}
function bu(n, e, o) {
  return e && zf(n.prototype, e), o && zf(n, o), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function _l(n, e) {
  return _l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, i) {
    return a.__proto__ = i, a;
  }, _l(n, e);
}
function Gi(n, e) {
  n.prototype = Object.create(e.prototype), n.prototype.constructor = n, _l(n, e);
}
function Fl(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
var RC = {}.constructor;
function Il(n) {
  if (n == null || typeof n != "object")
    return n;
  if (Array.isArray(n))
    return n.map(Il);
  if (n.constructor !== RC)
    return n;
  var e = {};
  for (var o in n)
    e[o] = Il(n[o]);
  return e;
}
function pu(n, e, o) {
  n === void 0 && (n = "unnamed");
  var a = o.jss, i = Il(e), s = a.plugins.onCreateRule(n, i, o);
  return s || (n[0] === "@" && process.env.NODE_ENV !== "production" && Co(!1, "[JSS] Unknown rule " + n), null);
}
var Gf = function(e, o) {
  for (var a = "", i = 0; i < e.length && e[i] !== "!important"; i++)
    a && (a += o), a += e[i];
  return a;
}, $t = function(e) {
  if (!Array.isArray(e))
    return e;
  var o = "";
  if (Array.isArray(e[0]))
    for (var a = 0; a < e.length && e[a] !== "!important"; a++)
      o && (o += ", "), o += Gf(e[a], " ");
  else
    o = Gf(e, ", ");
  return e[e.length - 1] === "!important" && (o += " !important"), o;
};
function Ka(n) {
  return n && n.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function nr(n, e) {
  for (var o = "", a = 0; a < e; a++)
    o += "  ";
  return o + n;
}
function br(n, e, o) {
  o === void 0 && (o = {});
  var a = "";
  if (!e)
    return a;
  var i = o, s = i.indent, c = s === void 0 ? 0 : s, u = e.fallbacks;
  o.format === !1 && (c = -1 / 0);
  var A = Ka(o), b = A.linebreak, h = A.space;
  if (n && c++, u)
    if (Array.isArray(u))
      for (var m = 0; m < u.length; m++) {
        var E = u[m];
        for (var y in E) {
          var k = E[y];
          k != null && (a && (a += b), a += nr(y + ":" + h + $t(k) + ";", c));
        }
      }
    else
      for (var w in u) {
        var _ = u[w];
        _ != null && (a && (a += b), a += nr(w + ":" + h + $t(_) + ";", c));
      }
  for (var O in e) {
    var F = e[O];
    F != null && O !== "fallbacks" && (a && (a += b), a += nr(O + ":" + h + $t(F) + ";", c));
  }
  return !a && !o.allowEmpty || !n ? a : (c--, a && (a = "" + b + a + b), nr("" + n + h + "{" + a, c) + nr("}", c));
}
var BC = /([[\].#*$><+~=|^:(),"'`\s])/g, Zf = typeof CSS < "u" && CSS.escape, hu = function(n) {
  return Zf ? Zf(n) : n.replace(BC, "\\$1");
}, Mp = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "style", this.isProcessed = !1;
    var s = i.sheet, c = i.Renderer;
    this.key = o, this.options = i, this.style = a, s ? this.renderer = s.renderer : c && (this.renderer = new c());
  }
  var e = n.prototype;
  return e.prop = function(a, i, s) {
    if (i === void 0)
      return this.style[a];
    var c = s ? s.force : !1;
    if (!c && this.style[a] === i)
      return this;
    var u = i;
    (!s || s.process !== !1) && (u = this.options.jss.plugins.onChangeValue(i, a, this));
    var A = u == null || u === !1, b = a in this.style;
    if (A && !b && !c)
      return this;
    var h = A && b;
    if (h ? delete this.style[a] : this.style[a] = u, this.renderable && this.renderer)
      return h ? this.renderer.removeProperty(this.renderable, a) : this.renderer.setProperty(this.renderable, a, u), this;
    var m = this.options.sheet;
    return m && m.attached && process.env.NODE_ENV !== "production" && Co(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, n;
}(), Tl = /* @__PURE__ */ function(n) {
  Gi(e, n);
  function e(a, i, s) {
    var c;
    c = n.call(this, a, i, s) || this;
    var u = s.selector, A = s.scoped, b = s.sheet, h = s.generateId;
    return u ? c.selectorText = u : A !== !1 && (c.id = h(Fl(Fl(c)), b), c.selectorText = "." + hu(c.id)), c;
  }
  var o = e.prototype;
  return o.applyTo = function(i) {
    var s = this.renderer;
    if (s) {
      var c = this.toJSON();
      for (var u in c)
        s.setProperty(i, u, c[u]);
    }
    return this;
  }, o.toJSON = function() {
    var i = {};
    for (var s in this.style) {
      var c = this.style[s];
      typeof c != "object" ? i[s] = c : Array.isArray(c) && (i[s] = $t(c));
    }
    return i;
  }, o.toString = function(i) {
    var s = this.options.sheet, c = s ? s.options.link : !1, u = c ? j({}, i, {
      allowEmpty: !0
    }) : i;
    return br(this.selectorText, this.style, u);
  }, bu(e, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var s = this.renderer, c = this.renderable;
        if (!(!c || !s)) {
          var u = s.setSelector(c, i);
          u || s.replaceRule(c, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), e;
}(Mp), _C = {
  onCreateRule: function(e, o, a) {
    return e[0] === "@" || a.parent && a.parent.type === "keyframes" ? null : new Tl(e, o, a);
  }
}, Mc = {
  indent: 1,
  children: !0
}, FC = /@([\w-]+)/, IC = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = o;
    var s = o.match(FC);
    this.at = s ? s[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new Zi(j({}, i, {
      parent: this
    }));
    for (var c in a)
      this.rules.add(c, a[c]);
    this.rules.process();
  }
  var e = n.prototype;
  return e.getRule = function(a) {
    return this.rules.get(a);
  }, e.indexOf = function(a) {
    return this.rules.indexOf(a);
  }, e.addRule = function(a, i, s) {
    var c = this.rules.add(a, i, s);
    return c ? (this.options.jss.plugins.onProcessRule(c), c) : null;
  }, e.replaceRule = function(a, i, s) {
    var c = this.rules.replace(a, i, s);
    return c && this.options.jss.plugins.onProcessRule(c), c;
  }, e.toString = function(a) {
    a === void 0 && (a = Mc);
    var i = Ka(a), s = i.linebreak;
    if (a.indent == null && (a.indent = Mc.indent), a.children == null && (a.children = Mc.children), a.children === !1)
      return this.query + " {}";
    var c = this.rules.toString(a);
    return c ? this.query + " {" + s + c + s + "}" : "";
  }, n;
}(), TC = /@container|@media|@supports\s+/, OC = {
  onCreateRule: function(e, o, a) {
    return TC.test(e) ? new IC(e, o, a) : null;
  }
}, jc = {
  indent: 1,
  children: !0
}, UC = /@keyframes\s+([\w-]+)/, Ol = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var s = o.match(UC);
    s && s[1] ? this.name = s[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Co(!1, "[JSS] Bad keyframes name " + o)), this.key = this.type + "-" + this.name, this.options = i;
    var c = i.scoped, u = i.sheet, A = i.generateId;
    this.id = c === !1 ? this.name : hu(A(this, u)), this.rules = new Zi(j({}, i, {
      parent: this
    }));
    for (var b in a)
      this.rules.add(b, a[b], j({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var e = n.prototype;
  return e.toString = function(a) {
    a === void 0 && (a = jc);
    var i = Ka(a), s = i.linebreak;
    if (a.indent == null && (a.indent = jc.indent), a.children == null && (a.children = jc.children), a.children === !1)
      return this.at + " " + this.id + " {}";
    var c = this.rules.toString(a);
    return c && (c = "" + s + c + s), this.at + " " + this.id + " {" + c + "}";
  }, n;
}(), KC = /@keyframes\s+/, PC = /\$([\w-]+)/g, Ul = function(e, o) {
  return typeof e == "string" ? e.replace(PC, function(a, i) {
    return i in o ? o[i] : (process.env.NODE_ENV !== "production" && Co(!1, '[JSS] Referenced keyframes rule "' + i + '" is not defined.'), a);
  }) : e;
}, Jf = function(e, o, a) {
  var i = e[o], s = Ul(i, a);
  s !== i && (e[o] = s);
}, DC = {
  onCreateRule: function(e, o, a) {
    return typeof e == "string" && KC.test(e) ? new Ol(e, o, a) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(e, o, a) {
    return o.type !== "style" || !a || ("animation-name" in e && Jf(e, "animation-name", a.keyframes), "animation" in e && Jf(e, "animation", a.keyframes)), e;
  },
  onChangeValue: function(e, o, a) {
    var i = a.options.sheet;
    if (!i)
      return e;
    switch (o) {
      case "animation":
        return Ul(e, i.keyframes);
      case "animation-name":
        return Ul(e, i.keyframes);
      default:
        return e;
    }
  }
}, LC = /* @__PURE__ */ function(n) {
  Gi(e, n);
  function e() {
    return n.apply(this, arguments) || this;
  }
  var o = e.prototype;
  return o.toString = function(i) {
    var s = this.options.sheet, c = s ? s.options.link : !1, u = c ? j({}, i, {
      allowEmpty: !0
    }) : i;
    return br(this.key, this.style, u);
  }, e;
}(Mp), NC = {
  onCreateRule: function(e, o, a) {
    return a.parent && a.parent.type === "keyframes" ? new LC(e, o, a) : null;
  }
}, MC = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = o, this.style = a, this.options = i;
  }
  var e = n.prototype;
  return e.toString = function(a) {
    var i = Ka(a), s = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var c = "", u = 0; u < this.style.length; u++)
        c += br(this.at, this.style[u]), this.style[u + 1] && (c += s);
      return c;
    }
    return br(this.at, this.style, a);
  }, n;
}(), jC = /@font-face/, $C = {
  onCreateRule: function(e, o, a) {
    return jC.test(e) ? new MC(e, o, a) : null;
  }
}, QC = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = o, this.style = a, this.options = i;
  }
  var e = n.prototype;
  return e.toString = function(a) {
    return br(this.key, this.style, a);
  }, n;
}(), HC = {
  onCreateRule: function(e, o, a) {
    return e === "@viewport" || e === "@-ms-viewport" ? new QC(e, o, a) : null;
  }
}, VC = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "simple", this.isProcessed = !1, this.key = o, this.value = a, this.options = i;
  }
  var e = n.prototype;
  return e.toString = function(a) {
    if (Array.isArray(this.value)) {
      for (var i = "", s = 0; s < this.value.length; s++)
        i += this.key + " " + this.value[s] + ";", this.value[s + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, n;
}(), qC = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, WC = {
  onCreateRule: function(e, o, a) {
    return e in qC ? new VC(e, o, a) : null;
  }
}, Xf = [_C, OC, DC, NC, $C, HC, WC], YC = {
  process: !0
}, eb = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Zi = /* @__PURE__ */ function() {
  function n(o) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = o, this.classes = o.classes, this.keyframes = o.keyframes;
  }
  var e = n.prototype;
  return e.add = function(a, i, s) {
    var c = this.options, u = c.parent, A = c.sheet, b = c.jss, h = c.Renderer, m = c.generateId, E = c.scoped, y = j({
      classes: this.classes,
      parent: u,
      sheet: A,
      jss: b,
      Renderer: h,
      generateId: m,
      scoped: E,
      name: a,
      keyframes: this.keyframes,
      selector: void 0
    }, s), k = a;
    a in this.raw && (k = a + "-d" + this.counter++), this.raw[k] = i, k in this.classes && (y.selector = "." + hu(this.classes[k]));
    var w = pu(k, i, y);
    if (!w)
      return null;
    this.register(w);
    var _ = y.index === void 0 ? this.index.length : y.index;
    return this.index.splice(_, 0, w), w;
  }, e.replace = function(a, i, s) {
    var c = this.get(a), u = this.index.indexOf(c);
    c && this.remove(c);
    var A = s;
    return u !== -1 && (A = j({}, s, {
      index: u
    })), this.add(a, i, A);
  }, e.get = function(a) {
    return this.map[a];
  }, e.remove = function(a) {
    this.unregister(a), delete this.raw[a.key], this.index.splice(this.index.indexOf(a), 1);
  }, e.indexOf = function(a) {
    return this.index.indexOf(a);
  }, e.process = function() {
    var a = this.options.jss.plugins;
    this.index.slice(0).forEach(a.onProcessRule, a);
  }, e.register = function(a) {
    this.map[a.key] = a, a instanceof Tl ? (this.map[a.selector] = a, a.id && (this.classes[a.key] = a.id)) : a instanceof Ol && this.keyframes && (this.keyframes[a.name] = a.id);
  }, e.unregister = function(a) {
    delete this.map[a.key], a instanceof Tl ? (delete this.map[a.selector], delete this.classes[a.key]) : a instanceof Ol && delete this.keyframes[a.name];
  }, e.update = function() {
    var a, i, s;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (a = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], s = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], s = arguments.length <= 1 ? void 0 : arguments[1], a = null), a)
      this.updateOne(this.get(a), i, s);
    else
      for (var c = 0; c < this.index.length; c++)
        this.updateOne(this.index[c], i, s);
  }, e.updateOne = function(a, i, s) {
    s === void 0 && (s = YC);
    var c = this.options, u = c.jss.plugins, A = c.sheet;
    if (a.rules instanceof n) {
      a.rules.update(i, s);
      return;
    }
    var b = a.style;
    if (u.onUpdate(i, a, A, s), s.process && b && b !== a.style) {
      u.onProcessStyle(a.style, a, A);
      for (var h in a.style) {
        var m = a.style[h], E = b[h];
        m !== E && a.prop(h, m, eb);
      }
      for (var y in b) {
        var k = a.style[y], w = b[y];
        k == null && k !== w && a.prop(y, null, eb);
      }
    }
  }, e.toString = function(a) {
    for (var i = "", s = this.options.sheet, c = s ? s.options.link : !1, u = Ka(a), A = u.linebreak, b = 0; b < this.index.length; b++) {
      var h = this.index[b], m = h.toString(a);
      !m && !c || (i && (i += A), i += m);
    }
    return i;
  }, n;
}(), jp = /* @__PURE__ */ function() {
  function n(o, a) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = j({}, a, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), a.Renderer && (this.renderer = new a.Renderer(this)), this.rules = new Zi(this.options);
    for (var i in o)
      this.rules.add(i, o[i]);
    this.rules.process();
  }
  var e = n.prototype;
  return e.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, e.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, e.addRule = function(a, i, s) {
    var c = this.queue;
    this.attached && !c && (this.queue = []);
    var u = this.rules.add(a, i, s);
    return u ? (this.options.jss.plugins.onProcessRule(u), this.attached ? (this.deployed && (c ? c.push(u) : (this.insertRule(u), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), u) : (this.deployed = !1, u)) : null;
  }, e.replaceRule = function(a, i, s) {
    var c = this.rules.get(a);
    if (!c)
      return this.addRule(a, i, s);
    var u = this.rules.replace(a, i, s);
    return u && this.options.jss.plugins.onProcessRule(u), this.attached ? (this.deployed && this.renderer && (u ? c.renderable && this.renderer.replaceRule(c.renderable, u) : this.renderer.deleteRule(c)), u) : (this.deployed = !1, u);
  }, e.insertRule = function(a) {
    this.renderer && this.renderer.insertRule(a);
  }, e.addRules = function(a, i) {
    var s = [];
    for (var c in a) {
      var u = this.addRule(c, a[c], i);
      u && s.push(u);
    }
    return s;
  }, e.getRule = function(a) {
    return this.rules.get(a);
  }, e.deleteRule = function(a) {
    var i = typeof a == "object" ? a : this.rules.get(a);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, e.indexOf = function(a) {
    return this.rules.indexOf(a);
  }, e.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, e.update = function() {
    var a;
    return (a = this.rules).update.apply(a, arguments), this;
  }, e.updateOne = function(a, i, s) {
    return this.rules.updateOne(a, i, s), this;
  }, e.toString = function(a) {
    return this.rules.toString(a);
  }, n;
}(), zC = /* @__PURE__ */ function() {
  function n() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var e = n.prototype;
  return e.onCreateRule = function(a, i, s) {
    for (var c = 0; c < this.registry.onCreateRule.length; c++) {
      var u = this.registry.onCreateRule[c](a, i, s);
      if (u)
        return u;
    }
    return null;
  }, e.onProcessRule = function(a) {
    if (!a.isProcessed) {
      for (var i = a.options.sheet, s = 0; s < this.registry.onProcessRule.length; s++)
        this.registry.onProcessRule[s](a, i);
      a.style && this.onProcessStyle(a.style, a, i), a.isProcessed = !0;
    }
  }, e.onProcessStyle = function(a, i, s) {
    for (var c = 0; c < this.registry.onProcessStyle.length; c++)
      i.style = this.registry.onProcessStyle[c](i.style, i, s);
  }, e.onProcessSheet = function(a) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](a);
  }, e.onUpdate = function(a, i, s, c) {
    for (var u = 0; u < this.registry.onUpdate.length; u++)
      this.registry.onUpdate[u](a, i, s, c);
  }, e.onChangeValue = function(a, i, s) {
    for (var c = a, u = 0; u < this.registry.onChangeValue.length; u++)
      c = this.registry.onChangeValue[u](c, i, s);
    return c;
  }, e.use = function(a, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var s = this.plugins[i.queue];
    s.indexOf(a) === -1 && (s.push(a), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(c, u) {
      for (var A in u)
        A in c ? c[A].push(u[A]) : process.env.NODE_ENV !== "production" && Co(!1, '[JSS] Unknown hook "' + A + '".');
      return c;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, n;
}(), GC = /* @__PURE__ */ function() {
  function n() {
    this.registry = [];
  }
  var e = n.prototype;
  return e.add = function(a) {
    var i = this.registry, s = a.options.index;
    if (i.indexOf(a) === -1) {
      if (i.length === 0 || s >= this.index) {
        i.push(a);
        return;
      }
      for (var c = 0; c < i.length; c++)
        if (i[c].options.index > s) {
          i.splice(c, 0, a);
          return;
        }
    }
  }, e.reset = function() {
    this.registry = [];
  }, e.remove = function(a) {
    var i = this.registry.indexOf(a);
    this.registry.splice(i, 1);
  }, e.toString = function(a) {
    for (var i = a === void 0 ? {} : a, s = i.attached, c = Wi(i, ["attached"]), u = Ka(c), A = u.linebreak, b = "", h = 0; h < this.registry.length; h++) {
      var m = this.registry[h];
      s != null && m.attached !== s || (b && (b += A), b += m.toString(c));
    }
    return b;
  }, bu(n, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), n;
}(), ur = new GC(), Kl = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Pl = "2f1acc6c3a606b082e5eef5e54414ffb";
Kl[Pl] == null && (Kl[Pl] = 0);
var nb = Kl[Pl]++, ZC = 1e10, ob = function(e) {
  e === void 0 && (e = {});
  var o = 0, a = function(s, c) {
    o += 1, o > ZC && process.env.NODE_ENV !== "production" && Co(!1, "[JSS] You might have a memory leak. Rule counter is at " + o + ".");
    var u = "", A = "";
    return c && (c.options.classNamePrefix && (A = c.options.classNamePrefix), c.options.jss.id != null && (u = String(c.options.jss.id))), e.minify ? "" + (A || "c") + nb + u + o : A + s.key + "-" + nb + (u ? "-" + u : "") + "-" + o;
  };
  return a;
}, $p = function(e) {
  var o;
  return function() {
    return o || (o = e()), o;
  };
}, JC = function(e, o) {
  try {
    return e.attributeStyleMap ? e.attributeStyleMap.get(o) : e.style.getPropertyValue(o);
  } catch {
    return "";
  }
}, XC = function(e, o, a) {
  try {
    var i = a;
    if (Array.isArray(a) && (i = $t(a)), e.attributeStyleMap)
      e.attributeStyleMap.set(o, i);
    else {
      var s = i ? i.indexOf("!important") : -1, c = s > -1 ? i.substr(0, s - 1) : i;
      e.style.setProperty(o, c, s > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, e6 = function(e, o) {
  try {
    e.attributeStyleMap ? e.attributeStyleMap.delete(o) : e.style.removeProperty(o);
  } catch (a) {
    process.env.NODE_ENV !== "production" && Co(!1, '[JSS] DOMException "' + a.message + '" was thrown. Tried to remove property "' + o + '".');
  }
}, n6 = function(e, o) {
  return e.selectorText = o, e.selectorText === o;
}, Qp = $p(function() {
  return document.querySelector("head");
});
function o6(n, e) {
  for (var o = 0; o < n.length; o++) {
    var a = n[o];
    if (a.attached && a.options.index > e.index && a.options.insertionPoint === e.insertionPoint)
      return a;
  }
  return null;
}
function t6(n, e) {
  for (var o = n.length - 1; o >= 0; o--) {
    var a = n[o];
    if (a.attached && a.options.insertionPoint === e.insertionPoint)
      return a;
  }
  return null;
}
function a6(n) {
  for (var e = Qp(), o = 0; o < e.childNodes.length; o++) {
    var a = e.childNodes[o];
    if (a.nodeType === 8 && a.nodeValue.trim() === n)
      return a;
  }
  return null;
}
function r6(n) {
  var e = ur.registry;
  if (e.length > 0) {
    var o = o6(e, n);
    if (o && o.renderer)
      return {
        parent: o.renderer.element.parentNode,
        node: o.renderer.element
      };
    if (o = t6(e, n), o && o.renderer)
      return {
        parent: o.renderer.element.parentNode,
        node: o.renderer.element.nextSibling
      };
  }
  var a = n.insertionPoint;
  if (a && typeof a == "string") {
    var i = a6(a);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
    process.env.NODE_ENV !== "production" && Co(!1, '[JSS] Insertion point "' + a + '" not found.');
  }
  return !1;
}
function i6(n, e) {
  var o = e.insertionPoint, a = r6(e);
  if (a !== !1 && a.parent) {
    a.parent.insertBefore(n, a.node);
    return;
  }
  if (o && typeof o.nodeType == "number") {
    var i = o, s = i.parentNode;
    s ? s.insertBefore(n, i.nextSibling) : process.env.NODE_ENV !== "production" && Co(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  Qp().appendChild(n);
}
var s6 = $p(function() {
  var n = document.querySelector('meta[property="csp-nonce"]');
  return n ? n.getAttribute("content") : null;
}), tb = function(e, o, a) {
  try {
    "insertRule" in e ? e.insertRule(o, a) : "appendRule" in e && e.appendRule(o);
  } catch (i) {
    return process.env.NODE_ENV !== "production" && Co(!1, "[JSS] " + i.message), !1;
  }
  return e.cssRules[a];
}, ab = function(e, o) {
  var a = e.cssRules.length;
  return o === void 0 || o > a ? a : o;
}, c6 = function() {
  var e = document.createElement("style");
  return e.textContent = `
`, e;
}, l6 = /* @__PURE__ */ function() {
  function n(o) {
    this.getPropertyValue = JC, this.setProperty = XC, this.removeProperty = e6, this.setSelector = n6, this.hasInsertedRules = !1, this.cssRules = [], o && ur.add(o), this.sheet = o;
    var a = this.sheet ? this.sheet.options : {}, i = a.media, s = a.meta, c = a.element;
    this.element = c || c6(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), s && this.element.setAttribute("data-meta", s);
    var u = s6();
    u && this.element.setAttribute("nonce", u);
  }
  var e = n.prototype;
  return e.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      i6(this.element, this.sheet.options);
      var a = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && a && (this.hasInsertedRules = !1, this.deploy());
    }
  }, e.detach = function() {
    if (this.sheet) {
      var a = this.element.parentNode;
      a && a.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, e.deploy = function() {
    var a = this.sheet;
    if (a) {
      if (a.options.link) {
        this.insertRules(a.rules);
        return;
      }
      this.element.textContent = `
` + a.toString() + `
`;
    }
  }, e.insertRules = function(a, i) {
    for (var s = 0; s < a.index.length; s++)
      this.insertRule(a.index[s], s, i);
  }, e.insertRule = function(a, i, s) {
    if (s === void 0 && (s = this.element.sheet), a.rules) {
      var c = a, u = s;
      if (a.type === "conditional" || a.type === "keyframes") {
        var A = ab(s, i);
        if (u = tb(s, c.toString({
          children: !1
        }), A), u === !1)
          return !1;
        this.refCssRule(a, A, u);
      }
      return this.insertRules(c.rules, u), u;
    }
    var b = a.toString();
    if (!b)
      return !1;
    var h = ab(s, i), m = tb(s, b, h);
    return m === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(a, h, m), m);
  }, e.refCssRule = function(a, i, s) {
    a.renderable = s, a.options.parent instanceof jp && this.cssRules.splice(i, 0, s);
  }, e.deleteRule = function(a) {
    var i = this.element.sheet, s = this.indexOf(a);
    return s === -1 ? !1 : (i.deleteRule(s), this.cssRules.splice(s, 1), !0);
  }, e.indexOf = function(a) {
    return this.cssRules.indexOf(a);
  }, e.replaceRule = function(a, i) {
    var s = this.indexOf(a);
    return s === -1 ? !1 : (this.element.sheet.deleteRule(s), this.cssRules.splice(s, 1), this.insertRule(i, s));
  }, e.getRules = function() {
    return this.element.sheet.cssRules;
  }, n;
}(), u6 = 0, A6 = /* @__PURE__ */ function() {
  function n(o) {
    this.id = u6++, this.version = "10.10.0", this.plugins = new zC(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: ob,
      Renderer: yr ? l6 : null,
      plugins: []
    }, this.generateId = ob({
      minify: !1
    });
    for (var a = 0; a < Xf.length; a++)
      this.plugins.use(Xf[a], {
        queue: "internal"
      });
    this.setup(o);
  }
  var e = n.prototype;
  return e.setup = function(a) {
    return a === void 0 && (a = {}), a.createGenerateId && (this.options.createGenerateId = a.createGenerateId), a.id && (this.options.id = j({}, this.options.id, a.id)), (a.createGenerateId || a.id) && (this.generateId = this.options.createGenerateId(this.options.id)), a.insertionPoint != null && (this.options.insertionPoint = a.insertionPoint), "Renderer" in a && (this.options.Renderer = a.Renderer), a.plugins && this.use.apply(this, a.plugins), this;
  }, e.createStyleSheet = function(a, i) {
    i === void 0 && (i = {});
    var s = i, c = s.index;
    typeof c != "number" && (c = ur.index === 0 ? 0 : ur.index + 1);
    var u = new jp(a, j({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: c
    }));
    return this.plugins.onProcessSheet(u), u;
  }, e.removeStyleSheet = function(a) {
    return a.detach(), ur.remove(a), this;
  }, e.createRule = function(a, i, s) {
    if (i === void 0 && (i = {}), s === void 0 && (s = {}), typeof a == "object")
      return this.createRule(void 0, a, i);
    var c = j({}, s, {
      name: a,
      jss: this,
      Renderer: this.options.Renderer
    });
    c.generateId || (c.generateId = this.generateId), c.classes || (c.classes = {}), c.keyframes || (c.keyframes = {});
    var u = pu(a, i, c);
    return u && this.plugins.onProcessRule(u), u;
  }, e.use = function() {
    for (var a = this, i = arguments.length, s = new Array(i), c = 0; c < i; c++)
      s[c] = arguments[c];
    return s.forEach(function(u) {
      a.plugins.use(u);
    }), this;
  }, n;
}(), gu = function(e) {
  return new A6(e);
}, mu = typeof CSS == "object" && CSS != null && "number" in CSS;
function Hp(n) {
  var e = null;
  for (var o in n) {
    var a = n[o], i = typeof a;
    if (i === "function")
      e || (e = {}), e[o] = a;
    else if (i === "object" && a !== null && !Array.isArray(a)) {
      var s = Hp(a);
      s && (e || (e = {}), e[o] = s);
    }
  }
  return e;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
gu();
var Vp = Date.now(), $c = "fnValues" + Vp, Qc = "fnStyle" + ++Vp, d6 = function() {
  return {
    onCreateRule: function(o, a, i) {
      if (typeof a != "function")
        return null;
      var s = pu(o, {}, i);
      return s[Qc] = a, s;
    },
    onProcessStyle: function(o, a) {
      if ($c in a || Qc in a)
        return o;
      var i = {};
      for (var s in o) {
        var c = o[s];
        typeof c == "function" && (delete o[s], i[s] = c);
      }
      return a[$c] = i, o;
    },
    onUpdate: function(o, a, i, s) {
      var c = a, u = c[Qc];
      if (u && (c.style = u(o) || {}, process.env.NODE_ENV === "development")) {
        for (var A in c.style)
          if (typeof c.style[A] == "function") {
            process.env.NODE_ENV !== "production" && Co(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var b = c[$c];
      if (b)
        for (var h in b)
          c.prop(h, b[h](o), s);
    }
  };
}, bt = "@global", Dl = "@global ", f6 = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "global", this.at = bt, this.isProcessed = !1, this.key = o, this.options = i, this.rules = new Zi(j({}, i, {
      parent: this
    }));
    for (var s in a)
      this.rules.add(s, a[s]);
    this.rules.process();
  }
  var e = n.prototype;
  return e.getRule = function(a) {
    return this.rules.get(a);
  }, e.addRule = function(a, i, s) {
    var c = this.rules.add(a, i, s);
    return c && this.options.jss.plugins.onProcessRule(c), c;
  }, e.replaceRule = function(a, i, s) {
    var c = this.rules.replace(a, i, s);
    return c && this.options.jss.plugins.onProcessRule(c), c;
  }, e.indexOf = function(a) {
    return this.rules.indexOf(a);
  }, e.toString = function(a) {
    return this.rules.toString(a);
  }, n;
}(), b6 = /* @__PURE__ */ function() {
  function n(o, a, i) {
    this.type = "global", this.at = bt, this.isProcessed = !1, this.key = o, this.options = i;
    var s = o.substr(Dl.length);
    this.rule = i.jss.createRule(s, a, j({}, i, {
      parent: this
    }));
  }
  var e = n.prototype;
  return e.toString = function(a) {
    return this.rule ? this.rule.toString(a) : "";
  }, n;
}(), p6 = /\s*,\s*/g;
function qp(n, e) {
  for (var o = n.split(p6), a = "", i = 0; i < o.length; i++)
    a += e + " " + o[i].trim(), o[i + 1] && (a += ", ");
  return a;
}
function h6(n, e) {
  var o = n.options, a = n.style, i = a ? a[bt] : null;
  if (i) {
    for (var s in i)
      e.addRule(s, i[s], j({}, o, {
        selector: qp(s, n.selector)
      }));
    delete a[bt];
  }
}
function g6(n, e) {
  var o = n.options, a = n.style;
  for (var i in a)
    if (!(i[0] !== "@" || i.substr(0, bt.length) !== bt)) {
      var s = qp(i.substr(bt.length), n.selector);
      e.addRule(s, a[i], j({}, o, {
        selector: s
      })), delete a[i];
    }
}
function m6() {
  function n(o, a, i) {
    if (!o)
      return null;
    if (o === bt)
      return new f6(o, a, i);
    if (o[0] === "@" && o.substr(0, Dl.length) === Dl)
      return new b6(o, a, i);
    var s = i.parent;
    return s && (s.type === "global" || s.options.parent && s.options.parent.type === "global") && (i.scoped = !1), !i.selector && i.scoped === !1 && (i.selector = o), null;
  }
  function e(o, a) {
    o.type !== "style" || !a || (h6(o, a), g6(o, a));
  }
  return {
    onCreateRule: n,
    onProcessRule: e
  };
}
var rb = /\s*,\s*/g, v6 = /&/g, y6 = /\$([\w-]+)/g;
function x6() {
  function n(i, s) {
    return function(c, u) {
      var A = i.getRule(u) || s && s.getRule(u);
      return A ? A.selector : (process.env.NODE_ENV !== "production" && Co(!1, '[JSS] Could not find the referenced rule "' + u + '" in "' + (i.options.meta || i.toString()) + '".'), u);
    };
  }
  function e(i, s) {
    for (var c = s.split(rb), u = i.split(rb), A = "", b = 0; b < c.length; b++)
      for (var h = c[b], m = 0; m < u.length; m++) {
        var E = u[m];
        A && (A += ", "), A += E.indexOf("&") !== -1 ? E.replace(v6, h) : h + " " + E;
      }
    return A;
  }
  function o(i, s, c) {
    if (c)
      return j({}, c, {
        index: c.index + 1
      });
    var u = i.options.nestingLevel;
    u = u === void 0 ? 1 : u + 1;
    var A = j({}, i.options, {
      nestingLevel: u,
      index: s.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete A.name, A;
  }
  function a(i, s, c) {
    if (s.type !== "style")
      return i;
    var u = s, A = u.options.parent, b, h;
    for (var m in i) {
      var E = m.indexOf("&") !== -1, y = m[0] === "@";
      if (!(!E && !y)) {
        if (b = o(u, A, b), E) {
          var k = e(m, u.selector);
          h || (h = n(A, c)), k = k.replace(y6, h);
          var w = u.key + "-" + m;
          "replaceRule" in A ? A.replaceRule(w, i[m], j({}, b, {
            selector: k
          })) : A.addRule(w, i[m], j({}, b, {
            selector: k
          }));
        } else
          y && A.addRule(m, {}, b).addRule(u.key, i[m], {
            selector: u.selector
          });
        delete i[m];
      }
    }
    return i;
  }
  return {
    onProcessStyle: a
  };
}
var C6 = /[A-Z]/g, w6 = /^ms-/, Hc = {};
function E6(n) {
  return "-" + n.toLowerCase();
}
function Wp(n) {
  if (Hc.hasOwnProperty(n))
    return Hc[n];
  var e = n.replace(C6, E6);
  return Hc[n] = w6.test(e) ? "-" + e : e;
}
function Ii(n) {
  var e = {};
  for (var o in n) {
    var a = o.indexOf("--") === 0 ? o : Wp(o);
    e[a] = n[o];
  }
  return n.fallbacks && (Array.isArray(n.fallbacks) ? e.fallbacks = n.fallbacks.map(Ii) : e.fallbacks = Ii(n.fallbacks)), e;
}
function k6() {
  function n(o) {
    if (Array.isArray(o)) {
      for (var a = 0; a < o.length; a++)
        o[a] = Ii(o[a]);
      return o;
    }
    return Ii(o);
  }
  function e(o, a, i) {
    if (a.indexOf("--") === 0)
      return o;
    var s = Wp(a);
    return a === s ? o : (i.prop(s, o), null);
  }
  return {
    onProcessStyle: n,
    onChangeValue: e
  };
}
var V = mu && CSS ? CSS.px : "px", mi = mu && CSS ? CSS.ms : "ms", da = mu && CSS ? CSS.percent : "%", S6 = {
  // Animation properties
  "animation-delay": mi,
  "animation-duration": mi,
  // Background properties
  "background-position": V,
  "background-position-x": V,
  "background-position-y": V,
  "background-size": V,
  // Border Properties
  border: V,
  "border-bottom": V,
  "border-bottom-left-radius": V,
  "border-bottom-right-radius": V,
  "border-bottom-width": V,
  "border-left": V,
  "border-left-width": V,
  "border-radius": V,
  "border-right": V,
  "border-right-width": V,
  "border-top": V,
  "border-top-left-radius": V,
  "border-top-right-radius": V,
  "border-top-width": V,
  "border-width": V,
  "border-block": V,
  "border-block-end": V,
  "border-block-end-width": V,
  "border-block-start": V,
  "border-block-start-width": V,
  "border-block-width": V,
  "border-inline": V,
  "border-inline-end": V,
  "border-inline-end-width": V,
  "border-inline-start": V,
  "border-inline-start-width": V,
  "border-inline-width": V,
  "border-start-start-radius": V,
  "border-start-end-radius": V,
  "border-end-start-radius": V,
  "border-end-end-radius": V,
  // Margin properties
  margin: V,
  "margin-bottom": V,
  "margin-left": V,
  "margin-right": V,
  "margin-top": V,
  "margin-block": V,
  "margin-block-end": V,
  "margin-block-start": V,
  "margin-inline": V,
  "margin-inline-end": V,
  "margin-inline-start": V,
  // Padding properties
  padding: V,
  "padding-bottom": V,
  "padding-left": V,
  "padding-right": V,
  "padding-top": V,
  "padding-block": V,
  "padding-block-end": V,
  "padding-block-start": V,
  "padding-inline": V,
  "padding-inline-end": V,
  "padding-inline-start": V,
  // Mask properties
  "mask-position-x": V,
  "mask-position-y": V,
  "mask-size": V,
  // Width and height properties
  height: V,
  width: V,
  "min-height": V,
  "max-height": V,
  "min-width": V,
  "max-width": V,
  // Position properties
  bottom: V,
  left: V,
  top: V,
  right: V,
  inset: V,
  "inset-block": V,
  "inset-block-end": V,
  "inset-block-start": V,
  "inset-inline": V,
  "inset-inline-end": V,
  "inset-inline-start": V,
  // Shadow properties
  "box-shadow": V,
  "text-shadow": V,
  // Column properties
  "column-gap": V,
  "column-rule": V,
  "column-rule-width": V,
  "column-width": V,
  // Font and text properties
  "font-size": V,
  "font-size-delta": V,
  "letter-spacing": V,
  "text-decoration-thickness": V,
  "text-indent": V,
  "text-stroke": V,
  "text-stroke-width": V,
  "word-spacing": V,
  // Motion properties
  motion: V,
  "motion-offset": V,
  // Outline properties
  outline: V,
  "outline-offset": V,
  "outline-width": V,
  // Perspective properties
  perspective: V,
  "perspective-origin-x": da,
  "perspective-origin-y": da,
  // Transform properties
  "transform-origin": da,
  "transform-origin-x": da,
  "transform-origin-y": da,
  "transform-origin-z": da,
  // Transition properties
  "transition-delay": mi,
  "transition-duration": mi,
  // Alignment properties
  "vertical-align": V,
  "flex-basis": V,
  // Some random properties
  "shape-margin": V,
  size: V,
  gap: V,
  // Grid properties
  grid: V,
  "grid-gap": V,
  "row-gap": V,
  "grid-row-gap": V,
  "grid-column-gap": V,
  "grid-template-rows": V,
  "grid-template-columns": V,
  "grid-auto-rows": V,
  "grid-auto-columns": V,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": V,
  "box-shadow-y": V,
  "box-shadow-blur": V,
  "box-shadow-spread": V,
  "font-line-height": V,
  "text-shadow-x": V,
  "text-shadow-y": V,
  "text-shadow-blur": V
};
function Yp(n) {
  var e = /(-[a-z])/g, o = function(c) {
    return c[1].toUpperCase();
  }, a = {};
  for (var i in n)
    a[i] = n[i], a[i.replace(e, o)] = n[i];
  return a;
}
var R6 = Yp(S6);
function Ar(n, e, o) {
  if (e == null)
    return e;
  if (Array.isArray(e))
    for (var a = 0; a < e.length; a++)
      e[a] = Ar(n, e[a], o);
  else if (typeof e == "object")
    if (n === "fallbacks")
      for (var i in e)
        e[i] = Ar(i, e[i], o);
    else
      for (var s in e)
        e[s] = Ar(n + "-" + s, e[s], o);
  else if (typeof e == "number" && isNaN(e) === !1) {
    var c = o[n] || R6[n];
    return c && !(e === 0 && c === V) ? typeof c == "function" ? c(e).toString() : "" + e + c : e.toString();
  }
  return e;
}
function B6(n) {
  n === void 0 && (n = {});
  var e = Yp(n);
  function o(i, s) {
    if (s.type !== "style")
      return i;
    for (var c in i)
      i[c] = Ar(c, i[c], e);
    return i;
  }
  function a(i, s) {
    return Ar(s, i, e);
  }
  return {
    onProcessStyle: o,
    onChangeValue: a
  };
}
function Ll(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var o = 0, a = new Array(e); o < e; o++)
    a[o] = n[o];
  return a;
}
function _6(n) {
  if (Array.isArray(n))
    return Ll(n);
}
function F6(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
    return Array.from(n);
}
function zp(n, e) {
  if (n) {
    if (typeof n == "string")
      return Ll(n, e);
    var o = Object.prototype.toString.call(n).slice(8, -1);
    if (o === "Object" && n.constructor && (o = n.constructor.name), o === "Map" || o === "Set")
      return Array.from(n);
    if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
      return Ll(n, e);
  }
}
function I6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vt(n) {
  return _6(n) || F6(n) || zp(n) || I6();
}
var ir = "", Nl = "", Gp = "", Zp = "", T6 = yr && "ontouchstart" in document.documentElement;
if (yr) {
  var Vc = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, O6 = document.createElement("p"), qc = O6.style, U6 = "Transform";
  for (var Wc in Vc)
    if (Wc + U6 in qc) {
      ir = Wc, Nl = Vc[Wc];
      break;
    }
  ir === "Webkit" && "msHyphens" in qc && (ir = "ms", Nl = Vc.ms, Zp = "edge"), ir === "Webkit" && "-apple-trailing-word" in qc && (Gp = "apple");
}
var Te = {
  js: ir,
  css: Nl,
  vendor: Gp,
  browser: Zp,
  isTouch: T6
};
function K6(n) {
  return n[1] === "-" || Te.js === "ms" ? n : "@" + Te.css + "keyframes" + n.substr(10);
}
var P6 = {
  noPrefill: ["appearance"],
  supportedProperty: function(e) {
    return e !== "appearance" ? !1 : Te.js === "ms" ? "-webkit-" + e : Te.css + e;
  }
}, D6 = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(e) {
    return e !== "color-adjust" ? !1 : Te.js === "Webkit" ? Te.css + "print-" + e : e;
  }
}, L6 = /[-\s]+(.)?/g;
function N6(n, e) {
  return e ? e.toUpperCase() : "";
}
function vu(n) {
  return n.replace(L6, N6);
}
function pt(n) {
  return vu("-" + n);
}
var M6 = {
  noPrefill: ["mask"],
  supportedProperty: function(e, o) {
    if (!/^mask/.test(e))
      return !1;
    if (Te.js === "Webkit") {
      var a = "mask-image";
      if (vu(a) in o)
        return e;
      if (Te.js + pt(a) in o)
        return Te.css + e;
    }
    return e;
  }
}, j6 = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(e) {
    return e !== "text-orientation" ? !1 : Te.vendor === "apple" && !Te.isTouch ? Te.css + e : e;
  }
}, $6 = {
  noPrefill: ["transform"],
  supportedProperty: function(e, o, a) {
    return e !== "transform" ? !1 : a.transform ? e : Te.css + e;
  }
}, Q6 = {
  noPrefill: ["transition"],
  supportedProperty: function(e, o, a) {
    return e !== "transition" ? !1 : a.transition ? e : Te.css + e;
  }
}, H6 = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(e) {
    return e !== "writing-mode" ? !1 : Te.js === "Webkit" || Te.js === "ms" && Te.browser !== "edge" ? Te.css + e : e;
  }
}, V6 = {
  noPrefill: ["user-select"],
  supportedProperty: function(e) {
    return e !== "user-select" ? !1 : Te.js === "Moz" || Te.js === "ms" || Te.vendor === "apple" ? Te.css + e : e;
  }
}, q6 = {
  supportedProperty: function(e, o) {
    if (!/^break-/.test(e))
      return !1;
    if (Te.js === "Webkit") {
      var a = "WebkitColumn" + pt(e);
      return a in o ? Te.css + "column-" + e : !1;
    }
    if (Te.js === "Moz") {
      var i = "page" + pt(e);
      return i in o ? "page-" + e : !1;
    }
    return !1;
  }
}, W6 = {
  supportedProperty: function(e, o) {
    if (!/^(border|margin|padding)-inline/.test(e))
      return !1;
    if (Te.js === "Moz")
      return e;
    var a = e.replace("-inline", "");
    return Te.js + pt(a) in o ? Te.css + a : !1;
  }
}, Y6 = {
  supportedProperty: function(e, o) {
    return vu(e) in o ? e : !1;
  }
}, z6 = {
  supportedProperty: function(e, o) {
    var a = pt(e);
    return e[0] === "-" || e[0] === "-" && e[1] === "-" ? e : Te.js + a in o ? Te.css + e : Te.js !== "Webkit" && "Webkit" + a in o ? "-webkit-" + e : !1;
  }
}, G6 = {
  supportedProperty: function(e) {
    return e.substring(0, 11) !== "scroll-snap" ? !1 : Te.js === "ms" ? "" + Te.css + e : e;
  }
}, Z6 = {
  supportedProperty: function(e) {
    return e !== "overscroll-behavior" ? !1 : Te.js === "ms" ? Te.css + "scroll-chaining" : e;
  }
}, J6 = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, X6 = {
  supportedProperty: function(e, o) {
    var a = J6[e];
    return a && Te.js + pt(a) in o ? Te.css + a : !1;
  }
}, Jp = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, ew = Object.keys(Jp), nw = function(e) {
  return Te.css + e;
}, ow = {
  supportedProperty: function(e, o, a) {
    var i = a.multiple;
    if (ew.indexOf(e) > -1) {
      var s = Jp[e];
      if (!Array.isArray(s))
        return Te.js + pt(s) in o ? Te.css + s : !1;
      if (!i)
        return !1;
      for (var c = 0; c < s.length; c++)
        if (!(Te.js + pt(s[0]) in o))
          return !1;
      return s.map(nw);
    }
    return !1;
  }
}, Xp = [P6, D6, M6, j6, $6, Q6, H6, V6, q6, W6, Y6, z6, G6, Z6, X6, ow], ib = Xp.filter(function(n) {
  return n.supportedProperty;
}).map(function(n) {
  return n.supportedProperty;
}), tw = Xp.filter(function(n) {
  return n.noPrefill;
}).reduce(function(n, e) {
  return n.push.apply(n, Vt(e.noPrefill)), n;
}, []), sr, Dt = {};
if (yr) {
  sr = document.createElement("p");
  var Yc = window.getComputedStyle(document.documentElement, "");
  for (var zc in Yc)
    isNaN(zc) || (Dt[Yc[zc]] = Yc[zc]);
  tw.forEach(function(n) {
    return delete Dt[n];
  });
}
function Ml(n, e) {
  if (e === void 0 && (e = {}), !sr)
    return n;
  if (process.env.NODE_ENV !== "benchmark" && Dt[n] != null)
    return Dt[n];
  (n === "transition" || n === "transform") && (e[n] = n in sr.style);
  for (var o = 0; o < ib.length && (Dt[n] = ib[o](n, sr.style, e), !Dt[n]); o++)
    ;
  try {
    sr.style[n] = "";
  } catch {
    return !1;
  }
  return Dt[n];
}
var fa = {}, aw = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, rw = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, lt;
function iw(n, e, o) {
  if (e === "var")
    return "var";
  if (e === "all")
    return "all";
  if (o === "all")
    return ", all";
  var a = e ? Ml(e) : ", " + Ml(o);
  return a || e || o;
}
yr && (lt = document.createElement("p"));
function sb(n, e) {
  var o = e;
  if (!lt || n === "content")
    return e;
  if (typeof o != "string" || !isNaN(parseInt(o, 10)))
    return o;
  var a = n + o;
  if (process.env.NODE_ENV !== "benchmark" && fa[a] != null)
    return fa[a];
  try {
    lt.style[n] = o;
  } catch {
    return fa[a] = !1, !1;
  }
  if (aw[n])
    o = o.replace(rw, iw);
  else if (lt.style[n] === "" && (o = Te.css + o, o === "-ms-flex" && (lt.style[n] = "-ms-flexbox"), lt.style[n] = o, lt.style[n] === ""))
    return fa[a] = !1, !1;
  return lt.style[n] = "", fa[a] = o, fa[a];
}
function sw() {
  function n(i) {
    if (i.type === "keyframes") {
      var s = i;
      s.at = K6(s.at);
    }
  }
  function e(i) {
    for (var s in i) {
      var c = i[s];
      if (s === "fallbacks" && Array.isArray(c)) {
        i[s] = c.map(e);
        continue;
      }
      var u = !1, A = Ml(s);
      A && A !== s && (u = !0);
      var b = !1, h = sb(A, $t(c));
      h && h !== c && (b = !0), (u || b) && (u && delete i[s], i[A || s] = h || c);
    }
    return i;
  }
  function o(i, s) {
    return s.type !== "style" ? i : e(i);
  }
  function a(i, s) {
    return sb(s, $t(i)) || i;
  }
  return {
    onProcessRule: n,
    onProcessStyle: o,
    onChangeValue: a
  };
}
function cw() {
  var n = function(o, a) {
    return o.length === a.length ? o > a ? 1 : -1 : o.length - a.length;
  };
  return {
    onProcessStyle: function(o, a) {
      if (a.type !== "style")
        return o;
      for (var i = {}, s = Object.keys(o).sort(n), c = 0; c < s.length; c++)
        i[s[c]] = o[s[c]];
      return i;
    }
  };
}
function eh() {
  return {
    plugins: [
      d6(),
      m6(),
      x6(),
      k6(),
      B6(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : sw(),
      cw()
    ]
  };
}
function nh() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = n.baseClasses, o = n.newClasses, a = n.Component;
  if (!o)
    return e;
  var i = j({}, e);
  return process.env.NODE_ENV !== "production" && typeof o == "string" ? (console.error(["Material-UI: The value `".concat(o, "` ") + "provided to the classes prop of ".concat(jt(a), " is incorrect."), "You might want to use the className prop instead."].join(`
`)), e) : (Object.keys(o).forEach(function(s) {
    process.env.NODE_ENV !== "production" && (!e[s] && o[s] && console.error(["Material-UI: The key `".concat(s, "` ") + "provided to the classes prop is not implemented in ".concat(jt(a), "."), "You can only override one of the following: ".concat(Object.keys(e).join(","), ".")].join(`
`)), o[s] && typeof o[s] != "string" && console.error(["Material-UI: The key `".concat(s, "` ") + "provided to the classes prop is not valid for ".concat(jt(a), "."), "You need to provide a non empty string instead of: ".concat(o[s], ".")].join(`
`))), o[s] && (i[s] = "".concat(e[s], " ").concat(o[s]));
  }), i);
}
var lw = {
  set: function(e, o, a, i) {
    var s = e.get(o);
    s || (s = /* @__PURE__ */ new Map(), e.set(o, s)), s.set(a, i);
  },
  get: function(e, o, a) {
    var i = e.get(o);
    return i ? i.get(a) : void 0;
  },
  delete: function(e, o, a) {
    var i = e.get(o);
    i.delete(a);
  }
};
const ma = lw;
var oh = C.createContext(null);
process.env.NODE_ENV !== "production" && (oh.displayName = "ThemeContext");
const th = oh;
function Yt() {
  var n = C.useContext(th);
  return process.env.NODE_ENV !== "production" && C.useDebugValue(n), n;
}
var uw = gu(eh()), Aw = kC(), dw = /* @__PURE__ */ new Map(), fw = {
  disableGeneration: !1,
  generateClassName: Aw,
  jss: uw,
  sheetsCache: null,
  sheetsManager: dw,
  sheetsRegistry: null
}, Ti = C.createContext(fw);
process.env.NODE_ENV !== "production" && (Ti.displayName = "StylesContext");
var vi;
function jl(n) {
  var e = n.children, o = n.injectFirst, a = o === void 0 ? !1 : o, i = n.disableGeneration, s = i === void 0 ? !1 : i, c = xe(n, ["children", "injectFirst", "disableGeneration"]), u = C.useContext(Ti), A = j({}, u, {
    disableGeneration: s
  }, c);
  if (process.env.NODE_ENV !== "production" && typeof window > "u" && !A.sheetsManager && console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && A.jss.options.insertionPoint && a && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && a && c.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !A.jss.options.insertionPoint && a && typeof window < "u") {
    if (!vi) {
      var b = document.head;
      vi = document.createComment("mui-inject-first"), b.insertBefore(vi, b.firstChild);
    }
    A.jss = gu({
      plugins: eh().plugins,
      insertionPoint: vi
    });
  }
  return /* @__PURE__ */ C.createElement(Ti.Provider, {
    value: A
  }, e);
}
process.env.NODE_ENV !== "production" && (jl.propTypes = {
  /**
   * Your component tree.
   */
  children: f.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: f.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: f.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: f.bool,
  /**
   * JSS's instance.
   */
  jss: f.object,
  /**
   * @ignore
   */
  serverGenerateClassName: f.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: f.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: f.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: f.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (jl.propTypes = vr(jl.propTypes));
var Gc = -1e9;
function bw() {
  return Gc += 1, process.env.NODE_ENV !== "production" && Gc >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), Gc;
}
var pw = {};
const ah = pw;
function hw(n) {
  var e = typeof n == "function";
  return process.env.NODE_ENV !== "production" && zo(n) !== "object" && !e && console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: function(a, i) {
      var s;
      try {
        s = e ? n(a) : n;
      } catch (A) {
        throw process.env.NODE_ENV !== "production" && e === !0 && a === ah && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), A;
      }
      if (!i || !a.overrides || !a.overrides[i])
        return s;
      var c = a.overrides[i], u = j({}, s);
      return Object.keys(c).forEach(function(A) {
        process.env.NODE_ENV !== "production" && (u[A] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(A, "` key of `theme.overrides.").concat(i, "`.")].join(`
`))), u[A] = Ht(u[A], c[A]);
      }), u;
    },
    options: {}
  };
}
function gw(n, e, o) {
  var a = n.state, i = n.stylesOptions;
  if (i.disableGeneration)
    return e || {};
  a.cacheClasses || (a.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var s = !1;
  return a.classes !== a.cacheClasses.lastJSS && (a.cacheClasses.lastJSS = a.classes, s = !0), e !== a.cacheClasses.lastProp && (a.cacheClasses.lastProp = e, s = !0), s && (a.cacheClasses.value = nh({
    baseClasses: a.cacheClasses.lastJSS,
    newClasses: e,
    Component: o
  })), a.cacheClasses.value;
}
function mw(n, e) {
  var o = n.state, a = n.theme, i = n.stylesOptions, s = n.stylesCreator, c = n.name;
  if (!i.disableGeneration) {
    var u = ma.get(i.sheetsManager, s, a);
    u || (u = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, ma.set(i.sheetsManager, s, a, u));
    var A = j({}, s.options, i, {
      theme: a,
      flip: typeof i.flip == "boolean" ? i.flip : a.direction === "rtl"
    });
    A.generateId = A.serverGenerateClassName || A.generateClassName;
    var b = i.sheetsRegistry;
    if (u.refs === 0) {
      var h;
      i.sheetsCache && (h = ma.get(i.sheetsCache, s, a));
      var m = s.create(a, c);
      h || (h = i.jss.createStyleSheet(m, j({
        link: !1
      }, A)), h.attach(), i.sheetsCache && ma.set(i.sheetsCache, s, a, h)), b && b.add(h), u.staticSheet = h, u.dynamicStyles = Hp(m);
    }
    if (u.dynamicStyles) {
      var E = i.jss.createStyleSheet(u.dynamicStyles, j({
        link: !0
      }, A));
      E.update(e), E.attach(), o.dynamicSheet = E, o.classes = nh({
        baseClasses: u.staticSheet.classes,
        newClasses: E.classes
      }), b && b.add(E);
    } else
      o.classes = u.staticSheet.classes;
    u.refs += 1;
  }
}
function vw(n, e) {
  var o = n.state;
  o.dynamicSheet && o.dynamicSheet.update(e);
}
function yw(n) {
  var e = n.state, o = n.theme, a = n.stylesOptions, i = n.stylesCreator;
  if (!a.disableGeneration) {
    var s = ma.get(a.sheetsManager, i, o);
    s.refs -= 1;
    var c = a.sheetsRegistry;
    s.refs === 0 && (ma.delete(a.sheetsManager, i, o), a.jss.removeStyleSheet(s.staticSheet), c && c.remove(s.staticSheet)), e.dynamicSheet && (a.jss.removeStyleSheet(e.dynamicSheet), c && c.remove(e.dynamicSheet));
  }
}
function xw(n, e) {
  var o = C.useRef([]), a, i = C.useMemo(function() {
    return {};
  }, e);
  o.current !== i && (o.current = i, a = n()), C.useEffect(
    function() {
      return function() {
        a && a();
      };
    },
    [i]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function yu(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = e.name, a = e.classNamePrefix, i = e.Component, s = e.defaultTheme, c = s === void 0 ? ah : s, u = xe(e, ["name", "classNamePrefix", "Component", "defaultTheme"]), A = hw(n), b = o || a || "makeStyles";
  A.options = {
    index: bw(),
    name: o,
    meta: b,
    classNamePrefix: b
  };
  var h = function() {
    var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y = Yt() || c, k = j({}, C.useContext(Ti), u), w = C.useRef(), _ = C.useRef();
    xw(function() {
      var F = {
        name: o,
        state: {},
        stylesCreator: A,
        stylesOptions: k,
        theme: y
      };
      return mw(F, E), _.current = !1, w.current = F, function() {
        yw(F);
      };
    }, [y, A]), C.useEffect(function() {
      _.current && vw(w.current, E), _.current = !0;
    });
    var O = gw(w.current, E.classes, i);
    return process.env.NODE_ENV !== "production" && C.useDebugValue(O), O;
  };
  return h;
}
function Cw(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function rh(n) {
  var e, o, a = "";
  if (typeof n == "string" || typeof n == "number")
    a += n;
  else if (typeof n == "object")
    if (Array.isArray(n))
      for (e = 0; e < n.length; e++)
        n[e] && (o = rh(n[e])) && (a && (a += " "), a += o);
    else
      for (e in n)
        n[e] && (a && (a += " "), a += e);
  return a;
}
function Se() {
  for (var n, e, o = 0, a = ""; o < arguments.length; )
    (n = arguments[o++]) && (e = rh(n)) && (a && (a += " "), a += e);
  return a;
}
var xu = Yi(), ww = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Ew = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, kw = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ih = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Cu = {};
Cu[xu.ForwardRef] = kw;
Cu[xu.Memo] = ih;
function cb(n) {
  return xu.isMemo(n) ? ih : Cu[n.$$typeof] || ww;
}
var Sw = Object.defineProperty, Rw = Object.getOwnPropertyNames, lb = Object.getOwnPropertySymbols, Bw = Object.getOwnPropertyDescriptor, _w = Object.getPrototypeOf, ub = Object.prototype;
function sh(n, e, o) {
  if (typeof e != "string") {
    if (ub) {
      var a = _w(e);
      a && a !== ub && sh(n, a, o);
    }
    var i = Rw(e);
    lb && (i = i.concat(lb(e)));
    for (var s = cb(n), c = cb(e), u = 0; u < i.length; ++u) {
      var A = i[u];
      if (!Ew[A] && !(o && o[A]) && !(c && c[A]) && !(s && s[A])) {
        var b = Bw(e, A);
        try {
          Sw(n, A, b);
        } catch {
        }
      }
    }
  }
  return n;
}
var Fw = sh;
const wu = /* @__PURE__ */ Ua(Fw);
function Iw(n, e) {
  var o = {};
  return Object.keys(n).forEach(function(a) {
    e.indexOf(a) === -1 && (o[a] = n[a]);
  }), o;
}
function Tw(n) {
  var e = function(a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = i.name, c = xe(i, ["name"]);
    if (process.env.NODE_ENV !== "production" && n === void 0)
      throw new Error(["You are calling styled(Component)(style) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var u = s;
    if (process.env.NODE_ENV !== "production" && !s) {
      var A = jt(n);
      A !== void 0 && (u = A);
    }
    var b = typeof a == "function" ? function(k) {
      return {
        root: function(_) {
          return a(j({
            theme: k
          }, _));
        }
      };
    } : {
      root: a
    }, h = yu(b, j({
      Component: n,
      name: s || n.displayName,
      classNamePrefix: u
    }, c)), m, E = {};
    a.filterProps && (m = a.filterProps, delete a.filterProps), a.propTypes && (E = a.propTypes, delete a.propTypes);
    var y = /* @__PURE__ */ C.forwardRef(function(w, _) {
      var O = w.children, F = w.className, P = w.clone, M = w.component, B = xe(w, ["children", "className", "clone", "component"]), D = h(w), H = Se(D.root, F), X = B;
      if (m && (X = Iw(X, m)), P)
        return /* @__PURE__ */ C.cloneElement(O, j({
          className: Se(O.props.className, H)
        }, X));
      if (typeof O == "function")
        return O(j({
          className: H
        }, X));
      var ce = M || n;
      return /* @__PURE__ */ C.createElement(ce, j({
        ref: _,
        className: H
      }, X), O);
    });
    return process.env.NODE_ENV !== "production" && (y.propTypes = j({
      /**
       * A render function or node.
       */
      children: f.oneOfType([f.node, f.func]),
      /**
       * @ignore
       */
      className: f.string,
      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: xo(f.bool, function(k) {
        return k.clone && k.component ? new Error("You can not use the clone and component prop at the same time.") : null;
      }),
      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: f.elementType
    }, E)), process.env.NODE_ENV !== "production" && (y.displayName = "Styled(".concat(u, ")")), wu(y, n), y;
  };
  return e;
}
function Ow(n, e) {
  if (typeof e == "function") {
    var o = e(n);
    return process.env.NODE_ENV !== "production" && (o || console.error(["Material-UI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), o;
  }
  return j({}, n, e);
}
function pr(n) {
  var e = n.children, o = n.theme, a = Yt();
  process.env.NODE_ENV !== "production" && a === null && typeof o == "function" && console.error(["Material-UI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  var i = C.useMemo(function() {
    var s = a === null ? o : Ow(a, o);
    return s != null && (s[Np] = a !== null), s;
  }, [o, a]);
  return /* @__PURE__ */ C.createElement(th.Provider, {
    value: i
  }, e);
}
process.env.NODE_ENV !== "production" && (pr.propTypes = {
  /**
   * Your component tree.
   */
  children: f.node.isRequired,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: f.oneOfType([f.object, f.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (pr.propTypes = vr(pr.propTypes));
var Uw = function(e) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(a) {
    var i = o.defaultTheme, s = o.withTheme, c = s === void 0 ? !1 : s, u = o.name, A = xe(o, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production" && a === void 0)
      throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var b = u;
    if (process.env.NODE_ENV !== "production" && !u) {
      var h = jt(a);
      h !== void 0 && (b = h);
    }
    var m = yu(e, j({
      defaultTheme: i,
      Component: a,
      name: u || a.displayName,
      classNamePrefix: b
    }, A)), E = /* @__PURE__ */ C.forwardRef(function(k, w) {
      k.classes;
      var _ = k.innerRef, O = xe(k, ["classes", "innerRef"]), F = m(j({}, a.defaultProps, k)), P, M = O;
      return (typeof u == "string" || c) && (P = Yt() || i, u && (M = zi({
        theme: P,
        name: u,
        props: O
      })), c && !M.theme && (M.theme = P)), /* @__PURE__ */ C.createElement(a, j({
        ref: _ || w,
        classes: F
      }, M));
    });
    return process.env.NODE_ENV !== "production" && (E.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: f.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: xo(f.oneOfType([f.func, f.object]), function(y) {
        return y.innerRef == null, null;
      })
    }), process.env.NODE_ENV !== "production" && (E.displayName = "WithStyles(".concat(jt(a), ")")), wu(E, a), process.env.NODE_ENV !== "production" && (E.Naked = a, E.options = o, E.useStyles = m), E;
  };
}, Kw = fu();
const Ji = Kw;
function wo(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return yu(n, j({
    defaultTheme: Ji
  }, e));
}
var Pw = function(e) {
  var o = Tw(e);
  return function(a, i) {
    return o(a, j({
      defaultTheme: Ji
    }, i));
  };
};
function Zo() {
  return Yt() || Ji;
}
function $e(n, e) {
  return Uw(n, j({
    defaultTheme: Ji
  }, e));
}
function en(n) {
  if (process.env.NODE_ENV !== "production" && typeof n != "string")
    throw new Error("Material-UI: capitalize(string) expects a string argument.");
  return n.charAt(0).toUpperCase() + n.slice(1);
}
var Dw = function(e) {
  var o = {};
  return e.shadows.forEach(function(a, i) {
    o["elevation".concat(i)] = {
      boxShadow: a
    };
  }), j({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: e.palette.background.paper,
      color: e.palette.text.primary,
      transition: e.transitions.create("box-shadow")
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: e.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="outlined"` */
    outlined: {
      border: "1px solid ".concat(e.palette.divider)
    }
  }, o);
}, ch = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.component, c = s === void 0 ? "div" : s, u = e.square, A = u === void 0 ? !1 : u, b = e.elevation, h = b === void 0 ? 1 : b, m = e.variant, E = m === void 0 ? "elevation" : m, y = xe(e, ["classes", "className", "component", "square", "elevation", "variant"]);
  return process.env.NODE_ENV !== "production" && a["elevation".concat(h)] === void 0 && console.error("Material-UI: this elevation `".concat(h, "` is not implemented.")), C.createElement(c, j({
    className: Se(a.root, i, E === "outlined" ? a.outlined : a["elevation".concat(h)], !A && a.rounded),
    ref: o
  }, y));
});
process.env.NODE_ENV !== "production" && (ch.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: f.number,
  /**
   * If `true`, rounded corners are disabled.
   */
  square: f.bool,
  /**
   * The variant to use.
   */
  variant: f.oneOf(["elevation", "outlined"])
});
const Xi = $e(Dw, {
  name: "MuiPaper"
})(ch);
var Lw = function(e) {
  var o = e.palette.type === "light" ? e.palette.grey[100] : e.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      boxSizing: "border-box",
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: e.zIndex.appBar,
      flexShrink: 0
    },
    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: "fixed",
      top: 0,
      left: "auto",
      right: 0,
      "@media print": {
        // Prevent the app bar to be visible on each printed page.
        position: "absolute"
      }
    },
    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: "absolute",
      top: 0,
      left: "auto",
      right: 0
    },
    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: "sticky",
      top: 0,
      left: "auto",
      right: 0
    },
    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: "static",
      transform: "translateZ(0)"
      // Make sure we can see the elevation.
    },
    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: "relative"
    },
    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: o,
      color: e.palette.getContrastText(o)
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: e.palette.primary.main,
      color: e.palette.primary.contrastText
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: e.palette.secondary.main,
      color: e.palette.secondary.contrastText
    }
  };
}, lh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.color, c = s === void 0 ? "primary" : s, u = e.position, A = u === void 0 ? "fixed" : u, b = xe(e, ["classes", "className", "color", "position"]);
  return C.createElement(Xi, j({
    square: !0,
    component: "header",
    elevation: 4,
    className: Se(a.root, a["position".concat(en(A))], i, c !== "inherit" && a["color".concat(en(c))], {
      fixed: "mui-fixed"
    }[A]),
    ref: o
  }, b));
});
process.env.NODE_ENV !== "production" && (lh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: f.oneOf(["default", "inherit", "primary", "secondary"]),
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: f.oneOf(["absolute", "fixed", "relative", "static", "sticky"])
});
const Nw = $e(Lw, {
  name: "MuiAppBar"
})(lh);
var Mw = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: e.typography.pxToRem(24),
      transition: e.transitions.create("fill", {
        duration: e.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: e.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: e.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: e.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: e.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: e.typography.pxToRem(35)
    }
  };
}, Eu = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.color, u = c === void 0 ? "inherit" : c, A = e.component, b = A === void 0 ? "svg" : A, h = e.fontSize, m = h === void 0 ? "default" : h, E = e.htmlColor, y = e.titleAccess, k = e.viewBox, w = k === void 0 ? "0 0 24 24" : k, _ = xe(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return C.createElement(b, j({
    className: Se(i.root, s, u !== "inherit" && i["color".concat(en(u))], m !== "default" && i["fontSize".concat(en(m))]),
    focusable: "false",
    viewBox: w,
    color: E,
    "aria-hidden": y ? null : "true",
    role: y ? "img" : "presentation",
    ref: o
  }, _), a, y ? C.createElement("title", null, y) : null);
});
process.env.NODE_ENV !== "production" && (Eu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: f.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: f.oneOf(["default", "inherit", "large", "small"]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: f.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: f.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: f.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: f.string
});
Eu.muiName = "SvgIcon";
const $l = $e(Mw, {
  name: "MuiSvgIcon"
})(Eu), jw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $l
}, Symbol.toStringTag, { value: "Module" }));
function $w(n, e) {
  var o = C.memo(C.forwardRef(function(a, i) {
    return C.createElement($l, j({}, a, {
      ref: i
    }), n);
  }));
  return process.env.NODE_ENV !== "production" && (o.displayName = "".concat(e, "Icon")), o.muiName = $l.muiName, o;
}
const Ab = {
  disabled: !1
};
var Qw = process.env.NODE_ENV !== "production" ? f.oneOfType([f.number, f.shape({
  enter: f.number,
  exit: f.number,
  appear: f.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && f.oneOfType([f.string, f.shape({
  enter: f.string,
  exit: f.string,
  active: f.string
}), f.shape({
  enter: f.string,
  enterDone: f.string,
  enterActive: f.string,
  exit: f.string,
  exitDone: f.string,
  exitActive: f.string
})]);
const Oi = C.createContext(null);
var Hw = function(e) {
  return e.scrollTop;
}, cr = "unmounted", Ot = "exited", Ut = "entering", ha = "entered", Ql = "exiting", Jo = /* @__PURE__ */ function(n) {
  Gi(e, n);
  function e(a, i) {
    var s;
    s = n.call(this, a, i) || this;
    var c = i, u = c && !c.isMounting ? a.enter : a.appear, A;
    return s.appearStatus = null, a.in ? u ? (A = Ot, s.appearStatus = Ut) : A = ha : a.unmountOnExit || a.mountOnEnter ? A = cr : A = Ot, s.state = {
      status: A
    }, s.nextCallback = null, s;
  }
  e.getDerivedStateFromProps = function(i, s) {
    var c = i.in;
    return c && s.status === cr ? {
      status: Ot
    } : null;
  };
  var o = e.prototype;
  return o.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, o.componentDidUpdate = function(i) {
    var s = null;
    if (i !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== Ut && c !== ha && (s = Ut) : (c === Ut || c === ha) && (s = Ql);
    }
    this.updateStatus(!1, s);
  }, o.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, o.getTimeouts = function() {
    var i = this.props.timeout, s, c, u;
    return s = c = u = i, i != null && typeof i != "number" && (s = i.exit, c = i.enter, u = i.appear !== void 0 ? i.appear : c), {
      exit: s,
      enter: c,
      appear: u
    };
  }, o.updateStatus = function(i, s) {
    if (i === void 0 && (i = !1), s !== null)
      if (this.cancelNextCallback(), s === Ut) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : co.findDOMNode(this);
          c && Hw(c);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === Ot && this.setState({
        status: cr
      });
  }, o.performEnter = function(i) {
    var s = this, c = this.props.enter, u = this.context ? this.context.isMounting : i, A = this.props.nodeRef ? [u] : [co.findDOMNode(this), u], b = A[0], h = A[1], m = this.getTimeouts(), E = u ? m.appear : m.enter;
    if (!i && !c || Ab.disabled) {
      this.safeSetState({
        status: ha
      }, function() {
        s.props.onEntered(b);
      });
      return;
    }
    this.props.onEnter(b, h), this.safeSetState({
      status: Ut
    }, function() {
      s.props.onEntering(b, h), s.onTransitionEnd(E, function() {
        s.safeSetState({
          status: ha
        }, function() {
          s.props.onEntered(b, h);
        });
      });
    });
  }, o.performExit = function() {
    var i = this, s = this.props.exit, c = this.getTimeouts(), u = this.props.nodeRef ? void 0 : co.findDOMNode(this);
    if (!s || Ab.disabled) {
      this.safeSetState({
        status: Ot
      }, function() {
        i.props.onExited(u);
      });
      return;
    }
    this.props.onExit(u), this.safeSetState({
      status: Ql
    }, function() {
      i.props.onExiting(u), i.onTransitionEnd(c.exit, function() {
        i.safeSetState({
          status: Ot
        }, function() {
          i.props.onExited(u);
        });
      });
    });
  }, o.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, o.safeSetState = function(i, s) {
    s = this.setNextCallback(s), this.setState(i, s);
  }, o.setNextCallback = function(i) {
    var s = this, c = !0;
    return this.nextCallback = function(u) {
      c && (c = !1, s.nextCallback = null, i(u));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, o.onTransitionEnd = function(i, s) {
    this.setNextCallback(s);
    var c = this.props.nodeRef ? this.props.nodeRef.current : co.findDOMNode(this), u = i == null && !this.props.addEndListener;
    if (!c || u) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var A = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], b = A[0], h = A[1];
      this.props.addEndListener(b, h);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, o.render = function() {
    var i = this.state.status;
    if (i === cr)
      return null;
    var s = this.props, c = s.children;
    s.in, s.mountOnEnter, s.unmountOnExit, s.appear, s.enter, s.exit, s.timeout, s.addEndListener, s.onEnter, s.onEntering, s.onEntered, s.onExit, s.onExiting, s.onExited, s.nodeRef;
    var u = Wi(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ C.createElement(Oi.Provider, {
        value: null
      }, typeof c == "function" ? c(i, u) : C.cloneElement(C.Children.only(c), u))
    );
  }, e;
}(C.Component);
Jo.contextType = Oi;
Jo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: f.shape({
    current: typeof Element > "u" ? f.any : function(n, e, o, a, i, s) {
      var c = n[e];
      return f.instanceOf(c && "ownerDocument" in c ? c.ownerDocument.defaultView.Element : Element)(n, e, o, a, i, s);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: f.oneOfType([f.func.isRequired, f.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: f.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: f.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: f.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: f.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: f.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: f.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var o = Qw;
    e.addEndListener || (o = o.isRequired);
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++)
      i[s - 1] = arguments[s];
    return o.apply(void 0, [e].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: f.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: f.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: f.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: f.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: f.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: f.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: f.func
} : {};
function ba() {
}
Jo.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: ba,
  onEntering: ba,
  onEntered: ba,
  onExit: ba,
  onExiting: ba,
  onExited: ba
};
Jo.UNMOUNTED = cr;
Jo.EXITED = Ot;
Jo.ENTERING = Ut;
Jo.ENTERED = ha;
Jo.EXITING = Ql;
const uh = Jo;
function ku(n, e) {
  var o = function(s) {
    return e && wi(s) ? e(s) : s;
  }, a = /* @__PURE__ */ Object.create(null);
  return n && Px.map(n, function(i) {
    return i;
  }).forEach(function(i) {
    a[i.key] = o(i);
  }), a;
}
function Vw(n, e) {
  n = n || {}, e = e || {};
  function o(h) {
    return h in e ? e[h] : n[h];
  }
  var a = /* @__PURE__ */ Object.create(null), i = [];
  for (var s in n)
    s in e ? i.length && (a[s] = i, i = []) : i.push(s);
  var c, u = {};
  for (var A in e) {
    if (a[A])
      for (c = 0; c < a[A].length; c++) {
        var b = a[A][c];
        u[a[A][c]] = o(b);
      }
    u[A] = o(A);
  }
  for (c = 0; c < i.length; c++)
    u[i[c]] = o(i[c]);
  return u;
}
function Lt(n, e, o) {
  return o[e] != null ? o[e] : n.props[e];
}
function qw(n, e) {
  return ku(n.children, function(o) {
    return Ei(o, {
      onExited: e.bind(null, o),
      in: !0,
      appear: Lt(o, "appear", n),
      enter: Lt(o, "enter", n),
      exit: Lt(o, "exit", n)
    });
  });
}
function Ww(n, e, o) {
  var a = ku(n.children), i = Vw(e, a);
  return Object.keys(i).forEach(function(s) {
    var c = i[s];
    if (wi(c)) {
      var u = s in e, A = s in a, b = e[s], h = wi(b) && !b.props.in;
      A && (!u || h) ? i[s] = Ei(c, {
        onExited: o.bind(null, c),
        in: !0,
        exit: Lt(c, "exit", n),
        enter: Lt(c, "enter", n)
      }) : !A && u && !h ? i[s] = Ei(c, {
        in: !1
      }) : A && u && wi(b) && (i[s] = Ei(c, {
        onExited: o.bind(null, c),
        in: b.props.in,
        exit: Lt(c, "exit", n),
        enter: Lt(c, "enter", n)
      }));
    }
  }), i;
}
var Yw = Object.values || function(n) {
  return Object.keys(n).map(function(e) {
    return n[e];
  });
}, zw = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, Su = /* @__PURE__ */ function(n) {
  Gi(e, n);
  function e(a, i) {
    var s;
    s = n.call(this, a, i) || this;
    var c = s.handleExited.bind(Fl(s));
    return s.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: c,
      firstRender: !0
    }, s;
  }
  var o = e.prototype;
  return o.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, o.componentWillUnmount = function() {
    this.mounted = !1;
  }, e.getDerivedStateFromProps = function(i, s) {
    var c = s.children, u = s.handleExited, A = s.firstRender;
    return {
      children: A ? qw(i, u) : Ww(i, c, u),
      firstRender: !1
    };
  }, o.handleExited = function(i, s) {
    var c = ku(this.props.children);
    i.key in c || (i.props.onExited && i.props.onExited(s), this.mounted && this.setState(function(u) {
      var A = j({}, u.children);
      return delete A[i.key], {
        children: A
      };
    }));
  }, o.render = function() {
    var i = this.props, s = i.component, c = i.childFactory, u = Wi(i, ["component", "childFactory"]), A = this.state.contextValue, b = Yw(this.state.children).map(c);
    return delete u.appear, delete u.enter, delete u.exit, s === null ? /* @__PURE__ */ C.createElement(Oi.Provider, {
      value: A
    }, b) : /* @__PURE__ */ C.createElement(Oi.Provider, {
      value: A
    }, /* @__PURE__ */ C.createElement(s, u, b));
  }, e;
}(C.Component);
Su.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: f.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: f.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: f.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: f.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: f.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: f.func
} : {};
Su.defaultProps = zw;
const Gw = Su;
var Ah = function(e) {
  return e.scrollTop;
};
function Ui(n, e) {
  var o = n.timeout, a = n.style, i = a === void 0 ? {} : a;
  return {
    duration: i.transitionDuration || typeof o == "number" ? o : o[e.mode] || 0,
    delay: i.transitionDelay
  };
}
function ka(n, e) {
  typeof n == "function" ? n(e) : n && (n.current = e);
}
function Nn(n, e) {
  return C.useMemo(function() {
    return n == null && e == null ? null : function(o) {
      ka(n, o), ka(e, o);
    };
  }, [n, e]);
}
var Zw = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Jw = {
  enter: Ea.enteringScreen,
  exit: Ea.leavingScreen
}, dh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.in, s = e.onEnter, c = e.onExit, u = e.style, A = e.timeout, b = A === void 0 ? Jw : A, h = xe(e, ["children", "in", "onEnter", "onExit", "style", "timeout"]), m = Zo(), E = Nn(a.ref, o), y = function(_, O) {
    Ah(_);
    var F = Ui({
      style: u,
      timeout: b
    }, {
      mode: "enter"
    });
    _.style.webkitTransition = m.transitions.create("opacity", F), _.style.transition = m.transitions.create("opacity", F), s && s(_, O);
  }, k = function(_) {
    var O = Ui({
      style: u,
      timeout: b
    }, {
      mode: "exit"
    });
    _.style.webkitTransition = m.transitions.create("opacity", O), _.style.transition = m.transitions.create("opacity", O), c && c(_);
  };
  return C.createElement(uh, j({
    appear: !0,
    in: i,
    onEnter: y,
    onExit: k,
    timeout: b
  }, h), function(w, _) {
    return C.cloneElement(a, j({
      style: j({
        opacity: 0,
        visibility: w === "exited" && !i ? "hidden" : void 0
      }, Zw[w], {}, u, {}, a.props.style),
      ref: E
    }, _));
  });
});
process.env.NODE_ENV !== "production" && (dh.propTypes = {
  /**
   * A single child content element.
   */
  children: f.element,
  /**
   * If `true`, the component will transition in.
   */
  in: f.bool,
  /**
   * @ignore
   */
  onEnter: f.func,
  /**
   * @ignore
   */
  onExit: f.func,
  /**
   * @ignore
   */
  style: f.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: f.oneOfType([f.number, f.shape({
    enter: f.number,
    exit: f.number
  })])
});
const Ru = dh;
var Xw = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent",
    // Disable scroll capabilities.
    touchAction: "none"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
}, fh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.invisible, u = c === void 0 ? !1 : c, A = e.open, b = e.transitionDuration, h = xe(e, ["children", "classes", "className", "invisible", "open", "transitionDuration"]);
  return C.createElement(Ru, j({
    in: A,
    timeout: b
  }, h), C.createElement("div", {
    className: Se(i.root, s, u && i.invisible),
    "aria-hidden": !0,
    ref: o
  }, a));
});
process.env.NODE_ENV !== "production" && (fh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: f.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: f.bool.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: f.oneOfType([f.number, f.shape({
    appear: f.number,
    enter: f.number,
    exit: f.number
  })])
});
const eE = $e(Xw, {
  name: "MuiBackdrop"
})(fh);
var nE = typeof window < "u" ? C.useLayoutEffect : C.useEffect;
function Nt(n) {
  var e = C.useRef(n);
  return nE(function() {
    e.current = n;
  }), C.useCallback(function() {
    return e.current.apply(void 0, arguments);
  }, []);
}
var oE = typeof window < "u" && process.env.NODE_ENV !== "test" ? C.useLayoutEffect : C.useEffect;
function Ki(n) {
  var e = n.children, o = n.defer, a = o === void 0 ? !1 : o, i = n.fallback, s = i === void 0 ? null : i, c = C.useState(!1), u = c[0], A = c[1];
  return oE(function() {
    a || A(!0);
  }, [a]), C.useEffect(function() {
    a && A(!0);
  }, [a]), C.createElement(C.Fragment, null, u ? e : s);
}
process.env.NODE_ENV !== "production" && (Ki.propTypes = {
  /**
   * You can wrap a node.
   */
  children: f.node.isRequired,
  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: f.bool,
  /**
   * The fallback content to display.
   */
  fallback: f.node
});
process.env.NODE_ENV !== "production" && (Ki.propTypes = vr(Ki.propTypes));
var es = !0, Hl = !1, db = null, tE = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function aE(n) {
  var e = n.type, o = n.tagName;
  return !!(o === "INPUT" && tE[e] && !n.readOnly || o === "TEXTAREA" && !n.readOnly || n.isContentEditable);
}
function rE(n) {
  n.metaKey || n.altKey || n.ctrlKey || (es = !0);
}
function Zc() {
  es = !1;
}
function iE() {
  this.visibilityState === "hidden" && Hl && (es = !0);
}
function sE(n) {
  n.addEventListener("keydown", rE, !0), n.addEventListener("mousedown", Zc, !0), n.addEventListener("pointerdown", Zc, !0), n.addEventListener("touchstart", Zc, !0), n.addEventListener("visibilitychange", iE, !0);
}
function cE(n) {
  var e = n.target;
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return es || aE(e);
}
function lE() {
  Hl = !0, window.clearTimeout(db), db = window.setTimeout(function() {
    Hl = !1;
  }, 100);
}
function Bu() {
  var n = C.useCallback(function(e) {
    var o = co.findDOMNode(e);
    o != null && sE(o.ownerDocument);
  }, []);
  return {
    isFocusVisible: cE,
    onBlurVisible: lE,
    ref: n
  };
}
var uE = typeof window > "u" ? C.useEffect : C.useLayoutEffect;
function bh(n) {
  var e = n.classes, o = n.pulsate, a = o === void 0 ? !1 : o, i = n.rippleX, s = n.rippleY, c = n.rippleSize, u = n.in, A = n.onExited, b = A === void 0 ? function() {
  } : A, h = n.timeout, m = C.useState(!1), E = m[0], y = m[1], k = Se(e.ripple, e.rippleVisible, a && e.ripplePulsate), w = {
    width: c,
    height: c,
    top: -(c / 2) + s,
    left: -(c / 2) + i
  }, _ = Se(e.child, E && e.childLeaving, a && e.childPulsate), O = Nt(b);
  return uE(function() {
    if (!u) {
      y(!0);
      var F = setTimeout(O, h);
      return function() {
        clearTimeout(F);
      };
    }
  }, [O, u, h]), C.createElement("span", {
    className: k,
    style: w
  }, C.createElement("span", {
    className: _
  }));
}
process.env.NODE_ENV !== "production" && (bh.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: f.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: f.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: f.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: f.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: f.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: f.number,
  /**
   * exit delay
   */
  timeout: f.number.isRequired
});
var Vl = 550, AE = 80, dE = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: "inherit"
    },
    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: "absolute"
    },
    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: "scale(1)",
      animation: "$enter ".concat(Vl, "ms ").concat(e.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(e.transitions.duration.shorter, "ms")
    },
    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      backgroundColor: "currentColor"
    },
    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(Vl, "ms ").concat(e.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: "absolute",
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
    },
    "@keyframes enter": {
      "0%": {
        transform: "scale(0)",
        opacity: 0.1
      },
      "100%": {
        transform: "scale(1)",
        opacity: 0.3
      }
    },
    "@keyframes exit": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    "@keyframes pulsate": {
      "0%": {
        transform: "scale(1)"
      },
      "50%": {
        transform: "scale(0.92)"
      },
      "100%": {
        transform: "scale(1)"
      }
    }
  };
}, ph = C.forwardRef(function(e, o) {
  var a = e.center, i = a === void 0 ? !1 : a, s = e.classes, c = e.className, u = xe(e, ["center", "classes", "className"]), A = C.useState([]), b = A[0], h = A[1], m = C.useRef(0), E = C.useRef(null);
  C.useEffect(function() {
    E.current && (E.current(), E.current = null);
  }, [b]);
  var y = C.useRef(!1), k = C.useRef(null), w = C.useRef(null), _ = C.useRef(null);
  C.useEffect(function() {
    return function() {
      clearTimeout(k.current);
    };
  }, []);
  var O = C.useCallback(function(B) {
    var D = B.pulsate, H = B.rippleX, X = B.rippleY, ce = B.rippleSize, Ae = B.cb;
    h(function(se) {
      return [].concat(Vt(se), [C.createElement(bh, {
        key: m.current,
        classes: s,
        timeout: Vl,
        pulsate: D,
        rippleX: H,
        rippleY: X,
        rippleSize: ce
      })]);
    }), m.current += 1, E.current = Ae;
  }, [s]), F = C.useCallback(function() {
    var B = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, H = arguments.length > 2 ? arguments[2] : void 0, X = D.pulsate, ce = X === void 0 ? !1 : X, Ae = D.center, se = Ae === void 0 ? i || D.pulsate : Ae, Be = D.fakeElement, Pe = Be === void 0 ? !1 : Be;
    if (B.type === "mousedown" && y.current) {
      y.current = !1;
      return;
    }
    B.type === "touchstart" && (y.current = !0);
    var ne = Pe ? null : _.current, J = ne ? ne.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }, $, z, q;
    if (se || B.clientX === 0 && B.clientY === 0 || !B.clientX && !B.touches)
      $ = Math.round(J.width / 2), z = Math.round(J.height / 2);
    else {
      var de = B.clientX ? B.clientX : B.touches[0].clientX, U = B.clientY ? B.clientY : B.touches[0].clientY;
      $ = Math.round(de - J.left), z = Math.round(U - J.top);
    }
    if (se)
      q = Math.sqrt((2 * Math.pow(J.width, 2) + Math.pow(J.height, 2)) / 3), q % 2 === 0 && (q += 1);
    else {
      var L = Math.max(Math.abs((ne ? ne.clientWidth : 0) - $), $) * 2 + 2, oe = Math.max(Math.abs((ne ? ne.clientHeight : 0) - z), z) * 2 + 2;
      q = Math.sqrt(Math.pow(L, 2) + Math.pow(oe, 2));
    }
    B.touches ? w.current === null && (w.current = function() {
      O({
        pulsate: ce,
        rippleX: $,
        rippleY: z,
        rippleSize: q,
        cb: H
      });
    }, k.current = setTimeout(function() {
      w.current && (w.current(), w.current = null);
    }, AE)) : O({
      pulsate: ce,
      rippleX: $,
      rippleY: z,
      rippleSize: q,
      cb: H
    });
  }, [i, O]), P = C.useCallback(function() {
    F({}, {
      pulsate: !0
    });
  }, [F]), M = C.useCallback(function(B, D) {
    if (clearTimeout(k.current), B.type === "touchend" && w.current) {
      B.persist(), w.current(), w.current = null, k.current = setTimeout(function() {
        M(B, D);
      });
      return;
    }
    w.current = null, h(function(H) {
      return H.length > 0 ? H.slice(1) : H;
    }), E.current = D;
  }, []);
  return C.useImperativeHandle(o, function() {
    return {
      pulsate: P,
      start: F,
      stop: M
    };
  }, [P, F, M]), C.createElement("span", j({
    className: Se(s.root, c),
    ref: _
  }, u), C.createElement(Gw, {
    component: null,
    exit: !0
  }, b));
});
function fE(n) {
  return n.muiName = "MuiTouchRipple", n;
}
process.env.NODE_ENV !== "production" && (ph.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: f.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string
});
const bE = $e(dE, {
  flip: !1,
  name: "MuiTouchRipple"
})(fE(C.memo(ph)));
var pE = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$disabled": {
      pointerEvents: "none",
      // Disable link interactions
      cursor: "default"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},
  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
}, hh = C.forwardRef(function(e, o) {
  var a = e.action, i = e.buttonRef, s = e.centerRipple, c = s === void 0 ? !1 : s, u = e.children, A = e.classes, b = e.className, h = e.component, m = h === void 0 ? "button" : h, E = e.disabled, y = E === void 0 ? !1 : E, k = e.disableRipple, w = k === void 0 ? !1 : k, _ = e.disableTouchRipple, O = _ === void 0 ? !1 : _, F = e.focusRipple, P = F === void 0 ? !1 : F, M = e.focusVisibleClassName, B = e.onBlur, D = e.onClick, H = e.onFocus, X = e.onFocusVisible, ce = e.onKeyDown, Ae = e.onKeyUp, se = e.onMouseDown, Be = e.onMouseLeave, Pe = e.onMouseUp, ne = e.onTouchEnd, J = e.onTouchMove, $ = e.onTouchStart, z = e.onDragLeave, q = e.tabIndex, de = q === void 0 ? 0 : q, U = e.TouchRippleProps, L = e.type, oe = L === void 0 ? "button" : L, re = xe(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]), ie = C.useRef(null);
  function fe() {
    return co.findDOMNode(ie.current);
  }
  var ae = C.useRef(null), be = C.useState(!1), pe = be[0], le = be[1];
  y && pe && le(!1);
  var me = Bu(), ge = me.isFocusVisible, G = me.onBlurVisible, _e = me.ref;
  C.useImperativeHandle(a, function() {
    return {
      focusVisible: function() {
        le(!0), ie.current.focus();
      }
    };
  }, []), C.useEffect(function() {
    pe && P && !w && ae.current.pulsate();
  }, [w, P, pe]);
  function we(Z, Re) {
    var qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : O;
    return Nt(function(Ve) {
      Re && Re(Ve);
      var Ne = qe;
      return !Ne && ae.current && ae.current[Z](Ve), !0;
    });
  }
  var He = we("start", se), nn = we("stop", z), Ze = we("stop", Pe), Un = we("stop", function(Z) {
    pe && Z.preventDefault(), Be && Be(Z);
  }), Mn = we("start", $), Sn = we("stop", ne), an = we("stop", J), pn = we("stop", function(Z) {
    pe && (G(Z), le(!1)), B && B(Z);
  }, !1), Xe = Nt(function(Z) {
    y || (ie.current || (ie.current = Z.currentTarget), ge(Z) && (le(!0), X && X(Z)), H && H(Z));
  }), An = function() {
    var Re = fe();
    return m && m !== "button" && !(Re.tagName === "A" && Re.href);
  }, Fn = C.useRef(!1), Eo = Nt(function(Z) {
    P && !Fn.current && pe && ae.current && Z.key === " " && (Fn.current = !0, Z.persist(), ae.current.stop(Z, function() {
      ae.current.start(Z);
    })), ce && ce(Z), Z.target === Z.currentTarget && An() && Z.key === "Enter" && (Z.preventDefault(), D && D(Z));
  }), ko = Nt(function(Z) {
    P && Z.key === " " && ae.current && pe && !Z.defaultPrevented && (Fn.current = !1, Z.persist(), ae.current.stop(Z, function() {
      ae.current.pulsate(Z);
    })), Ae && Ae(Z), Z.target === Z.currentTarget && An() && Z.key === " " && !Z.defaultPrevented && (Z.preventDefault(), D && D(Z));
  }), Rn = m;
  Rn === "button" && re.href && (Rn = "a");
  var Zn = {};
  Rn === "button" ? (Zn.type = oe, Zn.disabled = y) : ((Rn !== "a" || !re.href) && (Zn.role = "button"), Zn["aria-disabled"] = y);
  var To = Nn(i, o), K = Nn(_e, ie), te = Nn(To, K);
  return C.createElement(Rn, j({
    className: Se(A.root, b, pe && [A.focusVisible, M], y && A.disabled),
    onBlur: pn,
    onClick: D,
    onFocus: Xe,
    onKeyDown: Eo,
    onKeyUp: ko,
    onMouseDown: He,
    onMouseLeave: Un,
    onMouseUp: Ze,
    onDragLeave: nn,
    onTouchEnd: Sn,
    onTouchMove: an,
    onTouchStart: Mn,
    ref: te,
    tabIndex: y ? -1 : de
  }, Zn, re), u, !w && !y ? C.createElement(Ki, null, C.createElement(bE, j({
    ref: ae,
    center: c
  }, U))) : null);
});
process.env.NODE_ENV !== "production" && (hh.propTypes = {
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Fi,
  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: Fi,
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: f.bool,
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: du,
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: f.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: f.bool,
  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: f.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: f.bool,
  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: f.string,
  /**
   * @ignore
   */
  onBlur: f.func,
  /**
   * @ignore
   */
  onClick: f.func,
  /**
   * @ignore
   */
  onDragLeave: f.func,
  /**
   * @ignore
   */
  onFocus: f.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: f.func,
  /**
   * @ignore
   */
  onKeyDown: f.func,
  /**
   * @ignore
   */
  onKeyUp: f.func,
  /**
   * @ignore
   */
  onMouseDown: f.func,
  /**
   * @ignore
   */
  onMouseLeave: f.func,
  /**
   * @ignore
   */
  onMouseUp: f.func,
  /**
   * @ignore
   */
  onTouchEnd: f.func,
  /**
   * @ignore
   */
  onTouchMove: f.func,
  /**
   * @ignore
   */
  onTouchStart: f.func,
  /**
   * @ignore
   */
  role: f.string,
  /**
   * @ignore
   */
  tabIndex: f.oneOfType([f.number, f.string]),
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: f.object,
  /**
   * Used to control the button's purpose.
   * This prop passes the value to the `type` attribute of the native button component.
   */
  type: f.oneOf(["submit", "reset", "button"])
});
const _u = $e(pE, {
  name: "MuiButtonBase"
})(hh);
var hE = process.env.NODE_ENV !== "production" ? f.oneOfType([f.number, f.string, f.object, f.array]) : {};
const gh = hE;
function Pi(n, e) {
  return e ? Ht(n, e, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : n;
}
var gE = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}, fb = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: function(e) {
    return "@media (min-width:".concat(gE[e], "px)");
  }
};
function mh(n, e, o) {
  if (process.env.NODE_ENV !== "production" && (n.theme || console.error("Material-UI: You are calling a style function without a theme value.")), Array.isArray(e)) {
    var a = n.theme.breakpoints || fb;
    return e.reduce(function(c, u, A) {
      return c[a.up(a.keys[A])] = o(e[A]), c;
    }, {});
  }
  if (zo(e) === "object") {
    var i = n.theme.breakpoints || fb;
    return Object.keys(e).reduce(function(c, u) {
      return c[i.up(u)] = o(e[u]), c;
    }, {});
  }
  var s = o(e);
  return s;
}
function bb(n, e) {
  return !e || typeof e != "string" ? null : e.split(".").reduce(function(o, a) {
    return o && o[a] ? o[a] : null;
  }, n);
}
function Ce(n) {
  var e = n.prop, o = n.cssProperty, a = o === void 0 ? n.prop : o, i = n.themeKey, s = n.transform, c = function(A) {
    if (A[e] == null)
      return null;
    var b = A[e], h = A.theme, m = bb(h, i) || {}, E = function(k) {
      var w;
      return typeof m == "function" ? w = m(k) : Array.isArray(m) ? w = m[k] || k : (w = bb(m, k) || k, s && (w = s(w))), a === !1 ? w : tn({}, a, w);
    };
    return mh(A, b, E);
  };
  return c.propTypes = process.env.NODE_ENV !== "production" ? tn({}, e, gh) : {}, c.filterProps = [e], c;
}
function gt() {
  for (var n = arguments.length, e = new Array(n), o = 0; o < n; o++)
    e[o] = arguments[o];
  var a = function(s) {
    return e.reduce(function(c, u) {
      var A = u(s);
      return A ? Pi(c, A) : c;
    }, {});
  };
  return a.propTypes = process.env.NODE_ENV !== "production" ? e.reduce(function(i, s) {
    return j(i, s.propTypes);
  }, {}) : {}, a.filterProps = e.reduce(function(i, s) {
    return i.concat(s.filterProps);
  }, []), a;
}
function xr(n) {
  return typeof n != "number" ? n : "".concat(n, "px solid");
}
var mE = Ce({
  prop: "border",
  themeKey: "borders",
  transform: xr
}), vE = Ce({
  prop: "borderTop",
  themeKey: "borders",
  transform: xr
}), yE = Ce({
  prop: "borderRight",
  themeKey: "borders",
  transform: xr
}), xE = Ce({
  prop: "borderBottom",
  themeKey: "borders",
  transform: xr
}), CE = Ce({
  prop: "borderLeft",
  themeKey: "borders",
  transform: xr
}), wE = Ce({
  prop: "borderColor",
  themeKey: "palette"
}), EE = Ce({
  prop: "borderRadius",
  themeKey: "shape"
}), kE = gt(mE, vE, yE, xE, CE, wE, EE);
const SE = kE;
function pb(n, e) {
  var o = {};
  return Object.keys(n).forEach(function(a) {
    e.indexOf(a) === -1 && (o[a] = n[a]);
  }), o;
}
var hb = !1;
function RE(n) {
  var e = function(a) {
    var i = n(a);
    return a.css ? j({}, Pi(i, n(j({
      theme: a.theme
    }, a.css))), pb(a.css, [n.filterProps])) : a.sx ? j({}, Pi(i, n(j({
      theme: a.theme
    }, a.sx))), pb(a.sx, [n.filterProps])) : i;
  };
  return e.propTypes = process.env.NODE_ENV !== "production" ? j({}, n.propTypes, {
    css: xo(f.object, function(o) {
      return !hb && o.css !== void 0 ? (hb = !0, new Error("Material-UI: The `css` prop is deprecated, please use the `sx` prop instead.")) : null;
    }),
    sx: f.object
  }) : {}, e.filterProps = ["css", "sx"].concat(Vt(n.filterProps)), e;
}
function BE(n) {
  return process.env.NODE_ENV !== "production" && console.warn("Material-UI: The `css` function is deprecated. Use the `styleFunctionSx` instead."), RE(n);
}
var _E = Ce({
  prop: "displayPrint",
  cssProperty: !1,
  transform: function(e) {
    return {
      "@media print": {
        display: e
      }
    };
  }
}), FE = Ce({
  prop: "display"
}), IE = Ce({
  prop: "overflow"
}), TE = Ce({
  prop: "textOverflow"
}), OE = Ce({
  prop: "visibility"
}), UE = Ce({
  prop: "whiteSpace"
});
const KE = gt(_E, FE, IE, TE, OE, UE);
var PE = Ce({
  prop: "flexBasis"
}), DE = Ce({
  prop: "flexDirection"
}), LE = Ce({
  prop: "flexWrap"
}), NE = Ce({
  prop: "justifyContent"
}), ME = Ce({
  prop: "alignItems"
}), jE = Ce({
  prop: "alignContent"
}), $E = Ce({
  prop: "order"
}), QE = Ce({
  prop: "flex"
}), HE = Ce({
  prop: "flexGrow"
}), VE = Ce({
  prop: "flexShrink"
}), qE = Ce({
  prop: "alignSelf"
}), WE = Ce({
  prop: "justifyItems"
}), YE = Ce({
  prop: "justifySelf"
}), zE = gt(PE, DE, LE, NE, ME, jE, $E, QE, HE, VE, qE, WE, YE);
const GE = zE;
var ZE = Ce({
  prop: "color",
  themeKey: "palette"
}), JE = Ce({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette"
}), XE = gt(ZE, JE);
const e5 = XE;
var n5 = Ce({
  prop: "position"
}), o5 = Ce({
  prop: "zIndex",
  themeKey: "zIndex"
}), t5 = Ce({
  prop: "top"
}), a5 = Ce({
  prop: "right"
}), r5 = Ce({
  prop: "bottom"
}), i5 = Ce({
  prop: "left"
});
const s5 = gt(n5, o5, t5, a5, r5, i5);
var c5 = Ce({
  prop: "boxShadow",
  themeKey: "shadows"
});
const l5 = c5;
function mt(n) {
  return n <= 1 ? "".concat(n * 100, "%") : n;
}
var u5 = Ce({
  prop: "width",
  transform: mt
}), A5 = Ce({
  prop: "maxWidth",
  transform: mt
}), d5 = Ce({
  prop: "minWidth",
  transform: mt
}), f5 = Ce({
  prop: "height",
  transform: mt
}), b5 = Ce({
  prop: "maxHeight",
  transform: mt
}), p5 = Ce({
  prop: "minHeight",
  transform: mt
});
Ce({
  prop: "size",
  cssProperty: "width",
  transform: mt
});
Ce({
  prop: "size",
  cssProperty: "height",
  transform: mt
});
var h5 = Ce({
  prop: "boxSizing"
}), g5 = gt(u5, A5, d5, f5, b5, p5, h5);
const m5 = g5;
function v5(n) {
  if (Array.isArray(n))
    return n;
}
function y5(n, e) {
  var o = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (o != null) {
    var a, i, s, c, u = [], A = !0, b = !1;
    try {
      if (s = (o = o.call(n)).next, e === 0) {
        if (Object(o) !== o)
          return;
        A = !1;
      } else
        for (; !(A = (a = s.call(o)).done) && (u.push(a.value), u.length !== e); A = !0)
          ;
    } catch (h) {
      b = !0, i = h;
    } finally {
      try {
        if (!A && o.return != null && (c = o.return(), Object(c) !== c))
          return;
      } finally {
        if (b)
          throw i;
      }
    }
    return u;
  }
}
function x5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vh(n, e) {
  return v5(n) || y5(n, e) || zp(n, e) || x5();
}
function C5(n) {
  var e = {};
  return function(o) {
    return e[o] === void 0 && (e[o] = n(o)), e[o];
  };
}
var w5 = {
  m: "margin",
  p: "padding"
}, E5 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, gb = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, k5 = C5(function(n) {
  if (n.length > 2)
    if (gb[n])
      n = gb[n];
    else
      return [n];
  var e = n.split(""), o = vh(e, 2), a = o[0], i = o[1], s = w5[a], c = E5[i] || "";
  return Array.isArray(c) ? c.map(function(u) {
    return s + u;
  }) : [s + c];
}), Fu = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function S5(n) {
  var e = n.spacing || 8;
  return typeof e == "number" ? function(o) {
    return process.env.NODE_ENV !== "production" && typeof o != "number" && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(o, ".")), e * o;
  } : Array.isArray(e) ? function(o) {
    return process.env.NODE_ENV !== "production" && o > e.length - 1 && console.error(["Material-UI: The value provided (".concat(o, ") overflows."), "The supported values are: ".concat(JSON.stringify(e), "."), "".concat(o, " > ").concat(e.length - 1, ", you need to add the missing values.")].join(`
`)), e[o];
  } : typeof e == "function" ? e : (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `theme.spacing` value (".concat(e, ") is invalid."), "It should be a number, an array or a function."].join(`
`)), function() {
  });
}
function R5(n, e) {
  if (typeof e == "string" || e == null)
    return e;
  var o = Math.abs(e), a = n(o);
  return e >= 0 ? a : typeof a == "number" ? -a : "-".concat(a);
}
function B5(n, e) {
  return function(o) {
    return n.reduce(function(a, i) {
      return a[i] = R5(e, o), a;
    }, {});
  };
}
function Iu(n) {
  var e = n.theme, o = S5(e);
  return Object.keys(n).map(function(a) {
    if (Fu.indexOf(a) === -1)
      return null;
    var i = k5(a), s = B5(i, o), c = n[a];
    return mh(n, c, s);
  }).reduce(Pi, {});
}
Iu.propTypes = process.env.NODE_ENV !== "production" ? Fu.reduce(function(n, e) {
  return n[e] = gh, n;
}, {}) : {};
Iu.filterProps = Fu;
var _5 = Ce({
  prop: "fontFamily",
  themeKey: "typography"
}), F5 = Ce({
  prop: "fontSize",
  themeKey: "typography"
}), I5 = Ce({
  prop: "fontStyle",
  themeKey: "typography"
}), T5 = Ce({
  prop: "fontWeight",
  themeKey: "typography"
}), O5 = Ce({
  prop: "letterSpacing"
}), U5 = Ce({
  prop: "lineHeight"
}), K5 = Ce({
  prop: "textAlign"
}), P5 = gt(_5, F5, I5, T5, O5, U5, K5);
const D5 = P5;
var L5 = BE(gt(SE, KE, GE, s5, e5, l5, m5, Iu, D5)), N5 = Pw("div")(L5, {
  name: "MuiBox"
});
const En = N5;
var M5 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },
    /* Styles applied to the root element if `variant="body2"`. */
    body2: e.typography.body2,
    /* Styles applied to the root element if `variant="body1"`. */
    body1: e.typography.body1,
    /* Styles applied to the root element if `variant="caption"`. */
    caption: e.typography.caption,
    /* Styles applied to the root element if `variant="button"`. */
    button: e.typography.button,
    /* Styles applied to the root element if `variant="h1"`. */
    h1: e.typography.h1,
    /* Styles applied to the root element if `variant="h2"`. */
    h2: e.typography.h2,
    /* Styles applied to the root element if `variant="h3"`. */
    h3: e.typography.h3,
    /* Styles applied to the root element if `variant="h4"`. */
    h4: e.typography.h4,
    /* Styles applied to the root element if `variant="h5"`. */
    h5: e.typography.h5,
    /* Styles applied to the root element if `variant="h6"`. */
    h6: e.typography.h6,
    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: e.typography.subtitle1,
    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: e.typography.subtitle2,
    /* Styles applied to the root element if `variant="overline"`. */
    overline: e.typography.overline,
    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: "absolute",
      height: 1,
      width: 1,
      overflow: "hidden"
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: "left"
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: "center"
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: "right"
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: "justify"
    },
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: "0.35em"
    },
    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: e.palette.text.primary
    },
    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: e.palette.text.secondary
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: e.palette.error.main
    },
    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: "inline"
    },
    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: "block"
    }
  };
}, mb = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p"
}, yh = C.forwardRef(function(e, o) {
  var a = e.align, i = a === void 0 ? "inherit" : a, s = e.classes, c = e.className, u = e.color, A = u === void 0 ? "initial" : u, b = e.component, h = e.display, m = h === void 0 ? "initial" : h, E = e.gutterBottom, y = E === void 0 ? !1 : E, k = e.noWrap, w = k === void 0 ? !1 : k, _ = e.paragraph, O = _ === void 0 ? !1 : _, F = e.variant, P = F === void 0 ? "body1" : F, M = e.variantMapping, B = M === void 0 ? mb : M, D = xe(e, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]), H = b || (O ? "p" : B[P] || mb[P]) || "span";
  return C.createElement(H, j({
    className: Se(s.root, c, P !== "inherit" && s[P], A !== "initial" && s["color".concat(en(A))], w && s.noWrap, y && s.gutterBottom, O && s.paragraph, i !== "inherit" && s["align".concat(en(i))], m !== "initial" && s["display".concat(en(m))]),
    ref: o
  }, D));
});
process.env.NODE_ENV !== "production" && (yh.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: f.oneOf(["inherit", "left", "center", "right", "justify"]),
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: f.oneOf(["initial", "inherit", "primary", "secondary", "textPrimary", "textSecondary", "error"]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: f.elementType,
  /**
   * Controls the display type
   */
  display: f.oneOf(["initial", "block", "inline"]),
  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: f.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: f.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: f.bool,
  /**
   * Applies the theme typography styles.
   */
  variant: f.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline", "srOnly", "inherit"]),
  /**
   * The component maps the variant prop to a range of different DOM element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: f.object
});
const cn = $e(M5, {
  name: "MuiTypography"
})(yh), j5 = $w(C.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");
var $5 = function(e) {
  return {
    root: {
      display: "flex"
    },
    icon: {
      width: 24,
      height: 16,
      backgroundColor: e.palette.grey[100],
      color: e.palette.grey[700],
      borderRadius: 2,
      marginLeft: e.spacing(0.5),
      marginRight: e.spacing(0.5),
      cursor: "pointer",
      "&:hover, &:focus": {
        backgroundColor: e.palette.grey[200]
      },
      "&:active": {
        boxShadow: e.shadows[0],
        backgroundColor: qx(e.palette.grey[200], 0.12)
      }
    }
  };
};
function xh(n) {
  var e = n.classes, o = xe(n, ["classes"]);
  return C.createElement("li", j({
    className: e.root
  }, o), C.createElement(j5, {
    className: e.icon
  }));
}
process.env.NODE_ENV !== "production" && (xh.propTypes = {
  /**
   * @ignore
   */
  classes: f.object.isRequired
});
const Q5 = $e($5, {
  name: "PrivateBreadcrumbCollapsed"
})(xh);
var H5 = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the ol element. */
  ol: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    // Reset
    margin: 0
    // Reset
  },
  /* Styles applied to the li element. */
  li: {
    listStyle: "none"
  },
  /* Styles applied to the separator element. */
  separator: {
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
  }
};
function V5(n, e, o) {
  return n.reduce(function(a, i, s) {
    return s < n.length - 1 ? a = a.concat(i, C.createElement("li", {
      "aria-hidden": !0,
      key: "separator-".concat(s),
      className: e
    }, o)) : a.push(i), a;
  }, []);
}
var Ch = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.component, u = c === void 0 ? "nav" : c, A = e.itemsAfterCollapse, b = A === void 0 ? 1 : A, h = e.itemsBeforeCollapse, m = h === void 0 ? 1 : h, E = e.maxItems, y = E === void 0 ? 8 : E, k = e.separator, w = k === void 0 ? "/" : k, _ = xe(e, ["children", "classes", "className", "component", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]), O = C.useState(!1), F = O[0], P = O[1], M = function(H) {
    var X = function() {
      P(!0);
    };
    return m + b >= H.length ? (process.env.NODE_ENV !== "production" && console.error(["Material-UI: you have provided an invalid combination of props to the Breadcrumbs.", "itemsAfterCollapse={".concat(b, "} + itemsBeforeCollapse={").concat(m, "} >= maxItems={").concat(y, "}")].join(`
`)), H) : [].concat(Vt(H.slice(0, m)), [C.createElement(Q5, {
      key: "ellipsis",
      onClick: X
    })], Vt(H.slice(H.length - b, H.length)));
  }, B = C.Children.toArray(a).filter(function(D) {
    return process.env.NODE_ENV !== "production" && Bl.isFragment(D) && console.error(["Material-UI: the Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), C.isValidElement(D);
  }).map(function(D, H) {
    return C.createElement("li", {
      className: i.li,
      key: "child-".concat(H)
    }, D);
  });
  return C.createElement(cn, j({
    ref: o,
    component: u,
    color: "textSecondary",
    className: Se(i.root, s)
  }, _), C.createElement("ol", {
    className: i.ol
  }, V5(F || y && B.length <= y ? B : M(B), i.separator, w)));
});
process.env.NODE_ENV !== "production" && (Ch.propTypes = {
  /**
   * The breadcrumb children.
   */
  children: f.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: f.elementType,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   */
  itemsAfterCollapse: f.number,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   */
  itemsBeforeCollapse: f.number,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   */
  maxItems: f.number,
  /**
   * Custom separator node.
   */
  separator: f.node
});
const q5 = $e(H5, {
  name: "MuiBreadcrumbs"
})(Ch);
var W5 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: j({}, e.typography.button, {
      boxSizing: "border-box",
      minWidth: 64,
      padding: "6px 16px",
      borderRadius: e.shape.borderRadius,
      color: e.palette.text.primary,
      transition: e.transitions.create(["background-color", "box-shadow", "border"], {
        duration: e.transitions.duration.short
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: ro(e.palette.text.primary, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        },
        "&$disabled": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        color: e.palette.action.disabled
      }
    }),
    /* Styles applied to the span element that wraps the children. */
    label: {
      width: "100%",
      // Ensure the correct width for iOS Safari
      display: "inherit",
      alignItems: "inherit",
      justifyContent: "inherit"
    },
    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: "6px 8px"
    },
    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: e.palette.primary.main,
      "&:hover": {
        backgroundColor: ro(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: ro(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: "5px 15px",
      border: "1px solid ".concat(e.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
      "&$disabled": {
        border: "1px solid ".concat(e.palette.action.disabled)
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: e.palette.primary.main,
      border: "1px solid ".concat(ro(e.palette.primary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(e.palette.primary.main),
        backgroundColor: ro(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: e.palette.secondary.main,
      border: "1px solid ".concat(ro(e.palette.secondary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(e.palette.secondary.main),
        backgroundColor: ro(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        border: "1px solid ".concat(e.palette.action.disabled)
      }
    },
    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: e.palette.getContrastText(e.palette.grey[300]),
      backgroundColor: e.palette.grey[300],
      boxShadow: e.shadows[2],
      "&:hover": {
        backgroundColor: e.palette.grey.A100,
        boxShadow: e.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          boxShadow: e.shadows[2],
          backgroundColor: e.palette.grey[300]
        },
        "&$disabled": {
          backgroundColor: e.palette.action.disabledBackground
        }
      },
      "&$focusVisible": {
        boxShadow: e.shadows[6]
      },
      "&:active": {
        boxShadow: e.shadows[8]
      },
      "&$disabled": {
        color: e.palette.action.disabled,
        boxShadow: e.shadows[0],
        backgroundColor: e.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: e.palette.primary.contrastText,
      backgroundColor: e.palette.primary.main,
      "&:hover": {
        backgroundColor: e.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.palette.primary.main
        }
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: e.palette.secondary.contrastText,
      backgroundColor: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: e.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.palette.secondary.main
        }
      }
    },
    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none"
      },
      "&$focusVisible": {
        boxShadow: "none"
      },
      "&:active": {
        boxShadow: "none"
      },
      "&$disabled": {
        boxShadow: "none"
      }
    },
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit",
      borderColor: "currentColor"
    },
    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: "4px 5px",
      fontSize: e.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: "8px 11px",
      fontSize: e.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: "3px 9px",
      fontSize: e.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: "7px 21px",
      fontSize: e.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: "4px 10px",
      fontSize: e.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: "8px 22px",
      fontSize: e.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: "inherit",
      marginRight: 8,
      marginLeft: -4,
      "&$iconSizeSmall": {
        marginLeft: -2
      }
    },
    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: "inherit",
      marginRight: -4,
      marginLeft: 8,
      "&$iconSizeSmall": {
        marginRight: -2
      }
    },
    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      "& > *:first-child": {
        fontSize: 18
      }
    },
    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      "& > *:first-child": {
        fontSize: 20
      }
    },
    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      "& > *:first-child": {
        fontSize: 22
      }
    }
  };
}, wh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.color, u = c === void 0 ? "default" : c, A = e.component, b = A === void 0 ? "button" : A, h = e.disabled, m = h === void 0 ? !1 : h, E = e.disableElevation, y = E === void 0 ? !1 : E, k = e.disableFocusRipple, w = k === void 0 ? !1 : k, _ = e.endIcon, O = e.focusVisibleClassName, F = e.fullWidth, P = F === void 0 ? !1 : F, M = e.size, B = M === void 0 ? "medium" : M, D = e.startIcon, H = e.type, X = H === void 0 ? "button" : H, ce = e.variant, Ae = ce === void 0 ? "text" : ce, se = xe(e, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]), Be = D && C.createElement("span", {
    className: Se(i.startIcon, i["iconSize".concat(en(B))])
  }, D), Pe = _ && C.createElement("span", {
    className: Se(i.endIcon, i["iconSize".concat(en(B))])
  }, _);
  return C.createElement(_u, j({
    className: Se(i.root, i[Ae], s, u === "inherit" ? i.colorInherit : u !== "default" && i["".concat(Ae).concat(en(u))], B !== "medium" && [i["".concat(Ae, "Size").concat(en(B))], i["size".concat(en(B))]], y && i.disableElevation, m && i.disabled, P && i.fullWidth),
    component: b,
    disabled: m,
    focusRipple: !w,
    focusVisibleClassName: Se(i.focusVisible, O),
    ref: o,
    type: X
  }, se), C.createElement("span", {
    className: i.label
  }, Be, a, Pe));
});
process.env.NODE_ENV !== "production" && (wh.propTypes = {
  /**
   * The content of the button.
   */
  children: f.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: f.oneOf(["default", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: f.bool,
  /**
   * If `true`, no elevation is used.
   */
  disableElevation: f.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: f.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: f.bool,
  /**
   * Element placed after the children.
   */
  endIcon: f.node,
  /**
   * @ignore
   */
  focusVisibleClassName: f.string,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: f.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: f.string,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: f.oneOf(["small", "medium", "large"]),
  /**
   * Element placed before the children.
   */
  startIcon: f.node,
  /**
   * @ignore
   */
  type: f.string,
  /**
   * The variant to use.
   */
  variant: f.oneOf(["text", "outlined", "contained"])
});
const Go = $e(W5, {
  name: "MuiButton"
})(wh);
var Y5 = {
  /* Styles applied to the root element. */
  root: {
    overflow: "hidden"
  }
}, Eh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.raised, c = s === void 0 ? !1 : s, u = xe(e, ["classes", "className", "raised"]);
  return C.createElement(Xi, j({
    className: Se(a.root, i),
    elevation: c ? 8 : 1,
    ref: o
  }, u));
});
process.env.NODE_ENV !== "production" && (Eh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * If `true`, the card will use raised styling.
   */
  raised: f.bool
});
const Tu = $e(Y5, {
  name: "MuiCard"
})(Eh);
var z5 = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    "&:last-child": {
      paddingBottom: 24
    }
  }
}, kh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.component, c = s === void 0 ? "div" : s, u = xe(e, ["classes", "className", "component"]);
  return C.createElement(c, j({
    className: Se(a.root, i),
    ref: o
  }, u));
});
process.env.NODE_ENV !== "production" && (kh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType
});
const Ou = $e(z5, {
  name: "MuiCardContent"
})(kh);
var G5 = {
  /* Styles applied to the root element. */
  root: {
    display: "block",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  },
  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: "100%"
  },
  /* Styles applied to the root element if `component="picture or img"`. */
  img: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: "cover"
  }
}, Z5 = ["video", "audio", "picture", "iframe", "img"], Sh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.component, u = c === void 0 ? "div" : c, A = e.image, b = e.src, h = e.style, m = xe(e, ["children", "classes", "className", "component", "image", "src", "style"]), E = Z5.indexOf(u) !== -1, y = !E && A ? j({
    backgroundImage: 'url("'.concat(A, '")')
  }, h) : h;
  return C.createElement(u, j({
    className: Se(i.root, s, E && i.media, "picture img".indexOf(u) !== -1 && i.img),
    ref: o,
    style: y,
    src: E ? A || b : void 0
  }, m), a);
});
process.env.NODE_ENV !== "production" && (Sh.propTypes = {
  /**
   * The content of the component.
   */
  children: xo(f.node, function(n) {
    return !n.children && !n.image && !n.src ? new Error("Material-UI: either `children`, `image` or `src` prop must be specified.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: f.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: f.string,
  /**
   * @ignore
   */
  style: f.object
});
const J5 = $e(G5, {
  name: "MuiCardMedia"
})(Sh);
function X5(n) {
  var e = n.controlled, o = n.default, a = n.name, i = C.useRef(e !== void 0), s = i.current, c = C.useState(o), u = c[0], A = c[1], b = s ? e : u;
  if (process.env.NODE_ENV !== "production") {
    C.useEffect(function() {
      s !== (e !== void 0) && console.error(["Material-UI: A component is changing ".concat(s ? "a " : "an un", "controlled ").concat(a, " to be ").concat(s ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(a, " ") + "element for the lifetime of the component.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [e]);
    var h = C.useRef(o), m = h.current;
    C.useEffect(function() {
      m !== o && console.error(["Material-UI: A component is changing the default value of an uncontrolled ".concat(a, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(a, ".")].join(`
`));
    }, [JSON.stringify(o)]);
  }
  var E = C.useCallback(function(y) {
    s || A(y);
  }, []);
  return [b, E];
}
var e4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: "center",
      flex: "0 0 auto",
      fontSize: e.typography.pxToRem(24),
      padding: 12,
      borderRadius: "50%",
      overflow: "visible",
      // Explicitly set the default value to solve a bug on IE 11.
      color: e.palette.action.active,
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        backgroundColor: ro(e.palette.action.active, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        backgroundColor: "transparent",
        color: e.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      "$sizeSmall&": {
        marginLeft: -3
      }
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      "$sizeSmall&": {
        marginRight: -3
      }
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main,
      "&:hover": {
        backgroundColor: ro(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: ro(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: e.typography.pxToRem(18)
    },
    /* Styles applied to the children container element. */
    label: {
      width: "100%",
      display: "flex",
      alignItems: "inherit",
      justifyContent: "inherit"
    }
  };
}, Rh = C.forwardRef(function(e, o) {
  var a = e.edge, i = a === void 0 ? !1 : a, s = e.children, c = e.classes, u = e.className, A = e.color, b = A === void 0 ? "default" : A, h = e.disabled, m = h === void 0 ? !1 : h, E = e.disableFocusRipple, y = E === void 0 ? !1 : E, k = e.size, w = k === void 0 ? "medium" : k, _ = xe(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
  return C.createElement(_u, j({
    className: Se(c.root, u, b !== "default" && c["color".concat(en(b))], m && c.disabled, {
      small: c["size".concat(en(w))]
    }[w], {
      start: c.edgeStart,
      end: c.edgeEnd
    }[i]),
    centerRipple: !0,
    focusRipple: !y,
    disabled: m,
    ref: o
  }, _), C.createElement("span", {
    className: c.label
  }, s));
});
process.env.NODE_ENV !== "production" && (Rh.propTypes = {
  /**
   * The icon element.
   */
  children: xo(f.node, function(n) {
    var e = C.Children.toArray(n.children).some(function(o) {
      return C.isValidElement(o) && o.props.onClick;
    });
    return e ? new Error(["Material-UI: you are providing an onClick event listener to a child of a button element.", "Firefox will never trigger the event.", "You should move the onClick listener to the parent button element.", "https://github.com/mui-org/material-ui/issues/13957"].join(`
`)) : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: f.oneOf(["default", "inherit", "primary", "secondary"]),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: f.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: f.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: f.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: f.oneOf(["start", "end", !1]),
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: f.oneOf(["small", "medium"])
});
const n4 = $e(e4, {
  name: "MuiIconButton"
})(Rh);
var ct = 44;
function o4(n, e, o) {
  return (Math.min(Math.max(e, n), o) - e) / (o - e);
}
function t4(n) {
  return n = o4(n, 0, 1), n = (n -= 1) * n * n + 1, n;
}
function a4(n) {
  return n * n;
}
var r4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-block"
    },
    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: e.transitions.create("transform")
    },
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: "$circular-rotate 1.4s linear infinite"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the `svg` element. */
    svg: {
      display: "block"
      // Keeps the progress centered
    },
    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: "currentColor"
      // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',
    },
    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: e.transitions.create("stroke-dashoffset")
    },
    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: "$circular-dash 1.4s ease-in-out infinite",
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: "0px"
      // Add the unit to fix a Edge 16 and below bug.
    },
    "@keyframes circular-rotate": {
      "100%": {
        transform: "rotate(360deg)"
      }
    },
    "@keyframes circular-dash": {
      "0%": {
        strokeDasharray: "1px, 200px",
        strokeDashoffset: "0px"
      },
      "50%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-15px"
      },
      "100%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-125px"
      }
    },
    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: "none"
    }
  };
}, Bh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.color, c = s === void 0 ? "primary" : s, u = e.disableShrink, A = u === void 0 ? !1 : u, b = e.size, h = b === void 0 ? 40 : b, m = e.style, E = e.thickness, y = E === void 0 ? 3.6 : E, k = e.value, w = k === void 0 ? 0 : k, _ = e.variant, O = _ === void 0 ? "indeterminate" : _, F = xe(e, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]), P = {}, M = {}, B = {};
  if (O === "determinate" || O === "static") {
    var D = 2 * Math.PI * ((ct - y) / 2);
    P.strokeDasharray = D.toFixed(3), B["aria-valuenow"] = Math.round(w), O === "static" ? (P.strokeDashoffset = "".concat(((100 - w) / 100 * D).toFixed(3), "px"), M.transform = "rotate(-90deg)") : (P.strokeDashoffset = "".concat((a4((100 - w) / 100) * D).toFixed(3), "px"), M.transform = "rotate(".concat((t4(w / 70) * 270).toFixed(3), "deg)"));
  }
  return C.createElement("div", j({
    className: Se(a.root, i, c !== "inherit" && a["color".concat(en(c))], {
      indeterminate: a.indeterminate,
      static: a.static
    }[O]),
    style: j({
      width: h,
      height: h
    }, M, {}, m),
    ref: o,
    role: "progressbar"
  }, B, F), C.createElement("svg", {
    className: a.svg,
    viewBox: "".concat(ct / 2, " ").concat(ct / 2, " ").concat(ct, " ").concat(ct)
  }, C.createElement("circle", {
    className: Se(a.circle, A && a.circleDisableShrink, {
      indeterminate: a.circleIndeterminate,
      static: a.circleStatic
    }[O]),
    style: P,
    cx: ct,
    cy: ct,
    r: (ct - y) / 2,
    fill: "none",
    strokeWidth: y
  })));
});
process.env.NODE_ENV !== "production" && (Bh.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: f.oneOf(["primary", "secondary", "inherit"]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: xo(f.bool, function(n) {
    return n.disableShrink && n.variant && n.variant !== "indeterminate" ? new Error("Material-UI: you have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null;
  }),
  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: f.oneOfType([f.number, f.string]),
  /**
   * @ignore
   */
  style: f.object,
  /**
   * The thickness of the circle.
   */
  thickness: f.number,
  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: f.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: f.oneOf(["determinate", "indeterminate", "static"])
});
const Uu = $e(r4, {
  name: "MuiCircularProgress",
  flip: !1
})(Bh);
function qt(n) {
  return n && n.ownerDocument || document;
}
var i4 = function(e) {
  var o;
  return {
    /* Styles applied to the root element. */
    root: (o = {
      width: "100%",
      marginLeft: "auto",
      boxSizing: "border-box",
      marginRight: "auto",
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2)
    }, tn(o, e.breakpoints.up("sm"), {
      paddingLeft: e.spacing(3),
      paddingRight: e.spacing(3)
    }), tn(o, e.breakpoints.up("md"), {
      paddingLeft: e.spacing(4),
      paddingRight: e.spacing(4)
    }), o),
    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },
    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(e.breakpoints.values).reduce(function(a, i) {
      var s = e.breakpoints.values[i];
      return s !== 0 && (a[e.breakpoints.up(i)] = {
        maxWidth: s
      }), a;
    }, {}),
    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: tn({}, e.breakpoints.up("xs"), {
      maxWidth: Math.max(e.breakpoints.values.xs, 444)
    }),
    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: tn({}, e.breakpoints.up("sm"), {
      maxWidth: e.breakpoints.values.sm
    }),
    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: tn({}, e.breakpoints.up("md"), {
      maxWidth: e.breakpoints.values.md
    }),
    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: tn({}, e.breakpoints.up("lg"), {
      maxWidth: e.breakpoints.values.lg
    }),
    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: tn({}, e.breakpoints.up("xl"), {
      maxWidth: e.breakpoints.values.xl
    })
  };
}, _h = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.component, c = s === void 0 ? "div" : s, u = e.disableGutters, A = u === void 0 ? !1 : u, b = e.fixed, h = b === void 0 ? !1 : b, m = e.maxWidth, E = m === void 0 ? "lg" : m, y = xe(e, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);
  return C.createElement(c, j({
    className: Se(a.root, i, h && a.fixed, A && a.disableGutters, E !== !1 && a["maxWidth".concat(en(String(E)))]),
    ref: o
  }, y));
});
process.env.NODE_ENV !== "production" && (_h.propTypes = {
  children: f.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: f.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   */
  fixed: f.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: f.oneOf(["xs", "sm", "md", "lg", "xl", !1])
});
const vt = $e(i4, {
  name: "MuiContainer"
})(_h);
function s4(n) {
  return n = typeof n == "function" ? n() : n, co.findDOMNode(n);
}
var Jc = typeof window < "u" ? C.useLayoutEffect : C.useEffect, Di = C.forwardRef(function(e, o) {
  var a = e.children, i = e.container, s = e.disablePortal, c = s === void 0 ? !1 : s, u = e.onRendered, A = C.useState(null), b = A[0], h = A[1], m = Nn(C.isValidElement(a) ? a.ref : null, o);
  return Jc(function() {
    c || h(s4(i) || document.body);
  }, [i, c]), Jc(function() {
    if (b && !c)
      return ka(o, b), function() {
        ka(o, null);
      };
  }, [o, b, c]), Jc(function() {
    u && (b || c) && u();
  }, [u, b, c]), c ? C.isValidElement(a) ? C.cloneElement(a, {
    ref: m
  }) : a : b && co.createPortal(a, b);
});
process.env.NODE_ENV !== "production" && (Di.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The children to render into the `container`.
   */
  children: f.node,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: f.oneOfType([f.func, f.instanceOf(C.Component), f.instanceOf(typeof Element > "u" ? Object : Element)]),
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: f.bool,
  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: f.func
});
process.env.NODE_ENV !== "production" && (Di.propTypes = vr(Di.propTypes));
const Fh = Di;
function hr() {
  for (var n = arguments.length, e = new Array(n), o = 0; o < n; o++)
    e[o] = arguments[o];
  return e.reduce(function(a, i) {
    return i == null ? a : (process.env.NODE_ENV !== "production" && typeof i != "function" && console.error("Material-UI: invalid Argument Type, must only provide functions, undefined, or null."), function() {
      for (var c = arguments.length, u = new Array(c), A = 0; A < c; A++)
        u[A] = arguments[A];
      a.apply(this, u), i.apply(this, u);
    });
  }, function() {
  });
}
function c4() {
  var n = document.createElement("div");
  n.style.width = "99px", n.style.height = "99px", n.style.position = "absolute", n.style.top = "-9999px", n.style.overflow = "scroll", document.body.appendChild(n);
  var e = n.offsetWidth - n.clientWidth;
  return document.body.removeChild(n), e;
}
function Sa(n) {
  var e = qt(n);
  return e.defaultView || window;
}
function l4(n) {
  var e = qt(n);
  return e.body === n ? Sa(e).innerWidth > e.documentElement.clientWidth : n.scrollHeight > n.clientHeight;
}
function dr(n, e) {
  e ? n.setAttribute("aria-hidden", "true") : n.removeAttribute("aria-hidden");
}
function vb(n) {
  return parseInt(window.getComputedStyle(n)["padding-right"], 10) || 0;
}
function yb(n, e, o) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 ? arguments[4] : void 0, s = [e, o].concat(Vt(a)), c = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(n.children, function(u) {
    u.nodeType === 1 && s.indexOf(u) === -1 && c.indexOf(u.tagName) === -1 && dr(u, i);
  });
}
function Xc(n, e) {
  var o = -1;
  return n.some(function(a, i) {
    return e(a) ? (o = i, !0) : !1;
  }), o;
}
function u4(n, e) {
  var o = [], a = [], i = n.container, s;
  if (!e.disableScrollLock) {
    if (l4(i)) {
      var c = c4();
      o.push({
        value: i.style.paddingRight,
        key: "padding-right",
        el: i
      }), i.style["padding-right"] = "".concat(vb(i) + c, "px"), s = qt(i).querySelectorAll(".mui-fixed"), [].forEach.call(s, function(h) {
        a.push(h.style.paddingRight), h.style.paddingRight = "".concat(vb(h) + c, "px");
      });
    }
    var u = i.parentElement, A = u.nodeName === "HTML" && window.getComputedStyle(u)["overflow-y"] === "scroll" ? u : i;
    o.push({
      value: A.style.overflow,
      key: "overflow",
      el: A
    }), A.style.overflow = "hidden";
  }
  var b = function() {
    s && [].forEach.call(s, function(m, E) {
      a[E] ? m.style.paddingRight = a[E] : m.style.removeProperty("padding-right");
    }), o.forEach(function(m) {
      var E = m.value, y = m.el, k = m.key;
      E ? y.style.setProperty(k, E) : y.style.removeProperty(k);
    });
  };
  return b;
}
function A4(n) {
  var e = [];
  return [].forEach.call(n.children, function(o) {
    o.getAttribute && o.getAttribute("aria-hidden") === "true" && e.push(o);
  }), e;
}
var d4 = /* @__PURE__ */ function() {
  function n() {
    Cw(this, n), this.modals = [], this.containers = [];
  }
  return bu(n, [{
    key: "add",
    value: function(o, a) {
      var i = this.modals.indexOf(o);
      if (i !== -1)
        return i;
      i = this.modals.length, this.modals.push(o), o.modalRef && dr(o.modalRef, !1);
      var s = A4(a);
      yb(a, o.mountNode, o.modalRef, s, !0);
      var c = Xc(this.containers, function(u) {
        return u.container === a;
      });
      return c !== -1 ? (this.containers[c].modals.push(o), i) : (this.containers.push({
        modals: [o],
        container: a,
        restore: null,
        hiddenSiblingNodes: s
      }), i);
    }
  }, {
    key: "mount",
    value: function(o, a) {
      var i = Xc(this.containers, function(c) {
        return c.modals.indexOf(o) !== -1;
      }), s = this.containers[i];
      s.restore || (s.restore = u4(s, a));
    }
  }, {
    key: "remove",
    value: function(o) {
      var a = this.modals.indexOf(o);
      if (a === -1)
        return a;
      var i = Xc(this.containers, function(u) {
        return u.modals.indexOf(o) !== -1;
      }), s = this.containers[i];
      if (s.modals.splice(s.modals.indexOf(o), 1), this.modals.splice(a, 1), s.modals.length === 0)
        s.restore && s.restore(), o.modalRef && dr(o.modalRef, !0), yb(s.container, o.mountNode, o.modalRef, s.hiddenSiblingNodes, !1), this.containers.splice(i, 1);
      else {
        var c = s.modals[s.modals.length - 1];
        c.modalRef && dr(c.modalRef, !1);
      }
      return a;
    }
  }, {
    key: "isTopModal",
    value: function(o) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === o;
    }
  }]), n;
}();
function Ih(n) {
  var e = n.children, o = n.disableAutoFocus, a = o === void 0 ? !1 : o, i = n.disableEnforceFocus, s = i === void 0 ? !1 : i, c = n.disableRestoreFocus, u = c === void 0 ? !1 : c, A = n.getDoc, b = n.isEnabled, h = n.open, m = C.useRef(), E = C.useRef(null), y = C.useRef(null), k = C.useRef(), w = C.useRef(null), _ = C.useCallback(function(F) {
    w.current = co.findDOMNode(F);
  }, []), O = Nn(e.ref, _);
  return C.useMemo(function() {
    !h || typeof window > "u" || (k.current = A().activeElement);
  }, [h]), C.useEffect(function() {
    if (h) {
      var F = qt(w.current);
      !a && w.current && !w.current.contains(F.activeElement) && (w.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["Material-UI: the modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), w.current.setAttribute("tabIndex", -1)), w.current.focus());
      var P = function() {
        if (s || !b() || m.current) {
          m.current = !1;
          return;
        }
        w.current && !w.current.contains(F.activeElement) && w.current.focus();
      }, M = function(H) {
        s || !b() || H.keyCode !== 9 || F.activeElement === w.current && (m.current = !0, H.shiftKey ? y.current.focus() : E.current.focus());
      };
      F.addEventListener("focus", P, !0), F.addEventListener("keydown", M, !0);
      var B = setInterval(function() {
        P();
      }, 50);
      return function() {
        clearInterval(B), F.removeEventListener("focus", P, !0), F.removeEventListener("keydown", M, !0), u || (k.current && k.current.focus && k.current.focus(), k.current = null);
      };
    }
  }, [a, s, u, b, h]), C.createElement(C.Fragment, null, C.createElement("div", {
    tabIndex: 0,
    ref: E,
    "data-test": "sentinelStart"
  }), C.cloneElement(e, {
    ref: O
  }), C.createElement("div", {
    tabIndex: 0,
    ref: y,
    "data-test": "sentinelEnd"
  }));
}
process.env.NODE_ENV !== "production" && (Ih.propTypes = {
  /**
   * A single child content element.
   */
  children: f.element.isRequired,
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: f.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: f.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: f.bool,
  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: f.func.isRequired,
  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: f.func.isRequired,
  /**
   * If `true`, the modal is open.
   */
  open: f.bool.isRequired
});
var xb = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: "fixed",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent",
    // Disable scroll capabilities.
    touchAction: "none"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
}, Th = C.forwardRef(function(e, o) {
  var a = e.invisible, i = a === void 0 ? !1 : a, s = e.open, c = xe(e, ["invisible", "open"]);
  return s ? C.createElement("div", j({
    "aria-hidden": !0,
    ref: o
  }, c, {
    style: j({}, xb.root, {}, i ? xb.invisible : {}, {}, c.style)
  })) : null;
});
process.env.NODE_ENV !== "production" && (Th.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: f.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: f.bool.isRequired
});
const f4 = Th;
function b4(n) {
  return n = typeof n == "function" ? n() : n, co.findDOMNode(n);
}
function p4(n) {
  return n.children ? n.children.props.hasOwnProperty("in") : !1;
}
var h4 = new d4(), g4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "fixed",
      zIndex: e.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },
    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: "hidden"
    }
  };
}, Oh = C.forwardRef(function(e, o) {
  var a = Yt(), i = zi({
    name: "MuiModal",
    props: j({}, e),
    theme: a
  }), s = i.BackdropComponent, c = s === void 0 ? f4 : s, u = i.BackdropProps, A = i.children, b = i.closeAfterTransition, h = b === void 0 ? !1 : b, m = i.container, E = i.disableAutoFocus, y = E === void 0 ? !1 : E, k = i.disableBackdropClick, w = k === void 0 ? !1 : k, _ = i.disableEnforceFocus, O = _ === void 0 ? !1 : _, F = i.disableEscapeKeyDown, P = F === void 0 ? !1 : F, M = i.disablePortal, B = M === void 0 ? !1 : M, D = i.disableRestoreFocus, H = D === void 0 ? !1 : D, X = i.disableScrollLock, ce = X === void 0 ? !1 : X, Ae = i.hideBackdrop, se = Ae === void 0 ? !1 : Ae, Be = i.keepMounted, Pe = Be === void 0 ? !1 : Be, ne = i.manager, J = ne === void 0 ? h4 : ne, $ = i.onBackdropClick, z = i.onClose, q = i.onEscapeKeyDown, de = i.onRendered, U = i.open, L = xe(i, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]), oe = C.useState(!0), re = oe[0], ie = oe[1], fe = C.useRef({}), ae = C.useRef(null), be = C.useRef(null), pe = Nn(be, o), le = p4(i), me = function() {
    return qt(ae.current);
  }, ge = function() {
    return fe.current.modalRef = be.current, fe.current.mountNode = ae.current, fe.current;
  }, G = function() {
    J.mount(ge(), {
      disableScrollLock: ce
    }), be.current.scrollTop = 0;
  }, _e = Nt(function() {
    var Xe = b4(m) || me().body;
    J.add(ge(), Xe), be.current && G();
  }), we = C.useCallback(function() {
    return J.isTopModal(ge());
  }, [J]), He = Nt(function(Xe) {
    ae.current = Xe, Xe && (de && de(), U && we() ? G() : dr(be.current, !0));
  }), nn = C.useCallback(function() {
    J.remove(ge());
  }, [J]);
  if (C.useEffect(function() {
    return function() {
      nn();
    };
  }, [nn]), C.useEffect(function() {
    U ? _e() : (!le || !h) && nn();
  }, [U, nn, le, h, _e]), !Pe && !U && (!le || re))
    return null;
  var Ze = function() {
    ie(!1);
  }, Un = function() {
    ie(!0), h && nn();
  }, Mn = function(An) {
    An.target === An.currentTarget && ($ && $(An), !w && z && z(An, "backdropClick"));
  }, Sn = function(An) {
    An.key !== "Escape" || !we() || (An.stopPropagation(), q && q(An), !P && z && z(An, "escapeKeyDown"));
  }, an = g4(a || {
    zIndex: Lp
  }), pn = {};
  return A.props.tabIndex === void 0 && (pn.tabIndex = A.props.tabIndex || "-1"), le && (pn.onEnter = hr(Ze, A.props.onEnter), pn.onExited = hr(Un, A.props.onExited)), C.createElement(Fh, {
    ref: He,
    container: m,
    disablePortal: B
  }, C.createElement("div", j({
    ref: pe,
    onKeyDown: Sn,
    role: "presentation"
  }, L, {
    style: j({}, an.root, {}, !U && re ? an.hidden : {}, {}, L.style)
  }), se ? null : C.createElement(c, j({
    open: U,
    onClick: Mn
  }, u)), C.createElement(Ih, {
    disableEnforceFocus: O,
    disableAutoFocus: y,
    disableRestoreFocus: H,
    getDoc: me,
    isEnabled: we,
    open: U
  }, C.cloneElement(A, pn))));
});
process.env.NODE_ENV !== "production" && (Oh.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: f.elementType,
  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: f.object,
  /**
   * A single child content element.
   */
  children: Pp.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: f.bool,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: f.oneOfType([f.object, f.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: f.bool,
  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: f.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: f.bool,
  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: f.bool,
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: f.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: f.bool,
  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: f.bool,
  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: f.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: f.bool,
  /**
   * @ignore
   */
  manager: f.object,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: f.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: f.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: f.func,
  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: f.func,
  /**
   * If `true`, the modal is open.
   */
  open: f.bool.isRequired
});
const Uh = Oh;
var m4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
      }
    },
    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&:after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    },
    /* Styles applied to the container element. */
    container: {
      height: "100%",
      "@media print": {
        height: "auto"
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },
    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: "relative",
      overflowY: "auto",
      // Fix IE 11 issue, to remove at some point.
      "@media print": {
        overflowY: "visible",
        boxShadow: "none"
      }
    },
    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "left"
      // 'initial' doesn't work on IE 11
    },
    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(e.breakpoints.values.xs, 444),
      "&$paperScrollBody": tn({}, e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: e.breakpoints.values.sm,
      "&$paperScrollBody": tn({}, e.breakpoints.down(e.breakpoints.values.sm + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: e.breakpoints.values.md,
      "&$paperScrollBody": tn({}, e.breakpoints.down(e.breakpoints.values.md + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: e.breakpoints.values.lg,
      "&$paperScrollBody": tn({}, e.breakpoints.down(e.breakpoints.values.lg + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: e.breakpoints.values.xl,
      "&$paperScrollBody": tn({}, e.breakpoints.down(e.breakpoints.values.xl + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      "&$paperScrollBody": {
        margin: 0,
        maxWidth: "100%"
      }
    }
  };
}, v4 = {
  enter: Ea.enteringScreen,
  exit: Ea.leavingScreen
}, Kh = C.forwardRef(function(e, o) {
  var a = e.BackdropProps, i = e.children, s = e.classes, c = e.className, u = e.disableBackdropClick, A = u === void 0 ? !1 : u, b = e.disableEscapeKeyDown, h = b === void 0 ? !1 : b, m = e.fullScreen, E = m === void 0 ? !1 : m, y = e.fullWidth, k = y === void 0 ? !1 : y, w = e.maxWidth, _ = w === void 0 ? "sm" : w, O = e.onBackdropClick, F = e.onClose, P = e.onEnter, M = e.onEntered, B = e.onEntering, D = e.onEscapeKeyDown, H = e.onExit, X = e.onExited, ce = e.onExiting, Ae = e.open, se = e.PaperComponent, Be = se === void 0 ? Xi : se, Pe = e.PaperProps, ne = Pe === void 0 ? {} : Pe, J = e.scroll, $ = J === void 0 ? "paper" : J, z = e.TransitionComponent, q = z === void 0 ? Ru : z, de = e.transitionDuration, U = de === void 0 ? v4 : de, L = e.TransitionProps, oe = e["aria-describedby"], re = e["aria-labelledby"], ie = xe(e, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]), fe = C.useRef(), ae = function(le) {
    fe.current = le.target;
  }, be = function(le) {
    le.target === le.currentTarget && le.target === fe.current && (fe.current = null, O && O(le), !A && F && F(le, "backdropClick"));
  };
  return C.createElement(Uh, j({
    className: Se(s.root, c),
    BackdropComponent: eE,
    BackdropProps: j({
      transitionDuration: U
    }, a),
    closeAfterTransition: !0,
    disableBackdropClick: A,
    disableEscapeKeyDown: h,
    onEscapeKeyDown: D,
    onClose: F,
    open: Ae,
    ref: o
  }, ie), C.createElement(q, j({
    appear: !0,
    in: Ae,
    timeout: U,
    onEnter: P,
    onEntering: B,
    onEntered: M,
    onExit: H,
    onExiting: ce,
    onExited: X,
    role: "none presentation"
  }, L), C.createElement("div", {
    className: Se(s.container, s["scroll".concat(en($))]),
    onClick: be,
    onMouseDown: ae
  }, C.createElement(Be, j({
    elevation: 24,
    role: "dialog",
    "aria-describedby": oe,
    "aria-labelledby": re
  }, ne, {
    className: Se(s.paper, s["paperScroll".concat(en($))], s["paperWidth".concat(en(String(_)))], ne.className, E && s.paperFullScreen, k && s.paperFullWidth)
  }), i))));
});
process.env.NODE_ENV !== "production" && (Kh.propTypes = {
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": f.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": f.string,
  /**
   * @ignore
   */
  BackdropProps: f.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: f.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: f.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: f.bool,
  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: f.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: f.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: f.oneOf(["xs", "sm", "md", "lg", "xl", !1]),
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: f.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: f.func,
  /**
   * Callback fired before the dialog enters.
   */
  onEnter: f.func,
  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: f.func,
  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: f.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: f.func,
  /**
   * Callback fired before the dialog exits.
   */
  onExit: f.func,
  /**
   * Callback fired when the dialog has exited.
   */
  onExited: f.func,
  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: f.func,
  /**
   * If `true`, the Dialog is open.
   */
  open: f.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: f.elementType,
  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: f.object,
  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: f.oneOf(["body", "paper"]),
  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: f.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: f.oneOfType([f.number, f.shape({
    enter: f.number,
    exit: f.number
  })]),
  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: f.object
});
const Ku = $e(m4, {
  name: "MuiDialog"
})(Kh);
var y4 = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 8,
    justifyContent: "flex-end",
    flex: "0 0 auto"
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    "& > :not(:first-child)": {
      marginLeft: 8
    }
  }
}, Ph = C.forwardRef(function(e, o) {
  var a = e.disableSpacing, i = a === void 0 ? !1 : a, s = e.classes, c = e.className, u = xe(e, ["disableSpacing", "classes", "className"]);
  return C.createElement("div", j({
    className: Se(s.root, c, !i && s.spacing),
    ref: o
  }, u));
});
process.env.NODE_ENV !== "production" && (Ph.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: f.bool
});
const Dh = $e(y4, {
  name: "MuiDialogActions"
})(Ph);
var x4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: "1 1 auto",
      WebkitOverflowScrolling: "touch",
      // Add iOS momentum scrolling.
      overflowY: "auto",
      padding: "8px 24px",
      "&:first-child": {
        // dialog without title
        paddingTop: 20
      }
    },
    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: "16px 24px",
      borderTop: "1px solid ".concat(e.palette.divider),
      borderBottom: "1px solid ".concat(e.palette.divider)
    }
  };
}, Lh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.dividers, c = s === void 0 ? !1 : s, u = xe(e, ["classes", "className", "dividers"]);
  return C.createElement("div", j({
    className: Se(a.root, i, c && a.dividers),
    ref: o
  }, u));
});
process.env.NODE_ENV !== "production" && (Lh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * Display the top and bottom dividers.
   */
  dividers: f.bool
});
const Pu = $e(x4, {
  name: "MuiDialogContent"
})(Lh);
var C4 = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
}, Nh = C.forwardRef(function(e, o) {
  return C.createElement(cn, j({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: o
  }, e));
});
process.env.NODE_ENV !== "production" && (Nh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired
});
const w4 = $e(C4, {
  name: "MuiDialogContentText"
})(Nh);
var E4 = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: "16px 24px",
    flex: "0 0 auto"
  }
}, Mh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.disableTypography, u = c === void 0 ? !1 : c, A = xe(e, ["children", "classes", "className", "disableTypography"]);
  return C.createElement("div", j({
    className: Se(i.root, s),
    ref: o
  }, A), u ? a : C.createElement(cn, {
    component: "h2",
    variant: "h6"
  }, a));
});
process.env.NODE_ENV !== "production" && (Mh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: f.bool
});
const k4 = $e(E4, {
  name: "MuiDialogTitle"
})(Mh);
var S4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: "none",
      flexShrink: 0,
      backgroundColor: e.palette.divider
    },
    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    },
    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },
    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: ro(e.palette.divider, 0.08)
    },
    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: "100%",
      width: 1
    }
  };
}, jh = C.forwardRef(function(e, o) {
  var a = e.absolute, i = a === void 0 ? !1 : a, s = e.classes, c = e.className, u = e.component, A = u === void 0 ? "hr" : u, b = e.light, h = b === void 0 ? !1 : b, m = e.orientation, E = m === void 0 ? "horizontal" : m, y = e.role, k = y === void 0 ? A !== "hr" ? "separator" : void 0 : y, w = e.variant, _ = w === void 0 ? "fullWidth" : w, O = xe(e, ["absolute", "classes", "className", "component", "light", "orientation", "role", "variant"]);
  return C.createElement(A, j({
    className: Se(s.root, c, _ !== "fullWidth" && s[_], i && s.absolute, h && s.light, {
      vertical: s.vertical
    }[E]),
    role: k,
    ref: o
  }, O));
});
process.env.NODE_ENV !== "production" && (jh.propTypes = {
  /**
   * Absolutely position the element.
   */
  absolute: f.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * If `true`, the divider will have a lighter color.
   */
  light: f.bool,
  /**
   * The divider orientation.
   */
  orientation: f.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: f.string,
  /**
   * The variant to use.
   */
  variant: f.oneOf(["fullWidth", "inset", "middle"])
});
const R4 = $e(S4, {
  name: "MuiDivider"
})(jh);
function B4(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, o;
  function a() {
    for (var i = arguments.length, s = new Array(i), c = 0; c < i; c++)
      s[c] = arguments[c];
    var u = this, A = function() {
      n.apply(u, s);
    };
    clearTimeout(o), o = setTimeout(A, e);
  }
  return a.clear = function() {
    clearTimeout(o);
  }, a;
}
function $h(n, e) {
  return C.isValidElement(n) && e.indexOf(n.type.muiName) !== -1;
}
function _4(n) {
  if (process.env.NODE_ENV === "production")
    return function() {
      return null;
    };
  var e = function(a) {
    return function(i, s, c, u, A) {
      var b = A || s;
      return typeof i[s] < "u" && !i[a] ? new Error("The prop `".concat(b, "` of ") + "`".concat(n, "` must be used on `").concat(a, "`.")) : null;
    };
  };
  return e;
}
var Qh = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F4 = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
function I4(n, e, o) {
  var a = {};
  F4.forEach(function(i) {
    var s = "grid-".concat(o, "-").concat(i);
    if (i === !0) {
      a[s] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
      return;
    }
    if (i === "auto") {
      a[s] = {
        flexBasis: "auto",
        flexGrow: 0,
        maxWidth: "none"
      };
      return;
    }
    var c = "".concat(Math.round(i / 12 * 1e8) / 1e6, "%");
    a[s] = {
      flexBasis: c,
      flexGrow: 0,
      maxWidth: c
    };
  }), o === "xs" ? j(n, a) : n[e.breakpoints.up(o)] = a;
}
function el(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, o = parseFloat(n);
  return "".concat(o / e).concat(String(n).replace(String(o), "") || "px");
}
function T4(n, e) {
  var o = {};
  return Qh.forEach(function(a) {
    var i = n.spacing(a);
    i !== 0 && (o["spacing-".concat(e, "-").concat(a)] = {
      margin: "-".concat(el(i, 2)),
      width: "calc(100% + ".concat(el(i), ")"),
      "& > $item": {
        padding: el(i, 2)
      }
    });
  }), o;
}
var O4 = function(e) {
  return j({
    /* Styles applied to the root element */
    root: {},
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: "border-box",
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: "border-box",
      margin: "0"
      // For instance, it's useful when used with a `figure` element.
    },
    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },
    /* Styles applied to the root element if `direction="column"`. */
    "direction-xs-column": {
      flexDirection: "column"
    },
    /* Styles applied to the root element if `direction="column-reverse"`. */
    "direction-xs-column-reverse": {
      flexDirection: "column-reverse"
    },
    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    "direction-xs-row-reverse": {
      flexDirection: "row-reverse"
    },
    /* Styles applied to the root element if `wrap="nowrap"`. */
    "wrap-xs-nowrap": {
      flexWrap: "nowrap"
    },
    /* Styles applied to the root element if `wrap="reverse"`. */
    "wrap-xs-wrap-reverse": {
      flexWrap: "wrap-reverse"
    },
    /* Styles applied to the root element if `alignItems="center"`. */
    "align-items-xs-center": {
      alignItems: "center"
    },
    /* Styles applied to the root element if `alignItems="flex-start"`. */
    "align-items-xs-flex-start": {
      alignItems: "flex-start"
    },
    /* Styles applied to the root element if `alignItems="flex-end"`. */
    "align-items-xs-flex-end": {
      alignItems: "flex-end"
    },
    /* Styles applied to the root element if `alignItems="baseline"`. */
    "align-items-xs-baseline": {
      alignItems: "baseline"
    },
    /* Styles applied to the root element if `alignContent="center"`. */
    "align-content-xs-center": {
      alignContent: "center"
    },
    /* Styles applied to the root element if `alignContent="flex-start"`. */
    "align-content-xs-flex-start": {
      alignContent: "flex-start"
    },
    /* Styles applied to the root element if `alignContent="flex-end"`. */
    "align-content-xs-flex-end": {
      alignContent: "flex-end"
    },
    /* Styles applied to the root element if `alignContent="space-between"`. */
    "align-content-xs-space-between": {
      alignContent: "space-between"
    },
    /* Styles applied to the root element if `alignContent="space-around"`. */
    "align-content-xs-space-around": {
      alignContent: "space-around"
    },
    /* Styles applied to the root element if `justify="center"`. */
    "justify-xs-center": {
      justifyContent: "center"
    },
    /* Styles applied to the root element if `justify="flex-end"`. */
    "justify-xs-flex-end": {
      justifyContent: "flex-end"
    },
    /* Styles applied to the root element if `justify="space-between"`. */
    "justify-xs-space-between": {
      justifyContent: "space-between"
    },
    /* Styles applied to the root element if `justify="space-around"`. */
    "justify-xs-space-around": {
      justifyContent: "space-around"
    },
    /* Styles applied to the root element if `justify="space-evenly"`. */
    "justify-xs-space-evenly": {
      justifyContent: "space-evenly"
    }
  }, T4(e, "xs"), {}, e.breakpoints.keys.reduce(function(o, a) {
    return I4(o, e, a), o;
  }, {}));
}, Hh = C.forwardRef(function(e, o) {
  var a = e.alignContent, i = a === void 0 ? "stretch" : a, s = e.alignItems, c = s === void 0 ? "stretch" : s, u = e.classes, A = e.className, b = e.component, h = b === void 0 ? "div" : b, m = e.container, E = m === void 0 ? !1 : m, y = e.direction, k = y === void 0 ? "row" : y, w = e.item, _ = w === void 0 ? !1 : w, O = e.justify, F = O === void 0 ? "flex-start" : O, P = e.lg, M = P === void 0 ? !1 : P, B = e.md, D = B === void 0 ? !1 : B, H = e.sm, X = H === void 0 ? !1 : H, ce = e.spacing, Ae = ce === void 0 ? 0 : ce, se = e.wrap, Be = se === void 0 ? "wrap" : se, Pe = e.xl, ne = Pe === void 0 ? !1 : Pe, J = e.xs, $ = J === void 0 ? !1 : J, z = e.zeroMinWidth, q = z === void 0 ? !1 : z, de = xe(e, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]), U = Se(u.root, A, E && [u.container, Ae !== 0 && u["spacing-xs-".concat(String(Ae))]], _ && u.item, q && u.zeroMinWidth, k !== "row" && u["direction-xs-".concat(String(k))], Be !== "wrap" && u["wrap-xs-".concat(String(Be))], c !== "stretch" && u["align-items-xs-".concat(String(c))], i !== "stretch" && u["align-content-xs-".concat(String(i))], F !== "flex-start" && u["justify-xs-".concat(String(F))], $ !== !1 && u["grid-xs-".concat(String($))], X !== !1 && u["grid-sm-".concat(String(X))], D !== !1 && u["grid-md-".concat(String(D))], M !== !1 && u["grid-lg-".concat(String(M))], ne !== !1 && u["grid-xl-".concat(String(ne))]);
  return C.createElement(h, j({
    className: U,
    ref: o
  }, de));
});
process.env.NODE_ENV !== "production" && (Hh.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: f.oneOf(["stretch", "center", "flex-start", "flex-end", "space-between", "space-around"]),
  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: f.oneOf(["flex-start", "center", "flex-end", "stretch", "baseline"]),
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: f.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: f.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: f.bool,
  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: f.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: f.oneOf([!1, "auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: f.oneOf([!1, "auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: f.oneOf([!1, "auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: f.oneOf(Qh),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: f.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: f.oneOf([!1, "auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: f.oneOf([!1, "auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: f.bool
});
var ql = $e(O4, {
  name: "MuiGrid"
})(Hh);
if (process.env.NODE_ENV !== "production") {
  var Fo = _4("Grid");
  ql.propTypes = j({}, ql.propTypes, {
    alignContent: Fo("container"),
    alignItems: Fo("container"),
    direction: Fo("container"),
    justify: Fo("container"),
    lg: Fo("item"),
    md: Fo("item"),
    sm: Fo("item"),
    spacing: Fo("container"),
    wrap: Fo("container"),
    xs: Fo("item"),
    zeroMinWidth: Fo("item")
  });
}
const so = ql;
function Wl(n) {
  return "scale(".concat(n, ", ").concat(Math.pow(n, 2), ")");
}
var U4 = {
  entering: {
    opacity: 1,
    transform: Wl(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Du = C.forwardRef(function(e, o) {
  var a = e.children, i = e.in, s = e.onEnter, c = e.onExit, u = e.style, A = e.timeout, b = A === void 0 ? "auto" : A, h = xe(e, ["children", "in", "onEnter", "onExit", "style", "timeout"]), m = C.useRef(), E = C.useRef(), y = Nn(a.ref, o), k = Zo(), w = function(P, M) {
    Ah(P);
    var B = Ui({
      style: u,
      timeout: b
    }, {
      mode: "enter"
    }), D = B.duration, H = B.delay, X;
    b === "auto" ? (X = k.transitions.getAutoHeightDuration(P.clientHeight), E.current = X) : X = D, P.style.transition = [k.transitions.create("opacity", {
      duration: X,
      delay: H
    }), k.transitions.create("transform", {
      duration: X * 0.666,
      delay: H
    })].join(","), s && s(P, M);
  }, _ = function(P) {
    var M = Ui({
      style: u,
      timeout: b
    }, {
      mode: "exit"
    }), B = M.duration, D = M.delay, H;
    b === "auto" ? (H = k.transitions.getAutoHeightDuration(P.clientHeight), E.current = H) : H = B, P.style.transition = [k.transitions.create("opacity", {
      duration: H,
      delay: D
    }), k.transitions.create("transform", {
      duration: H * 0.666,
      delay: D || H * 0.333
    })].join(","), P.style.opacity = "0", P.style.transform = Wl(0.75), c && c(P);
  }, O = function(P, M) {
    b === "auto" && (m.current = setTimeout(M, E.current || 0));
  };
  return C.useEffect(function() {
    return function() {
      clearTimeout(m.current);
    };
  }, []), C.createElement(uh, j({
    appear: !0,
    in: i,
    onEnter: w,
    onExit: _,
    addEndListener: O,
    timeout: b === "auto" ? null : b
  }, h), function(F, P) {
    return C.cloneElement(a, j({
      style: j({
        opacity: 0,
        transform: Wl(0.75),
        visibility: F === "exited" && !i ? "hidden" : void 0
      }, U4[F], {}, u, {}, a.props.style),
      ref: y
    }, P));
  });
});
process.env.NODE_ENV !== "production" && (Du.propTypes = {
  /**
   * A single child content element.
   */
  children: f.element,
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: f.bool,
  /**
   * @ignore
   */
  onEnter: f.func,
  /**
   * @ignore
   */
  onExit: f.func,
  /**
   * @ignore
   */
  style: f.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: f.oneOfType([f.number, f.shape({
    enter: f.number,
    exit: f.number
  }), f.oneOf(["auto"])])
});
Du.muiSupportAuto = !0;
const Vh = Du;
function Lu(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = Yt(), a = zi({
    theme: o,
    name: "MuiUseMediaQuery",
    props: {}
  });
  process.env.NODE_ENV !== "production" && typeof n == "function" && o === null && console.error(["Material-UI: the `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  var i = typeof n == "function" ? n(o) : n;
  i = i.replace(/^@media( ?)/m, "");
  var s = typeof window < "u" && typeof window.matchMedia < "u", c = j({}, a, {}, e), u = c.defaultMatches, A = u === void 0 ? !1 : u, b = c.matchMedia, h = b === void 0 ? s ? window.matchMedia : null : b, m = c.noSsr, E = m === void 0 ? !1 : m, y = c.ssrMatchMedia, k = y === void 0 ? null : y, w = C.useState(function() {
    return E && s ? h(i).matches : k ? k(i).matches : A;
  }), _ = w[0], O = w[1];
  return C.useEffect(function() {
    var F = !0;
    if (s) {
      var P = h(i), M = function() {
        F && O(P.matches);
      };
      return M(), P.addListener(M), function() {
        F = !1, P.removeListener(M);
      };
    }
  }, [i, h, s]), _;
}
var K4 = function(e, o) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return a ? On.indexOf(e) <= On.indexOf(o) : On.indexOf(e) < On.indexOf(o);
}, P4 = function(e, o) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return a ? On.indexOf(o) <= On.indexOf(e) : On.indexOf(o) < On.indexOf(e);
}, D4 = typeof window > "u" ? C.useEffect : C.useLayoutEffect, L4 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return function(o) {
    var a = e.withTheme, i = a === void 0 ? !1 : a, s = e.noSSR, c = s === void 0 ? !1 : s, u = e.initialWidth;
    function A(b) {
      var h = Zo(), m = b.theme || h, E = zi({
        theme: m,
        name: "MuiWithWidth",
        props: j({}, b)
      }), y = E.initialWidth, k = E.width, w = xe(E, ["initialWidth", "width"]), _ = C.useState(!1), O = _[0], F = _[1];
      D4(function() {
        F(!0);
      }, []);
      var P = Vt(m.breakpoints.keys).reverse(), M = P.reduce(function(D, H) {
        var X = Lu(m.breakpoints.up(H));
        return !D && X ? H : D;
      }, null), B = j({
        width: k || (O || c ? M : void 0) || y || u
      }, i ? {
        theme: m
      } : {}, {}, w);
      return B.width === void 0 ? null : C.createElement(o, B);
    }
    return process.env.NODE_ENV !== "production" && (A.propTypes = {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * You might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * https://caniuse.com/#search=client%20hint
       */
      initialWidth: f.oneOf(["xs", "sm", "md", "lg", "xl"]),
      /**
       * @ignore
       */
      theme: f.object,
      /**
       * Bypass the width calculation logic.
       */
      width: f.oneOf(["xs", "sm", "md", "lg", "xl"])
    }), process.env.NODE_ENV !== "production" && (A.displayName = "WithWidth(".concat(jt(o), ")")), wu(A, o), A;
  };
};
function Li(n) {
  var e = n.children, o = n.only, a = n.width, i = Zo(), s = !0;
  if (o)
    if (Array.isArray(o))
      for (var c = 0; c < o.length; c += 1) {
        var u = o[c];
        if (a === u) {
          s = !1;
          break;
        }
      }
    else
      o && a === o && (s = !1);
  if (s)
    for (var A = 0; A < i.breakpoints.keys.length; A += 1) {
      var b = i.breakpoints.keys[A], h = n["".concat(b, "Up")], m = n["".concat(b, "Down")];
      if (h && K4(b, a) || m && P4(b, a)) {
        s = !1;
        break;
      }
    }
  return s ? e : null;
}
Li.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: f.oneOf(["js", "css"]),
  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: f.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: f.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: f.oneOfType([f.oneOf(["xs", "sm", "md", "lg", "xl"]), f.arrayOf(f.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: f.bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: f.string.isRequired,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: f.bool
};
process.env.NODE_ENV !== "production" && (Li.propTypes = vr(Li.propTypes));
const N4 = L4()(Li);
var M4 = function(e) {
  var o = {
    display: "none"
  };
  return e.breakpoints.keys.reduce(function(a, i) {
    return a["only".concat(en(i))] = tn({}, e.breakpoints.only(i), o), a["".concat(i, "Up")] = tn({}, e.breakpoints.up(i), o), a["".concat(i, "Down")] = tn({}, e.breakpoints.down(i), o), a;
  }, {});
};
function qh(n) {
  var e = n.children, o = n.classes, a = n.className, i = n.only, s = xe(n, ["children", "classes", "className", "only"]), c = Zo();
  if (process.env.NODE_ENV !== "production") {
    var u = Object.keys(s).filter(function(k) {
      var w = !c.breakpoints.keys.some(function(_) {
        return "".concat(_, "Up") === k || "".concat(_, "Down") === k;
      });
      return w;
    });
    u.length > 0 && console.error('Material-UI: unsupported props received by `<Hidden implementation="css" />`: '.concat(u.join(", "), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
  }
  var A = [];
  a && A.push(a);
  for (var b = 0; b < c.breakpoints.keys.length; b += 1) {
    var h = c.breakpoints.keys[b], m = n["".concat(h, "Up")], E = n["".concat(h, "Down")];
    m && A.push(o["".concat(h, "Up")]), E && A.push(o["".concat(h, "Down")]);
  }
  if (i) {
    var y = Array.isArray(i) ? i : [i];
    y.forEach(function(k) {
      A.push(o["only".concat(en(k))]);
    });
  }
  return C.createElement("div", {
    className: A.join(" ")
  }, e);
}
process.env.NODE_ENV !== "production" && (qh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: f.oneOf(["js", "css"]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: f.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: f.oneOfType([f.oneOf(["xs", "sm", "md", "lg", "xl"]), f.arrayOf(f.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: f.bool
});
const j4 = $e(M4, {
  name: "PrivateHiddenCss"
})(qh);
function ya(n) {
  var e = n.implementation, o = e === void 0 ? "js" : e, a = n.lgDown, i = a === void 0 ? !1 : a, s = n.lgUp, c = s === void 0 ? !1 : s, u = n.mdDown, A = u === void 0 ? !1 : u, b = n.mdUp, h = b === void 0 ? !1 : b, m = n.smDown, E = m === void 0 ? !1 : m, y = n.smUp, k = y === void 0 ? !1 : y, w = n.xlDown, _ = w === void 0 ? !1 : w, O = n.xlUp, F = O === void 0 ? !1 : O, P = n.xsDown, M = P === void 0 ? !1 : P, B = n.xsUp, D = B === void 0 ? !1 : B, H = xe(n, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
  return o === "js" ? C.createElement(N4, j({
    lgDown: i,
    lgUp: c,
    mdDown: A,
    mdUp: h,
    smDown: E,
    smUp: k,
    xlDown: _,
    xlUp: F,
    xsDown: M,
    xsUp: D
  }, H)) : C.createElement(j4, j({
    lgDown: i,
    lgUp: c,
    mdDown: A,
    mdUp: h,
    smDown: E,
    smUp: k,
    xlDown: _,
    xlUp: F,
    xsDown: M,
    xsUp: D
  }, H));
}
process.env.NODE_ENV !== "production" && (ya.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: f.oneOf(["js", "css"]),
  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: f.oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: f.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: f.oneOfType([f.oneOf(["xs", "sm", "md", "lg", "xl"]), f.arrayOf(f.oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: f.bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: f.bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: f.bool
});
var nl = 4, $4 = function(e) {
  var o = function(c) {
    return e.palette.type === "light" ? uu(c, 0.62) : lu(c, 0.5);
  }, a = o(e.palette.primary.main), i = o(e.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      overflow: "hidden",
      height: 4
    },
    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: a
    },
    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: i
    },
    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},
    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: "transparent"
    },
    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: "rotate(180deg)"
    },
    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: "absolute",
      marginTop: 0,
      height: "100%",
      width: "100%",
      animation: "$buffer 3s infinite linear"
    },
    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(a, " 0%, ").concat(a, " 16%, transparent 42%)"),
      backgroundSize: "10px 10px",
      backgroundPosition: "0px -23px"
    },
    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(i, " 0%, ").concat(i, " 16%, transparent 42%)"),
      backgroundSize: "10px 10px",
      backgroundPosition: "0px -23px"
    },
    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: "100%",
      position: "absolute",
      left: 0,
      bottom: 0,
      top: 0,
      transition: "transform 0.2s linear",
      transformOrigin: "left"
    },
    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: e.palette.primary.main
    },
    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: e.palette.secondary.main
    },
    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: "auto",
      animation: "$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite"
    },
    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(nl, "s linear")
    },
    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(nl, "s linear")
    },
    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: "auto",
      animation: "$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite"
    },
    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(nl, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    "@keyframes indeterminate1": {
      //  |-----|---x-||-----||-----|
      "0%": {
        left: "-35%",
        right: "100%"
      },
      //  |-----|-----||-----||xxxx-|
      "60%": {
        left: "100%",
        right: "-90%"
      },
      "100%": {
        left: "100%",
        right: "-90%"
      }
    },
    "@keyframes indeterminate2": {
      //  |xxxxx|xxxxx||-----||-----|
      "0%": {
        left: "-200%",
        right: "100%"
      },
      //  |-----|-----||-----||-x----|
      "60%": {
        left: "107%",
        right: "-8%"
      },
      "100%": {
        left: "107%",
        right: "-8%"
      }
    },
    "@keyframes buffer": {
      "0%": {
        opacity: 1,
        backgroundPosition: "0px -23px"
      },
      "50%": {
        opacity: 0,
        backgroundPosition: "0px -23px"
      },
      "100%": {
        opacity: 1,
        backgroundPosition: "-200px -23px"
      }
    }
  };
}, Wh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.color, c = s === void 0 ? "primary" : s, u = e.value, A = e.valueBuffer, b = e.variant, h = b === void 0 ? "indeterminate" : b, m = xe(e, ["classes", "className", "color", "value", "valueBuffer", "variant"]), E = Zo(), y = {}, k = {
    bar1: {},
    bar2: {}
  };
  if (h === "determinate" || h === "buffer")
    if (u !== void 0) {
      y["aria-valuenow"] = Math.round(u);
      var w = u - 100;
      E.direction === "rtl" && (w = -w), k.bar1.transform = "translateX(".concat(w, "%)");
    } else
      process.env.NODE_ENV !== "production" && console.error("Material-UI: you need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (h === "buffer")
    if (A !== void 0) {
      var _ = (A || 0) - 100;
      E.direction === "rtl" && (_ = -_), k.bar2.transform = "translateX(".concat(_, "%)");
    } else
      process.env.NODE_ENV !== "production" && console.error("Material-UI: you need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return C.createElement("div", j({
    className: Se(a.root, a["color".concat(en(c))], i, {
      determinate: a.determinate,
      indeterminate: a.indeterminate,
      buffer: a.buffer,
      query: a.query
    }[h]),
    role: "progressbar"
  }, y, {
    ref: o
  }, m), h === "buffer" ? C.createElement("div", {
    className: Se(a.dashed, a["dashedColor".concat(en(c))])
  }) : null, C.createElement("div", {
    className: Se(a.bar, a["barColor".concat(en(c))], (h === "indeterminate" || h === "query") && a.bar1Indeterminate, {
      determinate: a.bar1Determinate,
      buffer: a.bar1Buffer
    }[h]),
    style: k.bar1
  }), h === "determinate" ? null : C.createElement("div", {
    className: Se(a.bar, (h === "indeterminate" || h === "query") && a.bar2Indeterminate, h === "buffer" ? [a["color".concat(en(c))], a.bar2Buffer] : a["barColor".concat(en(c))]),
    style: k.bar2
  }));
});
process.env.NODE_ENV !== "production" && (Wh.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: f.oneOf(["primary", "secondary"]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: f.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: f.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: f.oneOf(["determinate", "indeterminate", "buffer", "query"])
});
const Cb = $e($4, {
  name: "MuiLinearProgress"
})(Wh);
var Q4 = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: "none"
  },
  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: "underline"
  },
  // Same reset as ButtonBase.root
  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$focusVisible": {
      outline: "auto"
    }
  },
  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
}, Yh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.color, c = s === void 0 ? "primary" : s, u = e.component, A = u === void 0 ? "a" : u, b = e.onBlur, h = e.onFocus, m = e.TypographyClasses, E = e.underline, y = E === void 0 ? "hover" : E, k = e.variant, w = k === void 0 ? "inherit" : k, _ = xe(e, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]), O = Bu(), F = O.isFocusVisible, P = O.onBlurVisible, M = O.ref, B = C.useState(!1), D = B[0], H = B[1], X = Nn(o, M), ce = function(Be) {
    D && (P(), H(!1)), b && b(Be);
  }, Ae = function(Be) {
    F(Be) && H(!0), h && h(Be);
  };
  return C.createElement(cn, j({
    className: Se(a.root, a["underline".concat(en(y))], i, D && a.focusVisible, {
      button: a.button
    }[A]),
    classes: m,
    color: c,
    component: A,
    onBlur: ce,
    onFocus: Ae,
    ref: X,
    variant: w
  }, _));
});
process.env.NODE_ENV !== "production" && (Yh.propTypes = {
  /**
   * The content of the link.
   */
  children: f.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The color of the link.
   */
  color: f.oneOf(["default", "error", "inherit", "primary", "secondary", "textPrimary", "textSecondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: du,
  /**
   * @ignore
   */
  onBlur: f.func,
  /**
   * @ignore
   */
  onFocus: f.func,
  /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: f.object,
  /**
   * Controls when the link should have an underline.
   */
  underline: f.oneOf(["none", "hover", "always"]),
  /**
   * Applies the theme typography styles.
   */
  variant: f.string
});
const Io = $e(Q4, {
  name: "MuiLink"
})(Yh);
var zh = C.createContext({});
process.env.NODE_ENV !== "production" && (zh.displayName = "ListContext");
const xa = zh;
var H4 = {
  /* Styles applied to the root element. */
  root: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative"
  },
  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },
  /* Styles applied to the root element if dense. */
  dense: {},
  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
}, Gh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.component, u = c === void 0 ? "ul" : c, A = e.dense, b = A === void 0 ? !1 : A, h = e.disablePadding, m = h === void 0 ? !1 : h, E = e.subheader, y = xe(e, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]), k = C.useMemo(function() {
    return {
      dense: b
    };
  }, [b]);
  return C.createElement(xa.Provider, {
    value: k
  }, C.createElement(u, j({
    className: Se(i.root, s, b && i.dense, !m && i.padding, E && i.subheader),
    ref: o
  }, y), E, a));
});
process.env.NODE_ENV !== "production" && (Gh.propTypes = {
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: f.bool,
  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: f.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: f.node
});
const yi = $e(H4, {
  name: "MuiList"
})(Gh);
var V4 = function(e) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      position: "relative",
      textDecoration: "none",
      width: "100%",
      boxSizing: "border-box",
      textAlign: "left",
      paddingTop: 8,
      paddingBottom: 8,
      "&$focusVisible": {
        backgroundColor: e.palette.action.selected
      },
      "&$selected, &$selected:hover": {
        backgroundColor: e.palette.action.selected
      },
      "&$disabled": {
        opacity: 0.5
      }
    },
    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: "relative"
    },
    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},
    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },
    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: "flex-start"
    },
    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(e.palette.divider),
      backgroundClip: "padding-box"
    },
    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },
    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: e.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
}, q4 = typeof window > "u" ? C.useEffect : C.useLayoutEffect, Zh = C.forwardRef(function(e, o) {
  var a = e.alignItems, i = a === void 0 ? "center" : a, s = e.autoFocus, c = s === void 0 ? !1 : s, u = e.button, A = u === void 0 ? !1 : u, b = e.children, h = e.classes, m = e.className, E = e.component, y = e.ContainerComponent, k = y === void 0 ? "li" : y, w = e.ContainerProps;
  w = w === void 0 ? {} : w;
  var _ = w.className, O = xe(w, ["className"]), F = e.dense, P = F === void 0 ? !1 : F, M = e.disabled, B = M === void 0 ? !1 : M, D = e.disableGutters, H = D === void 0 ? !1 : D, X = e.divider, ce = X === void 0 ? !1 : X, Ae = e.focusVisibleClassName, se = e.selected, Be = se === void 0 ? !1 : se, Pe = xe(e, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]), ne = C.useContext(xa), J = {
    dense: P || ne.dense || !1,
    alignItems: i
  }, $ = C.useRef(null);
  q4(function() {
    c && ($.current ? $.current.focus() : process.env.NODE_ENV !== "production" && console.error("Material-UI: unable to set focus to a ListItem whose component has not been rendered."));
  }, [c]);
  var z = C.Children.toArray(b), q = z.length && $h(z[z.length - 1], ["ListItemSecondaryAction"]), de = C.useCallback(function(re) {
    $.current = co.findDOMNode(re);
  }, []), U = Nn(de, o), L = j({
    className: Se(h.root, m, J.dense && h.dense, !H && h.gutters, ce && h.divider, B && h.disabled, A && h.button, i !== "center" && h.alignItemsFlexStart, q && h.secondaryAction, Be && h.selected),
    disabled: B
  }, Pe), oe = E || "li";
  return A && (L.component = E || "div", L.focusVisibleClassName = Se(h.focusVisible, Ae), oe = _u), q ? (oe = !L.component && !E ? "div" : oe, k === "li" && (oe === "li" ? oe = "div" : L.component === "li" && (L.component = "div")), C.createElement(xa.Provider, {
    value: J
  }, C.createElement(k, j({
    className: Se(h.container, _),
    ref: U
  }, O), C.createElement(oe, L, z), z.pop()))) : C.createElement(xa.Provider, {
    value: J
  }, C.createElement(oe, j({
    ref: U
  }, L), z));
});
process.env.NODE_ENV !== "production" && (Zh.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: f.oneOf(["flex-start", "center"]),
  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: f.bool,
  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: f.bool,
  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: xo(f.node, function(n) {
    for (var e = C.Children.toArray(n.children), o = -1, a = e.length - 1; a >= 0; a -= 1) {
      var i = e[a];
      if ($h(i, ["ListItemSecondaryAction"])) {
        o = a;
        break;
      }
    }
    return o !== -1 && o !== e.length - 1 ? new Error("Material-UI: you used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: f.elementType,
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: f.elementType,
  /**
   * Props applied to the container component if used.
   */
  ContainerProps: f.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: f.bool,
  /**
   * If `true`, the list item will be disabled.
   */
  disabled: f.bool,
  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: f.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: f.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: f.string,
  /**
   * Use to apply selected styling.
   */
  selected: f.bool
});
const or = $e(V4, {
  name: "MuiListItem"
})(Zh);
var W4 = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: e.palette.action.active,
      flexShrink: 0,
      display: "inline-flex"
    },
    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
}, Jh = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = xe(e, ["classes", "className"]), c = C.useContext(xa);
  return C.createElement("div", j({
    className: Se(a.root, i, c.alignItems === "flex-start" && a.alignItemsFlexStart),
    ref: o
  }, s));
});
process.env.NODE_ENV !== "production" && (Jh.propTypes = {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: f.element.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string
});
const Y4 = $e(W4, {
  name: "MuiListItemIcon"
})(Jh);
var z4 = {
  /* Styles applied to the root element. */
  root: {
    flex: "1 1 auto",
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },
  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },
  /* Styles applied to the `Typography` components if dense. */
  dense: {},
  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },
  /* Styles applied to the primary `Typography` component. */
  primary: {},
  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
}, Xh = C.forwardRef(function(e, o) {
  var a = e.children, i = e.classes, s = e.className, c = e.disableTypography, u = c === void 0 ? !1 : c, A = e.inset, b = A === void 0 ? !1 : A, h = e.primary, m = e.primaryTypographyProps, E = e.secondary, y = e.secondaryTypographyProps, k = xe(e, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]), w = C.useContext(xa), _ = w.dense, O = h ?? a;
  O != null && O.type !== cn && !u && (O = C.createElement(cn, j({
    variant: _ ? "body2" : "body1",
    className: i.primary,
    component: "span"
  }, m), O));
  var F = E;
  return F != null && F.type !== cn && !u && (F = C.createElement(cn, j({
    variant: "body2",
    className: i.secondary,
    color: "textSecondary"
  }, y), F)), C.createElement("div", j({
    className: Se(i.root, s, _ && i.dense, b && i.inset, O && F && i.multiline),
    ref: o
  }, k), O, F);
});
process.env.NODE_ENV !== "production" && (Xh.propTypes = {
  /**
   * Alias for the `primary` property.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: f.bool,
  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: f.bool,
  /**
   * The main content element.
   */
  primary: f.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: f.object,
  /**
   * The secondary content element.
   */
  secondary: f.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: f.object
});
const tr = $e(z4, {
  name: "MuiListItemText"
})(Xh);
function wb(n, e) {
  var o = 0;
  return typeof e == "number" ? o = e : e === "center" ? o = n.height / 2 : e === "bottom" && (o = n.height), o;
}
function Eb(n, e) {
  var o = 0;
  return typeof e == "number" ? o = e : e === "center" ? o = n.width / 2 : e === "right" && (o = n.width), o;
}
function kb(n) {
  return [n.horizontal, n.vertical].map(function(e) {
    return typeof e == "number" ? "".concat(e, "px") : e;
  }).join(" ");
}
function G4(n, e) {
  for (var o = e, a = 0; o && o !== n; )
    o = o.parentElement, a += o.scrollTop;
  return a;
}
function ki(n) {
  return typeof n == "function" ? n() : n;
}
var Z4 = {
  /* Styles applied to the root element */
  root: {},
  /* Styles applied to the `Paper` component. */
  paper: {
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
}, eg = C.forwardRef(function(e, o) {
  var a = e.action, i = e.anchorEl, s = e.anchorOrigin, c = s === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : s, u = e.anchorPosition, A = e.anchorReference, b = A === void 0 ? "anchorEl" : A, h = e.children, m = e.classes, E = e.className, y = e.container, k = e.elevation, w = k === void 0 ? 8 : k, _ = e.getContentAnchorEl, O = e.marginThreshold, F = O === void 0 ? 16 : O, P = e.onEnter, M = e.onEntered, B = e.onEntering, D = e.onExit, H = e.onExited, X = e.onExiting, ce = e.open, Ae = e.PaperProps, se = Ae === void 0 ? {} : Ae, Be = e.transformOrigin, Pe = Be === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : Be, ne = e.TransitionComponent, J = ne === void 0 ? Vh : ne, $ = e.transitionDuration, z = $ === void 0 ? "auto" : $, q = e.TransitionProps, de = q === void 0 ? {} : q, U = xe(e, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]), L = C.useRef(), oe = C.useCallback(function(ge) {
    if (b === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (u || console.error('Material-UI: you need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), u;
    var G = ki(i), _e = Sa(G), we = G instanceof _e.Element ? G : qt(L.current).body, He = we.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      var nn = we.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && nn.top === 0 && nn.left === 0 && nn.right === 0 && nn.bottom === 0 && console.warn(["Material-UI: the `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    var Ze = ge === 0 ? c.vertical : "center";
    return {
      top: He.top + wb(He, Ze),
      left: He.left + Eb(He, c.horizontal)
    };
  }, [i, c.horizontal, c.vertical, u, b]), re = C.useCallback(function(ge) {
    var G = 0;
    if (_ && b === "anchorEl") {
      var _e = _(ge);
      if (_e && ge.contains(_e)) {
        var we = G4(ge, _e);
        G = _e.offsetTop + _e.clientHeight / 2 - we || 0;
      }
      process.env.NODE_ENV !== "production" && c.vertical !== "top" && console.error(["Material-UI: you can not change the default `anchorOrigin.vertical` value ", "when also providing the `getContentAnchorEl` prop to the popover component.", "Only use one of the two props.", "Set `getContentAnchorEl` to `null | undefined` or leave `anchorOrigin.vertical` unchanged."].join(`
`));
    }
    return G;
  }, [c.vertical, b, _]), ie = C.useCallback(function(ge) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return {
      vertical: wb(ge, Pe.vertical) + G,
      horizontal: Eb(ge, Pe.horizontal)
    };
  }, [Pe.horizontal, Pe.vertical]), fe = C.useCallback(function(ge) {
    var G = re(ge), _e = {
      width: ge.offsetWidth,
      height: ge.offsetHeight
    }, we = ie(_e, G);
    if (b === "none")
      return {
        top: null,
        left: null,
        transformOrigin: kb(we)
      };
    var He = oe(G), nn = He.top - we.vertical, Ze = He.left - we.horizontal, Un = nn + _e.height, Mn = Ze + _e.width, Sn = Sa(ki(i)), an = Sn.innerHeight - F, pn = Sn.innerWidth - F;
    if (nn < F) {
      var Xe = nn - F;
      nn -= Xe, we.vertical += Xe;
    } else if (Un > an) {
      var An = Un - an;
      nn -= An, we.vertical += An;
    }
    if (process.env.NODE_ENV !== "production" && _e.height > an && _e.height && an && console.error(["Material-UI: the popover component is too tall.", "Some part of it can not be seen on the screen (".concat(_e.height - an, "px)."), "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), Ze < F) {
      var Fn = Ze - F;
      Ze -= Fn, we.horizontal += Fn;
    } else if (Mn > pn) {
      var Eo = Mn - pn;
      Ze -= Eo, we.horizontal += Eo;
    }
    return {
      top: "".concat(Math.round(nn), "px"),
      left: "".concat(Math.round(Ze), "px"),
      transformOrigin: kb(we)
    };
  }, [i, b, oe, re, ie, F]), ae = C.useCallback(function() {
    var ge = L.current;
    if (ge) {
      var G = fe(ge);
      G.top !== null && (ge.style.top = G.top), G.left !== null && (ge.style.left = G.left), ge.style.transformOrigin = G.transformOrigin;
    }
  }, [fe]), be = function(G, _e) {
    B && B(G, _e), ae();
  }, pe = C.useCallback(function(ge) {
    L.current = co.findDOMNode(ge);
  }, []);
  C.useEffect(function() {
    ce && ae();
  }), C.useImperativeHandle(a, function() {
    return ce ? {
      updatePosition: function() {
        ae();
      }
    } : null;
  }, [ce, ae]), C.useEffect(function() {
    if (ce) {
      var ge = B4(function() {
        ae();
      });
      return window.addEventListener("resize", ge), function() {
        ge.clear(), window.removeEventListener("rezise", ge);
      };
    }
  }, [ce, ae]);
  var le = z;
  z === "auto" && !J.muiSupportAuto && (le = void 0);
  var me = y || (i ? qt(ki(i)).body : void 0);
  return C.createElement(Uh, j({
    container: me,
    open: ce,
    ref: o,
    BackdropProps: {
      invisible: !0
    },
    className: Se(m.root, E)
  }, U), C.createElement(J, j({
    appear: !0,
    in: ce,
    onEnter: P,
    onEntered: M,
    onExit: D,
    onExited: H,
    onExiting: X,
    timeout: le
  }, de, {
    onEntering: hr(be, de.onEntering)
  }), C.createElement(Xi, j({
    elevation: w,
    ref: pe
  }, se, {
    className: Se(m.paper, se.className)
  }), h)));
});
process.env.NODE_ENV !== "production" && (eg.propTypes = {
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Fi,
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: xo(f.oneOfType([f.object, f.func]), function(n) {
    if (n.open && (!n.anchorReference || n.anchorReference === "anchorEl")) {
      var e = ki(n.anchorEl), o = Sa(e);
      if (e instanceof o.Element) {
        var a = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && a.top === 0 && a.left === 0 && a.right === 0 && a.bottom === 0)
          return new Error(["Material-UI: the `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["Material-UI: the `anchorEl` prop provided to the component is invalid.", "It should be an Element instance but it's `".concat(e, "` instead.")].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: f.shape({
    horizontal: f.oneOfType([f.number, f.oneOf(["left", "center", "right"])]).isRequired,
    vertical: f.oneOfType([f.number, f.oneOf(["top", "center", "bottom"])]).isRequired
  }),
  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: f.shape({
    left: f.number.isRequired,
    top: f.number.isRequired
  }),
  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: f.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: f.oneOfType([f.object, f.func]),
  /**
   * The elevation of the popover.
   */
  elevation: f.number,
  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: f.func,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: f.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: f.func,
  /**
   * Callback fired before the component is entering.
   */
  onEnter: f.func,
  /**
   * Callback fired when the component has entered.
   */
  onEntered: f.func,
  /**
   * Callback fired when the component is entering.
   */
  onEntering: f.func,
  /**
   * Callback fired before the component is exiting.
   */
  onExit: f.func,
  /**
   * Callback fired when the component has exited.
   */
  onExited: f.func,
  /**
   * Callback fired when the component is exiting.
   */
  onExiting: f.func,
  /**
   * If `true`, the popover is visible.
   */
  open: f.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: f.shape({
    component: du
  }),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: f.shape({
    horizontal: f.oneOfType([f.number, f.oneOf(["left", "center", "right"])]).isRequired,
    vertical: f.oneOfType([f.number, f.oneOf(["top", "center", "bottom"])]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: f.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: f.oneOfType([f.number, f.shape({
    enter: f.number,
    exit: f.number
  }), f.oneOf(["auto"])]),
  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: f.object
});
const J4 = $e(Z4, {
  name: "MuiPopover"
})(eg);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Cr = typeof window < "u" && typeof document < "u" && typeof navigator < "u", X4 = function() {
  for (var n = ["Edge", "Trident", "Firefox"], e = 0; e < n.length; e += 1)
    if (Cr && navigator.userAgent.indexOf(n[e]) >= 0)
      return 1;
  return 0;
}();
function ek(n) {
  var e = !1;
  return function() {
    e || (e = !0, window.Promise.resolve().then(function() {
      e = !1, n();
    }));
  };
}
function nk(n) {
  var e = !1;
  return function() {
    e || (e = !0, setTimeout(function() {
      e = !1, n();
    }, X4));
  };
}
var ok = Cr && window.Promise, tk = ok ? ek : nk;
function ng(n) {
  var e = {};
  return n && e.toString.call(n) === "[object Function]";
}
function zt(n, e) {
  if (n.nodeType !== 1)
    return [];
  var o = n.ownerDocument.defaultView, a = o.getComputedStyle(n, null);
  return e ? a[e] : a;
}
function Nu(n) {
  return n.nodeName === "HTML" ? n : n.parentNode || n.host;
}
function wr(n) {
  if (!n)
    return document.body;
  switch (n.nodeName) {
    case "HTML":
    case "BODY":
      return n.ownerDocument.body;
    case "#document":
      return n.body;
  }
  var e = zt(n), o = e.overflow, a = e.overflowX, i = e.overflowY;
  return /(auto|scroll|overlay)/.test(o + i + a) ? n : wr(Nu(n));
}
function og(n) {
  return n && n.referenceNode ? n.referenceNode : n;
}
var Sb = Cr && !!(window.MSInputMethodContext && document.documentMode), Rb = Cr && /MSIE 10/.test(navigator.userAgent);
function Pa(n) {
  return n === 11 ? Sb : n === 10 ? Rb : Sb || Rb;
}
function Ra(n) {
  if (!n)
    return document.documentElement;
  for (var e = Pa(10) ? document.body : null, o = n.offsetParent || null; o === e && n.nextElementSibling; )
    o = (n = n.nextElementSibling).offsetParent;
  var a = o && o.nodeName;
  return !a || a === "BODY" || a === "HTML" ? n ? n.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(o.nodeName) !== -1 && zt(o, "position") === "static" ? Ra(o) : o;
}
function ak(n) {
  var e = n.nodeName;
  return e === "BODY" ? !1 : e === "HTML" || Ra(n.firstElementChild) === n;
}
function Yl(n) {
  return n.parentNode !== null ? Yl(n.parentNode) : n;
}
function Ni(n, e) {
  if (!n || !n.nodeType || !e || !e.nodeType)
    return document.documentElement;
  var o = n.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, a = o ? n : e, i = o ? e : n, s = document.createRange();
  s.setStart(a, 0), s.setEnd(i, 0);
  var c = s.commonAncestorContainer;
  if (n !== c && e !== c || a.contains(i))
    return ak(c) ? c : Ra(c);
  var u = Yl(n);
  return u.host ? Ni(u.host, e) : Ni(n, Yl(e).host);
}
function Ba(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", o = e === "top" ? "scrollTop" : "scrollLeft", a = n.nodeName;
  if (a === "BODY" || a === "HTML") {
    var i = n.ownerDocument.documentElement, s = n.ownerDocument.scrollingElement || i;
    return s[o];
  }
  return n[o];
}
function rk(n, e) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = Ba(e, "top"), i = Ba(e, "left"), s = o ? -1 : 1;
  return n.top += a * s, n.bottom += a * s, n.left += i * s, n.right += i * s, n;
}
function Bb(n, e) {
  var o = e === "x" ? "Left" : "Top", a = o === "Left" ? "Right" : "Bottom";
  return parseFloat(n["border" + o + "Width"]) + parseFloat(n["border" + a + "Width"]);
}
function _b(n, e, o, a) {
  return Math.max(e["offset" + n], e["scroll" + n], o["client" + n], o["offset" + n], o["scroll" + n], Pa(10) ? parseInt(o["offset" + n]) + parseInt(a["margin" + (n === "Height" ? "Top" : "Left")]) + parseInt(a["margin" + (n === "Height" ? "Bottom" : "Right")]) : 0);
}
function tg(n) {
  var e = n.body, o = n.documentElement, a = Pa(10) && getComputedStyle(o);
  return {
    height: _b("Height", e, o, a),
    width: _b("Width", e, o, a)
  };
}
var ik = function(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, sk = /* @__PURE__ */ function() {
  function n(e, o) {
    for (var a = 0; a < o.length; a++) {
      var i = o[a];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, o, a) {
    return o && n(e.prototype, o), a && n(e, a), e;
  };
}(), _a = function(n, e, o) {
  return e in n ? Object.defineProperty(n, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = o, n;
}, vo = Object.assign || function(n) {
  for (var e = 1; e < arguments.length; e++) {
    var o = arguments[e];
    for (var a in o)
      Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
  }
  return n;
};
function ht(n) {
  return vo({}, n, {
    right: n.left + n.width,
    bottom: n.top + n.height
  });
}
function zl(n) {
  var e = {};
  try {
    if (Pa(10)) {
      e = n.getBoundingClientRect();
      var o = Ba(n, "top"), a = Ba(n, "left");
      e.top += o, e.left += a, e.bottom += o, e.right += a;
    } else
      e = n.getBoundingClientRect();
  } catch {
  }
  var i = {
    left: e.left,
    top: e.top,
    width: e.right - e.left,
    height: e.bottom - e.top
  }, s = n.nodeName === "HTML" ? tg(n.ownerDocument) : {}, c = s.width || n.clientWidth || i.width, u = s.height || n.clientHeight || i.height, A = n.offsetWidth - c, b = n.offsetHeight - u;
  if (A || b) {
    var h = zt(n);
    A -= Bb(h, "x"), b -= Bb(h, "y"), i.width -= A, i.height -= b;
  }
  return ht(i);
}
function Mu(n, e) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = Pa(10), i = e.nodeName === "HTML", s = zl(n), c = zl(e), u = wr(n), A = zt(e), b = parseFloat(A.borderTopWidth), h = parseFloat(A.borderLeftWidth);
  o && i && (c.top = Math.max(c.top, 0), c.left = Math.max(c.left, 0));
  var m = ht({
    top: s.top - c.top - b,
    left: s.left - c.left - h,
    width: s.width,
    height: s.height
  });
  if (m.marginTop = 0, m.marginLeft = 0, !a && i) {
    var E = parseFloat(A.marginTop), y = parseFloat(A.marginLeft);
    m.top -= b - E, m.bottom -= b - E, m.left -= h - y, m.right -= h - y, m.marginTop = E, m.marginLeft = y;
  }
  return (a && !o ? e.contains(u) : e === u && u.nodeName !== "BODY") && (m = rk(m, e)), m;
}
function ck(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = n.ownerDocument.documentElement, a = Mu(n, o), i = Math.max(o.clientWidth, window.innerWidth || 0), s = Math.max(o.clientHeight, window.innerHeight || 0), c = e ? 0 : Ba(o), u = e ? 0 : Ba(o, "left"), A = {
    top: c - a.top + a.marginTop,
    left: u - a.left + a.marginLeft,
    width: i,
    height: s
  };
  return ht(A);
}
function ag(n) {
  var e = n.nodeName;
  if (e === "BODY" || e === "HTML")
    return !1;
  if (zt(n, "position") === "fixed")
    return !0;
  var o = Nu(n);
  return o ? ag(o) : !1;
}
function rg(n) {
  if (!n || !n.parentElement || Pa())
    return document.documentElement;
  for (var e = n.parentElement; e && zt(e, "transform") === "none"; )
    e = e.parentElement;
  return e || document.documentElement;
}
function ju(n, e, o, a) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, s = { top: 0, left: 0 }, c = i ? rg(n) : Ni(n, og(e));
  if (a === "viewport")
    s = ck(c, i);
  else {
    var u = void 0;
    a === "scrollParent" ? (u = wr(Nu(e)), u.nodeName === "BODY" && (u = n.ownerDocument.documentElement)) : a === "window" ? u = n.ownerDocument.documentElement : u = a;
    var A = Mu(u, c, i);
    if (u.nodeName === "HTML" && !ag(c)) {
      var b = tg(n.ownerDocument), h = b.height, m = b.width;
      s.top += A.top - A.marginTop, s.bottom = h + A.top, s.left += A.left - A.marginLeft, s.right = m + A.left;
    } else
      s = A;
  }
  o = o || 0;
  var E = typeof o == "number";
  return s.left += E ? o : o.left || 0, s.top += E ? o : o.top || 0, s.right -= E ? o : o.right || 0, s.bottom -= E ? o : o.bottom || 0, s;
}
function lk(n) {
  var e = n.width, o = n.height;
  return e * o;
}
function ig(n, e, o, a, i) {
  var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (n.indexOf("auto") === -1)
    return n;
  var c = ju(o, a, s, i), u = {
    top: {
      width: c.width,
      height: e.top - c.top
    },
    right: {
      width: c.right - e.right,
      height: c.height
    },
    bottom: {
      width: c.width,
      height: c.bottom - e.bottom
    },
    left: {
      width: e.left - c.left,
      height: c.height
    }
  }, A = Object.keys(u).map(function(E) {
    return vo({
      key: E
    }, u[E], {
      area: lk(u[E])
    });
  }).sort(function(E, y) {
    return y.area - E.area;
  }), b = A.filter(function(E) {
    var y = E.width, k = E.height;
    return y >= o.clientWidth && k >= o.clientHeight;
  }), h = b.length > 0 ? b[0].key : A[0].key, m = n.split("-")[1];
  return h + (m ? "-" + m : "");
}
function sg(n, e, o) {
  var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, i = a ? rg(e) : Ni(e, og(o));
  return Mu(o, i, a);
}
function cg(n) {
  var e = n.ownerDocument.defaultView, o = e.getComputedStyle(n), a = parseFloat(o.marginTop || 0) + parseFloat(o.marginBottom || 0), i = parseFloat(o.marginLeft || 0) + parseFloat(o.marginRight || 0), s = {
    width: n.offsetWidth + i,
    height: n.offsetHeight + a
  };
  return s;
}
function Mi(n) {
  var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return n.replace(/left|right|bottom|top/g, function(o) {
    return e[o];
  });
}
function lg(n, e, o) {
  o = o.split("-")[0];
  var a = cg(n), i = {
    width: a.width,
    height: a.height
  }, s = ["right", "left"].indexOf(o) !== -1, c = s ? "top" : "left", u = s ? "left" : "top", A = s ? "height" : "width", b = s ? "width" : "height";
  return i[c] = e[c] + e[A] / 2 - a[A] / 2, o === u ? i[u] = e[u] - a[b] : i[u] = e[Mi(u)], i;
}
function Er(n, e) {
  return Array.prototype.find ? n.find(e) : n.filter(e)[0];
}
function uk(n, e, o) {
  if (Array.prototype.findIndex)
    return n.findIndex(function(i) {
      return i[e] === o;
    });
  var a = Er(n, function(i) {
    return i[e] === o;
  });
  return n.indexOf(a);
}
function ug(n, e, o) {
  var a = o === void 0 ? n : n.slice(0, uk(n, "name", o));
  return a.forEach(function(i) {
    i.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var s = i.function || i.fn;
    i.enabled && ng(s) && (e.offsets.popper = ht(e.offsets.popper), e.offsets.reference = ht(e.offsets.reference), e = s(e, i));
  }), e;
}
function Ak() {
  if (!this.state.isDestroyed) {
    var n = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    n.offsets.reference = sg(this.state, this.popper, this.reference, this.options.positionFixed), n.placement = ig(this.options.placement, n.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), n.originalPlacement = n.placement, n.positionFixed = this.options.positionFixed, n.offsets.popper = lg(this.popper, n.offsets.reference, n.placement), n.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", n = ug(this.modifiers, n), this.state.isCreated ? this.options.onUpdate(n) : (this.state.isCreated = !0, this.options.onCreate(n));
  }
}
function Ag(n, e) {
  return n.some(function(o) {
    var a = o.name, i = o.enabled;
    return i && a === e;
  });
}
function $u(n) {
  for (var e = [!1, "ms", "Webkit", "Moz", "O"], o = n.charAt(0).toUpperCase() + n.slice(1), a = 0; a < e.length; a++) {
    var i = e[a], s = i ? "" + i + o : n;
    if (typeof document.body.style[s] < "u")
      return s;
  }
  return null;
}
function dk() {
  return this.state.isDestroyed = !0, Ag(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[$u("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function dg(n) {
  var e = n.ownerDocument;
  return e ? e.defaultView : window;
}
function fg(n, e, o, a) {
  var i = n.nodeName === "BODY", s = i ? n.ownerDocument.defaultView : n;
  s.addEventListener(e, o, { passive: !0 }), i || fg(wr(s.parentNode), e, o, a), a.push(s);
}
function fk(n, e, o, a) {
  o.updateBound = a, dg(n).addEventListener("resize", o.updateBound, { passive: !0 });
  var i = wr(n);
  return fg(i, "scroll", o.updateBound, o.scrollParents), o.scrollElement = i, o.eventsEnabled = !0, o;
}
function bk() {
  this.state.eventsEnabled || (this.state = fk(this.reference, this.options, this.state, this.scheduleUpdate));
}
function pk(n, e) {
  return dg(n).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(o) {
    o.removeEventListener("scroll", e.updateBound);
  }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e;
}
function hk() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = pk(this.reference, this.state));
}
function Qu(n) {
  return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
function Gl(n, e) {
  Object.keys(e).forEach(function(o) {
    var a = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(o) !== -1 && Qu(e[o]) && (a = "px"), n.style[o] = e[o] + a;
  });
}
function gk(n, e) {
  Object.keys(e).forEach(function(o) {
    var a = e[o];
    a !== !1 ? n.setAttribute(o, e[o]) : n.removeAttribute(o);
  });
}
function mk(n) {
  return Gl(n.instance.popper, n.styles), gk(n.instance.popper, n.attributes), n.arrowElement && Object.keys(n.arrowStyles).length && Gl(n.arrowElement, n.arrowStyles), n;
}
function vk(n, e, o, a, i) {
  var s = sg(i, e, n, o.positionFixed), c = ig(o.placement, s, e, n, o.modifiers.flip.boundariesElement, o.modifiers.flip.padding);
  return e.setAttribute("x-placement", c), Gl(e, { position: o.positionFixed ? "fixed" : "absolute" }), o;
}
function yk(n, e) {
  var o = n.offsets, a = o.popper, i = o.reference, s = Math.round, c = Math.floor, u = function(O) {
    return O;
  }, A = s(i.width), b = s(a.width), h = ["left", "right"].indexOf(n.placement) !== -1, m = n.placement.indexOf("-") !== -1, E = A % 2 === b % 2, y = A % 2 === 1 && b % 2 === 1, k = e ? h || m || E ? s : c : u, w = e ? s : u;
  return {
    left: k(y && !m && e ? a.left - 1 : a.left),
    top: w(a.top),
    bottom: w(a.bottom),
    right: k(a.right)
  };
}
var xk = Cr && /Firefox/i.test(navigator.userAgent);
function Ck(n, e) {
  var o = e.x, a = e.y, i = n.offsets.popper, s = Er(n.instance.modifiers, function(P) {
    return P.name === "applyStyle";
  }).gpuAcceleration;
  s !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var c = s !== void 0 ? s : e.gpuAcceleration, u = Ra(n.instance.popper), A = zl(u), b = {
    position: i.position
  }, h = yk(n, window.devicePixelRatio < 2 || !xk), m = o === "bottom" ? "top" : "bottom", E = a === "right" ? "left" : "right", y = $u("transform"), k = void 0, w = void 0;
  if (m === "bottom" ? u.nodeName === "HTML" ? w = -u.clientHeight + h.bottom : w = -A.height + h.bottom : w = h.top, E === "right" ? u.nodeName === "HTML" ? k = -u.clientWidth + h.right : k = -A.width + h.right : k = h.left, c && y)
    b[y] = "translate3d(" + k + "px, " + w + "px, 0)", b[m] = 0, b[E] = 0, b.willChange = "transform";
  else {
    var _ = m === "bottom" ? -1 : 1, O = E === "right" ? -1 : 1;
    b[m] = w * _, b[E] = k * O, b.willChange = m + ", " + E;
  }
  var F = {
    "x-placement": n.placement
  };
  return n.attributes = vo({}, F, n.attributes), n.styles = vo({}, b, n.styles), n.arrowStyles = vo({}, n.offsets.arrow, n.arrowStyles), n;
}
function bg(n, e, o) {
  var a = Er(n, function(u) {
    var A = u.name;
    return A === e;
  }), i = !!a && n.some(function(u) {
    return u.name === o && u.enabled && u.order < a.order;
  });
  if (!i) {
    var s = "`" + e + "`", c = "`" + o + "`";
    console.warn(c + " modifier is required by " + s + " modifier in order to work, be sure to include it before " + s + "!");
  }
  return i;
}
function wk(n, e) {
  var o;
  if (!bg(n.instance.modifiers, "arrow", "keepTogether"))
    return n;
  var a = e.element;
  if (typeof a == "string") {
    if (a = n.instance.popper.querySelector(a), !a)
      return n;
  } else if (!n.instance.popper.contains(a))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), n;
  var i = n.placement.split("-")[0], s = n.offsets, c = s.popper, u = s.reference, A = ["left", "right"].indexOf(i) !== -1, b = A ? "height" : "width", h = A ? "Top" : "Left", m = h.toLowerCase(), E = A ? "left" : "top", y = A ? "bottom" : "right", k = cg(a)[b];
  u[y] - k < c[m] && (n.offsets.popper[m] -= c[m] - (u[y] - k)), u[m] + k > c[y] && (n.offsets.popper[m] += u[m] + k - c[y]), n.offsets.popper = ht(n.offsets.popper);
  var w = u[m] + u[b] / 2 - k / 2, _ = zt(n.instance.popper), O = parseFloat(_["margin" + h]), F = parseFloat(_["border" + h + "Width"]), P = w - n.offsets.popper[m] - O - F;
  return P = Math.max(Math.min(c[b] - k, P), 0), n.arrowElement = a, n.offsets.arrow = (o = {}, _a(o, m, Math.round(P)), _a(o, E, ""), o), n;
}
function Ek(n) {
  return n === "end" ? "start" : n === "start" ? "end" : n;
}
var pg = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], ol = pg.slice(3);
function Fb(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, o = ol.indexOf(n), a = ol.slice(o + 1).concat(ol.slice(0, o));
  return e ? a.reverse() : a;
}
var tl = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function kk(n, e) {
  if (Ag(n.instance.modifiers, "inner") || n.flipped && n.placement === n.originalPlacement)
    return n;
  var o = ju(n.instance.popper, n.instance.reference, e.padding, e.boundariesElement, n.positionFixed), a = n.placement.split("-")[0], i = Mi(a), s = n.placement.split("-")[1] || "", c = [];
  switch (e.behavior) {
    case tl.FLIP:
      c = [a, i];
      break;
    case tl.CLOCKWISE:
      c = Fb(a);
      break;
    case tl.COUNTERCLOCKWISE:
      c = Fb(a, !0);
      break;
    default:
      c = e.behavior;
  }
  return c.forEach(function(u, A) {
    if (a !== u || c.length === A + 1)
      return n;
    a = n.placement.split("-")[0], i = Mi(a);
    var b = n.offsets.popper, h = n.offsets.reference, m = Math.floor, E = a === "left" && m(b.right) > m(h.left) || a === "right" && m(b.left) < m(h.right) || a === "top" && m(b.bottom) > m(h.top) || a === "bottom" && m(b.top) < m(h.bottom), y = m(b.left) < m(o.left), k = m(b.right) > m(o.right), w = m(b.top) < m(o.top), _ = m(b.bottom) > m(o.bottom), O = a === "left" && y || a === "right" && k || a === "top" && w || a === "bottom" && _, F = ["top", "bottom"].indexOf(a) !== -1, P = !!e.flipVariations && (F && s === "start" && y || F && s === "end" && k || !F && s === "start" && w || !F && s === "end" && _), M = !!e.flipVariationsByContent && (F && s === "start" && k || F && s === "end" && y || !F && s === "start" && _ || !F && s === "end" && w), B = P || M;
    (E || O || B) && (n.flipped = !0, (E || O) && (a = c[A + 1]), B && (s = Ek(s)), n.placement = a + (s ? "-" + s : ""), n.offsets.popper = vo({}, n.offsets.popper, lg(n.instance.popper, n.offsets.reference, n.placement)), n = ug(n.instance.modifiers, n, "flip"));
  }), n;
}
function Sk(n) {
  var e = n.offsets, o = e.popper, a = e.reference, i = n.placement.split("-")[0], s = Math.floor, c = ["top", "bottom"].indexOf(i) !== -1, u = c ? "right" : "bottom", A = c ? "left" : "top", b = c ? "width" : "height";
  return o[u] < s(a[A]) && (n.offsets.popper[A] = s(a[A]) - o[b]), o[A] > s(a[u]) && (n.offsets.popper[A] = s(a[u])), n;
}
function Rk(n, e, o, a) {
  var i = n.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), s = +i[1], c = i[2];
  if (!s)
    return n;
  if (c.indexOf("%") === 0) {
    var u = void 0;
    switch (c) {
      case "%p":
        u = o;
        break;
      case "%":
      case "%r":
      default:
        u = a;
    }
    var A = ht(u);
    return A[e] / 100 * s;
  } else if (c === "vh" || c === "vw") {
    var b = void 0;
    return c === "vh" ? b = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : b = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), b / 100 * s;
  } else
    return s;
}
function Bk(n, e, o, a) {
  var i = [0, 0], s = ["right", "left"].indexOf(a) !== -1, c = n.split(/(\+|\-)/).map(function(h) {
    return h.trim();
  }), u = c.indexOf(Er(c, function(h) {
    return h.search(/,|\s/) !== -1;
  }));
  c[u] && c[u].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var A = /\s*,\s*|\s+/, b = u !== -1 ? [c.slice(0, u).concat([c[u].split(A)[0]]), [c[u].split(A)[1]].concat(c.slice(u + 1))] : [c];
  return b = b.map(function(h, m) {
    var E = (m === 1 ? !s : s) ? "height" : "width", y = !1;
    return h.reduce(function(k, w) {
      return k[k.length - 1] === "" && ["+", "-"].indexOf(w) !== -1 ? (k[k.length - 1] = w, y = !0, k) : y ? (k[k.length - 1] += w, y = !1, k) : k.concat(w);
    }, []).map(function(k) {
      return Rk(k, E, e, o);
    });
  }), b.forEach(function(h, m) {
    h.forEach(function(E, y) {
      Qu(E) && (i[m] += E * (h[y - 1] === "-" ? -1 : 1));
    });
  }), i;
}
function _k(n, e) {
  var o = e.offset, a = n.placement, i = n.offsets, s = i.popper, c = i.reference, u = a.split("-")[0], A = void 0;
  return Qu(+o) ? A = [+o, 0] : A = Bk(o, s, c, u), u === "left" ? (s.top += A[0], s.left -= A[1]) : u === "right" ? (s.top += A[0], s.left += A[1]) : u === "top" ? (s.left += A[0], s.top -= A[1]) : u === "bottom" && (s.left += A[0], s.top += A[1]), n.popper = s, n;
}
function Fk(n, e) {
  var o = e.boundariesElement || Ra(n.instance.popper);
  n.instance.reference === o && (o = Ra(o));
  var a = $u("transform"), i = n.instance.popper.style, s = i.top, c = i.left, u = i[a];
  i.top = "", i.left = "", i[a] = "";
  var A = ju(n.instance.popper, n.instance.reference, e.padding, o, n.positionFixed);
  i.top = s, i.left = c, i[a] = u, e.boundaries = A;
  var b = e.priority, h = n.offsets.popper, m = {
    primary: function(y) {
      var k = h[y];
      return h[y] < A[y] && !e.escapeWithReference && (k = Math.max(h[y], A[y])), _a({}, y, k);
    },
    secondary: function(y) {
      var k = y === "right" ? "left" : "top", w = h[k];
      return h[y] > A[y] && !e.escapeWithReference && (w = Math.min(h[k], A[y] - (y === "right" ? h.width : h.height))), _a({}, k, w);
    }
  };
  return b.forEach(function(E) {
    var y = ["left", "top"].indexOf(E) !== -1 ? "primary" : "secondary";
    h = vo({}, h, m[y](E));
  }), n.offsets.popper = h, n;
}
function Ik(n) {
  var e = n.placement, o = e.split("-")[0], a = e.split("-")[1];
  if (a) {
    var i = n.offsets, s = i.reference, c = i.popper, u = ["bottom", "top"].indexOf(o) !== -1, A = u ? "left" : "top", b = u ? "width" : "height", h = {
      start: _a({}, A, s[A]),
      end: _a({}, A, s[A] + s[b] - c[b])
    };
    n.offsets.popper = vo({}, c, h[a]);
  }
  return n;
}
function Tk(n) {
  if (!bg(n.instance.modifiers, "hide", "preventOverflow"))
    return n;
  var e = n.offsets.reference, o = Er(n.instance.modifiers, function(a) {
    return a.name === "preventOverflow";
  }).boundaries;
  if (e.bottom < o.top || e.left > o.right || e.top > o.bottom || e.right < o.left) {
    if (n.hide === !0)
      return n;
    n.hide = !0, n.attributes["x-out-of-boundaries"] = "";
  } else {
    if (n.hide === !1)
      return n;
    n.hide = !1, n.attributes["x-out-of-boundaries"] = !1;
  }
  return n;
}
function Ok(n) {
  var e = n.placement, o = e.split("-")[0], a = n.offsets, i = a.popper, s = a.reference, c = ["left", "right"].indexOf(o) !== -1, u = ["top", "left"].indexOf(o) === -1;
  return i[c ? "left" : "top"] = s[o] - (u ? i[c ? "width" : "height"] : 0), n.placement = Mi(e), n.offsets.popper = ht(i), n;
}
var Uk = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Ik
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: _k,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Fk,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Sk
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: wk,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: kk,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: Ok
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Tk
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: Ck,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: mk,
    /** @prop {Function} */
    onLoad: vk,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, Kk = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: Uk
}, ns = function() {
  function n(e, o) {
    var a = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    ik(this, n), this.scheduleUpdate = function() {
      return requestAnimationFrame(a.update);
    }, this.update = tk(this.update.bind(this)), this.options = vo({}, n.Defaults, i), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = e && e.jquery ? e[0] : e, this.popper = o && o.jquery ? o[0] : o, this.options.modifiers = {}, Object.keys(vo({}, n.Defaults.modifiers, i.modifiers)).forEach(function(c) {
      a.options.modifiers[c] = vo({}, n.Defaults.modifiers[c] || {}, i.modifiers ? i.modifiers[c] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(c) {
      return vo({
        name: c
      }, a.options.modifiers[c]);
    }).sort(function(c, u) {
      return c.order - u.order;
    }), this.modifiers.forEach(function(c) {
      c.enabled && ng(c.onLoad) && c.onLoad(a.reference, a.popper, a.options, c, a.state);
    }), this.update();
    var s = this.options.eventsEnabled;
    s && this.enableEventListeners(), this.state.eventsEnabled = s;
  }
  return sk(n, [{
    key: "update",
    value: function() {
      return Ak.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return dk.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return bk.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return hk.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), n;
}();
ns.Utils = (typeof window < "u" ? window : global).PopperUtils;
ns.placements = pg;
ns.Defaults = Kk;
const Pk = ns;
function Dk(n, e) {
  var o = e && e.direction || "ltr";
  if (o === "ltr")
    return n;
  switch (n) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return n;
  }
}
function Zl(n) {
  return typeof n == "function" ? n() : n;
}
var Lk = typeof window < "u" ? C.useLayoutEffect : C.useEffect, Nk = {}, hg = C.forwardRef(function(e, o) {
  var a = e.anchorEl, i = e.children, s = e.container, c = e.disablePortal, u = c === void 0 ? !1 : c, A = e.keepMounted, b = A === void 0 ? !1 : A, h = e.modifiers, m = e.open, E = e.placement, y = E === void 0 ? "bottom" : E, k = e.popperOptions, w = k === void 0 ? Nk : k, _ = e.popperRef, O = e.transition, F = O === void 0 ? !1 : O, P = xe(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition"]), M = C.useRef(null), B = Nn(M, o), D = C.useRef(null), H = Nn(D, _), X = C.useRef(H);
  Lk(function() {
    X.current = H;
  }, [H]), C.useImperativeHandle(_, function() {
    return D.current;
  }, []);
  var ce = C.useState(!0), Ae = ce[0], se = ce[1], Be = Yt(), Pe = Dk(y, Be), ne = C.useState(Pe), J = ne[0], $ = ne[1];
  C.useEffect(function() {
    D.current && D.current.update();
  });
  var z = C.useCallback(function() {
    if (!(!M.current || !a || !m)) {
      D.current && (D.current.destroy(), X.current(null));
      var re = function(le) {
        $(le.placement);
      }, ie = Zl(a);
      if (process.env.NODE_ENV !== "production") {
        var fe = Sa(ie);
        if (ie instanceof fe.Element) {
          var ae = ie.getBoundingClientRect();
          process.env.NODE_ENV !== "test" && ae.top === 0 && ae.left === 0 && ae.right === 0 && ae.bottom === 0 && console.warn(["Material-UI: the `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
        }
      }
      var be = new Pk(Zl(a), M.current, j({
        placement: Pe
      }, w, {
        modifiers: j({}, u ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: "window"
          }
        }, {}, h, {}, w.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: hr(re, w.onCreate),
        onUpdate: hr(re, w.onUpdate)
      }));
      X.current(be);
    }
  }, [a, u, h, m, Pe, w]), q = C.useCallback(function(re) {
    ka(B, re), z();
  }, [B, z]), de = function() {
    se(!1);
  }, U = function() {
    D.current && (D.current.destroy(), X.current(null));
  }, L = function() {
    se(!0), U();
  };
  if (C.useEffect(function() {
    z();
  }, [z]), C.useEffect(function() {
    return function() {
      U();
    };
  }, []), C.useEffect(function() {
    !m && !F && U();
  }, [m, F]), !b && !m && (!F || Ae))
    return null;
  var oe = {
    placement: J
  };
  return F && (oe.TransitionProps = {
    in: m,
    onEnter: de,
    onExited: L
  }), C.createElement(Fh, {
    disablePortal: u,
    container: s
  }, C.createElement("div", j({
    ref: q,
    role: "tooltip"
  }, P, {
    style: j({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: "fixed",
      // Fix Popper.js display issue
      top: 0,
      left: 0
    }, P.style)
  }), typeof i == "function" ? i(oe) : i));
});
process.env.NODE_ENV !== "production" && (hg.propTypes = {
  /**
   * This is the reference element, or a function that returns the reference element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   *
   * The reference element should be an HTML Element instance or a referenceObject:
   * https://popper.js.org/popper-documentation.html#referenceObject.
   */
  anchorEl: xo(f.oneOfType([f.object, f.func]), function(n) {
    if (n.open) {
      var e = Zl(n.anchorEl), o = Sa(e);
      if (e instanceof o.Element) {
        var a = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && a.top === 0 && a.left === 0 && a.right === 0 && a.bottom === 0)
          return new Error(["Material-UI: the `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.clientWidth != "number" || typeof e.clientHeight != "number" || typeof e.getBoundingClientRect != "function")
        return new Error(["Material-UI: the `anchorEl` prop provided to the component is invalid.", "It should be an HTML Element instance or a referenceObject:", "https://popper.js.org/popper-documentation.html#referenceObject."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: f.oneOfType([f.node, f.func]).isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: f.oneOfType([f.object, f.func]),
  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: f.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: f.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: f.object,
  /**
   * If `true`, the popper is visible.
   */
  open: f.bool.isRequired,
  /**
   * Popper placement.
   */
  placement: f.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: f.object,
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Fi,
  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: f.bool
});
const Mk = hg;
var jk = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: tn({
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2)
    }, e.breakpoints.up("sm"), {
      paddingLeft: e.spacing(3),
      paddingRight: e.spacing(3)
    }),
    /* Styles applied to the root element if `variant="regular"`. */
    regular: e.mixins.toolbar,
    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
}, gg = C.forwardRef(function(e, o) {
  var a = e.classes, i = e.className, s = e.component, c = s === void 0 ? "div" : s, u = e.disableGutters, A = u === void 0 ? !1 : u, b = e.variant, h = b === void 0 ? "regular" : b, m = xe(e, ["classes", "className", "component", "disableGutters", "variant"]);
  return C.createElement(c, j({
    className: Se(a.root, a[h], i, !A && a.gutters),
    ref: o
  }, m));
});
process.env.NODE_ENV !== "production" && (gg.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: f.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * @ignore
   */
  className: f.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: f.elementType,
  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: f.bool,
  /**
   * The variant to use.
   */
  variant: f.oneOf(["regular", "dense"])
});
const $k = $e(jk, {
  name: "MuiToolbar"
})(gg);
function Ib(n) {
  return Math.round(n * 1e5) / 1e5;
}
function Qk() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      flip: !1,
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      marginLeft: 4,
      marginRight: 4,
      width: "2em",
      height: "1em",
      "&::before": {
        flip: !1,
        borderWidth: "0 1em 1em 1em",
        borderColor: "transparent transparent currentcolor transparent"
      }
    },
    '&[x-placement*="top"] $arrow': {
      flip: !1,
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      marginLeft: 4,
      marginRight: 4,
      width: "2em",
      height: "1em",
      "&::before": {
        flip: !1,
        borderWidth: "1em 1em 0 1em",
        borderColor: "currentcolor transparent transparent transparent"
      }
    },
    '&[x-placement*="right"] $arrow': {
      flip: !1,
      left: 0,
      marginLeft: "-0.95em",
      marginTop: 4,
      marginBottom: 4,
      height: "2em",
      width: "1em",
      "&::before": {
        flip: !1,
        borderWidth: "1em 1em 1em 0",
        borderColor: "transparent currentcolor transparent transparent"
      }
    },
    '&[x-placement*="left"] $arrow': {
      flip: !1,
      right: 0,
      marginRight: "-0.95em",
      marginTop: 4,
      marginBottom: 4,
      height: "2em",
      width: "1em",
      "&::before": {
        flip: !1,
        borderWidth: "1em 0 1em 1em",
        borderColor: "transparent transparent transparent currentcolor"
      }
    }
  };
}
var Hk = function(e) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: e.zIndex.tooltip,
      pointerEvents: "none",
      flip: !1
      // disable jss-rtl plugin
    },
    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: "auto"
    },
    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: Qk(),
    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: ro(e.palette.grey[700], 0.9),
      borderRadius: e.shape.borderRadius,
      color: e.palette.common.white,
      fontFamily: e.typography.fontFamily,
      padding: "4px 8px",
      fontSize: e.typography.pxToRem(10),
      lineHeight: "".concat(Ib(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: "break-word",
      fontWeight: e.typography.fontWeightMedium
    },
    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: "relative",
      margin: "0"
    },
    /* Styles applied to the arrow element. */
    arrow: {
      position: "absolute",
      fontSize: 6,
      color: ro(e.palette.grey[700], 0.9),
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid"
      }
    },
    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: "".concat(Ib(16 / 14), "em"),
      fontWeight: e.typography.fontWeightRegular
    },
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: tn({
      transformOrigin: "right center",
      margin: "0 24px "
    }, e.breakpoints.up("sm"), {
      margin: "0 14px"
    }),
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: tn({
      transformOrigin: "left center",
      margin: "0 24px"
    }, e.breakpoints.up("sm"), {
      margin: "0 14px"
    }),
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: tn({
      transformOrigin: "center bottom",
      margin: "24px 0"
    }, e.breakpoints.up("sm"), {
      margin: "14px 0"
    }),
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: tn({
      transformOrigin: "center top",
      margin: "24px 0"
    }, e.breakpoints.up("sm"), {
      margin: "14px 0"
    })
  };
}, al = !1, rl = null, mg = C.forwardRef(function(e, o) {
  var a = e.arrow, i = a === void 0 ? !1 : a, s = e.children, c = e.classes, u = e.disableFocusListener, A = u === void 0 ? !1 : u, b = e.disableHoverListener, h = b === void 0 ? !1 : b, m = e.disableTouchListener, E = m === void 0 ? !1 : m, y = e.enterDelay, k = y === void 0 ? 0 : y, w = e.enterTouchDelay, _ = w === void 0 ? 700 : w, O = e.id, F = e.interactive, P = F === void 0 ? !1 : F, M = e.leaveDelay, B = M === void 0 ? 0 : M, D = e.leaveTouchDelay, H = D === void 0 ? 1500 : D, X = e.onClose, ce = e.onOpen, Ae = e.open, se = e.placement, Be = se === void 0 ? "bottom" : se, Pe = e.PopperProps, ne = e.title, J = e.TransitionComponent, $ = J === void 0 ? Vh : J, z = e.TransitionProps, q = xe(e, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]), de = Zo(), U = C.useState(), L = U[0], oe = U[1], re = C.useState(null), ie = re[0], fe = re[1], ae = C.useRef(!1), be = C.useRef(), pe = C.useRef(), le = C.useRef(), me = C.useRef(), ge = X5({
    controlled: Ae,
    default: !1,
    name: "Tooltip"
  }), G = vh(ge, 2), _e = G[0], we = G[1], He = _e;
  if (process.env.NODE_ENV !== "production") {
    var nn = C.useRef(Ae !== void 0), Ze = nn.current;
    C.useEffect(function() {
      L && L.disabled && !Ze && ne !== "" && L.tagName.toLowerCase() === "button" && console.error(["Material-UI: you are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [ne, L, Ze]);
  }
  var Un = C.useState(), Mn = Un[0], Sn = Un[1], an = O || Mn;
  C.useEffect(function() {
    !He || Mn || Sn("mui-tooltip-".concat(Math.round(Math.random() * 1e5)));
  }, [He, Mn]), C.useEffect(function() {
    return function() {
      clearTimeout(be.current), clearTimeout(pe.current), clearTimeout(le.current), clearTimeout(me.current);
    };
  }, []);
  var pn = function(Le) {
    clearTimeout(rl), al = !0, we(!0), ce && ce(Le);
  }, Xe = function(Le) {
    var xn = s.props;
    Le.type === "mouseover" && xn.onMouseOver && Le.currentTarget === L && xn.onMouseOver(Le), !(ae.current && Le.type !== "touchstart") && (L && L.removeAttribute("title"), clearTimeout(pe.current), clearTimeout(le.current), k && !al ? (Le.persist(), pe.current = setTimeout(function() {
      pn(Le);
    }, k)) : pn(Le));
  }, An = Bu(), Fn = An.isFocusVisible, Eo = An.onBlurVisible, ko = An.ref, Rn = C.useState(!1), Zn = Rn[0], To = Rn[1], K = function() {
    Zn && (To(!1), Eo());
  }, te = function(Le) {
    L || oe(Le.currentTarget), Fn(Le) && (To(!0), Xe(Le));
    var xn = s.props;
    xn.onFocus && Le.currentTarget === L && xn.onFocus(Le);
  }, Z = function(Le) {
    clearTimeout(rl), rl = setTimeout(function() {
      al = !1;
    }, 500), we(!1), X && X(Le), clearTimeout(be.current), be.current = setTimeout(function() {
      ae.current = !1;
    }, de.transitions.duration.shortest);
  }, Re = function(Le) {
    var xn = s.props;
    Le.type === "blur" && (xn.onBlur && Le.currentTarget === L && xn.onBlur(Le), K()), Le.type === "mouseleave" && xn.onMouseLeave && Le.currentTarget === L && xn.onMouseLeave(Le), clearTimeout(pe.current), clearTimeout(le.current), Le.persist(), le.current = setTimeout(function() {
      Z(Le);
    }, B);
  }, qe = function(Le) {
    ae.current = !0;
    var xn = s.props;
    xn.onTouchStart && xn.onTouchStart(Le), clearTimeout(le.current), clearTimeout(be.current), clearTimeout(me.current), Le.persist(), me.current = setTimeout(function() {
      Xe(Le);
    }, _);
  }, Ve = function(Le) {
    s.props.onTouchEnd && s.props.onTouchEnd(Le), clearTimeout(me.current), clearTimeout(le.current), Le.persist(), le.current = setTimeout(function() {
      Z(Le);
    }, H);
  }, Ne = Nn(oe, o), Ue = Nn(ko, Ne), yn = C.useCallback(function($n) {
    ka(Ue, co.findDOMNode($n));
  }, [Ue]), jn = Nn(s.ref, yn);
  ne === "" && (He = !1);
  var Jn = !He && !h, fn = j({
    "aria-describedby": He ? an : null,
    title: Jn && typeof ne == "string" ? ne : null
  }, q, {}, s.props, {
    className: Se(q.className, s.props.className)
  });
  E || (fn.onTouchStart = qe, fn.onTouchEnd = Ve), h || (fn.onMouseOver = Xe, fn.onMouseLeave = Re), A || (fn.onFocus = te, fn.onBlur = Re);
  var xt = P ? {
    onMouseOver: fn.onMouseOver,
    onMouseLeave: fn.onMouseLeave,
    onFocus: fn.onFocus,
    onBlur: fn.onBlur
  } : {};
  process.env.NODE_ENV !== "production" && s.props.title && console.error(["Material-UI: you have provided a `title` prop to the child of <Tooltip />.", "Remove this title prop `".concat(s.props.title, "` or the Tooltip component.")].join(`
`));
  var ds = C.useMemo(function() {
    return {
      modifiers: {
        arrow: {
          enabled: !!ie,
          element: ie
        }
      }
    };
  }, [ie]);
  return C.createElement(C.Fragment, null, C.cloneElement(s, j({
    ref: jn
  }, fn)), C.createElement(Mk, j({
    className: Se(c.popper, P && c.popperInteractive, i && c.popperArrow),
    placement: Be,
    anchorEl: L,
    open: L ? He : !1,
    id: fn["aria-describedby"],
    transition: !0,
    popperOptions: ds
  }, xt, Pe), function($n) {
    var Le = $n.placement, xn = $n.TransitionProps;
    return C.createElement($, j({
      timeout: de.transitions.duration.shorter
    }, xn, z), C.createElement("div", {
      className: Se(c.tooltip, c["tooltipPlacement".concat(en(Le.split("-")[0]))], ae.current && c.touch, i && c.tooltipArrow)
    }, ne, i ? C.createElement("span", {
      className: c.arrow,
      ref: fe
    }) : null));
  }));
});
process.env.NODE_ENV !== "production" && (mg.propTypes = {
  /**
   * If `true`, adds an arrow to the tooltip.
   */
  arrow: f.bool,
  /**
   * Tooltip reference element.
   */
  children: Pp.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: f.object.isRequired,
  /**
   * Do not respond to focus events.
   */
  disableFocusListener: f.bool,
  /**
   * Do not respond to hover events.
   */
  disableHoverListener: f.bool,
  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: f.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: f.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: f.number,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: f.string,
  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: f.bool,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: f.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: f.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: f.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: f.func,
  /**
   * If `true`, the tooltip is shown.
   */
  open: f.bool,
  /**
   * Tooltip placement.
   */
  placement: f.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: f.object,
  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: f.node.isRequired,
  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: f.elementType,
  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: f.object
});
const Vk = $e(Hk, {
  name: "MuiTooltip"
})(mg);
var Hu = { exports: {} }, vg = function(e, o) {
  return function() {
    for (var i = new Array(arguments.length), s = 0; s < i.length; s++)
      i[s] = arguments[s];
    return e.apply(o, i);
  };
};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var qk = function(e) {
  return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}, Wk = vg, Yk = qk, Da = Object.prototype.toString;
function yg(n) {
  return Da.call(n) === "[object Array]";
}
function zk(n) {
  return Da.call(n) === "[object ArrayBuffer]";
}
function Gk(n) {
  return typeof FormData < "u" && n instanceof FormData;
}
function Zk(n) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(n) : e = n && n.buffer && n.buffer instanceof ArrayBuffer, e;
}
function Jk(n) {
  return typeof n == "string";
}
function Xk(n) {
  return typeof n == "number";
}
function e9(n) {
  return typeof n > "u";
}
function xg(n) {
  return n !== null && typeof n == "object";
}
function n9(n) {
  return Da.call(n) === "[object Date]";
}
function o9(n) {
  return Da.call(n) === "[object File]";
}
function t9(n) {
  return Da.call(n) === "[object Blob]";
}
function Cg(n) {
  return Da.call(n) === "[object Function]";
}
function a9(n) {
  return xg(n) && Cg(n.pipe);
}
function r9(n) {
  return typeof URLSearchParams < "u" && n instanceof URLSearchParams;
}
function i9(n) {
  return n.replace(/^\s*/, "").replace(/\s*$/, "");
}
function s9() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function os(n, e) {
  if (!(n === null || typeof n > "u"))
    if (typeof n != "object" && (n = [n]), yg(n))
      for (var o = 0, a = n.length; o < a; o++)
        e.call(null, n[o], o, n);
    else
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && e.call(null, n[i], i, n);
}
function wg() {
  var n = {};
  function e(i, s) {
    typeof n[s] == "object" && typeof i == "object" ? n[s] = wg(n[s], i) : n[s] = i;
  }
  for (var o = 0, a = arguments.length; o < a; o++)
    os(arguments[o], e);
  return n;
}
function Jl() {
  var n = {};
  function e(i, s) {
    typeof n[s] == "object" && typeof i == "object" ? n[s] = Jl(n[s], i) : typeof i == "object" ? n[s] = Jl({}, i) : n[s] = i;
  }
  for (var o = 0, a = arguments.length; o < a; o++)
    os(arguments[o], e);
  return n;
}
function c9(n, e, o) {
  return os(e, function(i, s) {
    o && typeof i == "function" ? n[s] = Wk(i, o) : n[s] = i;
  }), n;
}
var lo = {
  isArray: yg,
  isArrayBuffer: zk,
  isBuffer: Yk,
  isFormData: Gk,
  isArrayBufferView: Zk,
  isString: Jk,
  isNumber: Xk,
  isObject: xg,
  isUndefined: e9,
  isDate: n9,
  isFile: o9,
  isBlob: t9,
  isFunction: Cg,
  isStream: a9,
  isURLSearchParams: r9,
  isStandardBrowserEnv: s9,
  forEach: os,
  merge: wg,
  deepMerge: Jl,
  extend: c9,
  trim: i9
}, pa = lo;
function Tb(n) {
  return encodeURIComponent(n).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Eg = function(e, o, a) {
  if (!o)
    return e;
  var i;
  if (a)
    i = a(o);
  else if (pa.isURLSearchParams(o))
    i = o.toString();
  else {
    var s = [];
    pa.forEach(o, function(A, b) {
      A === null || typeof A > "u" || (pa.isArray(A) ? b = b + "[]" : A = [A], pa.forEach(A, function(m) {
        pa.isDate(m) ? m = m.toISOString() : pa.isObject(m) && (m = JSON.stringify(m)), s.push(Tb(b) + "=" + Tb(m));
      }));
    }), i = s.join("&");
  }
  if (i) {
    var c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}, l9 = lo;
function ts() {
  this.handlers = [];
}
ts.prototype.use = function(e, o) {
  return this.handlers.push({
    fulfilled: e,
    rejected: o
  }), this.handlers.length - 1;
};
ts.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
ts.prototype.forEach = function(e) {
  l9.forEach(this.handlers, function(a) {
    a !== null && e(a);
  });
};
var u9 = ts, A9 = lo, d9 = function(e, o, a) {
  return A9.forEach(a, function(s) {
    e = s(e, o);
  }), e;
}, il, Ob;
function kg() {
  return Ob || (Ob = 1, il = function(e) {
    return !!(e && e.__CANCEL__);
  }), il;
}
var f9 = lo, b9 = function(e, o) {
  f9.forEach(e, function(i, s) {
    s !== o && s.toUpperCase() === o.toUpperCase() && (e[o] = i, delete e[s]);
  });
}, sl, Ub;
function p9() {
  return Ub || (Ub = 1, sl = function(e, o, a, i, s) {
    return e.config = o, a && (e.code = a), e.request = i, e.response = s, e.isAxiosError = !0, e.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, e;
  }), sl;
}
var cl, Kb;
function Sg() {
  if (Kb)
    return cl;
  Kb = 1;
  var n = p9();
  return cl = function(o, a, i, s, c) {
    var u = new Error(o);
    return n(u, a, i, s, c);
  }, cl;
}
var ll, Pb;
function h9() {
  if (Pb)
    return ll;
  Pb = 1;
  var n = Sg();
  return ll = function(o, a, i) {
    var s = i.config.validateStatus;
    !s || s(i.status) ? o(i) : a(n(
      "Request failed with status code " + i.status,
      i.config,
      null,
      i.request,
      i
    ));
  }, ll;
}
var ul, Db;
function g9() {
  if (Db)
    return ul;
  Db = 1;
  var n = lo, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return ul = function(a) {
    var i = {}, s, c, u;
    return a && n.forEach(a.split(`
`), function(b) {
      if (u = b.indexOf(":"), s = n.trim(b.substr(0, u)).toLowerCase(), c = n.trim(b.substr(u + 1)), s) {
        if (i[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? i[s] = (i[s] ? i[s] : []).concat([c]) : i[s] = i[s] ? i[s] + ", " + c : c;
      }
    }), i;
  }, ul;
}
var Al, Lb;
function m9() {
  if (Lb)
    return Al;
  Lb = 1;
  var n = lo;
  return Al = n.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var o = /(msie|trident)/i.test(navigator.userAgent), a = document.createElement("a"), i;
      function s(c) {
        var u = c;
        return o && (a.setAttribute("href", u), u = a.href), a.setAttribute("href", u), {
          href: a.href,
          protocol: a.protocol ? a.protocol.replace(/:$/, "") : "",
          host: a.host,
          search: a.search ? a.search.replace(/^\?/, "") : "",
          hash: a.hash ? a.hash.replace(/^#/, "") : "",
          hostname: a.hostname,
          port: a.port,
          pathname: a.pathname.charAt(0) === "/" ? a.pathname : "/" + a.pathname
        };
      }
      return i = s(window.location.href), function(u) {
        var A = n.isString(u) ? s(u) : u;
        return A.protocol === i.protocol && A.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), Al;
}
var dl, Nb;
function v9() {
  if (Nb)
    return dl;
  Nb = 1;
  var n = lo;
  return dl = n.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(a, i, s, c, u, A) {
          var b = [];
          b.push(a + "=" + encodeURIComponent(i)), n.isNumber(s) && b.push("expires=" + new Date(s).toGMTString()), n.isString(c) && b.push("path=" + c), n.isString(u) && b.push("domain=" + u), A === !0 && b.push("secure"), document.cookie = b.join("; ");
        },
        read: function(a) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + a + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(a) {
          this.write(a, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), dl;
}
var fl, Mb;
function jb() {
  if (Mb)
    return fl;
  Mb = 1;
  var n = lo, e = h9(), o = Eg, a = g9(), i = m9(), s = Sg();
  return fl = function(u) {
    return new Promise(function(b, h) {
      var m = u.data, E = u.headers;
      n.isFormData(m) && delete E["Content-Type"];
      var y = new XMLHttpRequest();
      if (u.auth) {
        var k = u.auth.username || "", w = u.auth.password || "";
        E.Authorization = "Basic " + btoa(k + ":" + w);
      }
      if (y.open(u.method.toUpperCase(), o(u.url, u.params, u.paramsSerializer), !0), y.timeout = u.timeout, y.onreadystatechange = function() {
        if (!(!y || y.readyState !== 4) && !(y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0))) {
          var P = "getAllResponseHeaders" in y ? a(y.getAllResponseHeaders()) : null, M = !u.responseType || u.responseType === "text" ? y.responseText : y.response, B = {
            data: M,
            status: y.status,
            statusText: y.statusText,
            headers: P,
            config: u,
            request: y
          };
          e(b, h, B), y = null;
        }
      }, y.onabort = function() {
        y && (h(s("Request aborted", u, "ECONNABORTED", y)), y = null);
      }, y.onerror = function() {
        h(s("Network Error", u, null, y)), y = null;
      }, y.ontimeout = function() {
        h(s(
          "timeout of " + u.timeout + "ms exceeded",
          u,
          "ECONNABORTED",
          y
        )), y = null;
      }, n.isStandardBrowserEnv()) {
        var _ = v9(), O = (u.withCredentials || i(u.url)) && u.xsrfCookieName ? _.read(u.xsrfCookieName) : void 0;
        O && (E[u.xsrfHeaderName] = O);
      }
      if ("setRequestHeader" in y && n.forEach(E, function(P, M) {
        typeof m > "u" && M.toLowerCase() === "content-type" ? delete E[M] : y.setRequestHeader(M, P);
      }), u.withCredentials && (y.withCredentials = !0), u.responseType)
        try {
          y.responseType = u.responseType;
        } catch (F) {
          if (u.responseType !== "json")
            throw F;
        }
      typeof u.onDownloadProgress == "function" && y.addEventListener("progress", u.onDownloadProgress), typeof u.onUploadProgress == "function" && y.upload && y.upload.addEventListener("progress", u.onUploadProgress), u.cancelToken && u.cancelToken.promise.then(function(P) {
        y && (y.abort(), h(P), y = null);
      }), m === void 0 && (m = null), y.send(m);
    });
  }, fl;
}
var Yn = lo, $b = b9, y9 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function Qb(n, e) {
  !Yn.isUndefined(n) && Yn.isUndefined(n["Content-Type"]) && (n["Content-Type"] = e);
}
function x9() {
  var n;
  return (typeof process < "u" && Object.prototype.toString.call(process) === "[object process]" || typeof XMLHttpRequest < "u") && (n = jb()), n;
}
var as = {
  adapter: x9(),
  transformRequest: [function(e, o) {
    return $b(o, "Accept"), $b(o, "Content-Type"), Yn.isFormData(e) || Yn.isArrayBuffer(e) || Yn.isBuffer(e) || Yn.isStream(e) || Yn.isFile(e) || Yn.isBlob(e) ? e : Yn.isArrayBufferView(e) ? e.buffer : Yn.isURLSearchParams(e) ? (Qb(o, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : Yn.isObject(e) ? (Qb(o, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
  }],
  transformResponse: [function(e) {
    if (typeof e == "string")
      try {
        e = JSON.parse(e);
      } catch {
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  }
};
as.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
Yn.forEach(["delete", "get", "head"], function(e) {
  as.headers[e] = {};
});
Yn.forEach(["post", "put", "patch"], function(e) {
  as.headers[e] = Yn.merge(y9);
});
var Rg = as, C9 = function(e) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
}, w9 = function(e, o) {
  return o ? e.replace(/\/+$/, "") + "/" + o.replace(/^\/+/, "") : e;
}, Hb = lo, bl = d9, E9 = kg(), k9 = Rg, S9 = C9, R9 = w9;
function pl(n) {
  n.cancelToken && n.cancelToken.throwIfRequested();
}
var B9 = function(e) {
  pl(e), e.baseURL && !S9(e.url) && (e.url = R9(e.baseURL, e.url)), e.headers = e.headers || {}, e.data = bl(
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = Hb.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers || {}
  ), Hb.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete e.headers[i];
    }
  );
  var o = e.adapter || k9.adapter;
  return o(e).then(function(i) {
    return pl(e), i.data = bl(
      i.data,
      i.headers,
      e.transformResponse
    ), i;
  }, function(i) {
    return E9(i) || (pl(e), i && i.response && (i.response.data = bl(
      i.response.data,
      i.response.headers,
      e.transformResponse
    ))), Promise.reject(i);
  });
}, It = lo, Bg = function(e, o) {
  o = o || {};
  var a = {};
  return It.forEach(["url", "method", "params", "data"], function(s) {
    typeof o[s] < "u" && (a[s] = o[s]);
  }), It.forEach(["headers", "auth", "proxy"], function(s) {
    It.isObject(o[s]) ? a[s] = It.deepMerge(e[s], o[s]) : typeof o[s] < "u" ? a[s] = o[s] : It.isObject(e[s]) ? a[s] = It.deepMerge(e[s]) : typeof e[s] < "u" && (a[s] = e[s]);
  }), It.forEach([
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "maxContentLength",
    "validateStatus",
    "maxRedirects",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath"
  ], function(s) {
    typeof o[s] < "u" ? a[s] = o[s] : typeof e[s] < "u" && (a[s] = e[s]);
  }), a;
}, ji = lo, _9 = Eg, Vb = u9, F9 = B9, _g = Bg;
function kr(n) {
  this.defaults = n, this.interceptors = {
    request: new Vb(),
    response: new Vb()
  };
}
kr.prototype.request = function(e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = _g(this.defaults, e), e.method = e.method ? e.method.toLowerCase() : "get";
  var o = [F9, void 0], a = Promise.resolve(e);
  for (this.interceptors.request.forEach(function(s) {
    o.unshift(s.fulfilled, s.rejected);
  }), this.interceptors.response.forEach(function(s) {
    o.push(s.fulfilled, s.rejected);
  }); o.length; )
    a = a.then(o.shift(), o.shift());
  return a;
};
kr.prototype.getUri = function(e) {
  return e = _g(this.defaults, e), _9(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
ji.forEach(["delete", "get", "head", "options"], function(e) {
  kr.prototype[e] = function(o, a) {
    return this.request(ji.merge(a || {}, {
      method: e,
      url: o
    }));
  };
});
ji.forEach(["post", "put", "patch"], function(e) {
  kr.prototype[e] = function(o, a, i) {
    return this.request(ji.merge(i || {}, {
      method: e,
      url: o,
      data: a
    }));
  };
});
var I9 = kr, hl, qb;
function Fg() {
  if (qb)
    return hl;
  qb = 1;
  function n(e) {
    this.message = e;
  }
  return n.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, n.prototype.__CANCEL__ = !0, hl = n, hl;
}
var gl, Wb;
function T9() {
  if (Wb)
    return gl;
  Wb = 1;
  var n = Fg();
  function e(o) {
    if (typeof o != "function")
      throw new TypeError("executor must be a function.");
    var a;
    this.promise = new Promise(function(c) {
      a = c;
    });
    var i = this;
    o(function(c) {
      i.reason || (i.reason = new n(c), a(i.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.source = function() {
    var a, i = new e(function(c) {
      a = c;
    });
    return {
      token: i,
      cancel: a
    };
  }, gl = e, gl;
}
var ml, Yb;
function O9() {
  return Yb || (Yb = 1, ml = function(e) {
    return function(a) {
      return e.apply(null, a);
    };
  }), ml;
}
var zb = lo, U9 = vg, Si = I9, K9 = Bg, P9 = Rg;
function Ig(n) {
  var e = new Si(n), o = U9(Si.prototype.request, e);
  return zb.extend(o, Si.prototype, e), zb.extend(o, e), o;
}
var Po = Ig(P9);
Po.Axios = Si;
Po.create = function(e) {
  return Ig(K9(Po.defaults, e));
};
Po.Cancel = Fg();
Po.CancelToken = T9();
Po.isCancel = kg();
Po.all = function(e) {
  return Promise.all(e);
};
Po.spread = O9();
Hu.exports = Po;
Hu.exports.default = Po;
var D9 = Hu.exports, L9 = D9;
const rs = /* @__PURE__ */ Ua(L9), N9 = {
  sessionReset: 0
};
function M9(n = N9, e) {
  switch (e.type) {
    case "UPDATE_SESSION":
      return {
        ...n,
        sessionReset: n.sessionReset + 1
      };
    default:
      return n;
  }
}
const j9 = (n, e = "/personal-investing/tools/adv-nasu", o = !1) => {
  let a = n.split(e)[0];
  const i = n.split(e)[1] ? n.split(e)[1] : "";
  o ? (a.includes("localhost") && (a = "https://wwwdev.troweprice.com"), window.location.replace(`${a}/usis/advice/fps`)) : n.includes("/error") || window.location.replace(`${a}${e}/error${i}`);
}, $9 = (n) => !!n.isAxiosError && !n.response, Q9 = (n, e, o) => {
  $9(n) && console.log("Network Error");
  const a = window.location.href, i = a.split(e)[0];
  if (n.response && n.response.status === 401)
    window.location.replace(`${i}/usis/login/?pdurl=/clx-tk/token-exchange/redirect/default?sdurl=${a}`);
  else
    throw o && j9(a, e), n;
}, H9 = (n) => n && (n.status === 204 || n.status === 205) ? null : n, Tg = async (n = { apiKey: void 0, serviceHost: void 0 }, e, o = "get", a = {}, i = null, s = "/personal-investing/tools/adv-nasu", c = !0) => {
  const { apiKey: u, serviceHost: A } = n;
  return await rs({
    method: o,
    url: e,
    baseURL: A,
    responseType: "json",
    withCredentials: !0,
    headers: {
      apikey: u,
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-trp-requested-with": "app",
      ...a
    },
    data: i
  }).then((b) => H9(b)).catch((b) => Q9(b, s, c));
}, Og = { sessionReset: 0 }, V9 = Rp(Og), q9 = 1680, vl = 1800;
let Ug = Date.now(), Gb = 0;
const Zb = () => {
  Ug = Date.now();
}, W9 = ({ children: n, appBase: e }) => {
  const { applicationConfig: o } = Bp(Vu).state, [a, i] = _p(M9, { ...Og }), { sessionReset: s } = a;
  s !== Gb && (Gb = s, Zb());
  const [c, u] = va(Date.now()), A = Math.floor((c - Ug) / 1e3), b = () => {
    const m = `${document.location.origin}/usis/advice/fps/api-config.json`;
    rs.create({
      headers: {
        "Application-Type": "application/json"
      }
    }).get(`${m}`).then(async (y) => {
      const { apiKey: k } = y.data;
      return k;
    }).then((y) => {
      Tg(
        { ...o, apiKey: y },
        "/aps-services/service/client/v1/session",
        "get",
        {},
        null,
        e
      ), Zb();
    });
  }, h = () => {
    const m = window.location.href;
    window.location.href = `${document.location.origin}/usis/login/logout?sdurl=${m}`;
  };
  return A >= vl && h(), iu(() => {
    setInterval(() => {
      u(Date.now());
    }, 1e3);
  }, []), /* @__PURE__ */ p.jsxs(V9.Provider, { value: { state: a, dispatch: i }, children: [
    /* @__PURE__ */ p.jsxs(
      Ku,
      {
        open: A >= q9,
        children: [
          /* @__PURE__ */ p.jsxs(Pu, { children: [
            /* @__PURE__ */ p.jsx("p", { children: /* @__PURE__ */ p.jsx("strong", { children: "You are about to be logged out" }) }),
            /* @__PURE__ */ p.jsxs("p", { children: [
              "We have noticed that you have been inactive for a while. For your security, we",
              "'",
              "ll automatically log you out in approximately ",
              vl - A > 0 ? vl - A : 0,
              " seconds."
            ] }),
            /* @__PURE__ */ p.jsxs("p", { children: [
              "Click ",
              '"',
              "Keep Me Online",
              '"',
              " to continue using your online accounts. If you",
              "'",
              "re done, you may click ",
              '"',
              "Log Out",
              '"',
              "."
            ] })
          ] }),
          /* @__PURE__ */ p.jsxs(Dh, { style: { display: "flex", padding: "16px" }, children: [
            /* @__PURE__ */ p.jsx(Go, { onClick: h, variant: "outlined", type: "button", style: { flex: "1", marginRight: "32px" }, children: "Log Out" }),
            /* @__PURE__ */ p.jsx(
              Go,
              {
                onClick: b,
                variant: "outlined",
                type: "button",
                style: {
                  flex: "1",
                  backgroundColor: "#086EA1",
                  borderColor: "#086EA1",
                  color: "white"
                },
                children: "Keep Me Online"
              }
            )
          ] })
        ]
      }
    ),
    n
  ] });
};
var Kg = { exports: {} };
(function(n, e) {
  (function(o, a) {
    n.exports = a();
  })(dt, function() {
    var o = "minute", a = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
    return function(s, c, u) {
      var A = c.prototype;
      u.utc = function(w) {
        var _ = { date: w, utc: !0, args: arguments };
        return new c(_);
      }, A.utc = function(w) {
        var _ = u(this.toDate(), { locale: this.$L, utc: !0 });
        return w ? _.add(this.utcOffset(), o) : _;
      }, A.local = function() {
        return u(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var b = A.parse;
      A.parse = function(w) {
        w.utc && (this.$u = !0), this.$utils().u(w.$offset) || (this.$offset = w.$offset), b.call(this, w);
      };
      var h = A.init;
      A.init = function() {
        if (this.$u) {
          var w = this.$d;
          this.$y = w.getUTCFullYear(), this.$M = w.getUTCMonth(), this.$D = w.getUTCDate(), this.$W = w.getUTCDay(), this.$H = w.getUTCHours(), this.$m = w.getUTCMinutes(), this.$s = w.getUTCSeconds(), this.$ms = w.getUTCMilliseconds();
        } else
          h.call(this);
      };
      var m = A.utcOffset;
      A.utcOffset = function(w, _) {
        var O = this.$utils().u;
        if (O(w))
          return this.$u ? 0 : O(this.$offset) ? m.call(this) : this.$offset;
        if (typeof w == "string" && (w = function(B) {
          B === void 0 && (B = "");
          var D = B.match(a);
          if (!D)
            return null;
          var H = ("" + D[0]).match(i) || ["-", 0, 0], X = H[0], ce = 60 * +H[1] + +H[2];
          return ce === 0 ? 0 : X === "+" ? ce : -ce;
        }(w), w === null))
          return this;
        var F = Math.abs(w) <= 16 ? 60 * w : w, P = this;
        if (_)
          return P.$offset = F, P.$u = w === 0, P;
        if (w !== 0) {
          var M = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (P = this.local().add(F + M, o)).$offset = F, P.$x.$localOffset = M;
        } else
          P = this.utc();
        return P;
      };
      var E = A.format;
      A.format = function(w) {
        var _ = w || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return E.call(this, _);
      }, A.valueOf = function() {
        var w = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * w;
      }, A.isUTC = function() {
        return !!this.$u;
      }, A.toISOString = function() {
        return this.toDate().toISOString();
      }, A.toString = function() {
        return this.toDate().toUTCString();
      };
      var y = A.toDate;
      A.toDate = function(w) {
        return w === "s" && this.$offset ? u(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : y.call(this);
      };
      var k = A.diff;
      A.diff = function(w, _, O) {
        if (w && this.$u === w.$u)
          return k.call(this, w, _, O);
        var F = this.local(), P = u(w).local();
        return k.call(F, P, _, O);
      };
    };
  });
})(Kg);
var Y9 = Kg.exports;
const z9 = /* @__PURE__ */ Ua(Y9);
var Pg = { exports: {} };
(function(n, e) {
  (function(o, a) {
    n.exports = a();
  })(dt, function() {
    var o = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, a = {};
    return function(i, s, c) {
      var u, A = function(E, y, k) {
        k === void 0 && (k = {});
        var w = new Date(E), _ = function(O, F) {
          F === void 0 && (F = {});
          var P = F.timeZoneName || "short", M = O + "|" + P, B = a[M];
          return B || (B = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: O, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: P }), a[M] = B), B;
        }(y, k);
        return _.formatToParts(w);
      }, b = function(E, y) {
        for (var k = A(E, y), w = [], _ = 0; _ < k.length; _ += 1) {
          var O = k[_], F = O.type, P = O.value, M = o[F];
          M >= 0 && (w[M] = parseInt(P, 10));
        }
        var B = w[3], D = B === 24 ? 0 : B, H = w[0] + "-" + w[1] + "-" + w[2] + " " + D + ":" + w[4] + ":" + w[5] + ":000", X = +E;
        return (c.utc(H).valueOf() - (X -= X % 1e3)) / 6e4;
      }, h = s.prototype;
      h.tz = function(E, y) {
        E === void 0 && (E = u);
        var k = this.utcOffset(), w = this.toDate(), _ = w.toLocaleString("en-US", { timeZone: E }), O = Math.round((w - new Date(_)) / 1e3 / 60), F = c(_, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(w.getTimezoneOffset() / 15) - O, !0);
        if (y) {
          var P = F.utcOffset();
          F = F.add(k - P, "minute");
        }
        return F.$x.$timezone = E, F;
      }, h.offsetName = function(E) {
        var y = this.$x.$timezone || c.tz.guess(), k = A(this.valueOf(), y, { timeZoneName: E }).find(function(w) {
          return w.type.toLowerCase() === "timezonename";
        });
        return k && k.value;
      };
      var m = h.startOf;
      h.startOf = function(E, y) {
        if (!this.$x || !this.$x.$timezone)
          return m.call(this, E, y);
        var k = c(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return m.call(k, E, y).tz(this.$x.$timezone, !0);
      }, c.tz = function(E, y, k) {
        var w = k && y, _ = k || y || u, O = b(+c(), _);
        if (typeof E != "string")
          return c(E).tz(_);
        var F = function(D, H, X) {
          var ce = D - 60 * H * 1e3, Ae = b(ce, X);
          if (H === Ae)
            return [ce, H];
          var se = b(ce -= 60 * (Ae - H) * 1e3, X);
          return Ae === se ? [ce, Ae] : [D - 60 * Math.min(Ae, se) * 1e3, Math.max(Ae, se)];
        }(c.utc(E, w).valueOf(), O, _), P = F[0], M = F[1], B = c(P).utcOffset(M);
        return B.$x.$timezone = _, B;
      }, c.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, c.tz.setDefault = function(E) {
        u = E;
      };
    };
  });
})(Pg);
var G9 = Pg.exports;
const Z9 = /* @__PURE__ */ Ua(G9);
var Dg = { exports: {} };
(function(n, e) {
  (function(o, a) {
    n.exports = a();
  })(dt, function() {
    var o = 1e3, a = 6e4, i = 36e5, s = "millisecond", c = "second", u = "minute", A = "hour", b = "day", h = "week", m = "month", E = "quarter", y = "year", k = "date", w = "Invalid Date", _ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, O = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, F = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(ne) {
      var J = ["th", "st", "nd", "rd"], $ = ne % 100;
      return "[" + ne + (J[($ - 20) % 10] || J[$] || J[0]) + "]";
    } }, P = function(ne, J, $) {
      var z = String(ne);
      return !z || z.length >= J ? ne : "" + Array(J + 1 - z.length).join($) + ne;
    }, M = { s: P, z: function(ne) {
      var J = -ne.utcOffset(), $ = Math.abs(J), z = Math.floor($ / 60), q = $ % 60;
      return (J <= 0 ? "+" : "-") + P(z, 2, "0") + ":" + P(q, 2, "0");
    }, m: function ne(J, $) {
      if (J.date() < $.date())
        return -ne($, J);
      var z = 12 * ($.year() - J.year()) + ($.month() - J.month()), q = J.clone().add(z, m), de = $ - q < 0, U = J.clone().add(z + (de ? -1 : 1), m);
      return +(-(z + ($ - q) / (de ? q - U : U - q)) || 0);
    }, a: function(ne) {
      return ne < 0 ? Math.ceil(ne) || 0 : Math.floor(ne);
    }, p: function(ne) {
      return { M: m, y, w: h, d: b, D: k, h: A, m: u, s: c, ms: s, Q: E }[ne] || String(ne || "").toLowerCase().replace(/s$/, "");
    }, u: function(ne) {
      return ne === void 0;
    } }, B = "en", D = {};
    D[B] = F;
    var H = "$isDayjsObject", X = function(ne) {
      return ne instanceof Be || !(!ne || !ne[H]);
    }, ce = function ne(J, $, z) {
      var q;
      if (!J)
        return B;
      if (typeof J == "string") {
        var de = J.toLowerCase();
        D[de] && (q = de), $ && (D[de] = $, q = de);
        var U = J.split("-");
        if (!q && U.length > 1)
          return ne(U[0]);
      } else {
        var L = J.name;
        D[L] = J, q = L;
      }
      return !z && q && (B = q), q || !z && B;
    }, Ae = function(ne, J) {
      if (X(ne))
        return ne.clone();
      var $ = typeof J == "object" ? J : {};
      return $.date = ne, $.args = arguments, new Be($);
    }, se = M;
    se.l = ce, se.i = X, se.w = function(ne, J) {
      return Ae(ne, { locale: J.$L, utc: J.$u, x: J.$x, $offset: J.$offset });
    };
    var Be = function() {
      function ne($) {
        this.$L = ce($.locale, null, !0), this.parse($), this.$x = this.$x || $.x || {}, this[H] = !0;
      }
      var J = ne.prototype;
      return J.parse = function($) {
        this.$d = function(z) {
          var q = z.date, de = z.utc;
          if (q === null)
            return /* @__PURE__ */ new Date(NaN);
          if (se.u(q))
            return /* @__PURE__ */ new Date();
          if (q instanceof Date)
            return new Date(q);
          if (typeof q == "string" && !/Z$/i.test(q)) {
            var U = q.match(_);
            if (U) {
              var L = U[2] - 1 || 0, oe = (U[7] || "0").substring(0, 3);
              return de ? new Date(Date.UTC(U[1], L, U[3] || 1, U[4] || 0, U[5] || 0, U[6] || 0, oe)) : new Date(U[1], L, U[3] || 1, U[4] || 0, U[5] || 0, U[6] || 0, oe);
            }
          }
          return new Date(q);
        }($), this.init();
      }, J.init = function() {
        var $ = this.$d;
        this.$y = $.getFullYear(), this.$M = $.getMonth(), this.$D = $.getDate(), this.$W = $.getDay(), this.$H = $.getHours(), this.$m = $.getMinutes(), this.$s = $.getSeconds(), this.$ms = $.getMilliseconds();
      }, J.$utils = function() {
        return se;
      }, J.isValid = function() {
        return this.$d.toString() !== w;
      }, J.isSame = function($, z) {
        var q = Ae($);
        return this.startOf(z) <= q && q <= this.endOf(z);
      }, J.isAfter = function($, z) {
        return Ae($) < this.startOf(z);
      }, J.isBefore = function($, z) {
        return this.endOf(z) < Ae($);
      }, J.$g = function($, z, q) {
        return se.u($) ? this[z] : this.set(q, $);
      }, J.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, J.valueOf = function() {
        return this.$d.getTime();
      }, J.startOf = function($, z) {
        var q = this, de = !!se.u(z) || z, U = se.p($), L = function(le, me) {
          var ge = se.w(q.$u ? Date.UTC(q.$y, me, le) : new Date(q.$y, me, le), q);
          return de ? ge : ge.endOf(b);
        }, oe = function(le, me) {
          return se.w(q.toDate()[le].apply(q.toDate("s"), (de ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(me)), q);
        }, re = this.$W, ie = this.$M, fe = this.$D, ae = "set" + (this.$u ? "UTC" : "");
        switch (U) {
          case y:
            return de ? L(1, 0) : L(31, 11);
          case m:
            return de ? L(1, ie) : L(0, ie + 1);
          case h:
            var be = this.$locale().weekStart || 0, pe = (re < be ? re + 7 : re) - be;
            return L(de ? fe - pe : fe + (6 - pe), ie);
          case b:
          case k:
            return oe(ae + "Hours", 0);
          case A:
            return oe(ae + "Minutes", 1);
          case u:
            return oe(ae + "Seconds", 2);
          case c:
            return oe(ae + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, J.endOf = function($) {
        return this.startOf($, !1);
      }, J.$set = function($, z) {
        var q, de = se.p($), U = "set" + (this.$u ? "UTC" : ""), L = (q = {}, q[b] = U + "Date", q[k] = U + "Date", q[m] = U + "Month", q[y] = U + "FullYear", q[A] = U + "Hours", q[u] = U + "Minutes", q[c] = U + "Seconds", q[s] = U + "Milliseconds", q)[de], oe = de === b ? this.$D + (z - this.$W) : z;
        if (de === m || de === y) {
          var re = this.clone().set(k, 1);
          re.$d[L](oe), re.init(), this.$d = re.set(k, Math.min(this.$D, re.daysInMonth())).$d;
        } else
          L && this.$d[L](oe);
        return this.init(), this;
      }, J.set = function($, z) {
        return this.clone().$set($, z);
      }, J.get = function($) {
        return this[se.p($)]();
      }, J.add = function($, z) {
        var q, de = this;
        $ = Number($);
        var U = se.p(z), L = function(ie) {
          var fe = Ae(de);
          return se.w(fe.date(fe.date() + Math.round(ie * $)), de);
        };
        if (U === m)
          return this.set(m, this.$M + $);
        if (U === y)
          return this.set(y, this.$y + $);
        if (U === b)
          return L(1);
        if (U === h)
          return L(7);
        var oe = (q = {}, q[u] = a, q[A] = i, q[c] = o, q)[U] || 1, re = this.$d.getTime() + $ * oe;
        return se.w(re, this);
      }, J.subtract = function($, z) {
        return this.add(-1 * $, z);
      }, J.format = function($) {
        var z = this, q = this.$locale();
        if (!this.isValid())
          return q.invalidDate || w;
        var de = $ || "YYYY-MM-DDTHH:mm:ssZ", U = se.z(this), L = this.$H, oe = this.$m, re = this.$M, ie = q.weekdays, fe = q.months, ae = q.meridiem, be = function(me, ge, G, _e) {
          return me && (me[ge] || me(z, de)) || G[ge].slice(0, _e);
        }, pe = function(me) {
          return se.s(L % 12 || 12, me, "0");
        }, le = ae || function(me, ge, G) {
          var _e = me < 12 ? "AM" : "PM";
          return G ? _e.toLowerCase() : _e;
        };
        return de.replace(O, function(me, ge) {
          return ge || function(G) {
            switch (G) {
              case "YY":
                return String(z.$y).slice(-2);
              case "YYYY":
                return se.s(z.$y, 4, "0");
              case "M":
                return re + 1;
              case "MM":
                return se.s(re + 1, 2, "0");
              case "MMM":
                return be(q.monthsShort, re, fe, 3);
              case "MMMM":
                return be(fe, re);
              case "D":
                return z.$D;
              case "DD":
                return se.s(z.$D, 2, "0");
              case "d":
                return String(z.$W);
              case "dd":
                return be(q.weekdaysMin, z.$W, ie, 2);
              case "ddd":
                return be(q.weekdaysShort, z.$W, ie, 3);
              case "dddd":
                return ie[z.$W];
              case "H":
                return String(L);
              case "HH":
                return se.s(L, 2, "0");
              case "h":
                return pe(1);
              case "hh":
                return pe(2);
              case "a":
                return le(L, oe, !0);
              case "A":
                return le(L, oe, !1);
              case "m":
                return String(oe);
              case "mm":
                return se.s(oe, 2, "0");
              case "s":
                return String(z.$s);
              case "ss":
                return se.s(z.$s, 2, "0");
              case "SSS":
                return se.s(z.$ms, 3, "0");
              case "Z":
                return U;
            }
            return null;
          }(me) || U.replace(":", "");
        });
      }, J.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, J.diff = function($, z, q) {
        var de, U = this, L = se.p(z), oe = Ae($), re = (oe.utcOffset() - this.utcOffset()) * a, ie = this - oe, fe = function() {
          return se.m(U, oe);
        };
        switch (L) {
          case y:
            de = fe() / 12;
            break;
          case m:
            de = fe();
            break;
          case E:
            de = fe() / 3;
            break;
          case h:
            de = (ie - re) / 6048e5;
            break;
          case b:
            de = (ie - re) / 864e5;
            break;
          case A:
            de = ie / i;
            break;
          case u:
            de = ie / a;
            break;
          case c:
            de = ie / o;
            break;
          default:
            de = ie;
        }
        return q ? de : se.a(de);
      }, J.daysInMonth = function() {
        return this.endOf(m).$D;
      }, J.$locale = function() {
        return D[this.$L];
      }, J.locale = function($, z) {
        if (!$)
          return this.$L;
        var q = this.clone(), de = ce($, z, !0);
        return de && (q.$L = de), q;
      }, J.clone = function() {
        return se.w(this.$d, this);
      }, J.toDate = function() {
        return new Date(this.valueOf());
      }, J.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, J.toISOString = function() {
        return this.$d.toISOString();
      }, J.toString = function() {
        return this.$d.toUTCString();
      }, ne;
    }(), Pe = Be.prototype;
    return Ae.prototype = Pe, [["$ms", s], ["$s", c], ["$m", u], ["$H", A], ["$W", b], ["$M", m], ["$y", y], ["$D", k]].forEach(function(ne) {
      Pe[ne[1]] = function(J) {
        return this.$g(J, ne[0], ne[1]);
      };
    }), Ae.extend = function(ne, J) {
      return ne.$i || (ne(J, Be, Ae), ne.$i = !0), Ae;
    }, Ae.locale = ce, Ae.isDayjs = X, Ae.unix = function(ne) {
      return Ae(1e3 * ne);
    }, Ae.en = D[B], Ae.Ls = D, Ae.p = {}, Ae;
  });
})(Dg);
var J9 = Dg.exports;
const Fa = /* @__PURE__ */ Ua(J9);
Fa.extend(z9);
Fa.extend(Z9);
const Jb = "America/New_York", X9 = async (n, e) => {
  let o;
  return await Tg(
    n,
    "/adv-disc-svc/service/brokerage/v1/consent",
    "get",
    {},
    null,
    e
  ).then((a) => {
    const i = a.data.clientSummary.planningGroup && a.data.clientSummary.planningGroup.previousEngagements && a.data.clientSummary.planningGroup.previousEngagements.some((A) => A.engagementStatus.status === "CMPD"), s = Fa().tz(Jb).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }), c = Fa.tz(a.data.clientSummary.currentClient.clientConsent.expirationDate, Jb), u = i ? !s.isAfter(c) : a.data.groupConsentStatus;
    o = {
      client: a.data.clientSummary.currentClient ? a.data.clientSummary.currentClient.clientType ? a.data.clientSummary.currentClient.clientType.toUpperCase() === "PRIMARY" ? "PRIMARY" : "COCLIENT" : "BTR_USER" : "NEW_USER",
      businessPartyId: a.data.businessPartyId,
      financialPlanningGroupId: a.data.financialPlanningGroupId,
      financialPlanningEngagementId: a.data.financialPlanningEngagementId,
      engagementTypeId: a.data.engagementTypeId,
      consent: u,
      clientIsGuest: a.data.isClientGuest,
      coClientIsGuest: a.data.isCoClientGuest,
      clientActivated: a.data.isClientActivated,
      coClientActivated: a.data.isCoClientActivated,
      clientRasuConsented: a.data.isClientRasuConsented,
      coClientRasuConsented: a.data.isCoclientRasuConsented,
      clientSubmitted: a.data.isClientSubmitted,
      coClientSubmitted: a.data.isCoClientSubmitted,
      clientExternalSubmitted: a.data.clientExternalSubmitted,
      coClientExternalSubmitted: a.data.coClientExternalSubmitted,
      clientHasAccounts: a.data.hasClientRegistrations,
      coClientHasAccounts: a.data.hasCoClientRegistrations,
      clientRequiresRASU: a.data.clientRequiresRASU,
      coClientRequiresRASU: a.data.coClientRequiresRASU,
      jointRegistrations: a.data.jointRegistrations,
      clientHasInternalAccounts: a.data.clientHasInternalAccounts,
      coClientHasInternalAccounts: a.data.coClientHasInternalAccounts,
      clientHasExternalAccounts: a.data.clientHasExternalAccounts,
      coClientHasExternalAccounts: a.data.coClientHasExternalAccounts,
      jointExternalAccounts: a.data.jointExternalAccounts,
      externalFormStatus: a.data.externalFormStatus,
      clientHasRAS: a.data.hasClientRas,
      coClientHasRAS: a.data.hasCoClientRas,
      modelChange: a.data.isModelChange,
      groupStatus: a.data.clientSummary.planningGroup ? a.data.clientSummary.planningGroup.currentEngagement.engagementStatus.status : null,
      groupHasCoClient: a.data.clientSummary.planningGroup ? a.data.clientSummary.planningGroup.clients.length > 1 : null,
      proposalType: a.data.clientSummary.planningGroup ? a.data.clientSummary.planningGroup.proposalType : null,
      error: !1,
      isLoggedInUserPOA: a.data.isLoggedInUserPOA
    };
  }).catch((a) => {
    console.error(a), o = {
      client: "PRIMARY",
      consent: !1,
      groupStatus: void 0,
      error: !0
    };
  }), o;
}, eS = ({ appBase: n, internalDomain: e, disableRedirect: o, status: a, awaitRedirect: i, setAwaitRedirect: s }) => {
  const c = window.location.href;
  let u = c.split(n)[0];
  const A = a.client === "PRIMARY" ? "client" : "coClient", b = (m, E, y) => {
    const k = `${u}${m}`, w = E ? `${u}${E}` : void 0, _ = y ? `${u}${y}` : void 0, O = c === k, F = c.startsWith(w), P = c.startsWith(_);
    O || F || P ? s(!1) : window.location.replace(k);
  }, h = () => {
    switch (!0) {
      case (a[`${A}HasExternalAccounts`] && (!a[`${A}ExternalSubmitted`] || a.externalFormStatus)):
        return !1;
      case (a[`${A}HasExternalAccounts`] && a[`${A}ExternalSubmitted`] && !a.externalFormStatus):
        return !0;
      case (a.groupHasCoClient && !a.clientRequiresRASU && !a.coClientRequiresRASU && (!a.clientSubmitted || !a.coClientSubmitted) || !a.groupHasCoClient && !a.clientRequiresRASU && !a.clientSubmitted || a.groupHasCoClient && a.clientHasRAS && a.coClientHasRAS && (!a.clientSubmitted || !a.coClientSubmitted)):
        return !1;
      case (a.groupHasCoClient && (a.clientSubmitted || !a.clientRequiresRASU) && (a.coClientSubmitted || !a.coClientRequiresRASU)):
        return !0;
      case (!a.groupHasCoClient && a.clientSubmitted):
        return !0;
      default:
        return !1;
    }
  };
  return iu(() => {
    if (!a.error && !o && i)
      switch (!0) {
        case e:
          window.location.href.toLowerCase().indexOf("/usis/advice/checkout") === -1 && alert("Customer Web View has not been built to support this page."), b("/usis/advice/checkout/hub", "/usis/advice/checkout/error", "/usis/advice/checkout/hub/");
          break;
        case (!a.financialPlanningGroupId || !a.financialPlanningEngagementId):
          b("/usis/advice/fps");
          break;
        case (window.location.href.toLowerCase().indexOf("/usis/advice/checkout/transfer") !== -1 || window.location.href.toLowerCase().indexOf("/usis/advice/checkout/error/transfer") !== -1):
          a.consent && (a.groupStatus === "PLDL" || a.groupStatus === "IPLD" || a.groupStatus === "FUND") ? a.groupStatus === "PLDL" ? b("/usis/advice/fps") : a.groupStatus === "IPLD" && !a[`${A}Activated`] ? b("/usis/advice/checkout/hub") : a.groupStatus === "IPLD" && !a[`${A}RasuConsented`] ? b("/personal-investing/tools/adv-nasu/legal-consent") : b("/personal-investing/tools/adv-nasu/brokerage") : s(!1);
          break;
        case (a.groupStatus === "CMPD" && !a[`${A}HasExternalAccounts`]):
          b("/usis/my-accounts");
          break;
        case !(a.groupStatus === "IPLD" || a.groupStatus === "FUND" || a.groupStatus === "CMPD"):
          b("/usis/advice/fps");
          break;
        case h():
          b("/usis/my-accounts");
          break;
        case (!a.consent && a.groupStatus !== "CMPD"):
          b("/usis/advice/fps");
          break;
        case !a[`${A}Activated`]:
          b("/usis/advice/checkout/hub", "/usis/advice/checkout/error", "/usis/advice/checkout/hub/");
          break;
        case (a[`${A}Submitted`] && !a[`${A}RasuConsented`] && !a[`${A}HasExternalAccounts`]):
          b("/usis/advice/checkout/status", "/usis/advice/checkout/error");
          break;
        case (!a[`${A}RequiresRASU`] && !a[`${A}HasExternalAccounts`]):
          b("/personal-investing/tools/adv-nasu/brokerage/status", "/personal-investing/tools/adv-nasu/error");
          break;
        case (a[`${A}RequiresRASU`] && !a[`${A}RasuConsented`]):
          b("/personal-investing/tools/adv-nasu/legal-consent", "/personal-investing/tools/adv-nasu/error");
          break;
        case (a[`${A}RequiresRASU`] && !a[`${A}Submitted`]):
          b("/personal-investing/tools/adv-nasu/brokerage", "/personal-investing/tools/adv-nasu/error");
          break;
        case (a[`${A}Submitted`] && !a[`${A}HasExternalAccounts`]):
          b("/personal-investing/tools/adv-nasu/brokerage/status", "/personal-investing/tools/adv-nasu/error");
          break;
        case (a[`${A}HasExternalAccounts`] && !a[`${A}ExternalSubmitted`]):
          b("/personal-investing/tools/adv-nasu/external", "/personal-investing/tools/adv-nasu/error");
          break;
        case a[`${A}ExternalSubmitted`]:
          b("/personal-investing/tools/adv-nasu/external/signing", "/personal-investing/tools/adv-nasu/error", "/personal-investing/tools/adv-nasu/external/signing?");
          break;
        default:
          b("/usis/advice/fps");
      }
    else
      s(!1);
  }, []), null;
}, nS = ({ open: n, prod: e, internalDomain: o, status: a, setOpen: i }) => !e && !o && n && a && a.client ? /* @__PURE__ */ p.jsxs(
  "div",
  {
    style: {
      width: "200px",
      padding: "8px",
      backgroundColor: "white",
      border: "1px black solid",
      fontSize: "12px",
      position: "absolute",
      top: "8px",
      right: "24px",
      zIndex: 1300
    },
    children: [
      /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("strong", { children: "Current User Status" }),
        /* @__PURE__ */ p.jsx(
          "button",
          {
            style: { float: "right" },
            type: "button",
            onClick: () => i(!1),
            children: "X"
          }
        )
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Type: ",
        a.client
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "BPID: ",
        a.businessPartyId
      ] }),
      /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx("strong", { children: "Group Statuses" }) }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Financial Planning Group Id: ",
        a.financialPlanningGroupId
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Financial Planning Engagement Id: ",
        a.financialPlanningEngagementId
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Consent Status: ",
        a.consent ? a.consent.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Engagement Status: ",
        a.groupStatus
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Proposal Type: ",
        a.proposalType
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Model Change: ",
        a.modelChange ? a.modelChange.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Joint In RASU: ",
        a.jointRegistrations ? a.jointRegistrations.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Joint In External: ",
        a.jointExternalAccounts ? a.jointExternalAccounts.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "External Forms Available: ",
        a.externalFormStatus ? a.externalFormStatus.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx("strong", { children: "Client" }) }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client is Guest: ",
        a.clientIsGuest ? a.clientIsGuest.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Activated: ",
        a.clientActivated ? a.clientActivated.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Requires RASU: ",
        a.clientRequiresRASU ? a.clientRequiresRASU.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client RASU Consent: ",
        a.clientRasuConsented ? a.clientRasuConsented.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Submitted: ",
        a.clientSubmitted ? a.clientSubmitted.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client External Submitted: ",
        a.clientExternalSubmitted ? a.clientExternalSubmitted.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Has Accounts: ",
        a.clientRequiresRASU ? a.clientRequiresRASU.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Has Internal Accounts: ",
        a.clientHasInternalAccounts ? a.clientHasInternalAccounts.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Has External Accounts: ",
        a.clientHasExternalAccounts ? a.clientHasExternalAccounts.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Client Has RAS: ",
        a.clientHasRAS ? a.clientHasRAS.toString() : "false"
      ] }),
      /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx("strong", { children: "CoClient" }) }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "Group has CoClient: ",
        a.groupHasCoClient ? a.groupHasCoClient.toString() : "false"
      ] }),
      a.groupHasCoClient ? /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient is Guest: ",
          a.coClientIsGuest ? a.coClientIsGuest.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Activated: ",
          a.coClientActivated ? a.coClientActivated.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Requires RASU: ",
          a.coClientRequiresRASU ? a.coClientRequiresRASU.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient RASU Consent: ",
          a.coClientRasuConsented ? a.coClientRasuConsented.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Submitted: ",
          a.coClientSubmitted ? a.coClientSubmitted.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient External Submitted: ",
          a.coClientExternalSubmitted ? a.coClientExternalSubmitted.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Has Accounts: ",
          a.coClientRequiresRASU ? a.coClientRequiresRASU.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Has Internal Accounts: ",
          a.coClientHasInternalAccounts ? a.coClientHasInternalAccounts.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Has External Accounts: ",
          a.coClientHasExternalAccounts ? a.coClientHasExternalAccounts.toString() : "false"
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "CoClient Has RAS: ",
          a.coClientHasRAS ? a.coClientHasRAS.toString() : "false"
        ] })
      ] }) : null
    ]
  },
  "authStatusModal"
) : null, oS = wo((n) => ({
  progress: {
    margin: n.spacing(2),
    animation: "none",
    strokeDasharray: "80px, 200px",
    strokeDashoffset: "0px",
    color: "#05C3DE"
  },
  loaderText: {
    fontSize: "20px",
    lineHeight: "24px",
    paddingBottom: "16px"
  },
  container: {
    height: 600
  }
}));
function Xb({ headerText: n = "Preparing your planning experience..." }) {
  const e = oS();
  return /* @__PURE__ */ p.jsx(vt, { fixed: !0, className: e.container, children: /* @__PURE__ */ p.jsxs(
    En,
    {
      style: { height: "100%", width: "100%" },
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      children: [
        /* @__PURE__ */ p.jsx(cn, { className: e.loaderText, children: n }),
        /* @__PURE__ */ p.jsx(
          Uu,
          {
            className: e.progress,
            size: 200,
            thickness: 1,
            alt: "loading"
          }
        )
      ]
    }
  ) });
}
const tS = ({ appBase: n, internalDomain: e, prod: o, disableRedirect: a, children: i }) => {
  const { state: s, dispatch: c } = Bp(Vu), { applicationConfig: u, status: A } = s, [b, h] = va(!0), [m, E] = va(!0), [y, k] = va(!0);
  return iu(async () => {
    if (e)
      c({
        type: "UPDATE_STATUS",
        payload: {
          status: {
            client: "PRIMARY",
            consent: !0,
            groupStatus: void 0,
            error: !1
          }
        }
      });
    else {
      const w = await X9(u, n);
      c({
        type: "UPDATE_STATUS",
        payload: {
          status: w
        }
      });
    }
    h(!1);
  }, [u, n]), b ? /* @__PURE__ */ p.jsx(Xb, {}) : [
    /* @__PURE__ */ p.jsx(
      nS,
      {
        open: m,
        prod: o,
        internalDomain: e,
        status: A,
        setOpen: E
      }
    ),
    /* @__PURE__ */ p.jsx(
      eS,
      {
        appBase: n,
        internalDomain: e,
        disableRedirect: a,
        status: A,
        awaitRedirect: y,
        setAwaitRedirect: k
      },
      "authStatusRedirect"
    ),
    y ? /* @__PURE__ */ p.jsx(Xb, {}) : i
  ];
}, Lg = { status: { consent: !1, error: !1 } }, Vu = Rp(Lg), q8 = ({ children: n, appBase: e = "/personal-investing/tools/adv-nasu", disableRedirect: o, ...a }) => {
  const i = a, [s, c] = _p(jx, { ...i, ...Lg }), u = window.location.hostname.toLowerCase().indexOf(".awstrp.net") !== -1, A = window.location.hostname.toLowerCase().indexOf("www.troweprice.com") !== -1;
  return /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(Vu.Provider, { value: { state: s, dispatch: c }, children: /* @__PURE__ */ p.jsx(W9, { appBase: e, children: /* @__PURE__ */ p.jsx(tS, { appBase: e, internalDomain: u, prod: A, disableRedirect: o, children: n }) }) }) });
}, Ln = {
  interactiveBlue: "#086EA1",
  darkBlue: "#054C70",
  hoverBlue: "#043954",
  brightBlue: "#05C3DE",
  lightGray: "#EBEBEB ",
  gray: "#C4C4C4",
  mediumGray: "#898989",
  darkGray: "#3B3B3B",
  successGreen: "#7D9845",
  warningOrange: "#E17A17",
  errorRed: "#D82C26",
  appBarGradient: "radial-gradient(farthest-corner at 20% -100%, #05C3DE -25%, #054C70 60%, #063046 105%)"
}, aS = {
  active: `${Ln.darkGray} !important`,
  disabled: `${Ln.mediumGray} !important`,
  tRoweBlue: `${Ln.brightBlue} !important`,
  linkColor: `${Ln.interactiveBlue}`,
  linkColorHover: `${Ln.hoverBlue}`
}, rS = {
  xxsmall: "10px",
  xsmall: "12px",
  small: "14px",
  medium: "16px",
  xmedium: "18px",
  large: "20px",
  xlarge: "24px",
  xxlarge: "36px",
  xxxlarge: "48px",
  titleFont: "18px",
  labelSupFont: "100%",
  h1Font: "56px",
  h2Font: "48px",
  h3Font: "40px",
  h4Font: "32px",
  h5Font: "24px",
  h6Font: "20px",
  subtitle1: "16px",
  body1: "16px",
  body2: "12px",
  caption: "12px",
  p1Font: "16px",
  p2Font: "14px",
  h1FontMobile: "40px",
  h2FontMObile: "32px",
  h3FontMobile: "32px",
  h4FontMobile: "24px",
  h5FontMobile: "24px"
}, Ng = {
  cardMediaWrapper: {
    background: Ln.hoverBlue,
    border: `1px solid ${Ln.brightBlue}`,
    borderRadius: 4,
    boxSizing: "border-box",
    height: 40,
    position: process.env.REACT_APP_ENV === "local" ? "absolute" : "none"
  }
}, yo = {
  nimbusSansReg: "Nimbus Sans Reg",
  nimbusSansBold: "Nimbus Sans Bold",
  nimbusSansLight: "Nimbus Sans Light"
};
wo({
  titleHeader: {
    color: "#fff",
    fontSize: 32,
    lineHeight: "32px",
    fontFamily: yo.nimbusSansReg,
    paddingBottom: 8
  },
  continuePlanning: {
    background: Ln.interactiveBlue,
    boxShadow: "none",
    width: 187,
    maxWidth: 187,
    // padding: '8x 16px',
    fontSize: 16,
    fontFamily: yo.nimbusSansBold,
    color: "#fff",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: Ln.darkBlue
    }
  },
  arrowForward: {
    fontSize: "1rem !important",
    marginLeft: 4,
    verticalAlign: "middle"
  },
  popoverTelephoneLink: {
    color: "#fff",
    borderBottom: "1px solid #fff",
    "&:hover": {
      backgroundColor: Ln.hoverBlue,
      textDecoration: "none"
    }
  },
  cardButton: {
    boxShadow: "none !important",
    background: `${Ln.interactiveBlue} !important`,
    padding: "8px 16px !important",
    fontSize: "16px !important",
    fontFamily: `${yo.nimbusSansBold} !important`,
    color: "#fff !important",
    textTransform: "capitalize !important",
    marginRight: "16px !important",
    marginBottom: "8px !important",
    "&:hover": {
      backgroundColor: "#054C70 !important"
    },
    "&$disabled": {
      color: "white",
      background: Ln.interactiveBlue
    }
  }
});
wo((n) => ({
  root: {
    margin: "0",
    // padding: theme.spacing(2),
    background: Ln.hoverBlue,
    flexGrow: "1 !important",
    padding: "32px 24px !important",
    [n.breakpoints.only("sm")]: {
      flexGrow: "0 !important"
    }
  },
  closeButton: {
    position: "absolute !important",
    right: 0,
    top: 0,
    "&:hover": {
      background: `${Ln.hoverBlue}`
    }
  },
  closeButtonLoader: {
    color: aS.tRoweBlue
  },
  imageBox: {
    [n.breakpoints.up("md")]: {
      marginRight: 24
    },
    [n.breakpoints.down("sm")]: {
      padding: "16px 0px"
    }
  },
  icon: {
    color: "#fff",
    "&:hover": {
      color: `${Ln.brightBlue}`
    }
  }
}));
$e({
  root: {
    fontSize: rS.medium,
    lineHeight: "22px",
    color: "#fff",
    fontFamily: yo.nimbusSansLight
  }
})((n) => /* @__PURE__ */ p.jsx(cn, { ...n, children: n.children }));
const iS = ({ filled: n }) => /* @__PURE__ */ p.jsxs(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ p.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: `M9.58099 0.416761C9.58099 0.186709 9.7677 0 9.99775 0C15.5127 0 20 4.48727 20 10.0023C20 10.2323 19.8133 10.419 19.5833 10.419C19.3532 10.419 19.1665 10.2323
              19.1665 10.0023C19.1665 4.94654 15.0535 0.833522 9.99775 0.833522C9.7677 0.833522 9.58099 0.646813 9.58099 0.416761ZM12.8344 12.8547C13.3908 12.8547 13.9143 13.0715
              14.3077 13.4649L16.076 15.2332C16.8883 16.0459 16.8883 17.3679 16.076 18.1801L15.1058 19.1499C14.5561 19.7 13.8242 20.0026 13.0449 20.0026C12.471 20.0026 11.9146
              19.8355 11.4354 19.5188C7.12189 16.6652 3.33436 12.8777 0.481631 8.56544C-0.279792 7.4131 -0.124757 5.869 0.850047 4.8942L1.82027 3.92398C2.21411 3.53055 2.73714
              3.31384 3.29393 3.31384C3.85031 3.31384 4.37376 3.53055 4.76719 3.92398L6.5355 5.69229C7.34777 6.50456 7.34777 7.82694 6.5355 8.63921L6.2146 8.96012C7.65701
              10.6843 9.31405 12.3413 11.0399 13.7858L11.3608 13.4649C11.7546 13.0715 12.2776 12.8547 12.8344 12.8547ZM9.99775 4.1673C13.2151 4.1673 15.8324 6.78456 15.8324
              10.002C15.8324 10.232 16.0191 10.4187 16.2492 10.4187C16.4792 10.4187 16.6659 10.232 16.6659 10.002C16.6659 6.32529 13.6744 3.33378 9.99775 3.33378C9.76769 3.33378
              9.58099 3.52049 9.58099 3.75054C9.58099 3.98101 9.76769 4.1673 9.99775 4.1673ZM12.4983 10.0025C12.4983 8.62339 11.3768 7.50189 9.99775 7.50189C9.7677 7.50189
              9.58099 7.3156 9.58099 7.08513C9.58099 6.85507 9.7677 6.66837 9.99775 6.66837C11.8361 6.66837 13.3318 8.16412 13.3318 10.0025C13.3318 10.2325 13.1451 10.4192 12.9151
              10.4192C12.685 10.4192 12.4983 10.2325 12.4983 10.0025Z`,
          fill: n ? "#05C3DE" : "white"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "mask",
        {
          id: "mask0",
          masktype: "alpha",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "20",
          height: "21",
          children: /* @__PURE__ */ p.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: `M9.58099 0.416761C9.58099 0.186709 9.7677 0 9.99775 0C15.5127 0 20 4.48727 20 10.0023C20 10.2323 19.8133 10.419 19.5833 10.419C19.3532 10.419 19.1665 10.2323
                  19.1665 10.0023C19.1665 4.94654 15.0535 0.833522 9.99775 0.833522C9.7677 0.833522 9.58099 0.646813 9.58099 0.416761ZM12.8344 12.8547C13.3908 12.8547 13.9143
                  13.0715 14.3077 13.4649L16.076 15.2332C16.8883 16.0459 16.8883 17.3679 16.076 18.1801L15.1058 19.1499C14.5561 19.7 13.8242 20.0026 13.0449 20.0026C12.471
                  20.0026 11.9146 19.8355 11.4354 19.5188C7.12189 16.6652 3.33436 12.8777 0.481631 8.56544C-0.279792 7.4131 -0.124757 5.869 0.850047 4.8942L1.82027
                  3.92398C2.21411 3.53055 2.73714 3.31384 3.29393 3.31384C3.85031 3.31384 4.37376 3.53055 4.76719 3.92398L6.5355 5.69229C7.34777 6.50456 7.34777 7.82694 6.5355
                  8.63921L6.2146 8.96012C7.65701 10.6843 9.31405 12.3413 11.0399 13.7858L11.3608 13.4649C11.7546 13.0715 12.2776 12.8547 12.8344 12.8547ZM9.99775 4.1673C13.2151
                  4.1673 15.8324 6.78456 15.8324 10.002C15.8324 10.232 16.0191 10.4187 16.2492 10.4187C16.4792 10.4187 16.6659 10.232 16.6659 10.002C16.6659 6.32529 13.6744
                  3.33378 9.99775 3.33378C9.76769 3.33378 9.58099 3.52049 9.58099 3.75054C9.58099 3.98101 9.76769 4.1673 9.99775 4.1673ZM12.4983 10.0025C12.4983 8.62339 11.3768
                  7.50189 9.99775 7.50189C9.7677 7.50189 9.58099 7.3156 9.58099 7.08513C9.58099 6.85507 9.7677 6.66837 9.99775 6.66837C11.8361 6.66837 13.3318 8.16412 13.3318
                  10.0025C13.3318 10.2325 13.1451 10.4192 12.9151 10.4192C12.685 10.4192 12.4983 10.2325 12.4983 10.0025Z`,
              fill: n ? "#05C3DE" : "white"
            }
          )
        }
      ),
      /* @__PURE__ */ p.jsx("g", { mask: "url(#mask0)" })
    ]
  }
), sS = ({ name: n, onClick: e, icon: o, id: a, classes: i, href: s, target: c }) => /* @__PURE__ */ p.jsxs(
  Go,
  {
    className: i.popoverLinks,
    id: a,
    onClick: e,
    variant: "outlined",
    href: s,
    target: c,
    children: [
      n,
      o
    ]
  }
), cS = $e({
  tooltip: {
    backgroundColor: "#043954"
  }
})(Vk);
C.forwardRef((n, e) => /* @__PURE__ */ p.jsx(Go, { ref: e, ...n, children: n.children }));
const Mg = ({ state: n, classes: e, children: o, icon: a, title: i, aria: s, buttonId: c }) => {
  const [u, A] = C.useState(null), [b, h] = C.useState(null), m = (M) => {
    A(M.currentTarget);
  }, E = () => h(!0), y = () => h(!1), k = () => A(null), w = !!u, _ = w ? `${s}-bluebanner-popover` : void 0, P = (n && !!Object.values(n).filter((M) => M === !0)[0] ? !1 : !!w) || w;
  return /* @__PURE__ */ p.jsxs("div", { style: { paddingTop: 4 }, children: [
    /* @__PURE__ */ p.jsx(
      cS,
      {
        TransitionComponent: Ru,
        TransitionProps: { timeout: 600 },
        title: i,
        placement: "top",
        children: /* @__PURE__ */ p.jsx(
          Go,
          {
            "aria-describedby": _,
            onClick: m,
            className: e.button,
            size: "small",
            onMouseEnter: E,
            onMouseLeave: y,
            variant: "outlined",
            "data-metrics-link-text": i,
            id: c,
            children: C.cloneElement(a, { filled: !!(w || b) })
          }
        )
      }
    ),
    /* @__PURE__ */ p.jsx(
      J4,
      {
        id: _,
        PaperProps: {
          style: {
            height: 160,
            width: 200,
            padding: 20,
            marginTop: 16,
            borderRadius: 0,
            borderTop: "4px solid #05C3DE"
          }
        },
        "data-metrics-location": "PU",
        open: P,
        anchorEl: u,
        onClose: k,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        children: o
      }
    )
  ] });
}, lS = ({ state: n, classes: e }) => /* @__PURE__ */ p.jsxs(
  Mg,
  {
    state: n,
    classes: e,
    icon: /* @__PURE__ */ p.jsx(iS, { name: "phone" }),
    title: "Call Support",
    buttonId: "toolbar-call-support-button",
    aria: "phone",
    children: [
      /* @__PURE__ */ p.jsx(cn, { className: e.popoverTextHeader, children: "CALL US" }),
      /* @__PURE__ */ p.jsx("br", {}),
      /* @__PURE__ */ p.jsx(cn, { className: e.popoverTextBody, children: "Get technical support or help navigating the experience." }),
      /* @__PURE__ */ p.jsx("br", {}),
      /* @__PURE__ */ p.jsx(
        Io,
        {
          href: "tel:+1-888-358-8490}",
          className: e.popoverTelephoneLink,
          children: "1-888-358-8490"
        }
      )
    ]
  }
);
var qu = {}, jg = { exports: {} };
(function(n) {
  function e(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  n.exports = e, n.exports.__esModule = !0, n.exports.default = n.exports;
})(jg);
var is = jg.exports, xi = {}, yl = { exports: {} }, ep;
function uS() {
  return ep || (ep = 1, function(n) {
    function e() {
      return n.exports = e = Object.assign ? Object.assign.bind() : function(o) {
        for (var a = 1; a < arguments.length; a++) {
          var i = arguments[a];
          for (var s in i)
            Object.prototype.hasOwnProperty.call(i, s) && (o[s] = i[s]);
        }
        return o;
      }, n.exports.__esModule = !0, n.exports.default = n.exports, e.apply(this, arguments);
    }
    n.exports = e, n.exports.__esModule = !0, n.exports.default = n.exports;
  }(yl)), yl.exports;
}
const AS = /* @__PURE__ */ Dx(jw);
var np;
function Wu() {
  if (np)
    return xi;
  np = 1;
  var n = is;
  Object.defineProperty(xi, "__esModule", {
    value: !0
  }), xi.default = i;
  var e = n(uS()), o = n(C), a = n(AS);
  function i(s, c) {
    var u = o.default.memo(o.default.forwardRef(function(A, b) {
      return o.default.createElement(a.default, (0, e.default)({
        ref: b
      }, A), s);
    }));
    return process.env.NODE_ENV !== "production" && (u.displayName = "".concat(c, "Icon")), u.muiName = a.default.muiName, u;
  }
  return xi;
}
var $g = is;
Object.defineProperty(qu, "__esModule", {
  value: !0
});
var Qg = qu.default = void 0, dS = $g(C), fS = $g(Wu()), bS = (0, fS.default)(dS.default.createElement("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "Launch");
Qg = qu.default = bS;
const pS = ({ filled: n }) => /* @__PURE__ */ p.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ p.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: `M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10.1783 14.3636C9.53936 14.3636 9.0214 14.8816
               9.0214 15.5205C9.0214 16.1594 9.53936 16.6774 10.1783 16.6774C10.8172 16.6774 11.3352 16.1594 11.3352 15.5205C11.3352 14.8816 10.8172 14.3636 10.1783
               14.3636ZM6.81071 7.43425C6.81071 5.57721 8.32094 4.06698 10.178 4.06698C12.035 4.06698 13.5453 5.57721 13.5453 7.43425C13.5453 9.04657 12.4074 10.3965 10.8928
               10.7252V12.7392C10.8928 13.1338 10.5726 13.454 10.178 13.454C9.78334 13.454 9.46318 13.1338 9.46318 12.7392V10.0867C9.46318 9.69207 9.78334 9.37192 10.178
               9.37192C11.2462 9.37192 12.1157 8.50244 12.1157 7.43425C12.1157 6.36607 11.2462 5.49659 10.178 5.49659C9.1098 5.49659 8.24032 6.36607 8.24032 7.43425C8.24032 7.8289
               7.92017 8.14906 7.52552 8.14906C7.13086 8.14906 6.81071 7.8289 6.81071 7.43425Z`,
        fill: n ? "#05C3DE" : "white"
      }
    )
  }
), hS = ({ state: n, classes: e }) => /* @__PURE__ */ p.jsxs(Mg, { state: n, classes: e, icon: /* @__PURE__ */ p.jsx(pS, { name: "faq" }), title: "FAQs", aria: "faqs", buttonId: "toolbar-faq-button", children: [
  /* @__PURE__ */ p.jsx(cn, { className: e.popoverTextHeader, children: "VIEW FAQs" }),
  /* @__PURE__ */ p.jsx("br", {}),
  /* @__PURE__ */ p.jsxs(cn, { className: e.popoverTextBody, children: [
    "Quickly answer your questions about ",
    /* @__PURE__ */ p.jsx(cn, { className: e.popoverTextBody, display: "inline", noWrap: !0, children: "T. Rowe Price" }),
    " Retirement Advisory Service™."
  ] }),
  /* @__PURE__ */ p.jsx("br", {}),
  /* @__PURE__ */ p.jsx(
    sS,
    {
      icon: /* @__PURE__ */ p.jsx(Qg, { className: e.faqIcon }),
      name: "View FAQs",
      href: `${document.location.origin}/personal-investing/planning-and-research/advice/planning-service/faq.html`,
      classes: e,
      target: "_blank"
    }
  )
] }), gS = wo((n) => ({
  wrapper: Ng.cardMediaWrapper,
  button: {
    border: "none",
    minWidth: 36
  },
  popover: {
    height: 100,
    padding: n.spacingVars.xxmedium
  },
  popoverTextHeader: {
    fontSize: n.fontVars.xsmall,
    color: "#414141",
    lineHeight: "16px",
    fontFamily: yo.nimbusSansBold
  },
  popoverTextBody: {
    fontSize: n.fontVars.medium,
    color: n.palette.darkGray,
    lineHeight: n.fontVars.mediumLH,
    fontFamily: n.fontFamily.light
  },
  popoverLinks: {
    border: "1px solid #086EA1",
    color: n.palette.interactiveBlue,
    fontFamily: yo.nimbusSansReg,
    fontSize: n.fontVars.xsmall,
    marginTop: 6,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: n.palette.white,
      textDecoration: "none"
    }
  },
  popoverTelephoneLink: {
    border: "1px solid #086EA1",
    padding: "10px 16px",
    color: n.palette.interactiveBlue,
    minWidth: "64px",
    boxSizing: "border-box",
    fontFamily: n.fontFamily.reg,
    fontSize: n.fontVars.xsmall,
    marginTop: 6,
    fontWeight: 500,
    borderRadius: 4,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: n.palette.white,
      textDecoration: "none"
    }
  },
  faqIcon: {
    fontSize: ".7rem !important",
    paddingLeft: 5,
    marginTop: "-4px"
  },
  tooltip: {}
})), mS = () => {
  const n = gS();
  return /* @__PURE__ */ p.jsx("div", { className: n.wrapper, id: "banner-button-container", children: /* @__PURE__ */ p.jsxs(En, { display: "flex", flexDirection: "row", children: [
    /* @__PURE__ */ p.jsx(lS, { classes: n }),
    /* @__PURE__ */ p.jsx(hS, { classes: n })
  ] }) });
};
function vS() {
  return /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(mS, {}) });
}
const yS = wo((n) => ({
  root: {
    // flexGrow: 1
  },
  appbar: {
    display: "block",
    minHeight: 180,
    background: n.palette.appBarGradient,
    boxShadow: "none",
    width: "100%",
    [n.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column"
    }
  },
  appbarSmall: {
    display: "block",
    minheight: 196,
    background: n.palette.appBarGradient,
    boxShadow: "none",
    [n.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column"
    }
  },
  toolbar: {
    height: "100%",
    width: "100%",
    [n.breakpoints.down("850")]: {
      display: "flex",
      flexDirection: "column"
    },
    [n.breakpoints.down("sm")]: {
      alignItems: "baseline"
    }
  },
  bannerTextContainer: {
    height: "96%",
    maxWidth: "1220px",
    paddingLeft: "27px",
    paddingRight: "27px",
    [n.breakpoints.down("850")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
      paddingBottom: "32px"
    }
  },
  title: {
    fontSize: n.fontVars.title,
    fontFamily: n.fontFamily.light,
    lineHeight: n.spacingVars.xxlarge,
    paddingBottom: n.gutterFPS * 2,
    [n.breakpoints.down("sm")]: {
      lineHeight: n.spacingVars.xlarge
    },
    [n.breakpoints.down("440")]: {
      paddingRight: 18
    },
    [n.breakpoints.down("xs")]: {
      fontSize: n.fontVars.xlarge
    }
  },
  caption: {
    fontSize: n.fontVars.medium,
    fontFamily: n.fontFamily.reg,
    lineHeight: n.fontVars.mediumLH,
    [n.breakpoints.down("xs")]: {
      paddingBottom: n.spacingVars.xmedium
    }
  },
  breadCrumbs: {
    paddingTop: "16px",
    paddingBottom: "24px",
    lineHeight: "12px",
    fontSize: "12px",
    color: n.palette.white
  },
  breadcrumbsLink: {
    color: n.palette.white,
    textDecoration: "none",
    "&:hover": {
      color: n.palette.paleBlue
    }
  },
  breadcrumbsStatic: {
    fontSize: "12px",
    color: n.palette.paleBlue
  },
  progressText: {
    fontSize: "12px",
    color: n.palette.white,
    paddingRight: "16px",
    paddingTop: "12px",
    fontFamily: n.fontFamily.reg
  },
  linkBox: {
    display: "flex",
    marginLeft: "auto",
    alignSelf: "center",
    [n.breakpoints.down("850")]: {
      alignSelf: "flex-end"
    }
  },
  titleCaptionContainer: {
    marginBottom: 48,
    color: n.palette.white,
    [n.breakpoints.up("sm")]: {
      paddingRight: 32
    },
    [n.breakpoints.down("850")]: {
      marginBottom: 32
    }
  }
})), xS = (n) => {
  const { showBreadcrumbs: e, breadcrumbs: o, showBannerButtons: a, header: i, subheader: s } = n, c = yS(), u = window.location.origin, A = window.location.pathname.includes(
    "/usis/advice/fps/profile"
  );
  return /* @__PURE__ */ p.jsx("div", { className: c.root, children: /* @__PURE__ */ p.jsx(Nw, { className: c.appbar, position: "static", id: "blue-banner", children: /* @__PURE__ */ p.jsxs(vt, { fixed: !0, className: c.bannerTextContainer, children: [
    /* @__PURE__ */ p.jsx(q5, { className: c.breadCrumbs, id: "breadcrumbs", children: e && o.map(
      (b) => b.url ? /* @__PURE__ */ p.jsx(
        Io,
        {
          color: "inherit",
          href: `${u}/${b.url}`,
          underline: "none",
          className: c.breadcrumbsLink,
          children: b.displayText
        }
      ) : /* @__PURE__ */ p.jsx(cn, { className: c.breadcrumbsStatic, children: b.displayText })
    ) }),
    /* @__PURE__ */ p.jsxs($k, { className: c.toolbar, disableGutters: !0, children: [
      /* @__PURE__ */ p.jsxs(
        En,
        {
          className: c.titleCaptionContainer,
          component: "div",
          display: "block",
          children: [
            /* @__PURE__ */ p.jsx(
              cn,
              {
                className: c.title,
                variant: "h4",
                component: "h2",
                color: "inherit",
                id: "banner-title",
                children: i || /* @__PURE__ */ p.jsxs("span", { children: [
                  /* @__PURE__ */ p.jsx(
                    cn,
                    {
                      className: c.title,
                      display: "inline",
                      variant: "h4",
                      component: "h2",
                      noWrap: !0,
                      children: "T. Rowe Price"
                    }
                  ),
                  " Planning Service"
                ] })
              }
            ),
            /* @__PURE__ */ p.jsx(
              cn,
              {
                className: c.caption,
                variant: "caption",
                gutterBottom: !0,
                id: "banner-sub-text",
                children: s || "Personalized, point-in-time advice for your retirement and other financial goals."
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ p.jsxs(
        En,
        {
          className: c.linkBox,
          children: [
            A && /* @__PURE__ */ p.jsx(
              cn,
              {
                className: c.progressText,
                variant: "h4",
                component: "h2",
                color: "inherit",
                children: "Your progress auto-saves"
              }
            ),
            a && /* @__PURE__ */ p.jsx(vS, {})
          ]
        }
      )
    ] })
  ] }) }) });
};
function W8({ showBreadcrumbs: n, breadcrumbs: e, showBannerButtons: o = !0, header: a, subheader: i }) {
  return /* @__PURE__ */ p.jsx(xS, { showBreadcrumbs: n, breadcrumbs: e, showBannerButtons: o, header: a, subheader: i });
}
const CS = wo((n) => ({
  wrapper: {
    background: "#043954",
    border: "1px solid #05C3DE",
    borderRadius: 4,
    boxSizing: "border-box",
    height: 40
  },
  containerRoot: {
    [n.breakpoints.up("md")]: {
      paddingLeft: n.spacingVars.xmedium,
      paddingRight: n.spacingVars.xmedium,
      maxWidth: "1280px"
    }
  },
  card: {
    minHeight: 244,
    maxWidth: "100%",
    marginBottom: "120px",
    marginTop: n.fontVars.xxxlarge,
    borderTop: "4px solid #05C3DE",
    borderRadius: "0px",
    boxShadow: n.boxShadow,
    "&:hover": {
      boxShadow: n.boxShadowHover
    }
  },
  cardError: {
    minHeight: 244,
    marginBottom: "120px",
    marginTop: n.fontVars.xxxlarge,
    borderTop: "4px solid #E17A17",
    borderRadius: "0px",
    boxShadow: n.boxShadowError,
    "&:hover": {
      boxShadow: n.boxShadowErrorHover
    }
  },
  cardSuccess: {
    minHeight: 244,
    marginBottom: "120px",
    marginTop: n.fontVars.xxxlarge,
    borderTop: "4px solid #7D9845",
    borderRadius: "0px",
    boxShadow: n.boxShadow,
    "&:hover": {
      boxShadow: n.boxShadowHover
    }
  },
  details: {
    display: "flex",
    flexDirection: "row",
    height: "inherit"
  },
  content: {
    padding: n.spacingVars.xlarge,
    "&:last-child": {
      paddingBottom: n.spacingVars.xlarge
    },
    [n.breakpoints.down("sm")]: {
      padding: n.spacingVars.xxxmedium
    }
  },
  cardContentText: {
    display: "flex",
    justifyContent: "center",
    color: n.colors.darkGray
  },
  cardHeaderText: {
    fontSize: n.fontVars.h4Font,
    lineHeight: n.fontVars.h4FontLH,
    fontFamily: n.fontFamily.reg,
    color: n.colors.darkGray,
    [n.breakpoints.down("xs")]: {
      fontSize: n.fontVars.xlarge
    }
  },
  cardDataText: {
    fontSize: n.fontVars.large,
    lineHeight: "26px",
    fontFamily: n.fontFamily.light,
    paddingTop: n.spacingVars.medium,
    color: n.darkGray
  },
  cardMediaTextTitle: {
    paddingLeft: n.spacingVars.xlarge,
    lineHeight: "24px",
    fontFamily: n.fontFamily.bold,
    color: n.colors.white,
    fontSize: n.fontVars.xlarge
  },
  cardMediaText: {
    paddingLeft: n.spacingVars.xlarge,
    lineHeight: "24px",
    fontFamily: n.fontFamily.light,
    color: n.colors.white,
    paddingTop: 4,
    fontSize: n.fontVars.xlarge
  },
  secondaryText: {
    fontSize: n.fontVars.large,
    lineHeight: "24px",
    fontFamily: n.fontFamily.light,
    paddingTop: n.spacingVars.xxmedium,
    color: n.colors.darkGray
  },
  smallSecondaryText: {
    fontSize: "16px",
    lineHeight: "22px",
    fontFamily: "Nimbus Sans Reg",
    paddingTop: "20px",
    color: "#3b3b3b"
  },
  cardDataSubText: {
    fontSize: n.fontVars.large,
    lineHeight: "24px",
    fontFamily: n.fontFamily.light,
    paddingTop: "26px"
  },
  imageCover: {
    width: 191,
    height: 181
  },
  cardButton: {
    boxShadow: "none",
    background: n.colors.interactiveBlue,
    minWidth: "196px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue
    },
    marginTop: n.spacingVars.xlarge,
    fontSize: n.fontVars.medium,
    fontFamily: n.fontFamily.bold,
    color: n.colors.white,
    textTransform: "capitalize",
    marginRight: n.spacingVars.xmedium,
    marginBottom: n.spacingVars.small,
    [n.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  cardMediaButton: {
    boxShadow: "none",
    background: "none",
    minWidth: "196px",
    border: "1px solid #FFFFFF",
    borderRadius: "5px",
    borderColor: n.colors.white,
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue
    },
    marginTop: n.spacingVars.xxxmedium,
    fontSize: n.fontVars.medium,
    fontFamily: n.fontFamily.reg,
    color: n.colors.white,
    textTransform: "capitalize",
    marginRight: n.spacingVars.xmedium,
    marginBottom: n.spacingVars.xlarge,
    [n.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  disabled: {},
  secondaryCardButton: {
    boxShadow: "none",
    background: n.colors.white,
    border: "1px solid #086EA1",
    padding: "8px 16px",
    whiteSpace: "nowrap",
    minWidth: "196px",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue,
      color: n.colors.white,
      border: "1px solid #043954"
    },
    marginTop: n.spacingVars.xlarge,
    marginBottom: n.spacingVars.small,
    fontSize: n.fontVars.medium,
    maxHeight: 45,
    fontFamily: n.fontFamily.reg,
    color: n.colors.interactiveBlue,
    textTransform: "capitalize",
    [n.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  buttonProgress: {
    color: n.colors.brightBlue,
    marginLeft: n.spacingVars.small,
    verticalAlign: "sub"
  },
  cardImage: {
    marginLeft: "auto",
    marginRight: 0,
    backgroundColor: n.colors.interactiveBlue,
    minWidth: "392px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 244,
    textTransform: "capitalize",
    [n.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: "auto"
    }
  },
  mobileImage: {
    width: "24%",
    padding: "24px 24px 0",
    maxWidth: "120px"
  },
  alternateMediaImage: {
    padding: "32px 32px 24px",
    maxWidth: "120px"
  },
  tooltip: {}
})), op = ({ secondaryButton: n, mediaButton: e, id: o, onClick: a, cardButtonText: i, isLoading: s, classes: c, href: u, target: A }) => {
  const b = () => n ? c.secondaryCardButton : e ? c.cardMediaButton : c.cardButton, h = () => A || (u ? "_blank" : "");
  return /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(
    Go,
    {
      id: `${o}${s ? "-loading" : ""}`,
      size: "large",
      classes: { root: b(), disabled: c.disabled },
      onClick: a,
      color: "primary",
      variant: "contained",
      href: u,
      target: h(),
      disabled: s,
      children: /* @__PURE__ */ p.jsxs("span", { children: [
        s ? "" : i,
        s && /* @__PURE__ */ p.jsx(Uu, { size: 20, className: c.buttonProgress, alt: "loading", id: "loading-spinner" })
      ] })
    }
  ) });
};
function Y8({
  errorCardClass: n,
  successCardClass: e,
  headerText: o,
  title: a,
  cardMedia: i,
  text: s,
  cardDataSubText: c,
  secondaryText: u,
  smallSecondaryText: A,
  smallSubText: b,
  onClick: h,
  id: m,
  secondaryId: E,
  cardButtonText: y,
  secondaryCardButtonText: k,
  secondaryOnClick: w,
  children: _,
  statusHeader: O,
  isLoading: F,
  href: P,
  target: M,
  noImageInMobile: B = !1
}) {
  const D = CS();
  let H = D.card;
  return n ? H = D.cardError : e && (H = D.cardSuccess), /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(vt, { maxWidth: "xl", className: D.containerRoot, id: `${m}-media-card`, children: /* @__PURE__ */ p.jsxs(Tu, { className: H, style: { marginBottom: O ? "32px" : "" }, children: [
    !B && /* @__PURE__ */ p.jsx(ya, { mdUp: !0, children: /* @__PURE__ */ p.jsx(En, { children: /* @__PURE__ */ p.jsx("img", { className: D.mobileImage, src: i, alt: a }) }) }),
    /* @__PURE__ */ p.jsxs("div", { className: D.details, children: [
      /* @__PURE__ */ p.jsx("div", { className: D.cardContentText, children: /* @__PURE__ */ p.jsxs(Ou, { className: D.content, children: [
        /* @__PURE__ */ p.jsxs(cn, { component: "h5", variant: "h5", children: [
          /* @__PURE__ */ p.jsx("div", { className: D.cardHeaderText, id: `${m}-media-title`, children: o }),
          /* @__PURE__ */ p.jsx("div", { className: D.cardDataText, id: `${m}-media-main-content`, dangerouslySetInnerHTML: { __html: s } }),
          u && /* @__PURE__ */ p.jsx("div", { className: D.secondaryText, id: `${m}-media-secondary-content`, dangerouslySetInnerHTML: { __html: u } }),
          c && /* @__PURE__ */ p.jsx("div", { className: D.cardDataSubText, id: `${m}-media-sub-text`, dangerouslySetInnerHTML: { __html: c } }),
          A && /* @__PURE__ */ p.jsx("div", { className: D.smallSecondaryText, id: `${m}-media-small-secondary-text`, dangerouslySetInnerHTML: { __html: A } }),
          b && /* @__PURE__ */ p.jsx("div", { className: D.smallSecondaryText, id: `${m}-media-small-sub-text`, dangerouslySetInnerHTML: { __html: b } })
        ] }),
        /* @__PURE__ */ p.jsxs(so, { container: !0, children: [
          y && /* @__PURE__ */ p.jsx(so, { item: !0, xs: 12, lg: 4, md: 6, children: /* @__PURE__ */ p.jsx(
            op,
            {
              className: D.cardButton,
              id: `${m}-media-button`,
              onClick: h,
              cardButtonText: y,
              isLoading: F,
              classes: D,
              secondaryButton: !1,
              href: P,
              target: M
            }
          ) }),
          k && /* @__PURE__ */ p.jsx(so, { item: !0, xs: 12, lg: 4, md: 6, children: /* @__PURE__ */ p.jsx(
            op,
            {
              className: D.secondaryCardButton,
              id: `${E}-media-button`,
              onClick: w,
              cardButtonText: k,
              classes: D,
              secondaryButton: !0
            }
          ) })
        ] }),
        _
      ] }) }),
      /* @__PURE__ */ p.jsx(ya, { smDown: !0, children: /* @__PURE__ */ p.jsx("div", { className: D.cardImage, children: /* @__PURE__ */ p.jsx(
        J5,
        {
          className: D.imageCover,
          image: i,
          title: a,
          id: `${m}-media-image`
        }
      ) }) })
    ] })
  ] }) }) });
}
const wS = "data:image/svg+xml,%3csvg%20width='68'%20height='72'%20viewBox='0%200%2072%2072'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.6359%2021.7509C22.37%2021.4344%2022.2406%2021.0247%2022.2765%2020.6123C22.3124%2020.1999%2022.5106%2019.8189%2022.8272%2019.5534L31.48%2012.2777C25.8644%2011.4839%2020.2519%2012.5709%2015.4061%2015.4843C9.58212%2018.9841%205.34281%2024.8421%203.77368%2031.5547C1.67735%2040.521%204.657%2049.8818%2011.5525%2055.9815C12.1947%2056.5523%2012.257%2057.5349%2011.6893%2058.1837C11.1201%2058.8294%2010.1373%2058.8902%209.49347%2058.3209C1.73645%2051.4602%20-1.61643%2040.928%200.742717%2030.8435C2.50158%2023.3136%207.26341%2016.7398%2013.8059%2012.8096C18.8352%209.78702%2024.5861%208.50969%2030.393%209.01657L21.9517%203.3567C21.2379%202.87789%2021.045%201.90781%2021.5225%201.1935C21.7514%200.849294%2022.1073%200.610504%2022.512%200.529758C22.9166%200.449013%2023.3366%200.53294%2023.6794%200.763042L36.6073%209.43299C37.0147%209.70592%2037.2698%2010.1551%2037.2962%2010.6448C37.2978%2010.6729%2037.2978%2010.701%2037.2978%2010.729C37.2978%2011.1876%2037.0956%2011.6258%2036.7457%2011.9253L24.8271%2021.9443C24.1677%2022.498%2023.1865%2022.4106%2022.6359%2021.7509Z'%20fill='%23EBEBEB'/%3e%3cpath%20d='M35.4656%2073.7368L22.5378%2065.0716C22.1305%2064.7992%2021.8751%2064.3501%2021.8489%2063.8598C21.8303%2063.381%2022.0278%2062.8975%2022.4025%2062.5809L34.3211%2052.5557C34.9804%2052.002%2035.9602%2052.0893%2036.5122%2052.749C36.7781%2053.0656%2036.9073%2053.4753%2036.8714%2053.8876C36.8356%2054.2999%2036.6375%2054.681%2036.321%2054.9465L27.9963%2061.9492C39.2493%2062.3376%2049.5116%2054.5535%2052.2237%2042.9437C54.1894%2034.528%2051.7416%2025.83%2045.6689%2019.6742C45.0646%2019.0616%2045.0695%2018.0739%2045.6797%2017.4674C46.2909%2016.8607%2047.2753%2016.8653%2047.8803%2017.4783C53.1568%2022.8278%2056.0027%2029.8835%2056.0027%2037.1825C56.0027%2039.3316%2055.7554%2041.5011%2055.2516%2043.6565C52.216%2056.6543%2040.7546%2065.3929%2028.1363%2065.0731L37.1965%2071.1447C37.6444%2071.4457%2037.887%2071.9401%2037.887%2072.4439C37.887%2072.7418%2037.8015%2073.0428%2037.6226%2073.3064C37.1452%2074.0222%2036.1794%2074.2156%2035.4656%2073.7368Z'%20fill='%23EBEBEB'/%3e%3c/svg%3e", ES = wo((n) => ({
  root: {
    [n.breakpoints.up("md")]: {
      paddingLeft: "16px",
      paddingRight: "16px"
    }
  },
  wrapper: {
    background: n.colors.hoverBlue,
    border: "1px solid #05C3DE",
    borderRadius: 4,
    boxSizing: "border-box",
    height: 40,
    position: process.env.REACT_APP_ENV === "local" ? "absolute" : "none"
  },
  card: {
    minHeight: 264,
    paddingRight: 0,
    borderRadius: "0px",
    boxShadow: "0px 0px 8px rgba(59, 59, 59, 0.12), 0px 6px 4px rgba(59, 59, 59, 0.05), 0px 3px 3px rgba(59, 59, 59, 0.05)",
    "&:hover": {
      boxShadow: "0px 2px 15px rgba(59, 59, 59, 0.1), 0px 10px 15px rgba(0, 0, 0, 0.12), 0px 4px 3px rgba(0, 0, 0, 0.04)"
    },
    [n.breakpoints.only("md")]: {
      minHeight: 272,
      height: 1
    }
  },
  details: {
    display: "flex",
    flexDirection: "row",
    height: "100%"
  },
  content: {
    padding: "32px 32px 24px",
    "&:last-child": {
      paddingBottom: 24
    },
    [n.breakpoints.down("sm")]: {
      padding: 24
    }
  },
  cardContentText: {
    display: "flex",
    justifyContent: "center",
    color: n.colors.darkGray
  },
  cardHeaderText: {
    fontSize: n.fontVars.xlarge,
    lineHeight: "32px",
    fontFamily: n.fontFamily.light,
    color: n.colors.darkGray
  },
  cardDataText: {
    fontSize: n.fontVars.medium,
    lineHeight: "22px",
    fontFamily: n.fontFamily.light,
    paddingTop: n.gutterFPS * 3,
    color: n.colors.darkGray
  },
  cardDataSubText: {
    fontSize: n.fontVars.medium,
    lineHeight: "22px",
    fontFamily: n.fontFamily.light,
    paddingTop: n.gutterFPS * 4,
    color: n.colors.darkGray
  },
  cardButton: {
    boxShadow: "none",
    background: n.colors.white,
    border: "1px solid #086EA1",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue,
      color: n.colors.white,
      border: "1px solid #043954"
    },
    marginTop: n.gutterFPS * 8,
    marginBottom: n.gutterFPS * 2,
    fontSize: n.fontVars.medium,
    lineHeight: "16px",
    maxHeight: "32px",
    fontFamily: n.fontFamily.reg,
    color: n.colors.interactiveBlue,
    textTransform: "none",
    [n.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: n.gutterFPS * 2
    }
  },
  cardLink: {
    color: n.palette.interactiveBlue
  },
  cardButtonNoOutline: {
    boxShadow: "none",
    background: n.colors.white,
    marginBottom: n.gutterFPS * 2,
    fontSize: n.fontVars.medium,
    lineHeight: "16px",
    maxHeight: "32px",
    fontFamily: n.fontFamily.reg,
    color: n.colors.interactiveBlue,
    textTransform: "none",
    "& .arrow-icon": {
      paddingLeft: n.gutterFPS * 2
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: n.colors.hoverBlue,
      border: "none"
    },
    "&:active": {
      boxShadow: "none"
    },
    padding: "16px 0 0 0"
  },
  cardButtonContainer: {
    padding: "12px",
    flexGrow: "1",
    alignContent: "flex-end",
    [n.breakpoints.down("sm")]: {
      padding: "32px 12px 12px"
    }
  },
  cardImage: {
    marginBottom: n.gutterFPS * 4,
    maxHeight: "72px"
  },
  backgroundImage: {
    backgroundImage: `url(${wS})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right top",
    minHeight: 76
  }
})), kS = ({
  className: n,
  id: e,
  onClick: o,
  cardButtonText: a,
  noOutline: i,
  buttonIcon: s,
  href: c,
  target: u
}) => {
  const [A, b] = C.useState(null), h = () => b(!0), m = () => b(!1);
  return /* @__PURE__ */ p.jsxs("div", { children: [
    !c && /* @__PURE__ */ p.jsxs(
      Go,
      {
        id: e,
        size: "large",
        className: n,
        onClick: o,
        disableRipple: i,
        color: "primary",
        variant: "contained",
        onMouseEnter: h,
        onMouseLeave: m,
        children: [
          a,
          " ",
          s && C.cloneElement(s, { filled: !!A })
        ]
      }
    ),
    c && /* @__PURE__ */ p.jsxs(
      Go,
      {
        id: e,
        size: "large",
        className: n,
        color: "primary",
        variant: "contained",
        href: c,
        disableRipple: i,
        target: u || "_blank",
        onMouseEnter: h,
        onMouseLeave: m,
        children: [
          a,
          " ",
          s && C.cloneElement(s, { filled: !!A })
        ]
      }
    )
  ] });
};
function z8({
  buttonId: n,
  contentText: e,
  cardDataSubText: o,
  headerText: a,
  onClick: i,
  cardId: s,
  cardButtonText: c,
  cardLinkText: u,
  href: A,
  target: b,
  cardIcon: h,
  maxWidth: m = "xl",
  noOutline: E,
  buttonIcon: y,
  trademarked: k
}) {
  const w = ES(), _ = E ? w.cardButtonNoOutline : w.cardButton;
  return /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(vt, { maxWidth: m, className: w.root, id: s, children: /* @__PURE__ */ p.jsx(Tu, { className: w.card, children: /* @__PURE__ */ p.jsx("div", { className: w.details, children: /* @__PURE__ */ p.jsx("div", { className: w.cardContentText, children: /* @__PURE__ */ p.jsxs(Ou, { className: w.content, children: [
    /* @__PURE__ */ p.jsx("div", { style: { minHeight: "130px" }, children: /* @__PURE__ */ p.jsxs(cn, { component: "h5", variant: "h5", children: [
      /* @__PURE__ */ p.jsxs("div", { className: w.cardHeaderText, id: `${s}-title`, children: [
        a,
        k ? /* @__PURE__ */ p.jsx("sup", { children: "®" }) : ""
      ] }),
      /* @__PURE__ */ p.jsx("div", { className: w.cardDataText, id: `${s}-main-content`, children: e }),
      o && /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx(ya, { xsDown: !0, children: /* @__PURE__ */ p.jsx(
          "div",
          {
            className: w.backgroundImage,
            style: { backgroundImage: `url(${h})` },
            id: `${s}-secondary-content`,
            children: /* @__PURE__ */ p.jsx("div", { className: w.cardDataSubText, children: o })
          }
        ) }),
        /* @__PURE__ */ p.jsx(ya, { smUp: !0, children: /* @__PURE__ */ p.jsxs("div", { className: w.cardDataSubText, id: `${s}-secondary-content`, children: [
          " ",
          o
        ] }) })
      ] })
    ] }) }),
    /* @__PURE__ */ p.jsxs(so, { container: !0, spacing: 3, className: w.cardButtonContainer, children: [
      /* @__PURE__ */ p.jsxs(so, { item: !0, xs: 12, sm: 8, style: { display: "flex", alignSelf: "flex-end" }, children: [
        u && /* @__PURE__ */ p.jsx(
          Io,
          {
            color: "inherit",
            href: A,
            target: b || "_blank",
            underline: "none",
            className: w.cardLink,
            children: u
          }
        ),
        c && /* @__PURE__ */ p.jsx(
          kS,
          {
            className: _,
            id: n,
            onClick: i,
            href: A,
            target: b,
            noOutline: E,
            cardButtonText: c,
            buttonIcon: y
          }
        )
      ] }),
      !o && /* @__PURE__ */ p.jsx(ya, { xsDown: !0, children: /* @__PURE__ */ p.jsx(so, { item: !0, sm: 4, style: { alignSelf: "center" }, children: /* @__PURE__ */ p.jsx(En, { children: /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx("img", { src: h, alt: "add-co-client", style: { float: "right", maxWidth: "72px", maxHeight: "72px" } }) }) }) }) })
    ] })
  ] }) }) }) }) }) });
}
const SS = () => /* @__PURE__ */ p.jsxs("svg", { width: "280", height: "11", viewBox: "5 0 339 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M65.5112 4.63181C65.4141 3.43066 64.5892 2.73399 63.0851 2.73399C61.5809 2.73399 61.0229 3.28652 61.0229 4.17538C61.0045 4.54748 61.2023 4.89731 61.5324 5.07624C62.3533 5.43065 63.2119 5.69254 64.0919 5.85699C65.1431 6.03402 66.1537 6.39608 67.076 6.92601C68.0485 7.49908 68.6364 8.54419 68.6166 9.66464C68.6166 12.1871 66.6272 13.7365 63.4004 13.7365C59.9675 13.7365 57.9902 12.115 57.9175 9.25625H60.6711C60.6401 9.81649 60.8367 10.3657 61.217 10.7817C61.8277 11.3656 62.6638 11.6591 63.5096 11.5865C64.9289 11.5865 65.8265 10.9499 65.8265 9.9409C65.8265 9.37636 65.5475 9.01602 64.8561 8.73975C64.0611 8.45321 63.2512 8.20863 62.43 8.00705C61.3543 7.80045 60.3364 7.36613 59.4459 6.73383C58.783 6.11305 58.4321 5.23329 58.4876 4.33153C58.4876 2.03733 60.4285 0.55991 63.3398 0.55991C64.911 0.432619 66.4487 1.05777 67.4763 2.24152C67.9731 2.91753 68.2329 3.73588 68.2163 4.57176L65.5112 4.63181ZM17.365 13.4481H20.1308L20.0944 0.908081H17.4378V6.12108C17.4378 6.48767 17.4626 7.11376 17.4886 7.76879L17.4886 7.76889L17.4886 7.76898C17.5171 8.48747 17.547 9.24075 17.547 9.72453C17.0477 8.73607 16.497 7.77386 15.8972 6.84177L12.2581 0.908081H9.44383V13.4601H12.1004V8.11499C12.1004 6.81775 12.064 5.44843 11.9912 4.60763C12.4556 5.58933 12.9908 6.53668 13.5925 7.44235L17.365 13.4481ZM0.00640869 13.4481H2.74789V0.908096H0.00640869V13.4481ZM32.9525 13.4481H29.7986L25.6621 0.908081H28.5492L30.1989 5.98895C30.697 7.56584 31.1021 9.17008 31.412 10.7936C31.7311 9.1721 32.136 7.56836 32.625 5.98895L34.2748 0.908081H37.1618L32.9525 13.4481ZM45.447 3.2263H52.1673V0.908081H42.6933V13.4601H52.3128V11.1419H45.447V8.07896H51.6335V5.91688H45.447V3.2263ZM80.6257 3.2263H84.471L84.4225 0.908081H74.0024V3.2263H77.8721V13.4481H80.6257V3.2263ZM111.898 13.4482H109.181L107.761 8.079C107.482 6.87785 107.215 5.44848 106.961 3.91101C106.815 5.02808 106.451 6.91389 106.16 8.01895L104.838 13.4482H102.024L98.6514 0.90813H101.417L102.63 6.16917C103 7.67925 103.268 9.21214 103.431 10.7576C103.619 9.22025 103.902 7.69589 104.28 6.1932L105.687 0.90813H108.307L109.629 6.07308C110.009 7.61582 110.293 9.18029 110.479 10.7576C110.676 9.14158 110.964 7.53761 111.34 5.95297L112.553 0.896118H115.307L111.898 13.4482ZM121.7 13.4481H124.453V0.908081H121.7V13.4481ZM141.133 3.2263H137.287V13.4481H134.534V3.2263H130.725V0.908081H141.145L141.133 3.2263ZM154.767 13.4481H157.521L157.472 0.908081H154.718V5.71269H149.539V0.908081H146.785V13.4601H149.575V8.00689H154.767V13.4481ZM183.893 8.64361C183.849 10.0793 183.219 11.4362 182.147 12.4032C181.074 13.3701 179.651 13.8644 178.203 13.7725C174.564 13.7725 172.138 11.142 172.138 7.20222C172.138 3.26244 174.686 0.619911 178.325 0.619911C181.068 0.44698 183.473 2.4221 183.808 5.12423H181.078C180.867 3.77291 179.641 2.81018 178.264 2.91411C176.214 2.91411 174.904 4.59572 174.904 7.21423C174.904 9.83275 176.19 11.4303 178.228 11.4303C179.877 11.4303 180.884 10.4453 181.115 8.58355L183.893 8.64361ZM195.38 13.7726C199.092 13.7726 201.591 11.118 201.591 7.21426L201.579 7.19024C201.579 3.2985 199.08 0.619934 195.453 0.619934C191.668 0.619934 189.121 3.28649 189.121 7.21426C189.121 11.142 191.668 13.7726 195.38 13.7726ZM191.887 7.21335C191.887 9.85588 193.233 11.5135 195.38 11.5135C197.527 11.5135 198.777 9.84387 198.777 7.20134C198.777 4.55881 197.455 2.93726 195.392 2.93726C193.33 2.93726 191.899 4.52277 191.899 7.17732L191.887 7.21335ZM215.444 13.4841H218.21L218.149 0.908081H215.493V6.12108C215.493 6.48752 215.52 7.11323 215.549 7.76796L215.549 7.76889L215.549 7.76965C215.581 8.48794 215.614 9.2409 215.614 9.72453C215.114 8.73662 214.563 7.77446 213.964 6.84177L210.325 0.908081H207.523V13.5322H210.18V8.18706C210.18 6.88981 210.143 5.5205 210.058 4.6797C210.529 5.64662 211.064 6.58156 211.659 7.47838L215.444 13.4841ZM234.125 3.2263H227.987V6.1451H233.337V8.30717H227.987V13.4601H225.233V0.908081H234.125V3.2263ZM240.372 13.4481H243.126V0.908081H240.372V13.4481ZM255.778 0.908086C257.315 0.790311 258.836 1.27811 260.011 2.26539C261.312 3.52228 262.001 5.27333 261.904 7.07C262.027 8.90009 261.382 10.6994 260.121 12.0428C258.974 13.1284 257.404 13.6599 255.826 13.4962H250.671V0.908086H255.778ZM255.548 11.13H253.425L253.437 3.17841H255.463C257.889 3.17841 259.102 4.51169 259.102 7.05813C259.185 8.20145 258.83 9.33386 258.107 10.2292C257.446 10.9138 256.497 11.248 255.548 11.13ZM277.273 3.2263H270.516V5.91688H276.703V8.07896H270.516V11.1419H277.382V13.4601H267.763V0.908081H277.249L277.273 3.2263ZM292.012 13.4481H294.777V0.908081H292.097V6.12108C292.097 6.48713 292.124 7.1119 292.153 7.76586V7.76619L292.153 7.76889L292.153 7.77127L292.153 7.77239C292.185 8.48985 292.218 9.24152 292.218 9.72454C291.713 8.73639 291.159 7.77423 290.556 6.84177L286.917 0.908081H284.103V13.4962H286.759V8.15103C286.759 6.85378 286.723 5.48447 286.638 4.64366C287.109 5.60811 287.639 6.54279 288.227 7.44235L292.012 13.4481ZM312.33 8.64361C312.287 10.0816 311.655 11.4404 310.58 12.4077C309.505 13.3751 308.078 13.8678 306.629 13.7725C302.99 13.7725 300.563 11.142 300.563 7.20223C300.563 3.26245 303.038 0.619911 306.702 0.619911C309.445 0.446979 311.85 2.4221 312.184 5.12423H309.455C309.244 3.77291 308.018 2.81018 306.641 2.91411C304.591 2.91411 303.293 4.59573 303.293 7.21424C303.293 9.83275 304.567 11.4303 306.629 11.4303C308.278 11.4303 309.285 10.4453 309.516 8.58355L312.33 8.64361ZM320.773 3.25033H327.505L327.396 0.908081H317.91V13.4601H327.53V11.1419H320.773V8.07896H326.947V5.91688H320.773V3.25033Z", fill: "white" }),
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M337.623 1.65288C337.009 1.02742 336.162 0.679863 335.281 0.691956C334.149 0.704047 333.101 1.28852 332.503 2.24144C331.91 3.21045 331.865 4.41399 332.382 5.4245C332.922 6.46728 333.986 7.14237 335.168 7.19208C336.351 7.24179 337.469 6.65846 338.096 5.66473C338.412 5.1643 338.581 4.58572 338.581 3.99512C338.603 3.11662 338.256 2.26842 337.623 1.65288ZM333.402 2.08503C333.893 1.57817 334.574 1.29545 335.283 1.30428C335.995 1.29643 336.679 1.57872 337.175 2.08503C337.687 2.58344 337.965 3.27208 337.939 3.98284C337.936 4.32134 337.866 4.65594 337.733 4.96779C337.599 5.2854 337.406 5.57485 337.163 5.8206C336.671 6.32334 335.995 6.60718 335.289 6.60718C334.582 6.60718 333.906 6.32334 333.414 5.8206C332.907 5.32304 332.626 4.6419 332.638 3.9348C332.625 3.24032 332.901 2.57113 333.402 2.08503ZM333.947 2.21682H335.5C335.708 2.20614 335.917 2.22638 336.119 2.27688C336.313 2.33427 336.48 2.45761 336.592 2.62521C336.709 2.8033 336.769 3.01305 336.762 3.22579C336.77 3.42563 336.714 3.62299 336.604 3.79033C336.537 3.87958 336.455 3.95677 336.361 4.01855C336.467 4.07453 336.553 4.16301 336.604 4.27079C336.661 4.47828 336.689 4.69239 336.689 4.9074C336.672 5.09921 336.672 5.29214 336.689 5.48395C336.689 5.54401 336.762 5.61608 336.883 5.70016H336.022C335.957 5.51062 335.924 5.31174 335.925 5.1116C335.933 4.9175 335.913 4.72322 335.864 4.53504C335.833 4.46364 335.77 4.41046 335.694 4.39091H335.403H334.809V5.71217H333.984L333.947 2.21682ZM334.772 3.69361V2.93719H335.391C335.541 2.92422 335.692 2.94901 335.829 3.00923C335.917 3.08352 335.962 3.1957 335.95 3.3094C335.96 3.42281 335.915 3.5341 335.829 3.60957C335.691 3.6815 335.534 3.71078 335.379 3.69361H334.772Z", fill: "white" })
] }), RS = () => /* @__PURE__ */ p.jsx("svg", { width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.47198 0.737183C0.9197 0.737183 0.471985 1.1849 0.471985 1.73718V19.1386C0.471985 19.6909 0.9197 20.1386 1.47198 20.1386H9.58788V20.1387H13.0051V20.1386H18.9197C19.472 20.1386 19.9197 19.6909 19.9197 19.1386V1.73718C19.9197 1.1849 19.472 0.737183 18.9197 0.737183H1.47198ZM13.0051 20.1386V11.9461H15.7093L15.9124 9.58787H13.0051V7.74685C13.0051 7.1133 13.6398 6.88619 14.3491 6.88619C15.0578 6.88619 15.8175 7.08249 15.8175 7.08249L16.2731 4.66821C16.2731 4.66821 15.3049 4.375 13.0051 4.375C11.5934 4.375 10.773 4.85513 10.1749 5.56148C9.60761 6.22853 9.58788 7.30558 9.58788 8.00411V9.58787H7.76474V11.9461H9.58788V20.1386H13.0051Z", fill: "#898989" }) }), BS = () => /* @__PURE__ */ p.jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.47198 0.232666C0.9197 0.232666 0.471985 0.68038 0.471985 1.23266V18.6341C0.471985 19.1864 0.9197 19.6341 1.47198 19.6341H18.9197C19.472 19.6341 19.9197 19.1864 19.9197 18.6341V1.23267C19.9197 0.680381 19.472 0.232666 18.9197 0.232666H1.47198ZM6.4855 8.38049H3.86041V16.6026H6.4855V8.38049ZM5.09456 7.34412H5.07549C4.12614 7.34412 3.51035 6.7123 3.51035 5.91193C3.51035 5.09561 4.14464 4.47675 5.11306 4.47675C6.08091 4.47675 6.6763 5.0941 6.69537 5.90968C6.69537 6.71043 6.08091 7.34412 5.09456 7.34412ZM13.9309 16.6026H16.8808V12.0171C16.8808 9.4633 15.4284 8.27686 13.58 8.27686C12.0892 8.27686 11.1557 9.08461 10.9829 9.6504V8.35626H8.06064C8.09864 9.0436 8.06064 16.6026 8.06064 16.6026H10.9829V12.1405C10.9829 12.1113 10.9828 12.082 10.9826 12.0528C10.9814 11.8346 10.9803 11.6231 11.0466 11.4665C11.2478 10.9704 11.6789 10.4561 12.455 10.4561C13.4702 10.4561 13.9309 11.2184 13.9309 12.3353V16.6026Z", fill: "#898989" }) }), _S = () => /* @__PURE__ */ p.jsx("svg", { width: "24", height: "21", viewBox: "0 0 24 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsx("path", { d: "M16.6205 0.902344C13.9354 0.902344 11.7586 3.07393 11.7586 5.75271C11.7319 6.15836 11.7564 6.56576 11.8315 6.96531C7.87398 6.75732 4.19219 4.87892 1.70653 1.79966C1.27382 2.53535 1.04322 3.37187 1.03802 4.22485C0.946333 5.84372 1.69454 7.39609 3.01926 8.33554C2.18438 8.24854 1.36599 8.04442 0.588289 7.72924V7.78987C0.659726 10.1759 2.3828 12.1923 4.73309 12.6402C4.33851 12.7562 3.92893 12.8134 3.51761 12.81C3.22375 12.8116 2.9305 12.7832 2.64246 12.7251C3.32529 14.7289 5.21277 16.0753 7.33423 16.0719C5.60228 17.4326 3.46135 18.1716 1.25681 18.1697C0.85053 18.1704 0.444598 18.1461 0.0413208 18.0969C2.28508 19.5375 4.89692 20.3036 7.56517 20.3038C11.2792 20.3331 14.8498 18.8751 17.4773 16.2561C20.1047 13.6372 21.5694 10.0764 21.5432 6.37114C21.5432 6.15287 21.5432 5.94673 21.5432 5.74059C22.4975 5.04601 23.3206 4.18792 23.9742 3.20627C23.0782 3.60343 22.1277 3.86499 21.1543 3.98233C22.1843 3.36586 22.9535 2.39581 23.3179 1.254C22.3537 1.83335 21.2971 2.24349 20.1941 2.46659C19.2741 1.47022 17.9784 0.903052 16.6205 0.902344", fill: "#898989" }) }), FS = () => /* @__PURE__ */ p.jsx("svg", { width: "25", height: "18", viewBox: "0 0 25 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.0799 0.1453H11.6677L12.0376 0.134521C12.0376 0.134521 17.1321 0.156079 20.4932 0.403987C21.4098 0.428723 22.2812 0.815116 22.9241 1.48185C23.461 2.19273 23.8234 3.02425 23.9811 3.90703C24.1972 5.21447 24.3138 6.537 24.3299 7.86278V9.70592C24.3139 11.0317 24.1972 12.3542 23.9811 13.6617C23.8113 14.5406 23.4501 15.3694 22.9241 16.0869C22.293 16.7581 21.426 17.1459 20.5143 17.1647C17.1109 17.4234 12.0588 17.4234 12.0588 17.4234C12.0588 17.4234 5.81223 17.3587 3.88859 17.1755C2.90583 17.1539 1.96377 16.7711 1.23567 16.0976C0.724474 15.3832 0.397388 14.5493 0.284418 13.6724C0.13378 12.3593 0.0526304 11.0388 0.0413208 9.7167V7.86278C0.046791 6.5483 0.120882 5.23504 0.263279 3.92859C0.375418 3.0482 0.702499 2.21061 1.21453 1.49263C1.84768 0.824326 2.71339 0.437113 3.62436 0.414765C7.03828 0.1453 12.0799 0.1453 12.0799 0.1453ZM16.0437 8.54179L9.55405 5.09265V12.0017L16.0437 8.54179Z", fill: "#898989" }) }), IS = (n, e) => {
  const o = e || document.location.origin;
  if (process.env.REACT_APP_ENV === "production")
    switch (o) {
      case process.env.REACT_APP_DEV:
        return n.dev;
      case process.env.REACT_APP_STAGE:
        return n.stage;
      case process.env.REACT_APP_PROD:
        return n.prod;
      default:
        return n.dev;
    }
  else
    return n.dev;
}, TS = () => {
  const n = window.location.href;
  return n.indexOf("www.awstrp.net") !== -1 || n.indexOf("www.troweprice.com") !== -1 ? "prod" : n.indexOf("wwwstage.awstrp.net") !== -1 || n.indexOf("wwwstage.troweprice.com") !== -1 ? "stage" : "dev";
}, Wn = {
  dev: "https://wwwdev.troweprice.com",
  stage: "https://wwwstage.troweprice.com",
  prod: "https://www.troweprice.com"
}, At = (n) => IS(
  Wn
) + n;
process.env.REACT_APP_ENV === "production" && window.location.href.includes("/fps") ? `${document.location.origin}` : `${process.env.PUBLIC_URL}`;
At("/personal-investing/planning-and-research/advice/planning-service/faq.html"), At("/personal-investing/planning-and-research/advice/planning-service/implementation-guide.html");
At("/content/dam/iinvestor/products-and-services/adv/Aggregation-Services-Terms.pdf"), At("/content/dam/iinvestor/advice-and-planning/planning-service/t-rowe-price-planning-service-form-adv.pdf"), At("/content/dam/iinvestor/advice-and-planning/planning-service/t-rowe-price-planning-service-form-client-agreement.pdf"), At("/content/dam/iinvestor/Forms/trpas-form-crs.pdf"), At("/content/dam/iinvestor/Forms/trpis-form-crs.pdf"), At("/content/dam/trowecorp/Pdfs/PrivacyNoticeUSCAN.pdf");
const Ci = /* @__PURE__ */ p.jsx("span", { style: { whiteSpace: "nowrap" }, children: "T. Rowe Price" }), tp = /* @__PURE__ */ p.jsx("span", { style: { whiteSpace: "nowrap" }, children: "T. ROWE PRICE" }), OS = fu({
  overrides: {
    MuiListItem: {
      gutters: {
        paddingLeft: 0,
        paddingRight: 0
      }
    }
  }
}), US = wo((n) => ({
  root: {
    flexGrow: 1,
    height: "100%"
  },
  container: {
    height: "100%",
    paddingBottom: 16
  },
  contentTop: {
    width: "100%",
    background: "#F1F1F1"
  },
  contentMiddle: {
    width: "100%",
    minHeight: 383,
    background: "#4F4F4F"
  },
  contentMiddleInner: {
    paddingLeft: 24,
    paddingRight: 24,
    flexGrow: 1,
    height: "100%",
    [n.breakpoints.down("xs")]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  contentBottom: {
    width: "100%",
    minHeight: 115,
    background: "#3B3B3B"
  },
  listText: {
    lineHeight: "1 !important"
  },
  disclosureBox: {
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 24,
    paddingRight: 24,
    [n.breakpoints.down("xs")]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  rightsReservedBox: {
    padding: "0 24px",
    [n.breakpoints.down("xs")]: {
      padding: "0 16px"
    }
  },
  li: { paddingTop: 0, paddingBottom: 4 },
  a: {
    color: "#FFFFFF",
    fontSize: 15,
    lineHeight: "16px",
    fontFamily: yo.nimbusSansReg,
    cursor: "pointer",
    "&:hover": {
      color: "#1FBEDA "
    }
  },
  taglineContainer: {
    width: "33%",
    alignItems: "center",
    paddingTop: 12,
    paddingRight: 32,
    [n.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  footerLinkContainer: {
    paddingTop: 18,
    display: "flex",
    flexDirection: "row",
    [n.breakpoints.down("xs")]: {
      flexDirection: "inherit",
      paddingTop: 8
    }
  },
  secondColumnListItem: {
    paddingTop: 0,
    paddingBottom: 4,
    [n.breakpoints.down("503")]: {
      paddingRight: 106,
      whiteSpace: "nowrap"
    },
    [n.breakpoints.down("463")]: {
      paddingRight: 85
    },
    [n.breakpoints.down("430")]: {
      paddingRight: 50
    },
    [n.breakpoints.down("376")]: {
      paddingRight: 0
    }
  },
  socialMediaListItem: {
    paddingRight: 40,
    paddingTop: 0,
    paddingBottom: 4
  },
  columnContainer: {
    [n.breakpoints.down("xs")]: {
      paddingBottom: 20
    }
  }
})), xl = $e({
  root: {
    fontSize: 16,
    lineHeight: "22px",
    fontFamily: yo.nimbusSansLight
  }
})((n) => /* @__PURE__ */ p.jsx(cn, { ...n, children: n.children })), KS = (n) => {
  const { text1: e, text2: o, lrn: a, disableDisclosure: i, classes: s } = n, c = {
    color: "#3B3B3B"
  };
  return /* @__PURE__ */ p.jsx(En, { id: "disclosure-box", display: "flex", className: s.contentTop, children: /* @__PURE__ */ p.jsx(vt, { id: "disclosure-copy-container", children: /* @__PURE__ */ p.jsx("div", { className: s.root, children: /* @__PURE__ */ p.jsx(
    En,
    {
      id: "disclosure-sub-container",
      display: "flex",
      className: s.disclosureBox,
      children: /* @__PURE__ */ p.jsxs(En, { justifyContent: "center", children: [
        a ? /* @__PURE__ */ p.jsxs("span", { children: [
          /* @__PURE__ */ p.jsx(
            xl,
            {
              id: "lrn-number",
              style: c,
              variant: "body2",
              gutterBottom: !0,
              dangerouslySetInnerHTML: {
                __html: a
              }
            }
          ),
          /* @__PURE__ */ p.jsx("br", {})
        ] }) : null,
        i ? null : /* @__PURE__ */ p.jsxs(Fp, { children: [
          /* @__PURE__ */ p.jsx(
            xl,
            {
              id: "text1-disclosure-copy",
              style: c,
              variant: "body2",
              gutterBottom: !0,
              dangerouslySetInnerHTML: {
                __html: e && e.length ? e : "All investments involve risk, including possible loss of principal."
              }
            }
          ),
          o !== "none" ? /* @__PURE__ */ p.jsxs("span", { children: [
            /* @__PURE__ */ p.jsx("br", {}),
            /* @__PURE__ */ p.jsx(
              xl,
              {
                id: "text2-disclosure-copy",
                style: c,
                variant: "body2",
                gutterBottom: !0,
                dangerouslySetInnerHTML: {
                  __html: o && o.length ? o : `<span>
                                                            Advisory services are offered by <span style={{ whiteSpace: 'nowrap' }}>T. Rowe Price</span> Advisory
                                                            Services, Inc., a registered investment
                                                            adviser under the Investment Advisers Act of
                                                            1940. <span style={{ whiteSpace: 'nowrap' }}>T. Rowe Price</span> Advisory Services
                                                            and <span style={{ whiteSpace: 'nowrap' }}>T. Rowe Price</span> Investment
                                                            Services are affiliated companies.
                                                        </span>`
                }
              }
            )
          ] }) : null
        ] })
      ] })
    }
  ) }) }) });
}, PS = (n) => ({
  socialMedia: [
    {
      id: 1,
      icon: (e = {}) => /* @__PURE__ */ p.jsx(RS, { ...e }),
      title: "Facebook",
      href: "https://www.facebook.com/troweprice"
    },
    {
      id: 2,
      icon: (e = {}) => /* @__PURE__ */ p.jsx(_S, { ...e }),
      title: "Twitter",
      href: "https://twitter.com/troweprice"
    },
    {
      id: 3,
      icon: (e = {}) => /* @__PURE__ */ p.jsx(FS, { ...e }),
      title: "Youtube",
      href: "https://www.youtube.com/trowepricegroup"
    },
    {
      id: 4,
      icon: (e = {}) => /* @__PURE__ */ p.jsx(BS, { ...e }),
      title: "LinkedIn",
      href: "https://www.linkedin.com/company/157329?trk=tyah"
    }
  ],
  secondColumn: [
    {
      id: 5,
      title: "Company Overview",
      href: Wn[n] + "/corporate/en/what-we-do.html",
      divId: "company-overview"
    },
    {
      id: 6,
      title: "Responsibility",
      href: Wn[n] + "/corporate/en/what-sets-us-apart/corporate-responsibility.html",
      divId: "reponsibility"
    },
    {
      id: 7,
      title: "Careers",
      href: Wn[n] + "/corporate/en/careers.html",
      divId: "careers"
    },
    {
      id: 8,
      title: "Investors Relations",
      href: "https://troweprice.gcs-web.com",
      divId: "investor-relations"
    },
    {
      id: 9,
      title: "Press Releases",
      href: Wn[n] + "/corporate/en/press.html",
      divId: "press-releases"
    }
  ],
  thirdColumn: [
    {
      id: 10,
      title: "Site Map",
      href: Wn[n] + "/personal-investing/sitemap.html",
      divId: "site-map"
    },
    {
      id: 11,
      title: "U.S. & Canada Privacy Notice",
      href: Wn[n] + "/enterprise/legal/us/en/privacy-notices.html",
      divId: "privacy-policy"
    },
    {
      id: 12,
      title: "Terms of Use",
      href: Wn[n] + "/personal-investing/help/terms-of-use.html",
      divId: "terms-of-use"
    },
    {
      id: 13,
      title: "Security Measures",
      href: Wn[n] + "/corporate/en/utility/security-measures.html",
      divId: "security-measures"
    },
    {
      id: 14,
      title: "Legal Information",
      href: Wn[n] + "/personal-investing/help/policies-and-security/legal-information.html",
      divId: "legal-info"
    },
    {
      id: 15,
      title: "Customer Agreement",
      href: Wn[n] + "/personal-investing/help/policies-and-security/customer-agreement.html",
      divId: "customer-agreement"
    }
  ],
  fourthColumn: [
    {
      id: 16,
      title: "Form CRS",
      href: Wn[n] + "/personal-investing/about-t-rowe-price/form-crs.html",
      divId: "form-crs"
    },
    {
      id: 17,
      title: "Mobile Solution",
      href: Wn[n] + "/corporate/en/mobile-solutions.html",
      divId: "mobile-solution"
    },
    {
      id: 18,
      title: "Contact Us",
      href: Wn[n] + "/personal-investing/help/contact-us.html",
      divId: "contact-us"
    }
  ]
}), DS = ({ classes: n }) => {
  const e = PS(TS());
  return /* @__PURE__ */ p.jsx(pr, { theme: OS, children: /* @__PURE__ */ p.jsxs(so, { container: !0, spacing: 3, children: [
    /* @__PURE__ */ p.jsx(so, { container: !0, item: !0, xs: !0, children: /* @__PURE__ */ p.jsxs(yi, { id: "social-media-footer-links-column", className: n.columnContainer, role: "list", "aria-label": "social media", children: [
      /* @__PURE__ */ p.jsx(or, { id: "social-media-header-title-container", className: n.li, children: /* @__PURE__ */ p.jsx(
        tr,
        {
          primary: /* @__PURE__ */ p.jsx(
            cn,
            {
              id: "social-media-header-title",
              style: {
                color: "#959FA6",
                fontFamily: yo.nimbusSansBold,
                fontSize: 15,
                lineHeight: "18px"
              },
              variant: "body1",
              gutterBottom: !0,
              children: "Connect with us:"
            }
          )
        }
      ) }),
      e.socialMedia.map((o) => /* @__PURE__ */ p.jsxs(or, { id: `social-media-${o.title}-container`, className: n.socialMediaListItem, children: [
        /* @__PURE__ */ p.jsx(Y4, { id: `social-media-${o.title}-icon-container`, style: { minWidth: 33 }, children: o.icon({}) }),
        /* @__PURE__ */ p.jsx(
          tr,
          {
            id: `social-media-${o.title}-link-container`,
            className: n.listText,
            primary: /* @__PURE__ */ p.jsx(
              Io,
              {
                id: `social-media-${o.title}-link`,
                className: n.a,
                component: "a",
                rel: "noreferrer",
                href: o.href,
                target: "_blank",
                underline: "none",
                children: o.title
              }
            )
          }
        )
      ] }, o.id))
    ] }) }),
    /* @__PURE__ */ p.jsx(so, { container: !0, item: !0, xs: !0, children: /* @__PURE__ */ p.jsx(yi, { id: "second-column-links", className: n.columnContainer, role: "list", "aria-label": "second column", children: e.secondColumn.map((o) => /* @__PURE__ */ p.jsx(or, { id: `sec-col-${o.divId}-container`, className: n.secondColumnListItem, children: /* @__PURE__ */ p.jsx(
      tr,
      {
        id: `sec-col-${o.divId}-link-container`,
        primary: /* @__PURE__ */ p.jsx(
          Io,
          {
            id: `sec-col-${o.divId}-link`,
            className: n.a,
            component: "a",
            rel: "noreferrer",
            href: o.href,
            target: "_blank",
            underline: "none",
            children: o.title
          }
        )
      }
    ) }, o.id)) }) }),
    /* @__PURE__ */ p.jsx(so, { container: !0, item: !0, xs: !0, children: /* @__PURE__ */ p.jsx(yi, { id: "third-column-links", className: n.columnContainer, role: "list", "aria-label": "third column", children: e.thirdColumn.map((o) => /* @__PURE__ */ p.jsx(or, { id: `third-col-${o.divId}-container`, className: n.li, children: /* @__PURE__ */ p.jsx(
      tr,
      {
        id: `third-col-${o.divId}-link-container`,
        className: n.listText,
        primary: /* @__PURE__ */ p.jsx(
          Io,
          {
            id: `third-col-${o.divId}-link`,
            className: n.a,
            component: "a",
            rel: "noreferrer",
            href: o.href,
            target: "_blank",
            underline: "none",
            children: o.title
          }
        )
      }
    ) }, o.id)) }) }),
    /* @__PURE__ */ p.jsx(so, { container: !0, item: !0, xs: !0, children: /* @__PURE__ */ p.jsx(yi, { id: "fourth-column-links", role: "list", "aria-label": "fourth column", children: e.fourthColumn.map((o) => /* @__PURE__ */ p.jsx(or, { id: `fourth-col-${o.divId}-container`, className: n.li, children: /* @__PURE__ */ p.jsx(
      tr,
      {
        id: `fourth-col-${o.divId}-link-container`,
        className: n.listText,
        primary: /* @__PURE__ */ p.jsx(
          Io,
          {
            id: `fourth-col-${o.divId}-link`,
            className: n.a,
            component: "a",
            rel: "noreferrer",
            href: o.href,
            target: "_blank",
            underline: "none",
            children: o.title
          }
        )
      }
    ) }, o.id)) }) })
  ] }) });
}, LS = ({ classes: n }) => /* @__PURE__ */ p.jsx(En, { id: "gray-container", component: "div", display: "flex", className: n.contentMiddle, children: /* @__PURE__ */ p.jsx(vt, { children: /* @__PURE__ */ p.jsx("div", { id: "gray-container-content-container", className: n.contentMiddleInner, children: /* @__PURE__ */ p.jsxs(
  En,
  {
    id: "gray-container-content",
    display: "flex",
    flexDirection: "column",
    style: { paddingTop: 32, paddingBottom: 16 },
    children: [
      /* @__PURE__ */ p.jsx("div", { id: "iwc-img-container", style: { float: "left", paddingBottom: 16 }, children: /* @__PURE__ */ p.jsx(SS, { id: "iwc-img" }) }),
      /* @__PURE__ */ p.jsx(
        R4,
        {
          id: "gray-container-divider",
          style: { backgroundColor: "#898989", height: 1 },
          variant: "fullWidth"
        }
      ),
      /* @__PURE__ */ p.jsxs("div", { id: "footer-links-container", className: n.footerLinkContainer, children: [
        /* @__PURE__ */ p.jsxs(En, { id: "mission-container", className: n.taglineContainer, children: [
          /* @__PURE__ */ p.jsx(
            "p",
            {
              id: "mission-header",
              style: {
                color: "#959FA6",
                fontSize: 15,
                fontFamily: yo.nimbusSansBold,
                lineHeight: "18px",
                marginTop: 0,
                marginBottom: 0
              },
              children: "Our Mission Is Simple."
            }
          ),
          /* @__PURE__ */ p.jsx(
            "p",
            {
              id: "mission-statement",
              style: {
                color: "#FFFFFF",
                fontSize: 15,
                fontFamily: yo.nimbusSansReg,
                lineHeight: "18px"
              },
              children: "Help clients around the world achieve their long-term investment goals."
            }
          )
        ] }),
        /* @__PURE__ */ p.jsx(DS, { classes: n })
      ] })
    ]
  }
) }) }) }), NS = ({ disableCPRA: n, classes: e }) => {
  const o = {
    fontFamily: yo.nimbusSansReg,
    fontSize: 12,
    lineHeight: "17px",
    color: "#FFFFFF"
  }, a = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ p.jsx(En, { id: "content-bottom-container", component: "div", display: "flex", className: e.contentBottom, children: /* @__PURE__ */ p.jsx(vt, { children: /* @__PURE__ */ p.jsx("div", { id: "content-bottom-content-container", className: e.rightsReservedBox, children: /* @__PURE__ */ p.jsx(so, { id: "content-bottom-grid-container", container: !0, spacing: 3, className: e.container, children: /* @__PURE__ */ p.jsx(so, { id: "content-bottom-grid", item: !0, xs: 12, children: /* @__PURE__ */ p.jsxs(En, { id: "content-bottom-disclosure-container", display: "flex", flexDirection: "column", style: { paddingTop: 30 }, children: [
    n ? null : /* @__PURE__ */ p.jsx("p", { children: /* @__PURE__ */ p.jsx(
      Io,
      {
        id: "onetrust-link",
        className: `${e.a} ot-sdk-show-settings`,
        style: { fontSize: "12px", lineHeight: "17px" },
        component: "button",
        underline: "always",
        children: "Do Not Sell or Share My Personal Information"
      }
    ) }),
    /* @__PURE__ */ p.jsxs("p", { id: "content-bottom-disclosure", style: o, children: [
      "The funds referred to in this website are offered and sold only to persons residing in the United States and are offered by prospectus only. The prospectuses include investment objectives, risks, fees, expenses, and other information that you should read and consider carefully before investing.",
      /* @__PURE__ */ p.jsxs("div", { id: "content-bottom-prospectuses", children: [
        "Download a ",
        /* @__PURE__ */ p.jsx(
          Io,
          {
            id: "mf-footer-link",
            className: e.a,
            style: { fontSize: "inherit" },
            component: "a",
            rel: "noreferrer",
            href: "https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html",
            target: "_blank",
            underline: "always",
            children: "mutual fund prospectus"
          }
        ),
        " or ",
        /* @__PURE__ */ p.jsx(
          Io,
          {
            id: "etf-footer-link",
            className: e.a,
            style: { fontSize: "inherit" },
            component: "a",
            rel: "noreferrer",
            href: "https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html",
            target: "_blank",
            underline: "always",
            children: "ETF prospectus"
          }
        ),
        "."
      ] })
    ] }),
    /* @__PURE__ */ p.jsxs("p", { id: "content-bottom-rights", style: o, children: [
      "©",
      a.getFullYear(),
      " ",
      Ci,
      ". All Rights Reserved. ",
      tp,
      ", INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart, trademarks of ",
      Ci,
      " Group, Inc. RETIRE WITH CONFIDENCE, ",
      tp,
      " INSIGHTS, ACTIVEPLUS PORTFOLIOS, and GOTUITION and design, are trademarks of ",
      Ci,
      " Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement, sponsorship, or affiliation of ",
      Ci,
      " with any of the trademark owners."
    ] })
  ] }) }) }) }) }) });
};
function G8({ text1: n, text2: e, lrn: o, disableDisclosure: a, disableCPRA: i }) {
  const s = US(), c = window.location.pathname.includes("/usis/advice/fps/profile");
  return /* @__PURE__ */ p.jsx("footer", { children: /* @__PURE__ */ p.jsxs("div", { "data-metrics-location": "FTR", style: { paddingTop: c ? "" : "120px" }, id: "footer", children: [
    (!a || o) && /* @__PURE__ */ p.jsx(KS, { classes: s, text1: n, text2: e, lrn: o, disableDisclosure: a }),
    /* @__PURE__ */ p.jsx(LS, { classes: s }),
    /* @__PURE__ */ p.jsx(NS, { disableCPRA: i, classes: s })
  ] }) });
}
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ri = globalThis, Yu = Ri.ShadowRoot && (Ri.ShadyCSS === void 0 || Ri.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, zu = Symbol(), ap = /* @__PURE__ */ new WeakMap();
let Hg = class {
  constructor(n, e, o) {
    if (this._$cssResult$ = !0, o !== zu)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = n, this.t = e;
  }
  get styleSheet() {
    let n = this.o;
    const e = this.t;
    if (Yu && n === void 0) {
      const o = e !== void 0 && e.length === 1;
      o && (n = ap.get(e)), n === void 0 && ((this.o = n = new CSSStyleSheet()).replaceSync(this.cssText), o && ap.set(e, n));
    }
    return n;
  }
  toString() {
    return this.cssText;
  }
};
const MS = (n) => new Hg(typeof n == "string" ? n : n + "", void 0, zu), kn = (n, ...e) => {
  const o = n.length === 1 ? n[0] : e.reduce((a, i, s) => a + ((c) => {
    if (c._$cssResult$ === !0)
      return c.cssText;
    if (typeof c == "number")
      return c;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + c + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + n[s + 1], n[0]);
  return new Hg(o, n, zu);
}, jS = (n, e) => {
  if (Yu)
    n.adoptedStyleSheets = e.map((o) => o instanceof CSSStyleSheet ? o : o.styleSheet);
  else
    for (const o of e) {
      const a = document.createElement("style"), i = Ri.litNonce;
      i !== void 0 && a.setAttribute("nonce", i), a.textContent = o.cssText, n.appendChild(a);
    }
}, rp = Yu ? (n) => n : (n) => n instanceof CSSStyleSheet ? ((e) => {
  let o = "";
  for (const a of e.cssRules)
    o += a.cssText;
  return MS(o);
})(n) : n;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: $S, defineProperty: QS, getOwnPropertyDescriptor: HS, getOwnPropertyNames: VS, getOwnPropertySymbols: qS, getPrototypeOf: WS } = Object, Ia = globalThis, ip = Ia.trustedTypes, YS = ip ? ip.emptyScript : "", sp = Ia.reactiveElementPolyfillSupport, fr = (n, e) => n, $i = { toAttribute(n, e) {
  switch (e) {
    case Boolean:
      n = n ? YS : null;
      break;
    case Object:
    case Array:
      n = n == null ? n : JSON.stringify(n);
  }
  return n;
}, fromAttribute(n, e) {
  let o = n;
  switch (e) {
    case Boolean:
      o = n !== null;
      break;
    case Number:
      o = n === null ? null : Number(n);
      break;
    case Object:
    case Array:
      try {
        o = JSON.parse(n);
      } catch {
        o = null;
      }
  }
  return o;
} }, Gu = (n, e) => !$S(n, e), cp = { attribute: !0, type: String, converter: $i, reflect: !1, hasChanged: Gu };
Symbol.metadata != null || (Symbol.metadata = Symbol("metadata")), Ia.litPropertyMetadata != null || (Ia.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class ga extends HTMLElement {
  static addInitializer(e) {
    var o;
    this._$Ei(), ((o = this.l) != null ? o : this.l = []).push(e);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(e, o = cp) {
    if (o.state && (o.attribute = !1), this._$Ei(), this.elementProperties.set(e, o), !o.noAccessor) {
      const a = Symbol(), i = this.getPropertyDescriptor(e, a, o);
      i !== void 0 && QS(this.prototype, e, i);
    }
  }
  static getPropertyDescriptor(e, o, a) {
    var i;
    const { get: s, set: c } = (i = HS(this.prototype, e)) != null ? i : { get() {
      return this[o];
    }, set(u) {
      this[o] = u;
    } };
    return { get() {
      return s == null ? void 0 : s.call(this);
    }, set(u) {
      const A = s == null ? void 0 : s.call(this);
      c.call(this, u), this.requestUpdate(e, A, a);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    var o;
    return (o = this.elementProperties.get(e)) != null ? o : cp;
  }
  static _$Ei() {
    if (this.hasOwnProperty(fr("elementProperties")))
      return;
    const e = WS(this);
    e.finalize(), e.l !== void 0 && (this.l = [...e.l]), this.elementProperties = new Map(e.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(fr("finalized")))
      return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(fr("properties"))) {
      const o = this.properties, a = [...VS(o), ...qS(o)];
      for (const i of a)
        this.createProperty(i, o[i]);
    }
    const e = this[Symbol.metadata];
    if (e !== null) {
      const o = litPropertyMetadata.get(e);
      if (o !== void 0)
        for (const [a, i] of o)
          this.elementProperties.set(a, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [o, a] of this.elementProperties) {
      const i = this._$Eu(o, a);
      i !== void 0 && this._$Eh.set(i, o);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(e) {
    const o = [];
    if (Array.isArray(e)) {
      const a = new Set(e.flat(1 / 0).reverse());
      for (const i of a)
        o.unshift(rp(i));
    } else
      e !== void 0 && o.push(rp(e));
    return o;
  }
  static _$Eu(e, o) {
    const a = o.attribute;
    return a === !1 ? void 0 : typeof a == "string" ? a : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var e;
    this._$ES = new Promise((o) => this.enableUpdating = o), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (e = this.constructor.l) == null || e.forEach((o) => o(this));
  }
  addController(e) {
    var o, a;
    ((o = this._$EO) != null ? o : this._$EO = /* @__PURE__ */ new Set()).add(e), this.renderRoot !== void 0 && this.isConnected && ((a = e.hostConnected) == null || a.call(e));
  }
  removeController(e) {
    var o;
    (o = this._$EO) == null || o.delete(e);
  }
  _$E_() {
    const e = /* @__PURE__ */ new Map(), o = this.constructor.elementProperties;
    for (const a of o.keys())
      this.hasOwnProperty(a) && (e.set(a, this[a]), delete this[a]);
    e.size > 0 && (this._$Ep = e);
  }
  createRenderRoot() {
    var e;
    const o = (e = this.shadowRoot) != null ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return jS(o, this.constructor.elementStyles), o;
  }
  connectedCallback() {
    var e;
    this.renderRoot != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$EO) == null || e.forEach((o) => {
      var a;
      return (a = o.hostConnected) == null ? void 0 : a.call(o);
    });
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    var e;
    (e = this._$EO) == null || e.forEach((o) => {
      var a;
      return (a = o.hostDisconnected) == null ? void 0 : a.call(o);
    });
  }
  attributeChangedCallback(e, o, a) {
    this._$AK(e, a);
  }
  _$EC(e, o) {
    var a;
    const i = this.constructor.elementProperties.get(e), s = this.constructor._$Eu(e, i);
    if (s !== void 0 && i.reflect === !0) {
      const c = (((a = i.converter) == null ? void 0 : a.toAttribute) !== void 0 ? i.converter : $i).toAttribute(o, i.type);
      this._$Em = e, c == null ? this.removeAttribute(s) : this.setAttribute(s, c), this._$Em = null;
    }
  }
  _$AK(e, o) {
    var a;
    const i = this.constructor, s = i._$Eh.get(e);
    if (s !== void 0 && this._$Em !== s) {
      const c = i.getPropertyOptions(s), u = typeof c.converter == "function" ? { fromAttribute: c.converter } : ((a = c.converter) == null ? void 0 : a.fromAttribute) !== void 0 ? c.converter : $i;
      this._$Em = s, this[s] = u.fromAttribute(o, c.type), this._$Em = null;
    }
  }
  requestUpdate(e, o, a) {
    var i;
    if (e !== void 0) {
      if (a != null || (a = this.constructor.getPropertyOptions(e)), !((i = a.hasChanged) != null ? i : Gu)(this[e], o))
        return;
      this.P(e, o, a);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(e, o, a) {
    var i;
    this._$AL.has(e) || this._$AL.set(e, o), a.reflect === !0 && this._$Em !== e && ((i = this._$Ej) != null ? i : this._$Ej = /* @__PURE__ */ new Set()).add(e);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (o) {
      Promise.reject(o);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var e;
    if (!this.isUpdatePending)
      return;
    if (!this.hasUpdated) {
      if (this.renderRoot != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [s, c] of this._$Ep)
          this[s] = c;
        this._$Ep = void 0;
      }
      const i = this.constructor.elementProperties;
      if (i.size > 0)
        for (const [s, c] of i)
          c.wrapped !== !0 || this._$AL.has(s) || this[s] === void 0 || this.P(s, this[s], c);
    }
    let o = !1;
    const a = this._$AL;
    try {
      o = this.shouldUpdate(a), o ? (this.willUpdate(a), (e = this._$EO) == null || e.forEach((i) => {
        var s;
        return (s = i.hostUpdate) == null ? void 0 : s.call(i);
      }), this.update(a)) : this._$EU();
    } catch (i) {
      throw o = !1, this._$EU(), i;
    }
    o && this._$AE(a);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    var o;
    (o = this._$EO) == null || o.forEach((a) => {
      var i;
      return (i = a.hostUpdated) == null ? void 0 : i.call(a);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((o) => this._$EC(o, this[o]))), this._$EU();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
}
var lp;
ga.elementStyles = [], ga.shadowRootOptions = { mode: "open" }, ga[fr("elementProperties")] = /* @__PURE__ */ new Map(), ga[fr("finalized")] = /* @__PURE__ */ new Map(), sp == null || sp({ ReactiveElement: ga }), ((lp = Ia.reactiveElementVersions) != null ? lp : Ia.reactiveElementVersions = []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const zS = { attribute: !0, type: String, converter: $i, reflect: !1, hasChanged: Gu }, GS = (n = zS, e, o) => {
  const { kind: a, metadata: i } = o;
  let s = globalThis.litPropertyMetadata.get(i);
  if (s === void 0 && globalThis.litPropertyMetadata.set(i, s = /* @__PURE__ */ new Map()), s.set(o.name, n), a === "accessor") {
    const { name: c } = o;
    return { set(u) {
      const A = e.get.call(this);
      e.set.call(this, u), this.requestUpdate(c, A, n);
    }, init(u) {
      return u !== void 0 && this.P(c, void 0, n), u;
    } };
  }
  if (a === "setter") {
    const { name: c } = o;
    return function(u) {
      const A = this[c];
      e.call(this, u), this.requestUpdate(c, A, n);
    };
  }
  throw Error("Unsupported decorator location: " + a);
};
function zn(n) {
  return (e, o) => typeof o == "object" ? GS(n, e, o) : ((a, i, s) => {
    const c = i.hasOwnProperty(s);
    return i.constructor.createProperty(s, c ? { ...a, wrapped: !0 } : a), c ? Object.getOwnPropertyDescriptor(i, s) : void 0;
  })(n, e, o);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function La(n) {
  return zn({ ...n, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Qi = globalThis, Hi = Qi.trustedTypes, up = Hi ? Hi.createPolicy("lit-html", { createHTML: (n) => n }) : void 0, Vg = "$lit$", ft = `lit$${Math.random().toFixed(9).slice(2)}$`, qg = "?" + ft, ZS = `<${qg}>`, Wt = document, gr = () => Wt.createComment(""), mr = (n) => n === null || typeof n != "object" && typeof n != "function", Wg = Array.isArray, JS = (n) => Wg(n) || typeof (n == null ? void 0 : n[Symbol.iterator]) == "function", Cl = `[ 	
\f\r]`, ar = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Ap = /-->/g, dp = />/g, Tt = RegExp(`>|${Cl}(?:([^\\s"'>=/]+)(${Cl}*=${Cl}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), fp = /'/g, bp = /"/g, Yg = /^(?:script|style|textarea|title)$/i, XS = (n) => (e, ...o) => ({ _$litType$: n, strings: e, values: o }), io = XS(1), Ta = Symbol.for("lit-noChange"), wn = Symbol.for("lit-nothing"), pp = /* @__PURE__ */ new WeakMap(), Mt = Wt.createTreeWalker(Wt, 129);
function zg(n, e) {
  if (!Array.isArray(n) || !n.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return up !== void 0 ? up.createHTML(e) : e;
}
const e7 = (n, e) => {
  const o = n.length - 1, a = [];
  let i, s = e === 2 ? "<svg>" : "", c = ar;
  for (let u = 0; u < o; u++) {
    const A = n[u];
    let b, h, m = -1, E = 0;
    for (; E < A.length && (c.lastIndex = E, h = c.exec(A), h !== null); )
      E = c.lastIndex, c === ar ? h[1] === "!--" ? c = Ap : h[1] !== void 0 ? c = dp : h[2] !== void 0 ? (Yg.test(h[2]) && (i = RegExp("</" + h[2], "g")), c = Tt) : h[3] !== void 0 && (c = Tt) : c === Tt ? h[0] === ">" ? (c = i ?? ar, m = -1) : h[1] === void 0 ? m = -2 : (m = c.lastIndex - h[2].length, b = h[1], c = h[3] === void 0 ? Tt : h[3] === '"' ? bp : fp) : c === bp || c === fp ? c = Tt : c === Ap || c === dp ? c = ar : (c = Tt, i = void 0);
    const y = c === Tt && n[u + 1].startsWith("/>") ? " " : "";
    s += c === ar ? A + ZS : m >= 0 ? (a.push(b), A.slice(0, m) + Vg + A.slice(m) + ft + y) : A + ft + (m === -2 ? u : y);
  }
  return [zg(n, s + (n[o] || "<?>") + (e === 2 ? "</svg>" : "")), a];
};
let Xl = class Gg {
  constructor({ strings: e, _$litType$: o }, a) {
    let i;
    this.parts = [];
    let s = 0, c = 0;
    const u = e.length - 1, A = this.parts, [b, h] = e7(e, o);
    if (this.el = Gg.createElement(b, a), Mt.currentNode = this.el.content, o === 2) {
      const m = this.el.content.firstChild;
      m.replaceWith(...m.childNodes);
    }
    for (; (i = Mt.nextNode()) !== null && A.length < u; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes())
          for (const m of i.getAttributeNames())
            if (m.endsWith(Vg)) {
              const E = h[c++], y = i.getAttribute(m).split(ft), k = /([.?@])?(.*)/.exec(E);
              A.push({ type: 1, index: s, name: k[2], strings: y, ctor: k[1] === "." ? o7 : k[1] === "?" ? t7 : k[1] === "@" ? a7 : ss }), i.removeAttribute(m);
            } else
              m.startsWith(ft) && (A.push({ type: 6, index: s }), i.removeAttribute(m));
        if (Yg.test(i.tagName)) {
          const m = i.textContent.split(ft), E = m.length - 1;
          if (E > 0) {
            i.textContent = Hi ? Hi.emptyScript : "";
            for (let y = 0; y < E; y++)
              i.append(m[y], gr()), Mt.nextNode(), A.push({ type: 2, index: ++s });
            i.append(m[E], gr());
          }
        }
      } else if (i.nodeType === 8)
        if (i.data === qg)
          A.push({ type: 2, index: s });
        else {
          let m = -1;
          for (; (m = i.data.indexOf(ft, m + 1)) !== -1; )
            A.push({ type: 7, index: s }), m += ft.length - 1;
        }
      s++;
    }
  }
  static createElement(e, o) {
    const a = Wt.createElement("template");
    return a.innerHTML = e, a;
  }
};
function Oa(n, e, o = n, a) {
  var i, s, c;
  if (e === Ta)
    return e;
  let u = a !== void 0 ? (i = o._$Co) == null ? void 0 : i[a] : o._$Cl;
  const A = mr(e) ? void 0 : e._$litDirective$;
  return (u == null ? void 0 : u.constructor) !== A && ((s = u == null ? void 0 : u._$AO) == null || s.call(u, !1), A === void 0 ? u = void 0 : (u = new A(n), u._$AT(n, o, a)), a !== void 0 ? ((c = o._$Co) != null ? c : o._$Co = [])[a] = u : o._$Cl = u), u !== void 0 && (e = Oa(n, u._$AS(n, e.values), u, a)), e;
}
class n7 {
  constructor(e, o) {
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = o;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    var o;
    const { el: { content: a }, parts: i } = this._$AD, s = ((o = e == null ? void 0 : e.creationScope) != null ? o : Wt).importNode(a, !0);
    Mt.currentNode = s;
    let c = Mt.nextNode(), u = 0, A = 0, b = i[0];
    for (; b !== void 0; ) {
      if (u === b.index) {
        let h;
        b.type === 2 ? h = new Zu(c, c.nextSibling, this, e) : b.type === 1 ? h = new b.ctor(c, b.name, b.strings, this, e) : b.type === 6 && (h = new r7(c, this, e)), this._$AV.push(h), b = i[++A];
      }
      u !== (b == null ? void 0 : b.index) && (c = Mt.nextNode(), u++);
    }
    return Mt.currentNode = Wt, s;
  }
  p(e) {
    let o = 0;
    for (const a of this._$AV)
      a !== void 0 && (a.strings !== void 0 ? (a._$AI(e, a, o), o += a.strings.length - 2) : a._$AI(e[o])), o++;
  }
}
let Zu = class Zg {
  get _$AU() {
    var e, o;
    return (o = (e = this._$AM) == null ? void 0 : e._$AU) != null ? o : this._$Cv;
  }
  constructor(e, o, a, i) {
    var s;
    this.type = 2, this._$AH = wn, this._$AN = void 0, this._$AA = e, this._$AB = o, this._$AM = a, this.options = i, this._$Cv = (s = i == null ? void 0 : i.isConnected) != null ? s : !0;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const o = this._$AM;
    return o !== void 0 && (e == null ? void 0 : e.nodeType) === 11 && (e = o.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, o = this) {
    e = Oa(this, e, o), mr(e) ? e === wn || e == null || e === "" ? (this._$AH !== wn && this._$AR(), this._$AH = wn) : e !== this._$AH && e !== Ta && this._(e) : e._$litType$ !== void 0 ? this.$(e) : e.nodeType !== void 0 ? this.T(e) : JS(e) ? this.k(e) : this._(e);
  }
  S(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  T(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.S(e));
  }
  _(e) {
    this._$AH !== wn && mr(this._$AH) ? this._$AA.nextSibling.data = e : this.T(Wt.createTextNode(e)), this._$AH = e;
  }
  $(e) {
    var o;
    const { values: a, _$litType$: i } = e, s = typeof i == "number" ? this._$AC(e) : (i.el === void 0 && (i.el = Xl.createElement(zg(i.h, i.h[0]), this.options)), i);
    if (((o = this._$AH) == null ? void 0 : o._$AD) === s)
      this._$AH.p(a);
    else {
      const c = new n7(s, this), u = c.u(this.options);
      c.p(a), this.T(u), this._$AH = c;
    }
  }
  _$AC(e) {
    let o = pp.get(e.strings);
    return o === void 0 && pp.set(e.strings, o = new Xl(e)), o;
  }
  k(e) {
    Wg(this._$AH) || (this._$AH = [], this._$AR());
    const o = this._$AH;
    let a, i = 0;
    for (const s of e)
      i === o.length ? o.push(a = new Zg(this.S(gr()), this.S(gr()), this, this.options)) : a = o[i], a._$AI(s), i++;
    i < o.length && (this._$AR(a && a._$AB.nextSibling, i), o.length = i);
  }
  _$AR(e = this._$AA.nextSibling, o) {
    var a;
    for ((a = this._$AP) == null ? void 0 : a.call(this, !1, !0, o); e && e !== this._$AB; ) {
      const i = e.nextSibling;
      e.remove(), e = i;
    }
  }
  setConnected(e) {
    var o;
    this._$AM === void 0 && (this._$Cv = e, (o = this._$AP) == null || o.call(this, e));
  }
}, ss = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(e, o, a, i, s) {
    this.type = 1, this._$AH = wn, this._$AN = void 0, this.element = e, this.name = o, this._$AM = i, this.options = s, a.length > 2 || a[0] !== "" || a[1] !== "" ? (this._$AH = Array(a.length - 1).fill(new String()), this.strings = a) : this._$AH = wn;
  }
  _$AI(e, o = this, a, i) {
    const s = this.strings;
    let c = !1;
    if (s === void 0)
      e = Oa(this, e, o, 0), c = !mr(e) || e !== this._$AH && e !== Ta, c && (this._$AH = e);
    else {
      const u = e;
      let A, b;
      for (e = s[0], A = 0; A < s.length - 1; A++)
        b = Oa(this, u[a + A], o, A), b === Ta && (b = this._$AH[A]), c || (c = !mr(b) || b !== this._$AH[A]), b === wn ? e = wn : e !== wn && (e += (b ?? "") + s[A + 1]), this._$AH[A] = b;
    }
    c && !i && this.j(e);
  }
  j(e) {
    e === wn ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
  }
};
class o7 extends ss {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e) {
    this.element[this.name] = e === wn ? void 0 : e;
  }
}
class t7 extends ss {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e) {
    this.element.toggleAttribute(this.name, !!e && e !== wn);
  }
}
class a7 extends ss {
  constructor(e, o, a, i, s) {
    super(e, o, a, i, s), this.type = 5;
  }
  _$AI(e, o = this) {
    var a;
    if ((e = (a = Oa(this, e, o, 0)) != null ? a : wn) === Ta)
      return;
    const i = this._$AH, s = e === wn && i !== wn || e.capture !== i.capture || e.once !== i.once || e.passive !== i.passive, c = e !== wn && (i === wn || s);
    s && this.element.removeEventListener(this.name, this, i), c && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    var o, a;
    typeof this._$AH == "function" ? this._$AH.call((a = (o = this.options) == null ? void 0 : o.host) != null ? a : this.element, e) : this._$AH.handleEvent(e);
  }
}
class r7 {
  constructor(e, o, a) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = o, this.options = a;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    Oa(this, e);
  }
}
const hp = Qi.litHtmlPolyfillSupport;
var gp;
hp == null || hp(Xl, Zu), ((gp = Qi.litHtmlVersions) != null ? gp : Qi.litHtmlVersions = []).push("3.1.3");
const i7 = (n, e, o) => {
  var a, i;
  const s = (a = o == null ? void 0 : o.renderBefore) != null ? a : e;
  let c = s._$litPart$;
  if (c === void 0) {
    const u = (i = o == null ? void 0 : o.renderBefore) != null ? i : null;
    s._$litPart$ = c = new Zu(e.insertBefore(gr(), u), u, void 0, o ?? {});
  }
  return c._$AI(n), c;
};
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const s7 = Symbol.for(""), c7 = (n) => ({ _$litStatic$: n, r: s7 });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Ca = class extends ga {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e;
    const o = super.createRenderRoot();
    return (e = this.renderOptions).renderBefore != null || (e.renderBefore = o.firstChild), o;
  }
  update(e) {
    const o = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = i7(o, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return Ta;
  }
};
var mp;
Ca._$litElement$ = !0, Ca.finalized = !0, (mp = globalThis.litElementHydrateSupport) == null || mp.call(globalThis, { LitElement: Ca });
const vp = globalThis.litElementPolyfillSupport;
vp == null || vp({ LitElement: Ca });
var yp;
((yp = globalThis.litElementVersions) != null ? yp : globalThis.litElementVersions = []).push("4.0.5");
function Sr(n, ...e) {
  return e.reduce((o, a) => a(o), n);
}
var Bi = /* @__PURE__ */ ((n) => (n.NO_SYNC = "no-sync", n))(Bi || {}), wa = /* @__PURE__ */ ((n) => (n.VISIBLE = "visible", n.IDLE = "idle", n.INTERACTION = "interaction", n.MEDIA = "media", n.DEFINED = "defined", n))(wa || {}), Yo = /* @__PURE__ */ ((n) => (n.BLUR = "beacon-event-blur", n.CHANGE = "beacon-event-change", n.CLICK = "beacon-event-click", n.FOCUS = "beacon-event-focus", n.HIDE = "beacon-event-hide", n.INPUT = "beacon-event-input", n.KEYDOWN = "beacon-event-keydown", n.MOUSEDOWN = "beacon-event-mousedown", n.MOUSEENTER = "beacon-event-mouseenter", n.MOUSELEAVE = "beacon-event-mouseleave", n.RENDER = "beacon-event-render", n.SORT = "beacon-event-sort", n.DEFERRED_CHILD = "beacon-event-deferred-child", n.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", n.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", n.LANGUAGE_SELECT = "beacon-event-language-select", n.PLAY = "beacon-event-play", n.CLOSE = "beacon-event-close", n.OPEN = "beacon-event-open", n.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", n.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", n.ELEMENT_READY = "beacon-event-element-ready", n.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", n.DRILLDOWN = "beacon-event-drilldown", n.DRILLUP = "beacon-event-drillup", n.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", n.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", n.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", n.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", n.HAS_CURRENT_LINK = "beacon-event-has-current-link", n.REGISTER = "beacon-event-register", n.SKIP_LINK_CLICK = "beacon-event-skip-link-click", n.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", n.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", n.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", n.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", n))(Yo || {});
const l7 = kn`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(a){--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}[beacon-tag-name]:not([focus-override]) a:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, u7 = kn`:host(:not([focus-override])) *:not(a):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:host(:not([focus-override])) a:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override])) a:focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, A7 = kn`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, d7 = kn`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, f7 = kn`.has-cell-padding{padding-block:var(--beacon-cell-space-padding);padding-inline:var(--beacon-cell-space-padding)}.has-component-padding{padding-block:var(--beacon-component-space-padding);padding-inline:var(--beacon-component-space-padding)}@media (min-width: 1600px){:host{--beacon-space-default: calc(10 * var(--beacon-unit-base)) !important;--beacon-grid-layout-space-margin: 10rem !important;--beacon-grid-gutter-size-inline: 2rem !important}}:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));font-family:var(--beacon-system-font-family, var(--beacon-font-family-default));-webkit-font-smoothing:antialiased;letter-spacing:var(--beacon-system-font-letter-spacing, var(--beacon-font-letter-spacing-default))}[lang=zh]{font-family:var(--beacon-system-font-family, var(--beacon-font-family-cjk));letter-spacing:var(--beacon-system-font-letter-spacing, var(--beacon-font-letter-spacing-cjk))}a,::slotted(a){color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}a:not(:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`, Kt = class {
};
Kt.setPropertyOnEvent = (n, e, o, a) => {
  try {
    Object.defineProperty(n, o, {
      value: a || e[`${o}`],
      writable: !1
    });
  } catch {
  }
}, Kt.getAnalyticsEvents = () => {
  const n = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(n.join("|")).test(e));
}, Kt.setHostEventHandlerForAnalytics = (n, e) => {
  var o;
  const a = Kt.getAnalyticsEvents(), i = "beaconVersion";
  for (const s of a) {
    const c = s.slice(2);
    (o = n.shadowRoot) == null || o.addEventListener(
      c,
      (u) => {
        var A;
        const b = new u.constructor(c, u);
        Kt.setPropertyOnEvent(b, null, i, e);
        for (const h in u)
          Kt.setPropertyOnEvent(b, u, h);
        (A = n.shadowRoot) != null && A.contains(u.target) && n.dispatchEvent(b);
      },
      !0
    );
  }
};
let b7 = Kt;
function lr(n, e, o, a) {
  const i = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...o
  });
  return n.dispatchEvent(i), a && a(), i;
}
const xp = (n) => !!n.deferrable, p7 = (n) => {
  var e, o;
  return (!!((e = n.deferList) != null && e.includes(wa.VISIBLE)) || !!((o = n.getAttribute("defer-until")) != null && o.includes(wa.VISIBLE))) && n.isDeferUntilParent;
}, Cp = (n) => !!navigator.vendor && navigator.vendor.indexOf(n) > -1;
function h7(n) {
  return `${n}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, o, a) => `${o.toUpperCase() + a}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const g7 = "3.2.0", m7 = {
  rootMargin: "1500px",
  threshold: 0.1
}, Wo = {
  version: g7,
  hidden: "hidden",
  safari: "Apple",
  divTagName: "div",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: m7
}, wl = (n) => {
  for (const e of n)
    if (e !== void 0)
      return e;
};
var v7 = Object.defineProperty, y7 = Object.getOwnPropertyDescriptor, Do = (n, e, o, a) => {
  for (var i = a > 1 ? void 0 : a ? y7(e, o) : e, s = n.length - 1, c; s >= 0; s--)
    (c = n[s]) && (i = (a ? c(e, o, i) : c(i)) || i);
  return a && i && v7(e, o, i), i;
};
const ut = class extends Ca {
  constructor() {
    super(...arguments), this.isDeferUntilParent = !1, this.deferrable = !0, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = Wo.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      var o;
      const a = (o = e.target.name) != null ? o : "";
      this.slotDeprecationWarn(a);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: Wo.defaultDeferOptions.rootMargin,
      threshold: Wo.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const o = new IntersectionObserver((a) => {
          const [i] = a;
          i.isIntersecting && (o.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        o.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((o) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => o(), { once: !0 }) : o();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((o) => {
          requestIdleCallback(() => {
            o();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((o) => {
      var a;
      e instanceof CustomEvent && (a = e.detail) != null && a.type ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => o())) : o();
    }), this.renderLightDOMStyles = (e = `${this.beaconTagName}-light-DOM-styles`) => {
      const o = [], a = new Set(this.constructor.lightDOMStyles.flat(1 / 0));
      for (const i of a)
        o.push(i);
      o.reverse().forEach((i, s) => {
        var c;
        const u = document.createElement("style");
        u.setAttribute("slot", "lightDOM");
        let A = !1;
        if (u.textContent = i.toString(), e) {
          const b = Math.abs(s - o.length), h = `${e}-${b}`, m = this.getClosestHost();
          u.id = h, (m && (c = m == null ? void 0 : m.shadowRoot) != null && c.querySelector(`#${h}`) || !m && document.querySelector(`#${h}`)) && (A = !0);
        }
        A || this.prepend(u);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var o;
      (o = this.componentModeStyles) == null || o.forEach((a, i) => {
        const s = document.createElement("style");
        s.textContent = a.toString();
        const c = `${e}-${i}`;
        s.id = c, !document.querySelector(`#${c}`) && document.head.append(s);
      });
    }, this.getScopedTag = (e) => {
      if (!e)
        return null;
      const o = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return c7(o);
    };
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((o, a) => {
      this.elementProperties.has(o) && e.push(a);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, o, a) {
    const { alternateAttributesMap: i, hasDeprecatedProperties: s, elementProperties: c } = this.constructor;
    if (s && i.size > 0) {
      const u = i.get(e), A = c.get(u), b = this.getPropertyOptions(e).alternateSlot;
      if (u)
        if (u !== Bi.NO_SYNC && (a === null ? this.removeAttribute((A == null ? void 0 : A.attribute) || u) : this.setAttribute((A == null ? void 0 : A.attribute) || u, a || "")), b) {
          const h = this.createPropertyDeprecationForSlotMessage(e, b);
          console.warn(h);
        } else
          console.warn(this.createPropertyDeprecationMessage(e, u, A == null ? void 0 : A.attribute));
    }
    super.attributeChangedCallback(e, o, a);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param property property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, o, a) {
    let i = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return o !== Bi.NO_SYNC && (i += ` Start using [${a || o}] instead to avoid future disruptions.`), i;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, o) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${o}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, o) {
    if (o) {
      const { alternateAttributes: a, attribute: i } = o, s = Object.prototype.hasOwnProperty.call(o, "sync");
      if (Wo.deprecatedPropertyKeys.forEach((c) => {
        Object.prototype.hasOwnProperty.call(o, c) && (this.hasDeprecatedProperties = !0);
      }), a && a.forEach((c) => {
        this.alternateAttributesMap.set(c, e);
      }), s && !o.sync) {
        const c = i ?? e;
        this.alternateAttributesMap.set(c, Bi.NO_SYNC);
      }
    }
    super.createProperty(e, o);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var o;
    const { elementProperties: a } = this.constructor;
    return (o = a.get(e)) != null ? o : [...a.values()].find((i) => i.attribute === e);
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, o;
    return (o = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((a) => a).filter((a) => !!a)) != null ? o : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const o = this.alternateSlots.get(e);
    if (o !== void 0) {
      let a;
      const i = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(o).some((s) => s.match("alternate")) ? o.alternateAttribute ? a = `will be replaced by the element property '${o.alternateAttribute}'` : a = `will be replaced by the '${o.alternateSlots}' slot` : a = "will be removed", console.warn(`Beacon Deprecation Warning: ${i} ${a} in foundation@${o.version}`);
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e)
      return;
    const o = { ...this.resolvedDeferOptions };
    this.resolvedDeferOptions = {
      root: wl([e == null ? void 0 : e.root, o == null ? void 0 : o.root, document]),
      rootMargin: wl([
        e == null ? void 0 : e.rootMargin,
        o == null ? void 0 : o.rootMargin,
        Wo.defaultDeferOptions.rootMargin
      ]),
      threshold: wl([
        e == null ? void 0 : e.threshold,
        o == null ? void 0 : o.threshold,
        Wo.defaultDeferOptions.threshold
      ])
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    Cp(Wo.safari) || (this.style.visibility = Wo.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    Cp(Wo.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', o = this.closest(e);
    if (o && xp(o))
      return o;
    const a = this.getClosestHost();
    if (a) {
      const i = a.closest(e);
      if (i && xp(i))
        return i;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((o) => {
      e.includes(wa.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), o();
      })) : e.includes(wa.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), o();
      })) : o();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((o) => {
      if (e === null)
        o();
      else if (p7(e))
        this.selectDeferUntilHandler(e.deferList).then(() => o());
      else {
        const a = (i) => {
          this.deferredChildEventHandler(i).then(() => {
            e.removeEventListener(Yo.DEFERRED_CHILD, a), o();
          });
        };
        e.addEventListener(Yo.DEFERRED_CHILD, a);
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable)
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const o = this.getClosestDeferredParent();
        o ? this.handleParentalDeferUntil(o).then(() => e()) : e();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(wa.VISIBLE)) {
      const e = new IntersectionObserver((o) => {
        for (const a of o)
          a.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const o = `${e ? `${e}-` : ""}${this.tagName}`;
      if (!customElements.get(o)) {
        const a = class extends this {
        };
        Object.defineProperty(a, "name", { value: h7(o) }), customElements.define(o, a), customElements.whenDefined(o).then(() => {
          const i = new CustomEvent(Yo.REGISTER, { detail: o });
          document.dispatchEvent(i);
        }).catch((i) => {
          console.error(`Error defining Beacon Component ${o} in CustomElementsRegistry: `, i);
        });
      }
    }
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick(e) {
    lr(this, Yo.CLICK, !!this.onBeaconClick && this.onBeaconClick(e));
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown(e, o) {
    lr(this, Yo.KEYDOWN, !!this.onBeaconKeydown && this.onBeaconKeydown(o));
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild(e) {
    lr(this, Yo.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown(e);
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var o;
    try {
      if (!((o = this.constructor.mixins) != null && o.includes(e)))
        throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (a) {
      return console.error(a), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, o) {
    try {
      if (!(e in this))
        throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === o;
    } catch (a) {
      return console.error(a), !1;
    }
  }
  get prerenderHooks() {
    return [];
  }
  get postrenderHooks() {
    return [];
  }
  get destroyHooks() {
    return [];
  }
  prerender() {
  }
  postrender() {
  }
  destroy() {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), o = e == null ? void 0 : e.getAttribute("motion-state");
    o && (o === "enabled" || o === "disabled") && (this.motionState = o);
  }
  connectedCallback() {
    this.handleDefer().then(() => {
      super.connectedCallback(), b7.setHostEventHandlerForAnalytics(this, this.version), this.setMotionState(), this.renderLightDOMStyles(), this.prerenderHooks.length ? this.prerenderHooks.forEach((e) => {
        e.bind(this)();
      }) : this.prerender();
    });
  }
  firstUpdated() {
    this.postrenderHooks.length ? this.postrenderHooks.forEach((e) => {
      e.bind(this)();
    }) : this.postrender(), lr(this, Yo.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroyHooks.length ? this.destroyHooks.forEach((e) => {
      e.bind(this)();
    }) : this.destroy();
  }
};
ut.styles = [d7, f7, u7], ut.tagName = "", ut.shadowRootOptions = { ...Ca.shadowRootOptions, delegatesFocus: !0 }, ut.alternateAttributesMap = /* @__PURE__ */ new Map(), ut.hasDeprecatedProperties = !1, ut.mixins = [], ut.lightDOMStyles = [A7, l7];
let Gn = ut;
Do([
  zn({ attribute: "focus-override", type: Boolean, reflect: !0 })
], Gn.prototype, "focusOverride", 2);
Do([
  zn({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], Gn.prototype, "resetSpacing", 2);
Do([
  zn({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], Gn.prototype, "beaconTagName", 2);
Do([
  zn({ attribute: "beacon-version", reflect: !0 })
], Gn.prototype, "version", 2);
Do([
  zn({ attribute: "defer-until" })
], Gn.prototype, "deferUntil", 2);
Do([
  zn({ attribute: "defer-options" })
], Gn.prototype, "deferOptions", 2);
Do([
  zn({ type: Function })
], Gn.prototype, "onBeaconClick", 2);
Do([
  zn({ type: Function })
], Gn.prototype, "onBeaconKeydown", 2);
Do([
  zn({ attribute: "motion-state", reflect: !0 })
], Gn.prototype, "motionState", 2);
Do([
  La()
], Gn.prototype, "prefersReducedMotion", 2);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const eu = (n, e, o) => (o.configurable = !0, o.enumerable = !0, Reflect.decorate && typeof e != "object" && Object.defineProperty(n, e, o), o);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function x7(n, e) {
  return (o, a, i) => {
    const s = (c) => {
      var u, A;
      return (A = (u = c.renderRoot) == null ? void 0 : u.querySelector(n)) != null ? A : null;
    };
    if (e) {
      const { get: c, set: u } = typeof a == "object" ? o : i ?? (() => {
        const A = Symbol();
        return { get() {
          return this[A];
        }, set(b) {
          this[A] = b;
        } };
      })();
      return eu(o, a, { get() {
        let A = c.call(this);
        return A === void 0 && (A = s(this), (A !== null || this.hasUpdated) && u.call(this, A)), A;
      } });
    }
    return eu(o, a, { get() {
      return s(this);
    } });
  };
}
const C7 = ({
  finisher: n,
  descriptor: e
}) => (
  // eslint-disable-next-line consistent-return
  (o, a) => {
    var i;
    if (a !== void 0) {
      const s = o.constructor;
      e !== void 0 && Object.defineProperty(o, a, e(a)), n == null || n(s, a);
    } else {
      const s = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (i = o.originalKey) != null ? i : o.key
      ), c = e !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: s,
        descriptor: e(o.key)
      } : { ...o, key: s };
      return n && (c.finisher = function(u) {
        n(u, s);
      }), c;
    }
  }
);
function wp(n, e, o = {}, a = !1) {
  var i;
  const s = `slot${e ? `[name=${e}]` : ":not([name])"}`, c = (i = n.renderRoot) == null ? void 0 : i.querySelector(s);
  return c ? a ? c.assignedNodes(o).filter((u) => u.nodeType !== Node.COMMENT_NODE) : c.assignedElements(o) : [];
}
function w7(n) {
  return typeof n == "string" ? { version: n } : n.alternateSlot !== void 0 && n.alternateSlot !== null ? { alternateSlot: n.alternateSlot, version: n.version } : { alternateAttribute: n.alternateAttribute, version: n.version };
}
function cs(n, e = !1) {
  const { slot: o, selector: a, deprecated: i, flatten: s } = n ?? {};
  let c;
  return i && (c = w7(i)), C7({
    descriptor: (u) => ({
      get() {
        let A = wp(this, o, { flatten: s });
        return A.length === 0 && i && c && c.alternateSlot && (A = wp(this, c.alternateSlot, { flatten: s })), a ? A == null ? void 0 : A.filter((b) => {
          var h;
          return e ? ((h = b == null ? void 0 : b.nodeName) == null ? void 0 : h.toLowerCase()) === this.getScopedTagName(a) : b.matches(a);
        }) : A;
      },
      set(A) {
        if (i) {
          const b = o ?? "";
          this.alternateSlots.set(b, c);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const E7 = (n) => (...e) => ({ _$litDirective$: n, values: e });
class k7 {
  constructor(e) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(e, o, a) {
    this._$Ct = e, this._$AM = o, this._$Ci = a;
  }
  _$AS(e, o) {
    return this.update(e, o);
  }
  update(e, o) {
    return this.render(...o);
  }
}
const nu = class Pt extends k7 {
  constructor() {
    super(...arguments), this.slotHasEvent = !1, this.usingParentElement = !1, this.totalSlottedElements = 0, this.handleSlotchange = (e) => {
      if (e.eventPhase !== 2)
        return;
      const o = e.target, a = o == null ? void 0 : o.assignedElements();
      this.totalSlottedElements = a.length;
      const i = this.usingParentElement ? o.parentElement : o;
      this.totalSlottedElements < 1 ? i == null || i.classList.add(Pt.defaultClassName) : i == null || i.classList.remove(Pt.defaultClassName);
    };
  }
  /** Create and append a small set of styles when the directive is used. */
  createStyleElement(e) {
    const o = document.createElement("style");
    o.innerHTML = `.${Pt.defaultClassName} {display: none !important;}`, o.id = Pt.stylesID, e.appendChild(o);
  }
  update(e, [o = { useParent: !1 }]) {
    const { useParent: a } = o, i = e.element, s = i.getRootNode(), { parentElement: c } = i;
    a && (this.usingParentElement = !0);
    const u = {};
    return a && c ? u.element = c : u.element = i, s.querySelector(`#${Pt.stylesID}`) || this.createStyleElement(s), this.slotHasEvent || (i.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(u);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ useParent: e, element: o } = { useParent: !1 }) {
    o && this.totalSlottedElements < 1 && o.classList.add(Pt.defaultClassName);
  }
};
nu.defaultClassName = "hide-slot-area", nu.stylesID = "show-if-used-directive-styles";
let S7 = nu;
const Ep = E7(S7), R7 = kn`.beacon-theme-modern-outlook[beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: 0;--footer-links-padding-block: 0;--footer-links-gap: var(--beacon-system-space-micro-jumbo);--footer-mission-padding-block-end: var(--beacon-reference-space-5);--footer-mission-padding-block-start: 0;--footer-mission-zone-grid-gap: var(--beacon-system-space-micro-jumbo);--footer-socials-padding-block-start: var(--beacon-reference-space-5)}@media (min-width: 960px){.beacon-theme-modern-outlook[beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-footer]{--footer-disclaimer-content-padding-inline-end: var(--beacon-reference-space-7);--footer-mission-padding-block-end: var(--beacon-reference-space-9);--footer-mission-zone-grid-gap: var(--beacon-reference-space-9);--footer-socials-padding-block-start: var(--beacon-reference-space-9)}}@media (min-width: 1920px){.beacon-theme-modern-outlook[beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-footer],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-footer]{--footer-links-gap: var(--beacon-reference-space-9)}}`, ou = {
  beaconTagName: "beacon-footer",
  metricsLocationFooter: "FTR",
  get lightDOMStyleID() {
    return `${this.beaconTagName}-styles`;
  }
}, B7 = kn`[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) p{margin-block:var(--beacon-system-font-paragraph-spacing-loose, 1em)}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :first-child{margin-block-start:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) :last-child{margin-block-end:0}[beacon-tag-name=beacon-footer] :is([slot=disclaimer],[slot=copyright]) a{color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}[beacon-tag-name=beacon-footer] sup{font-size:var(--beacon-reference-space-3);line-height:var(--beacon-reference-space-7);vertical-align:baseline}@media (min-width: 640px){[beacon-tag-name=beacon-footer] sup{vertical-align:top}}`, _7 = kn`.b-grid{--b-default-auto-layout: calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi, var(--beacon-space-default)), var(--beacon-system-breakpoint-xx-large, var(--beacon-breakpoint-xx-large))) - (var(--beacon-system-grid-columns, var(--beacon-grid-column-total)) - 1) * var(--beacon-system-space-gutter, var(--beacon-grid-gutter-size-inline))) / var(--beacon-system-grid-columns, var(--beacon-grid-column-total)));--b-default-grid-gap: var(--b-grid-gap, var(--beacon-system-space-gutter, var(--beacon-grid-gutter-size-inline)));--b-default-column-count: var(--b-grid-columns, var(--beacon-system-grid-columns, var(--beacon-grid-column-total)));display:grid;gap:var(--b-default-grid-gap);grid-template-columns:var(--b-grid-template-col, repeat(var(--b-default-column-count), minmax(0, 1fr)));grid-template-rows:var(--b-grid-template-row, repeat(var(--b-grid-rows, 1), 1fr));inline-size:100%;margin-inline:auto;max-inline-size:var(--beacon-system-breakpoint-xx-large, var(--beacon-breakpoint-xx-large))}.b-grid.b-full-bleed{max-inline-size:none}.b-grid.b-auto-fill{--b-grid-template-col: repeat(auto-fill, minmax(min(var(--b-grid-auto-fill, var(--b-default-auto-layout)), 100%), 1fr))}.b-grid.b-auto-fit{--b-grid-template-col: repeat(auto-fit, minmax(min(var(--b-grid-auto-fit, var(--b-default-auto-layout)), 100%), 1fr))}@media (min-width: 1600px){.b-grid{--beacon-space-default: calc(10 * var(--beacon-unit-base))}}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item]{grid-column:var(--b-grid-start, auto)/span var(--b-grid-offset-column, var(--b-grid-span, 1))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--full-col{--b-grid-span: var(--b-default-column-count)}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item--offset]{--b-grid-offset-column: calc(var(--b-grid-offset) + var(--b-grid-offset-span));margin-inline-start:calc((100% + var(--b-default-grid-gap)) / (var(--b-grid-offset-span) + var(--b-grid-offset)) * var(--b-grid-offset))}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--1-col{--b-grid-offset-span: 1;--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-1:not([class*=b-grid-item--offset]){--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--2-col{--b-grid-offset-span: 2;--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-2:not([class*=b-grid-item--offset]){--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--3-col{--b-grid-offset-span: 3;--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-3:not([class*=b-grid-item--offset]){--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--4-col{--b-grid-offset-span: 4;--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-4:not([class*=b-grid-item--offset]){--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--5-col{--b-grid-offset-span: 5;--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-5:not([class*=b-grid-item--offset]){--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--6-col{--b-grid-offset-span: 6;--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-6:not([class*=b-grid-item--offset]){--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--7-col{--b-grid-offset-span: 7;--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-7:not([class*=b-grid-item--offset]){--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--8-col{--b-grid-offset-span: 8;--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-8:not([class*=b-grid-item--offset]){--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--9-col{--b-grid-offset-span: 9;--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-9:not([class*=b-grid-item--offset]){--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--10-col{--b-grid-offset-span: 10;--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-10:not([class*=b-grid-item--offset]){--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--11-col{--b-grid-offset-span: 11;--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-11:not([class*=b-grid-item--offset]){--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--12-col{--b-grid-offset-span: 12;--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--start-12:not([class*=b-grid-item--offset]){--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>.b-grid-item--offset-12{--b-grid-offset: 12}@media (min-width: 320px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-sm\\:offset-12{--b-grid-offset: 12}}@media (min-width: 640px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-md\\:offset-12{--b-grid-offset: 12}}@media (min-width: 960px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-lg\\:offset-12{--b-grid-offset: 12}}@media (min-width: 1280px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xl\\:offset-12{--b-grid-offset: 12}}@media (min-width: 1600px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxl\\:offset-12{--b-grid-offset: 12}}@media (min-width: 1920px){:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:1-col{--b-grid-span: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-1{--b-grid-start: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-1{--b-grid-offset: 1}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:2-col{--b-grid-span: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-2{--b-grid-start: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-2{--b-grid-offset: 2}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:3-col{--b-grid-span: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-3{--b-grid-start: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-3{--b-grid-offset: 3}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:4-col{--b-grid-span: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-4{--b-grid-start: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-4{--b-grid-offset: 4}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:5-col{--b-grid-span: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-5{--b-grid-start: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-5{--b-grid-offset: 5}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:6-col{--b-grid-span: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-6{--b-grid-start: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-6{--b-grid-offset: 6}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:7-col{--b-grid-span: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-7{--b-grid-start: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-7{--b-grid-offset: 7}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:8-col{--b-grid-span: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-8{--b-grid-start: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-8{--b-grid-offset: 8}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:9-col{--b-grid-span: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-9{--b-grid-start: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-9{--b-grid-offset: 9}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:10-col{--b-grid-span: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-10{--b-grid-start: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-10{--b-grid-offset: 10}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:11-col{--b-grid-span: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-11{--b-grid-start: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-11{--b-grid-offset: 11}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:12-col{--b-grid-span: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:start-12{--b-grid-start: 12}:not(.b-auto-fill,.b-auto-fit)>[class*=b-grid-item].b-xxxl\\:offset-12{--b-grid-offset: 12}}@media (min-width: 1600px){:root{--beacon-grid-layout-space-margin: 10rem;--beacon-grid-gutter-size-inline: 2rem}}*,::slotted(*){margin:0}.zone{--fallback-grid-gap: var(--beacon-system-space-gutter, var(--beacon-grid-gutter-size-inline));background-color:var(--zone-bg-color);padding-block:var(--beacon-system-space-organism-jumbo, var(--beacon-space-default));padding-inline:var(--beacon-system-space-organism-maxi, var(--beacon-space-default))}.zone--mission-and-links{--b-grid-gap: var(--footer-mission-zone-grid-gap, var(--fallback-grid-gap));--zone-bg-color: var(--beacon-system-color-background-0, var(--beacon-footer-mission-and-links-zone-color-background))}.zone--disclaimer{--zone-bg-color: var(--beacon-system-color-background-1, var(--beacon-footer-disclaimer-zone-color-background));font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-loose-100, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-long-form-200) var(--beacon-font-family-default))}.brand-wrapper,.socials{--container-border: var(--beacon-system-width-border-mini, var(--beacon-border-widths-hairline)) solid var(--beacon-system-color-border-0, var(--beacon-footer-divider-color-border))}.brand-wrapper{border-block-end:var(--container-border)}.brand,.disclaimer,.copyright{padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-cell-space-padding))}.disclaimer,.copyright{padding-inline-end:var(--footer-disclaimer-content-padding-inline-end, var(--beacon-footer-disclaimer-zone-space-padding-inline-end))}.trademark{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));letter-spacing:var(--beacon-system-letter-spacing-trademark, .24em);text-transform:uppercase}.keyline{background-color:var(--beacon-system-color-border-brand, var(--beacon-color-divider));block-size:var(--beacon-system-width-border-normal, calc(.125 * var(--beacon-unit-base)));border:0;inline-size:var(--beacon-reference-space-7, var(--beacon-footer-keyline-size-inline-size));margin-block:var(--beacon-reference-space-5, calc(.75 * var(--beacon-unit-base)))}.mission{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-loose-300, var(--beacon-headline-font-size-300)/var(--beacon-headline-font-line-height-long-form-300) var(--beacon-font-family-default));color:var(--beacon-system-color-text-title, inherit);padding-block-end:var(--footer-mission-padding-block-end, var(--beacon-footer-mission-space-padding-block-end));padding-block-start:var(--footer-mission-padding-block-start, var(--beacon-unit-atomic))}.links{display:flex;flex-direction:var(--links-flex-direction, column);gap:var(--footer-links-gap, 0);padding-block:var(--footer-links-padding-block, var(--beacon-footer-links-space-padding-block))}.socials{border-block-start:var(--container-border);padding-block-start:var(--footer-socials-padding-block-start, var(--beacon-footer-socials-space-padding-block-start))}.hide{display:none}@media (min-width: 960px){.links{--links-flex-direction: row}}`;
var F7 = Object.defineProperty, I7 = Object.getOwnPropertyDescriptor, Rr = (n, e, o, a) => {
  for (var i = a > 1 ? void 0 : a ? I7(e, o) : e, s = n.length - 1, c; s >= 0; s--)
    (c = n[s]) && (i = (a ? c(e, o, i) : c(i)) || i);
  return a && i && F7(e, o, i), i;
};
const Jg = class extends Sr(Gn) {
  constructor() {
    super(...arguments), this.beaconTagName = ou.beaconTagName, this.showKeyline = !1, this.hideBrandWrapper = !0, this.dataMetricsLocation = ou.metricsLocationFooter;
  }
  static get styles() {
    return [super.styles, _7];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, B7, R7];
  }
  checkForSlot() {
    this.showKeyline = !!this.slottedMissionContent.length && !!this.slottedTrademark.length, this.hideBrandWrapper = !this.slottedMissionContent.length && !this.slottedTrademark.length;
  }
  render() {
    return io`<div class="zone zone--mission-and-links">
        <div class="b-grid">
          <div class="brand-wrapper b-grid b-grid-item--full-col ${this.hideBrandWrapper ? "hide" : ""}">
            <div class="brand b-grid-item--full-col b-md:10-col b-lg:8-col">
              <div class="trademark">
                <slot name="trademark" @slotchange=${this.checkForSlot}></slot>
              </div>
              <hr class=${this.showKeyline ? "keyline" : "hide"} aria-hidden="true" />
              <div class="mission">
                <slot name="mission" @slotchange=${this.checkForSlot}></slot>
              </div>
            </div>
          </div>
          <div class="links b-grid-item--full-col">
            <slot name="links" ${Ep({ useParent: !0 })}></slot>
          </div>
          <div class="socials b-grid-item--full-col">
            <slot name="socials" ${Ep({ useParent: !0 })}></slot>
          </div>
        </div>
      </div>
      <div class="zone zone--disclaimer">
        <div class="b-grid">
          <div class="disclaimer b-grid-item--full-col b-md:10-col b-lg:6-col">
            <slot name="disclaimer"></slot>
          </div>
          <div class="copyright b-grid-item--full-col b-md:10-col b-lg:5-col b-lg:start-8">
            <slot name="copyright"></slot>
          </div>
        </div>
      </div>`;
  }
};
Jg.tagName = ou.beaconTagName;
let Na = Jg;
Rr([
  cs({ flatten: !0, slot: "mission" })
], Na.prototype, "slottedMissionContent", 2);
Rr([
  cs({ flatten: !0, slot: "trademark" })
], Na.prototype, "slottedTrademark", 2);
Rr([
  La()
], Na.prototype, "showKeyline", 2);
Rr([
  La()
], Na.prototype, "hideBrandWrapper", 2);
Rr([
  zn({ attribute: "data-metrics-location", reflect: !0 })
], Na.prototype, "dataMetricsLocation", 2);
const T7 = kn`:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) :is(h1,h2,h3,h4,h5,h6,p){margin:0;padding:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ::part(button){text-align:inherit}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer])>:is(a,[beacon-tag-name=beacon-navigation-button]){display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}`, O7 = kn`:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));inline-size:100%}[beacon-tag-name=beacon-navigation-button]{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}::slotted([slot=title]){color:var(--beacon-system-color-text-title, var(--heritage-navigation-expanded-title-color, var(--beacon-color-text-default-on-light)));font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-300, var(--beacon-headline-font-size-200)/var(--beacon-headline-font-line-height-module-200) var(--beacon-font-family-default))}::slotted([slot=description]){font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));color:var(--beacon-system-color-text-standard, var(--heritage-navigation-expanded-text-color, var(--beacon-color-text-default-on-light)))}.title-area{padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}.title-area>*+*{margin-block-start:var(--navigation-expanded-title-area-gap, var(--beacon-unit-atomic))}.slot-container{display:grid;gap:var(--beacon-reference-space-2, var(--beacon-unit-subatomic))}@media (min-width: 960px){.level-2 .slot-container{columns:var(--expanded-nav-grid-template);display:block}.level-2,.level-3{padding-inline-end:var(--beacon-reference-space-7, 1.5rem)}}`;
var U7 = Object.defineProperty, K7 = Object.getOwnPropertyDescriptor, Gt = (n, e, o, a) => {
  for (var i = a > 1 ? void 0 : a ? K7(e, o) : e, s = n.length - 1, c; s >= 0; s--)
    (c = n[s]) && (i = (a ? c(e, o, i) : c(i)) || i);
  return a && i && U7(e, o, i), i;
};
const yt = class tu extends Sr(Gn) {
  constructor() {
    super(...arguments), this.level = 1, this.splitColumns = "true", this.hasNestedExpandedNavigations = !1, this.handleCurrentLink = () => {
      this.currentLink && lr(this, Yo.HAS_CURRENT_LINK, !!this.onBeaconCurrentLink && this.onBeaconCurrentLink());
    };
  }
  static get styles() {
    return [super.styles, O7];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, T7];
  }
  /** Anchor link representing the current page. */
  get currentLink() {
    return this.querySelector('a[aria-current="page"]');
  }
  get hasValidNestedItems() {
    return this.links.filter(
      (e) => (e instanceof tu || e instanceof HTMLAnchorElement) && !(e instanceof HTMLStyleElement)
    );
  }
  firstUpdated() {
    super.firstUpdated(), this.handleCurrentLink();
  }
  /** Set the level property. Runs on slotchange as it is dependent on nested menus. */
  setLevel() {
    this.level = 1 + (this.parentElement instanceof tu ? this.parentElement.level : 0);
  }
  /** Updates based on this component having nested expanded navigations. */
  setNestedState() {
    this.hasValidNestedItems.length > 0 ? this.hasNestedExpandedNavigations = !0 : this.hasNestedExpandedNavigations = !1;
  }
  /** Calculate a number of CSS columns based on how many links are to be shown. */
  calculateCSSColumns(e) {
    let o = "";
    return e < 6 ? o = "1" : e < 11 ? o = "2" : e < 22 ? o = "3" : o = "4", o;
  }
  /** Calculate the grid template based on how many sections are shown. */
  calculateGridColumnTemplate(e) {
    let o = "";
    return e === 1 ? o = "1fr" : e === 2 ? o = "1fr 1fr" : e === 3 ? o = "1fr 1fr 1fr" : e >= 4 && (o = "1fr 1fr 1fr 1fr"), o;
  }
  setColumnsCSSProperty(e) {
    this.style.setProperty("--expanded-nav-grid-template", e);
  }
  setNestedGridTemplates(e) {
    const o = this.calculateCSSColumns(e);
    this.setColumnsCSSProperty(o);
  }
  setLevel1GridTemplate(e) {
    const o = this.calculateGridColumnTemplate(e);
    this.setColumnsCSSProperty(o);
  }
  setLevel2GridTemplate(e) {
    this.setNestedGridTemplates(e);
  }
  setGridTemplates() {
    let e = this.links.length;
    this.splitColumns === "false" && (e = 1), this.level === 1 ? this.setLevel1GridTemplate(e) : this.level === 2 ? this.setLevel2GridTemplate(e) : this.level === 3 && this.setNestedGridTemplates(e);
  }
  handleTitleSlotchange() {
    var e;
    this.titleSlotVal = (e = this.titleNodes) != null && e.length && this.titleNodes[0] instanceof HTMLElement ? this.titleNodes[0].innerText : "";
  }
  handleDefaultSlotchange() {
    this.setNestedState(), this.setLevel(), this.setGridTemplates();
  }
  renderExpanded() {
    return io`
      <section class="header-zone">
        <div class="title-area">
          <div class="title-container">
            <slot name="title" part="title" @slotchange=${this.handleTitleSlotchange}></slot>
          </div>
        </div>
      </section>
      <section class="slot-container">
        <slot @slotchange=${this.handleDefaultSlotchange}></slot>
      </section>
    `;
  }
  render() {
    return io`<div class="level-${this.level}">${this.renderExpanded()}</div> `;
  }
};
Gt([
  zn({ reflect: !0 })
], yt.prototype, "level", 2);
Gt([
  zn({ attribute: "split-columns", reflect: !0 })
], yt.prototype, "splitColumns", 2);
Gt([
  zn({ type: Function })
], yt.prototype, "onBeaconCurrentLink", 2);
Gt([
  La()
], yt.prototype, "titleSlotVal", 2);
Gt([
  La()
], yt.prototype, "hasNestedExpandedNavigations", 2);
Gt([
  cs({ slot: "", flatten: !0 })
], yt.prototype, "links", 2);
Gt([
  cs({ slot: "title", flatten: !0 })
], yt.prototype, "titleNodes", 2);
let P7 = yt;
const Xg = {
  beaconTagName: "beacon-navigation-expanded",
  beaconFooterNavTagName: "beacon-navigation-footer",
  navItemTagName: "beacon-navigation-button",
  maxLevel: 4
}, D7 = kn`[beacon-tag-name=beacon-navigation-footer]{--heritage-navigation-expanded-title-color: var(--beacon-color-text-default)}[beacon-tag-name=beacon-navigation-footer] a{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}[beacon-tag-name=beacon-navigation-footer] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini, var(--beacon-border-widths-hairline)) solid var(--beacon-system-color-border-0, var(--beacon-footer-divider-color-border));padding-block-end:var(--beacon-system-space-micro-jumbo, var(--beacon-space-micro-jumbo))}@media (min-width: 960px){[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:0;padding-block-end:0}}[beacon-tag-name=beacon-navigation-footer] .level-2 [slot=title]{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}`, L7 = kn`.level-2 ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}`, em = class extends Sr(P7) {
  constructor() {
    super(...arguments), this.beaconTagName = Xg.beaconFooterNavTagName;
  }
  static get styles() {
    return [super.styles, L7];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, D7];
  }
  setLevel() {
    this.level = 2;
  }
  setLevel2GridTemplate() {
    this.style.setProperty("--expanded-nav-grid-template", "1");
  }
};
em.tagName = Xg.beaconFooterNavTagName;
let N7 = em;
const M7 = kn`.beacon-theme-modern-outlook[beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook [beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-2);--social-link-container-links-gap: var(--beacon-reference-space-2)}@media (min-width: 960px){.beacon-theme-modern-outlook[beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook [beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link-container],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link-container]{--social-link-container-flex-gap: var(--beacon-reference-space-6);--social-link-container-links-gap: var(--beacon-reference-space-7)}}`, nm = {
  beaconTagName: "beacon-social-link-container"
}, j7 = kn`:host,.links{display:flex;flex-direction:var(--container-flex-direction, column);gap:var(--container-flex-gap)}:host{--heritage-text-gap: 0;--container-flex-gap: var(--social-link-container-flex-gap, var(--heritage-text-gap))}.links{--heritage-links-gap: 0;--container-flex-gap: var(--social-link-container-links-gap, var(--heritage-links-gap))}::slotted(*){margin:0}.text{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));margin-block-end:var(--social-link-container-text-margin-block-end, 0);padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-cell-space-padding))}@media (min-width: 960px){:host,.links{--container-flex-direction: row;align-items:center}:host{--heritage-text-gap: calc(1.25 * var(--beacon-unit-base))}.links{--heritage-links-gap: calc(1.5 * var(--beacon-unit-base))}}`, om = class extends Sr(Gn) {
  constructor() {
    super(...arguments), this.beaconTagName = nm.beaconTagName;
  }
  static get styles() {
    return [super.styles, j7];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, M7];
  }
  render() {
    return io`<div class="text">
        <slot name="text"></slot>
      </div>
      <div class="links">
        <slot></slot>
      </div>`;
  }
};
om.tagName = nm.beaconTagName;
let $7 = om;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Q7(n) {
  return (e, o) => {
    const { slot: a, selector: i } = n ?? {}, s = "slot" + (a ? `[name=${a}]` : ":not([name])");
    return eu(e, o, { get() {
      var c, u;
      const A = (c = this.renderRoot) == null ? void 0 : c.querySelector(s), b = (u = A == null ? void 0 : A.assignedElements(n)) != null ? u : [];
      return i === void 0 ? b : b.filter((h) => h.matches(i));
    } });
  };
}
function H7(n, e, o) {
  n.postrender = function(...a) {
    Object.getPrototypeOf(n).postrender(), o.value.apply(this, a);
  };
}
const V7 = kn`.beacon-theme-modern-outlook[beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-3);--social-link-icon-container-size: var(--beacon-reference-space-5)}@media (min-width: 960px){.beacon-theme-modern-outlook[beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [beacon-version="3.2.0"] [beacon-tag-name=beacon-social-link]{--social-link-flex-gap: var(--beacon-reference-space-2);--social-link-icon-container-size: var(--beacon-reference-space-7)}}[beacon-tag-name=beacon-social-link]{--social-link-icon-instagram-pattern-url-heritage: url(#pattern0)}`, au = {
  beaconTagName: "beacon-social-link",
  iconMap: /* @__PURE__ */ new Map([
    [
      "facebook",
      io`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2188_14217)">
          <path
            d="M16 8C16 3.58172 12.4183 -9.53674e-07 8 -9.53674e-07C3.58172 -9.53674e-07 0 3.58172 0 8C0 11.993 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94434 3.125 9.77172 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5537C9.55992 5.25 9.25 5.86667 9.25 6.49933V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8Z"
            fill="var(--social-link-facebook-color-fill-outside, var(--beacon-social-link-facebook-icon-color-fill-outside))"
          />
          <path
            d="M11.1141 10.3125L11.4688 8H9.25V6.49933C9.25 5.86667 9.55992 5.25 10.5537 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77172 3.125C7.94434 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.1573 15.9667 7.57475 16 8 16C8.42525 16 8.8427 15.9667 9.25 15.9028V10.3125H11.1141Z"
            fill="var(--social-link-facebook-color-fill-inside, var(--beacon-social-link-facebook-icon-color-fill-inside))"
          />
        </g>
        <defs>
          <clipPath id="clip0_2188_14217">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "twitter",
      io`<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2188_14227)">
          <path
            d="M14.3193 3.72903C14.329 3.86903 14.329 4.00903 14.329 4.15032C14.329 8.45548 11.0515 13.4206 5.05865 13.4206V13.4181C3.28832 13.4206 1.55478 12.9135 0.0644531 11.9574C0.321872 11.9884 0.580582 12.0039 0.839937 12.0045C2.30703 12.0058 3.73219 11.5135 4.88639 10.6071C3.49219 10.5806 2.26961 9.67161 1.84252 8.34451C2.3309 8.43871 2.83413 8.41935 3.31349 8.28838C1.79349 7.98129 0.699937 6.6458 0.699937 5.09484C0.699937 5.08064 0.699937 5.06709 0.699937 5.05354C1.15284 5.3058 1.65994 5.4458 2.17865 5.46129C0.747034 4.50451 0.305743 2.6 1.17026 1.11096C2.82445 3.14645 5.2651 4.38387 7.8851 4.51484C7.62252 3.38322 7.98123 2.19742 8.82768 1.40193C10.1399 0.168384 12.2038 0.23161 13.4374 1.54322C14.167 1.39935 14.8664 1.13161 15.5064 0.752255C15.2632 1.50645 14.7541 2.14709 14.0741 2.55419C14.7199 2.47806 15.3509 2.30516 15.9451 2.04129C15.5077 2.69677 14.9567 3.26774 14.3193 3.72903Z"
            fill="var(--social-link-twitter-color-fill, var(--beacon-social-link-twitter-icon-color-fill))"
          />
        </g>
        <defs>
          <clipPath id="clip0_2188_14227">
            <rect width="16" height="13.1613" fill="white" transform="translate(0 0.419998)" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "linkedin",
      io`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.8189 0H1.18111C0.867861 0 0.567441 0.124438 0.34594 0.34594C0.124438 0.567441 0 0.867861 0 1.18111V14.8189C0 15.1321 0.124438 15.4326 0.34594 15.6541C0.567441 15.8756 0.867861 16 1.18111 16H14.8189C15.1321 16 15.4326 15.8756 15.6541 15.6541C15.8756 15.4326 16 15.1321 16 14.8189V1.18111C16 0.867861 15.8756 0.567441 15.6541 0.34594C15.4326 0.124438 15.1321 0 14.8189 0ZM4.76889 13.63H2.36333V5.98889H4.76889V13.63ZM3.56445 4.93C3.29158 4.92846 3.02528 4.84613 2.79916 4.69339C2.57304 4.54065 2.39723 4.32435 2.29392 4.07179C2.19061 3.81923 2.16443 3.54173 2.21869 3.2743C2.27294 3.00688 2.4052 2.76152 2.59877 2.56919C2.79234 2.37686 3.03854 2.24618 3.30631 2.19364C3.57408 2.1411 3.85141 2.16906 4.1033 2.27399C4.35519 2.37892 4.57036 2.55611 4.72164 2.78321C4.87293 3.01031 4.95355 3.27713 4.95333 3.55C4.95591 3.73269 4.92167 3.91403 4.85267 4.0832C4.78368 4.25238 4.68132 4.40593 4.55171 4.53471C4.42211 4.66349 4.2679 4.76486 4.09828 4.83277C3.92867 4.90068 3.74711 4.93375 3.56445 4.93ZM13.6356 13.6367H11.2311V9.46222C11.2311 8.23111 10.7078 7.85111 10.0322 7.85111C9.31889 7.85111 8.61889 8.38889 8.61889 9.49333V13.6367H6.21333V5.99445H8.52667V7.05333H8.55778C8.79 6.58333 9.60333 5.78 10.8444 5.78C12.1867 5.78 13.6367 6.57667 13.6367 8.91L13.6356 13.6367Z"
          fill="var(--social-link-linkedin-color-fill, var(--beacon-social-link-linkedin-icon-color-fill))"
        />
      </svg>`
    ],
    [
      "youtube",
      io`<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.6656 2.14892C15.4816 1.46055 14.9395 0.918356 14.2511 0.73438C13.0033 0.400024 7.99996 0.400023 7.99996 0.400023C7.99996 0.400023 2.99666 0.400024 1.74888 0.73438C1.06052 0.918356 0.518326 1.46055 0.334352 2.14892C0 3.3967 0 6 0 6C0 6 0 8.60341 0.334352 9.85115C0.518326 10.5395 1.06052 11.0817 1.74888 11.2656C2.99666 11.6001 7.99996 11.6001 7.99996 11.6001C7.99996 11.6001 13.0033 11.6001 14.2511 11.2656C14.9395 11.0817 15.4816 10.5395 15.6656 9.85115C16 8.60341 16 6 16 6C16 6 16 3.3967 15.6656 2.14892Z"
          fill="var(--social-link-youtube-color-fill-outside, var(--beacon-social-link-youtube-icon-color-fill-outside))"
        />
        <path
          d="M6.40039 8.40002L10.5572 6.00004L6.40039 3.6V8.40002Z"
          fill="var(--social-link-youtube-color-fill-inside, var(--beacon-social-link-youtube-icon-color-fill-inside))"
        />
      </svg>`
    ],
    [
      "x",
      io`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1286_254)">
          <path
            d="M9.48734 6.77491L15.3156 0H13.9345L8.87381 5.88256L4.83185 0H0.169922L6.28217 8.89547L0.169922 16H1.55112L6.89534 9.78782L11.164 16H15.8259L9.48701 6.77491H9.48734ZM7.59561 8.97384L6.97631 8.08805L2.04878 1.03974H4.17022L8.14679 6.72795L8.76609 7.61374L13.9352 15.0075H11.8137L7.59561 8.97418V8.97384Z"
            fill="var(--social-link-x-color-fill, var(--beacon-social-link-x-icon-color-fill))"
          />
        </g>
        <defs>
          <clipPath id="clip0_1286_254">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>`
    ],
    [
      "instagram",
      io`<svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g clip-path="url(#clip0_2188_14249)">
          <mask id="mask0_2188_14249" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <path
              d="M4.70349 0.0949238C3.85651 0.1349 3.27802 0.270564 2.77251 0.468642C2.24921 0.672648 1.80561 0.946046 1.36433 1.38914C0.922524 1.83249 0.651202 2.27688 0.448748 2.8007C0.252733 3.3075 0.119906 3.88627 0.0825045 4.73377C0.0453702 5.58283 0.0368544 5.85363 0.0409937 8.01522C0.045117 10.1765 0.0546566 10.4479 0.0951453 11.2972C0.135632 12.1439 0.27079 12.7222 0.468867 13.2279C0.673131 13.7512 0.946248 14.1946 1.38959 14.6361C1.83269 15.0777 2.27733 15.3488 2.8014 15.5515C3.30768 15.7472 3.88669 15.8806 4.73393 15.9177C5.58298 15.9551 5.85403 15.9634 8.01507 15.9592C10.1771 15.9551 10.4482 15.9456 11.2972 15.9053C12.1442 15.8648 12.7222 15.7292 13.2282 15.5316C13.7515 15.3268 14.1951 15.0542 14.6364 14.6109C15.0777 14.1678 15.349 13.7231 15.5515 13.199C15.7475 12.6927 15.8808 12.1137 15.9177 11.267C15.9549 10.4174 15.9636 10.1461 15.9595 7.98478C15.9554 5.8232 15.9456 5.55239 15.9053 4.7036C15.8651 3.85609 15.7294 3.27811 15.5316 2.77208C15.3271 2.24877 15.0542 1.80567 14.6111 1.36387C14.1681 0.922574 13.7234 0.650729 13.1993 0.448785C12.6928 0.252768 12.1141 0.119166 11.2668 0.0825425C10.4178 0.0448876 10.1467 0.0366393 7.9849 0.0407642C5.8236 0.0448892 5.55255 0.0541772 4.70349 0.0949238ZM4.79635 14.485C4.02029 14.4512 3.59887 14.3222 3.31801 14.2142C2.94609 14.0703 2.68071 13.8977 2.40139 13.6205C2.12259 13.3422 1.94952 13.0776 1.80432 12.7064C1.69522 12.4255 1.56395 12.0046 1.52758 11.2286C1.48812 10.3896 1.4791 10.1378 1.47523 8.01237C1.4711 5.88742 1.47883 5.63569 1.51546 4.79593C1.54873 4.02038 1.67847 3.59843 1.78627 3.31782C1.93017 2.94539 2.1022 2.68051 2.37998 2.4012C2.65826 2.12187 2.92287 1.94933 3.29427 1.80412C3.57488 1.6945 3.99579 1.56426 4.77159 1.52738C5.61109 1.48766 5.86255 1.47915 7.98747 1.47502C10.1129 1.47089 10.3646 1.47838 11.2044 1.51526C11.9799 1.54904 12.4019 1.67749 12.6822 1.78607C13.0544 1.92998 13.3198 2.1015 13.5988 2.37979C13.8779 2.65808 14.051 2.92218 14.1962 3.29435C14.3058 3.57418 14.436 3.99562 14.4726 4.77117C14.5126 5.61068 14.5217 5.8624 14.5255 7.98736C14.5296 10.1128 14.5219 10.3646 14.485 11.2038C14.4512 11.9799 14.3225 12.4016 14.2142 12.6827C14.0703 13.0543 13.8983 13.3197 13.6202 13.5991C13.3422 13.8773 13.0776 14.0509 12.706 14.1961C12.4259 14.3055 12.0044 14.436 11.2292 14.4729C10.3897 14.5123 10.1382 14.5214 8.01249 14.5252C5.88756 14.5294 5.6361 14.5214 4.79635 14.485ZM11.2856 3.74493C11.2867 4.27211 11.7153 4.69896 12.2425 4.69792C12.7699 4.69689 13.1968 4.2685 13.196 3.74132C13.195 3.21414 12.7663 2.78704 12.2389 2.78807C11.7115 2.7891 11.2846 3.21775 11.2856 3.74493ZM3.91301 8.00773C3.91739 10.2653 5.75088 12.0913 8.00785 12.0869C10.2651 12.0825 12.0921 10.2495 12.0877 7.99201C12.0834 5.73526 10.2496 3.90819 7.99212 3.91257C5.73513 3.91696 3.90862 5.75073 3.91301 8.00773ZM5.34673 8.0049C5.34414 6.53969 6.53002 5.34942 7.99496 5.34683C9.46015 5.344 10.6507 6.52937 10.6535 7.99484C10.6563 9.46031 9.47047 10.6503 8.00501 10.6532C6.54008 10.656 5.34956 9.47037 5.34673 8.0049Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_2188_14249)">
            <mask id="mask1_2188_14249" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="-1" width="18" height="18">
              <path d="M16.5905 -0.583628H-0.603516V16.6106H16.5905V-0.583628Z" fill="white" />
            </mask>
            <g mask="url(#mask1_2188_14249)">
              <mask id="mask2_2188_14249" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="-1" width="18" height="18">
                <path d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z" fill="white" />
              </mask>
              <g mask="url(#mask2_2188_14249)">
                <mask id="mask3_2188_14249" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="-1" width="18" height="18">
                  <path d="M16.6696 -0.663237H-0.683594V16.6902H16.6696V-0.663237Z" fill="white" />
                </mask>
                <g mask="url(#mask3_2188_14249)">
                  <rect
                    x="-0.689453"
                    y="-0.665792"
                    width="17.3622"
                    height="17.3622"
                    fill="var(--social-link-instagram-color-fill, var(--beacon-social-link-instagram-icon-color-fill))"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <defs>
          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_2188_14249" transform="scale(0.000439947)" />
          </pattern>
          <clipPath id="clip0_2188_14249">
            <rect width="16" height="16" fill="white" />
          </clipPath>
          <image
            id="image0_2188_14249"
            width="2273"
            height="2275"
            xlink:href="data:image/jpeg;base64,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"
          />
        </defs>
      </svg>`
    ]
  ])
}, q7 = kn`[beacon-tag-name=beacon-social-link]{padding-block:var(--beacon-system-space-cell-contained, var(--beacon-cell-space-padding))}[beacon-tag-name=beacon-social-link] a{color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}[beacon-tag-name=beacon-social-link] a:not(:hover,:focus){text-decoration:none}`, W7 = kn`.beacon-theme-modern-outlook,.beacon-on-light .beacon-theme-modern-outlook,.beacon-theme-modern-outlook .beacon-on-light,.beacon-theme-modern-outlook.beacon-on-light,.beacon-theme-modern-outlook .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-light.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-light[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-light [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-lighter .beacon-theme-modern-outlook,.beacon-theme-modern-outlook .beacon-on-lighter,.beacon-theme-modern-outlook.beacon-on-lighter,.beacon-theme-modern-outlook .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-lighter.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-lighter[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-lighter [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: #fff;--social-link-facebook-color-fill-outside: #1877f2;--social-link-instagram-color-fill: url(#pattern0);--social-link-linkedin-color-fill: #0a66c2;--social-link-twitter-color-fill: #1d9bf0;--social-link-x-color-fill: #000;--social-link-youtube-color-fill-inside: #fff;--social-link-youtube-color-fill-outside: #ed1d24}.beacon-on-dark .beacon-theme-modern-outlook,.beacon-theme-modern-outlook .beacon-on-dark,.beacon-theme-modern-outlook.beacon-on-dark,.beacon-theme-modern-outlook .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-dark.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-dark[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-dark [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker .beacon-theme-modern-outlook,.beacon-theme-modern-outlook .beacon-on-darker,.beacon-theme-modern-outlook.beacon-on-darker,.beacon-theme-modern-outlook .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook [class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker .beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],[class*=beacon-on-] .beacon-on-darker.beacon-theme-modern-outlook [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-darker[beacon-version="3.2.0"][beacon-tag-name=beacon-social-link],.beacon-theme-modern-outlook[class*=beacon-on-] .beacon-on-darker [beacon-version="3.2.0"][beacon-tag-name=beacon-social-link]{--social-link-facebook-color-fill-inside: none;--social-link-facebook-color-fill-outside: #fff;--social-link-instagram-color-fill: #fff;--social-link-linkedin-color-fill: #fff;--social-link-twitter-color-fill: #fff;--social-link-x-color-fill: #fff;--social-link-youtube-color-fill-inside: #253746;--social-link-youtube-color-fill-outside: #fff}`, Y7 = kn`:host{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));align-items:center;display:flex;gap:var(--social-link-flex-gap, var(--beacon-social-link-space-gap))}.icon-slot{--icon-container-size: var(--social-link-icon-container-size, var(--beacon-social-link-icon-container-size));block-size:var(--icon-container-size);display:flex;inline-size:var(--icon-container-size)}.icon-slot svg{--icon-size: var(--beacon-reference-space-5, var(--beacon-unit-base));block-size:var(--icon-size);inline-size:var(--icon-size);margin:auto}`;
var z7 = Object.defineProperty, G7 = Object.getOwnPropertyDescriptor, ls = (n, e, o, a) => {
  for (var i = a > 1 ? void 0 : a ? G7(e, o) : e, s = n.length - 1, c; s >= 0; s--)
    (c = n[s]) && (i = (a ? c(e, o, i) : c(i)) || i);
  return a && i && z7(e, o, i), i;
};
const tm = class extends Sr(Gn) {
  constructor() {
    super(...arguments), this.beaconTagName = au.beaconTagName, this.componentModeStyles = [W7], this.icon = io``;
  }
  static get styles() {
    return [super.styles, Y7];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, V7, q7];
  }
  /** The textContent of the first element in the title nodes. */
  get nameElementText() {
    var e;
    if (this.nameNodes.length < 1)
      return console.warn("No text found in the default slot."), "";
    const o = Array.from(this.nameNodes).find((a) => a.nodeName === "A");
    return (e = o == null ? void 0 : o.textContent) != null ? e : "";
  }
  /**
   * Renders the appropriate icon based on the text passed into the name slot.
   *
   * If the name can't be matched, no icon is rendered.
   */
  renderIcon() {
    const e = this.nameElementText.toLowerCase(), o = au.iconMap.get(e);
    this.icon = o || io``;
  }
  postrenderMethods() {
    this.renderIcon(), this.renderComponentModeStyles();
  }
  render() {
    return io` <div class="icon-slot"><slot name="icon">${this.icon}</slot></div>
      <div class="name">
        <slot></slot>
      </div>`;
  }
};
tm.tagName = au.beaconTagName;
let Br = tm;
ls([
  La()
], Br.prototype, "icon", 2);
ls([
  Q7()
], Br.prototype, "nameNodes", 2);
ls([
  x7(".icon-slot")
], Br.prototype, "iconSlot", 2);
ls([
  H7
], Br.prototype, "postrenderMethods", 1);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Z7 = /* @__PURE__ */ new Set(["children", "localName", "ref", "style", "className"]), kp = /* @__PURE__ */ new WeakMap(), J7 = (n, e, o, a, i) => {
  const s = i == null ? void 0 : i[e];
  s === void 0 || o === a ? o == null && e in HTMLElement.prototype ? n.removeAttribute(e) : n[e] = o : ((c, u, A) => {
    let b = kp.get(c);
    b === void 0 && kp.set(c, b = /* @__PURE__ */ new Map());
    let h = b.get(u);
    A !== void 0 ? h === void 0 ? (b.set(u, h = { handleEvent: A }), c.addEventListener(u, h)) : h.handleEvent = A : h !== void 0 && (b.delete(u), c.removeEventListener(u, h));
  })(n, s, o);
}, X7 = (n, e) => {
  typeof n == "function" ? n(e) : n.current = e;
};
function e8(n = window.React, e, o, a, i) {
  let s, c, u;
  if (e === void 0) {
    const y = n;
    ({ tagName: c, elementClass: u, events: a, displayName: i } = y), s = y.react;
  } else
    s = n, u = o, c = e;
  const A = s.Component, b = s.createElement, h = new Set(Object.keys(a ?? {}));
  class m extends A {
    constructor() {
      super(...arguments), this.o = null;
    }
    t(k) {
      if (this.o !== null)
        for (const w in this.i)
          J7(this.o, w, this.props[w], k ? k[w] : void 0, a);
    }
    componentDidMount() {
      var k;
      this.t(), (k = this.o) === null || k === void 0 || k.removeAttribute("defer-hydration");
    }
    componentDidUpdate(k) {
      this.t(k);
    }
    render() {
      const { _$Gl: k, ...w } = this.props;
      this.h !== k && (this.u = (O) => {
        k !== null && X7(k, O), this.o = O, this.h = k;
      }), this.i = {};
      const _ = { ref: this.u };
      for (const [O, F] of Object.entries(w))
        Z7.has(O) ? _[O === "className" ? "class" : O] = F : h.has(O) || O in u.prototype ? this.i[O] = F : _[O] = F;
      return _.suppressHydrationWarning = !0, b(c, _);
    }
  }
  m.displayName = i ?? u.name;
  const E = s.forwardRef((y, k) => b(m, { ...y, _$Gl: k }, y == null ? void 0 : y.children));
  return E.displayName = m.displayName, E;
}
const n8 = (n) => n.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (e, o) => (o ? "-" : "") + e.toLowerCase()), o8 = (n) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(n);
function t8(n) {
  return `${n}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, o, a) => `${o.toUpperCase() + a}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function a8(n) {
  switch (n) {
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./index-D3dmL9jl-CDood2uG.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./index-GnGkIsuS-BhU0fxgR.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./index-DXPm1g_9-GX_sFuk6.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./index-BGmzjc85-BwFHZ7dq.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./index-C9Fjc1kv-BTHUKGoj.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./index-C-sb_jUz-PVpR_nRJ.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./index-G6BZ5ppZ-BkE3YERe.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./index-C3x5pw5Y-BICYNRHD.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./index-CYsasyJ4-B_DjwEWk.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./index-BcEfDW-U-CdGy8Mgy.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./index-B8PmfpfN-DrFCiy6d.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./index-Di3eUMjN-B3b79Gva.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./index-LzQMu0F8-BcfmY9nK.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./index-z8YIGLrO-DiaXbD-U.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./index-CtF7ygTJ-CnKVD5mC.js");
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./index-Do8zf-PZ-DFS1wXRA.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./index-ClmtGRiE-BjUTh_hP.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./index-BUAYEdKD-ByhvKCZ0.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./index-CT1qIwtH-Bs_lSlad.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./index-BxMcE18W-B1Hj9WLe.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./index-CMi0X4f8-BLXspeoF.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./index-MiHvfZkk-DwJlXcDx.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./index-CP1N5r5a-B_w7Dy1R.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./index-6OaYHacH-DTrBkQNs.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./index-BQ8Sx80D-Cc56b9vv.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./index-CjIEkhF_-B2LijZL8.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./index-C6Y4Uebj-DQHC7MMy.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./index-2wOKxB2G-hMXQI96T.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./index-DVylRKvi-BZwxOhAJ.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./index-BRzJuval-DY5k4Nrw.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./index-BYuJ_GTy-D7Who5nh.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./index-Cjphr2cJ-CIM1FD6F.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./index-BS91XPB3-C6tOVWcN.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./index-C5Pgbmvn-stDcsVKi.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./index-C5Pgbmvn-stDcsVKi.js").then((e) => e.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./index-C5Pgbmvn-stDcsVKi.js").then((e) => e.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./index-8UO-UUJJ-CmSUjH7Q.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./index-C5Pgbmvn-stDcsVKi.js").then((e) => e.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./index-C5Pgbmvn-stDcsVKi.js").then((e) => e.index$4);
    case "./__temp-separated/beacon-popover/index.js":
      return import("./index-CD7im8sx-D4PhGDZs.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./index-CEfPZPWA-CnIZflyf.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./index-C6R-is-Y-B1qnpWn5.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./index-BSKhy0oj-D28o5Wxd.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./index-D8MoaWA3-DpV8Wz0e.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./index-DR-kCA3V-DL07hYpo.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./index-DlMta8Q4-Bz0SNXQQ.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./index-C9G1UpKK-Ddq5t2Sy.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./index-DxlKOTO_-B1q7VSOL.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./index-DHuQRE33-B_XOn10Q.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./index-DLmkJ1lU-01YmmHsB.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./index-CJH4TBcp-BHWX8eZ-.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./index-CDUKDXCS-D6CExY7F.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./index-CFfB1GLM-BnXZRrTL.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./index-Cw6aloqT-CnQNBpAn.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./index-C6LyibcA-Dxv6tlRQ.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./index-Bz3ZXOQN-D7L-2aQ9.js").then((e) => e.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./index-Cgy1KUn9-BXXtaDQH.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./index-PyDeou6--DPXAWwzY.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./index-BtUuCunQ-qIXd8Pz5.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./index-KTYsOfQa-CfdA2RxQ.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./index-aRtcEsFl-D7GSHb1h.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./index-BJ2SDCZR-DuONGk7g.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./index-UsC7zzua-D18JGQFU.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./index-5LY0bxl1-CC9tVX0a.js");
    default:
      return new Promise(function(e, o) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          o.bind(null, new Error("Unknown variable dynamic import: " + n))
        );
      });
  }
}
const r8 = (n) => {
  const e = n8(n);
  return o8(n) || console.warn(
    `Beacon Warning: '${n}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e}".`
  ), e;
}, i8 = (n) => {
  const e = r8(n);
  return {
    tagName: e,
    className: t8(e)
  };
}, ru = async (n, e, o) => new Promise((a, i) => {
  var s;
  if (typeof e == "string") {
    const { tagName: c, className: u } = i8(e), A = n ? `${n}-${c}` : c;
    customElements.get(A) ? a(customElements.get(A)) : a8(`./__temp-separated/${c}/index.js`).then((b) => {
      var h;
      const m = b[`${u}`];
      m.registerComponent(n), (h = m.nestedComponents) != null && h.length && Promise.all(
        m.nestedComponents.map(
          (E) => ru(n, E, o)
        )
      ), a(m);
    }).catch(() => {
      o && i(new Error(`Beacon Registration Error: Unable to import ${e}`));
    });
  } else if (e.registerComponent) {
    const c = e;
    c.registerComponent(n), (s = c.nestedComponents) != null && s.length && Promise.all(
      c.nestedComponents.map(
        (u) => ru(n, u, o)
      )
    ), a(c);
  }
}), us = (n, e) => {
  ru(n, e);
  const o = n + "-" + e.tagName;
  return e8(Kx, o, e, {});
}, s8 = `
    ©2024 T. Rowe Price. All Rights Reserved. T. ROWE PRICE, INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart,
    trademarks of T. Rowe Price Group, Inc. RETIRE WITH CONFIDENCE, T. ROWE PRICE INSIGHTS, ACTIVEPLUS PORTFOLIOS, and GOTUITION and design,
    are trademarks of T. Rowe Price Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement,
    sponsorship, or affiliation of T. Rowe Price with any of the trademark owners.
`, c8 = `
    ©2024. All Rights Reserved. T. ROWE PRICE, INVEST WITH CONFIDENCE, and the Bighorn Sheep design are trademarks of T. Rowe Price Group, Inc.
    All other trademarks are the property of their respective owners. Use does not imply endorsement, sponsorship, or affiliation of
    T. Rowe Price with any of the trademark owners.
`, l8 = `
    ©2024 T. Rowe Price. All Rights Reserved. T.ROWE PRICE, INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart,
    trademarks of T. Rowe Price Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement,
    sponsorship, or affiliation of T. Rowe Price with any of the trademark owners.
`, u8 = (n) => {
  switch (n) {
    case "RAS":
      return s8;
    case "APP_IAT":
      return c8;
    case "SSOT":
    case "SSOT_RIC":
      return l8;
    default:
      return "";
  }
}, As = "advice-shared", A8 = us(As, Na), El = us(As, N7), d8 = us(As, $7), rr = us(As, Br), rR = ({
  copyright: n,
  copyrightContentOverride: e,
  disclosures: o,
  disclosuresOverrideStyles: a = { backgroundColor: "#E9EBED", paddingTop: "48px", paddingBottom: "48px" }
}) => /* @__PURE__ */ p.jsxs("div", { className: "beacon-theme-modern-outlook beacon-on-darker", children: [
  o && /* @__PURE__ */ p.jsx(
    "div",
    {
      className: "b-container",
      style: {
        inlineSize: "unset",
        ...a
      },
      children: o
    }
  ),
  /* @__PURE__ */ p.jsxs(A8, { children: [
    /* @__PURE__ */ p.jsxs("div", { slot: "trademark", children: [
      "Invest With Confidence",
      /* @__PURE__ */ p.jsx("sup", { children: "®" })
    ] }),
    /* @__PURE__ */ p.jsx("div", { slot: "mission", children: "We're driven by our purpose: To identify and actively invest in opportunities to help people thrive in an evolving world." }),
    /* @__PURE__ */ p.jsxs(El, { slot: "links", children: [
      /* @__PURE__ */ p.jsx("span", { slot: "title", children: "Company" }),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/corporate/en/what-we-do.html",
          children: "Company Overview"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/corporate/en/careers.html",
          children: "Careers"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/corporate/en/press.html",
          children: "Newsroom"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://troweprice.gcs-web.com",
          children: "Investor Relations"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/corporate/en/what-sets-us-apart/corporate-responsibility.html",
          children: "Responsibility"
        }
      )
    ] }),
    /* @__PURE__ */ p.jsxs(El, { slot: "links", children: [
      /* @__PURE__ */ p.jsx("span", { slot: "title", children: "Privacy & Legal" }),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/enterprise/legal/us/en/privacy-notices.html",
          children: "U.S. and Canada Privacy Notice"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/personal-investing/help/terms-of-use.html",
          children: "Terms of Use"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/corporate/en/utility/security-measures.html",
          children: "Security Measures"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/personal-investing/help/policies-and-security/legal-information.html",
          children: "Legal Information"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/personal-investing/about-t-rowe-price/form-crs.html",
          children: "Form CRS"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/en/us/accessibility.html",
          children: "Accessibility Statement"
        }
      )
    ] }),
    /* @__PURE__ */ p.jsxs(El, { slot: "links", children: [
      /* @__PURE__ */ p.jsx("span", { slot: "title", children: "Personal Investing" }),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/personal-investing/sitemap.html",
          children: "Site Map"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/corporate/en/mobile-solutions.html",
          children: "Mobile App"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/personal-investing/help/contact-us.html",
          children: "Contact Us"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/personal-investing/help/policies-and-security/customer-agreement.html",
          children: "Customer Agreement"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/en/us/glossary.html",
          children: "Glossary"
        }
      ),
      /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.troweprice.com/en/us/market-data-disclosures.html",
          children: "Market Data Disclosure"
        }
      )
    ] }),
    /* @__PURE__ */ p.jsxs(d8, { slot: "socials", children: [
      /* @__PURE__ */ p.jsx("p", { slot: "text", children: "Find us on:" }),
      /* @__PURE__ */ p.jsx(rr, { children: /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://facebook.com/troweprice",
          children: "Facebook"
        }
      ) }),
      /* @__PURE__ */ p.jsx(rr, { children: /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://x.com/troweprice",
          children: "X"
        }
      ) }),
      /* @__PURE__ */ p.jsx(rr, { children: /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://youtube.com/trowepricegroup",
          children: "YouTube"
        }
      ) }),
      /* @__PURE__ */ p.jsx(rr, { children: /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://linkedin.com/company/157329?trk=tyah",
          children: "LinkedIn"
        }
      ) }),
      /* @__PURE__ */ p.jsx(rr, { children: /* @__PURE__ */ p.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://instagram.com/t._rowe_price",
          children: "Instagram"
        }
      ) })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { slot: "disclaimer", children: [
      /* @__PURE__ */ p.jsx("p", { children: /* @__PURE__ */ p.jsx(
        "a",
        {
          id: "onetrust-link",
          className: "ot-sdk-show-settings",
          href: "javascript:void(0)",
          role: "button",
          children: "Do Not Sell or Share My Personal Information"
        }
      ) }),
      /* @__PURE__ */ p.jsx("p", { children: "The funds referred to in this website are offered and sold only to persons residing in the United States and are offered by prospectus only. The prospectuses include investment objectives, risks, fees, expenses, and other information that you should read and consider carefully before investing. T. Rowe Price Investment Services, Inc., distributor, T. Rowe Price mutual funds and T. Rowe Price ETFs." }),
      /* @__PURE__ */ p.jsxs("p", { children: [
        "Download a ",
        /* @__PURE__ */ p.jsx("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html", children: "mutual fund prospectus" }),
        " or ",
        /* @__PURE__ */ p.jsx("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html", children: "ETF prospectus" }),
        "."
      ] })
    ] }),
    /* @__PURE__ */ p.jsx("div", { slot: "copyright", children: /* @__PURE__ */ p.jsx("p", { children: e || u8(n) }) })
  ] })
] }), f8 = wo((n) => ({
  "@global": {
    "div.center-text": {
      width: "max-content !important"
    },
    ".MuiLinearProgress-root": {
      height: n.spacingVars.xmedium
    },
    ".MuiLinearProgress-colorSecondary": {
      backgroundColor: "#F4F5F6",
      border: " 1px solid #D3D7DA"
    },
    ".MuiLinearProgress-barColorSecondary": {
      backgroundColor: "#515F6B"
    },
    ".MuiLinearProgress-colorPrimary": {
      backgroundColor: "#F4F5F6",
      border: " 1px solid #D3D7DA"
    },
    ".MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#8EBF4C"
    },
    ".MuiLinearProgress-bar1Determinate": {
      transition: "transform 1s ease-out"
    }
  },
  contentContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-between",
    [n.breakpoints.down("840")]: {
      display: "flex",
      flexDirection: "column"
    }
  },
  contentText: {
    width: "50%",
    [n.breakpoints.down("840")]: {
      width: "100%",
      paddingBottom: n.spacingVars.xlarge
    }
  },
  contentTextHeader: {
    fontSize: n.fontVars.h4Font,
    color: n.palette.charcoal,
    paddingBottom: n.spacingVars.small
  },
  contentMainText: {
    fontFamily: n.fontFamily.light,
    fontSize: n.fontVars.medium,
    color: n.palette.charcoal,
    lineHeight: n.spacingVars.xxmedium
  },
  contentPercentText: {
    fontFamily: n.fontFamily.bold
  },
  chartContainer: {
    paddingBottom: "14px",
    justifyContent: "space-between",
    width: "45%",
    [n.breakpoints.down("840")]: {
      width: "100%"
    }
  },
  percentUpIcon: {
    alignSelf: "center"
  },
  chartHeader: {
    fontFamily: n.fontFamily.light,
    fontSize: n.fontVars.medium,
    textAlign: "center",
    color: n.palette.charcoal,
    lineHeight: n.spacingVars.xxxmedium
  },
  chartHeaderBold: {
    fontFamily: n.fontFamily.bold,
    fontSize: n.fontVars.medium,
    textAlign: "center",
    color: n.palette.charcoal,
    lineHeight: n.spacingVars.xxxmedium
  },
  chartPercent: {
    float: "right",
    fontFamily: n.fontFamily.light,
    fontSize: n.fontVars.medium,
    textAlign: "center",
    color: n.palette.charcoal,
    lineHeight: n.spacingVars.xxxmedium
  },
  chartPercentBold: {
    float: "right",
    fontFamily: n.fontFamily.bold,
    fontSize: n.fontVars.medium,
    textAlign: "center",
    color: n.palette.charcoal,
    lineHeight: n.spacingVars.xxxmedium
  },
  chartHeaderContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-between",
    paddingBottom: n.spacingVars.small
  },
  currentChartContainer: {
    paddingBottom: n.spacingVars.xlarge,
    width: "100%",
    position: "relative"
  },
  proposedChartContainer: {
    width: "100%",
    position: "relative"
  }
}));
function b8({ probability: n }) {
  const e = n ? parseFloat(n.filter((b) => b.scenarioId === "Current Scenario")[0].probabilityOfSuccess) : 0, o = n ? parseFloat(n.filter((b) => b.scenarioId === "Recommended Scenario")[0].probabilityOfSuccess) : 0, a = f8(), [i, s] = C.useState("0"), [c, u] = C.useState("0");
  setTimeout(function() {
    s(e), u(o);
  }, 2e3);
  const A = o - e;
  return /* @__PURE__ */ p.jsxs("div", { className: a.contentContainer, id: "content-container", children: [
    /* @__PURE__ */ p.jsxs("div", { className: a.contentText, id: "content-text", children: [
      /* @__PURE__ */ p.jsxs("div", { className: a.contentTextHeader, id: "content-text-header", children: [
        /* @__PURE__ */ p.jsx("span", { className: a.contentPercentText, id: "probability-percent", children: `${A}% increase` }),
        " in probability of success"
      ] }),
      /* @__PURE__ */ p.jsx("div", { className: a.contentMainText, id: "content-main-text", children: "We generate 1,000 hypothetical market scenarios so you can analyze hypothetical outcomes for a portfolio under a broad range of market conditions. The Recommended Scenario assumes the implementation of the Composite Portfolio for purposes of estimating the Probability of Success." })
    ] }),
    /* @__PURE__ */ p.jsxs("div", { className: a.chartContainer, children: [
      /* @__PURE__ */ p.jsxs("div", { className: a.currentChartContainer, id: "current-chart-container", children: [
        /* @__PURE__ */ p.jsxs("div", { className: a.chartHeaderContainer, id: "current-header-container", children: [
          /* @__PURE__ */ p.jsx("div", { className: a.chartHeader, id: "current-header", children: "Current" }),
          /* @__PURE__ */ p.jsx("div", { className: a.chartPercent, id: "current-percentage", children: `${e}%` })
        ] }),
        /* @__PURE__ */ p.jsx(En, { display: "flex", alignItems: "center", id: "current-bar-chart", children: /* @__PURE__ */ p.jsx(En, { width: "100%", children: /* @__PURE__ */ p.jsx(Cb, { variant: "determinate", color: "secondary", value: i }) }) })
      ] }),
      /* @__PURE__ */ p.jsxs("div", { className: a.proposedChartContainer, id: "proposed-chart-container", children: [
        /* @__PURE__ */ p.jsxs("div", { className: a.chartHeaderContainer, id: "current-header-container", children: [
          /* @__PURE__ */ p.jsx("div", { className: a.chartHeaderBold, id: "proposed-header", children: "Recommended" }),
          /* @__PURE__ */ p.jsx("div", { className: a.chartPercentBold, id: "proposed-percentage", children: `${o}%` })
        ] }),
        /* @__PURE__ */ p.jsx(En, { display: "flex", alignItems: "center", id: "proposed-bar-chart", children: /* @__PURE__ */ p.jsx(En, { width: "100%", children: /* @__PURE__ */ p.jsx(Cb, { variant: "determinate", color: "primary", value: c }) }) })
      ] })
    ] })
  ] });
}
const p8 = wo((n) => ({
  root: {
    [n.breakpoints.up("md")]: {
      paddingLeft: n.spacingVars.xmedium,
      paddingRight: n.spacingVars.xmedium
    }
  },
  card: {
    minHeight: 192,
    paddingRight: 0,
    borderRadius: "0px",
    boxShadow: n.boxShadow,
    "&:hover": {
      boxShadow: n.boxShadowHover
    },
    [n.breakpoints.down("840")]: {
      minHeight: 272
    }
  },
  details: {
    display: "flex",
    flexDirection: "row",
    height: "100%"
  },
  content: {
    padding: "32px 32px 24px",
    "&:last-child": {
      paddingBottom: n.spacingVars.xxxmedium
    },
    [n.breakpoints.down("sm")]: {
      padding: n.spacingVars.xxxmedium
    }
  },
  cardActionArea: {
    backgroundColor: `${n.palette.cardFooterGray || n.colors.cardFooterGray}`
  },
  simText: {
    fontFamily: n.fontFamily.regular,
    color: n.palette.charcoal,
    fontSize: n.fontVars.xsmall,
    textTransform: "none",
    display: "inline-flex",
    lineHeight: "16px",
    alignSelf: "center",
    justifyContent: "flex-end",
    width: "50%",
    [n.breakpoints.down("1085")]: {
      display: "block",
      float: "none",
      width: "100%"
    }
  },
  cardActions: {
    justifyContent: "center"
  }
}));
function iR({ probability: n }) {
  const e = p8();
  return /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsx(vt, { maxWidth: "lg", className: e.root, id: "probability-chart-card", children: /* @__PURE__ */ p.jsx(Tu, { className: e.card, children: /* @__PURE__ */ p.jsx(Ou, { className: e.content, id: "card-content-container", children: /* @__PURE__ */ p.jsx(b8, { probability: n }) }) }) }) });
}
var Ju = {}, am = is;
Object.defineProperty(Ju, "__esModule", {
  value: !0
});
var rm = Ju.default = void 0, h8 = am(C), g8 = am(Wu()), m8 = (0, g8.default)(h8.default.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
rm = Ju.default = m8;
const v8 = wo((n) => ({
  primaryButton: {
    boxShadow: "none",
    background: n.colors.interactiveBlue,
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue
    },
    fontSize: n.fontVars.medium,
    fontFamily: n.fontFamily.bold,
    color: n.colors.white,
    marginRight: n.spacingVars.xmedium,
    marginBottom: n.spacingVars.small,
    "&$disabled": {
      color: n.colors.white,
      background: n.colors.interactiveBlue
    },
    [n.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  disabled: {},
  secondaryButton: {
    boxShadow: "none",
    background: n.colors.white,
    backgroundColor: n.colors.white,
    border: `1px solid ${n.colors.interactiveBlue}`,
    padding: "8px 16px",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue,
      color: n.colors.white,
      border: `1px solid ${n.palette.hoverBlue}`
    },
    marginBottom: n.spacingVars.small,
    marginLeft: n.spacingVars.xlarge,
    fontSize: n.fontVars.medium,
    maxHeight: "45px",
    fontFamily: n.fontFamily.reg,
    color: n.colors.interactiveBlue,
    textTransform: "capitalize",
    [n.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0
    }
  },
  buttonProgress: {
    color: n.colors.brightBlue,
    marginLeft: n.spacingVars.small,
    verticalAlign: "sub"
  },
  buttonSuccess: {
    color: `${n.palette.successGreen} !important`,
    maxHeight: 40,
    minWidth: 266
  }
}));
function y8({
  children: n,
  className: e,
  color: o,
  buttonText: a,
  disabled: i,
  id: s,
  isLoading: c,
  noFullWidth: u,
  onClick: A,
  variant: b = "contained",
  secondaryButton: h,
  size: m,
  success: E,
  wrap: y,
  sentenceCase: k
}) {
  const w = v8(), _ = Zo(), F = Lu(_.breakpoints.down("sm")) ? "medium" : "large", P = Se({
    [w.buttonSuccess]: E,
    [e]: !E,
    [w.primaryButton]: !E && !h && !e,
    [w.secondaryButton]: !E && !e && h
  }), M = Se({
    [s]: !c && !E,
    [`${s}-loading`]: c && !E,
    [`${s}-success`]: !c && E
  }), B = y ? { whiteSpace: "normal", lineHeight: "24px" } : { whiteSpace: "nowrap" }, D = k ? { textTransform: "none" } : { textTransform: "capitalize" };
  return /* @__PURE__ */ p.jsx(
    Go,
    {
      id: M,
      className: P,
      color: o,
      disabled: i,
      fullWidth: !u,
      onClick: A,
      size: m || F,
      variant: b,
      style: D,
      children: /* @__PURE__ */ p.jsxs("span", { style: B, children: [
        n,
        !c && !E ? a : "",
        c && /* @__PURE__ */ p.jsx(Uu, { size: 20, className: w.buttonProgress, alt: "loading", id: "loading-spinner" }),
        E && /* @__PURE__ */ p.jsx(rm, { alt: "success" })
      ] })
    }
  );
}
var Xu = {}, im = is;
Object.defineProperty(Xu, "__esModule", {
  value: !0
});
var sm = Xu.default = void 0, x8 = im(C), C8 = im(Wu()), w8 = (0, C8.default)(x8.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
sm = Xu.default = w8;
const E8 = () => /* @__PURE__ */ p.jsxs("svg", { width: "18", height: "16", viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M16.6667 12.5586C14.9967 12.9059 13.96 11.2393 13.96 11.2393V11.2393C13.4362 12.0721 12.5297 12.5868 11.546 12.6099C10.6132 12.5926 9.76434 12.0668 9.33337 11.2393V11.2393C9.05563 11.5941 8.71703 11.8968 8.33337 12.1333", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M1.33337 14.6328H16.6667", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M2.9707 14.6325L6.6667 3.96582V14.6325", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M6.09341 3.73686L1.66675 1.96553C4.06675 0.365529 6.66675 2.29886 6.66675 3.96553", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M7.24341 3.73286L11.6667 1.96553C9.26675 0.365529 6.66675 2.29886 6.66675 3.96553", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.9054 8.63287C12.3921 4.89154 8.62075 2.9662 6.66675 3.9282L11.9054 8.63287Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.42806 8.63287C0.941392 4.89154 4.71273 2.9662 6.66673 3.9282L1.42806 8.63287Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M5.28198 13.1836H6.66665", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M5.61536 11.8506H6.66669", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" })
] }), k8 = () => /* @__PURE__ */ p.jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.33337 16.667C4.88566 16.667 5.33337 16.2193 5.33337 15.667C5.33337 15.1147 4.88566 14.667 4.33337 14.667C3.78109 14.667 3.33337 15.1147 3.33337 15.667C3.33337 16.2193 3.78109 16.667 4.33337 16.667Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.6667 16.667C12.219 16.667 12.6667 16.2193 12.6667 15.667C12.6667 15.1147 12.219 14.667 11.6667 14.667C11.1145 14.667 10.6667 15.1147 10.6667 15.667C10.6667 16.2193 11.1145 16.667 11.6667 16.667Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M16.6667 3.33301H15.3894C14.7706 3.33296 14.2331 3.75866 14.0914 4.36101L11.6667 14.6663H4.33337", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M11.9807 13.3333H4.25737C3.70112 13.3332 3.2034 12.9877 3.00871 12.4667L1.33337 8H13.2354", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.33337 7.99997V1.66664C7.33345 1.57575 7.29642 1.48877 7.23085 1.42584C7.16527 1.36291 7.07685 1.32949 6.98604 1.3333C4.10604 1.5193 1.33337 3.98064 1.33337 6.9893V7.99997H7.33337Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" })
] }), S8 = () => /* @__PURE__ */ p.jsxs("svg", { width: "14", height: "18", viewBox: "0 0 14 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.96598 11.6663C8.1626 11.6663 9.13265 10.6963 9.13265 9.49967C9.13265 8.30306 8.1626 7.33301 6.96598 7.33301C5.76937 7.33301 4.79932 8.30306 4.79932 9.49967C4.79932 10.6963 5.76937 11.6663 6.96598 11.6663Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M10.3373 14.9999C9.82721 13.5986 8.49521 12.666 7.00399 12.666C5.51277 12.666 4.18076 13.5986 3.67065 14.9999", stroke: "#05C3DE", "stroke-width": "0.989", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M7.00004 2.66602C7.09209 2.66602 7.16671 2.74063 7.16671 2.83268C7.16671 2.92473 7.09209 2.99935 7.00004 2.99935C6.90799 2.99935 6.83337 2.92473 6.83337 2.83268C6.83337 2.74063 6.90799 2.66602 7.00004 2.66602", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M8.66671 4H12C12.3682 4 12.6667 4.29848 12.6667 4.66667V16C12.6667 16.3682 12.3682 16.6667 12 16.6667H2.00004C1.63185 16.6667 1.33337 16.3682 1.33337 16V4.66667C1.33337 4.29848 1.63185 4 2.00004 4H5.33337", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.66671 4.99967C8.66671 5.18377 8.51747 5.33301 8.33337 5.33301H5.66671C5.48261 5.33301 5.33337 5.18377 5.33337 4.99967V2.99967C5.33337 2.0792 6.07957 1.33301 7.00004 1.33301C7.92052 1.33301 8.66671 2.0792 8.66671 2.99967V4.99967Z", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" })
] }), R8 = () => /* @__PURE__ */ p.jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M10.3334 7.5829L9.67608 4.9209L7.01941 5.5609", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M2.66667 4C2.57462 4 2.5 4.07462 2.5 4.16667C2.5 4.25871 2.57462 4.33333 2.66667 4.33333C2.75871 4.33333 2.83333 4.25871 2.83333 4.16667C2.83333 4.07462 2.75871 4 2.66667 4", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M2.66667 6.66699C2.57462 6.66699 2.5 6.74161 2.5 6.83366C2.5 6.92571 2.57462 7.00033 2.66667 7.00033C2.75871 7.00033 2.83333 6.92571 2.83333 6.83366C2.83333 6.74161 2.75871 6.66699 2.66667 6.66699", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M16 4C15.908 4 15.8334 4.07462 15.8334 4.16667C15.8334 4.25871 15.908 4.33333 16 4.33333C16.0921 4.33333 16.1667 4.25871 16.1667 4.16667C16.1667 4.07462 16.0921 4 16 4", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M16 6.66699C15.908 6.66699 15.8334 6.74161 15.8334 6.83366C15.8334 6.92571 15.908 7.00033 16 7.00033C16.0921 7.00033 16.1667 6.92571 16.1667 6.83366C16.1667 6.74161 16.0921 6.66699 16 6.66699", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M2.66667 1.33398C2.57462 1.33398 2.5 1.4086 2.5 1.50065C2.5 1.5927 2.57462 1.66732 2.66667 1.66732C2.75871 1.66732 2.83333 1.5927 2.83333 1.50065C2.83333 1.45645 2.81577 1.41406 2.78452 1.3828C2.75326 1.35154 2.71087 1.33398 2.66667 1.33398", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M5.33341 1.33398C5.24137 1.33398 5.16675 1.4086 5.16675 1.50065C5.16675 1.5927 5.24137 1.66732 5.33341 1.66732C5.42546 1.66732 5.50008 1.5927 5.50008 1.50065C5.50008 1.45645 5.48252 1.41406 5.45127 1.3828C5.42001 1.35154 5.37762 1.33398 5.33341 1.33398", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M8.00004 1.33398C7.90799 1.33398 7.83337 1.4086 7.83337 1.50065C7.83337 1.5927 7.90799 1.66732 8.00004 1.66732C8.09209 1.66732 8.16671 1.5927 8.16671 1.50065C8.16671 1.45645 8.14915 1.41406 8.11789 1.3828C8.08664 1.35154 8.04424 1.33398 8.00004 1.33398", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M10.6667 1.33398C10.5746 1.33398 10.5 1.4086 10.5 1.50065C10.5 1.5927 10.5746 1.66732 10.6667 1.66732C10.7587 1.66732 10.8333 1.5927 10.8333 1.50065C10.8333 1.45645 10.8158 1.41406 10.7845 1.3828C10.7533 1.35154 10.7109 1.33398 10.6667 1.33398", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M13.3334 1.33398C13.2414 1.33398 13.1667 1.4086 13.1667 1.50065C13.1667 1.5927 13.2414 1.66732 13.3334 1.66732C13.4255 1.66732 13.5001 1.5927 13.5001 1.50065C13.5001 1.45645 13.4825 1.41406 13.4513 1.3828C13.42 1.35154 13.3776 1.33398 13.3334 1.33398", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M16 1.33398C15.908 1.33398 15.8334 1.4086 15.8334 1.50065C15.8334 1.5927 15.908 1.66732 16 1.66732C16.0921 1.66732 16.1667 1.5927 16.1667 1.50065C16.1667 1.45645 16.1491 1.41406 16.1179 1.3828C16.0866 1.35154 16.0442 1.33398 16 1.33398", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M16.0001 10.667V16.0003C16.0001 16.3685 15.7016 16.667 15.3334 16.667H3.33341C2.96522 16.667 2.66675 16.3685 2.66675 16.0003V10.667", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M10 9.33301H16.6667", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M1.33337 9.33301H6.00004", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M9.66668 4.9209C7.45354 7.42853 7.44099 11.1879 9.63735 13.7102", stroke: "#05C3DE", "stroke-linecap": "round", "stroke-linejoin": "round" })
] }), B8 = wo((n) => ({
  wrapper: Ng.cardMediaWrapper,
  containerRoot: {
    [n.breakpoints.up("md")]: {
      paddingLeft: 16,
      paddingRight: 16,
      maxWidth: "1280px"
    }
  },
  card: {
    minHeight: 244,
    maxWidth: "100%",
    marginBottom: "120px",
    marginTop: n.fontVars.xxxlarge,
    borderRadius: "0px",
    boxShadow: n.boxShadow,
    "&:hover": {
      boxShadow: n.boxShadowHover
    }
  },
  details: {
    display: "flex",
    flexDirection: "row",
    height: "inherit"
  },
  closeButton: {
    alignSelf: "flex-end",
    paddingRight: "12px",
    paddingTop: "12px",
    paddingBottom: "8px"
  },
  closeIcon: {
    color: n.colors.interactiveBlue
  },
  content: {
    padding: "0 32px 32px 32px",
    "&:last-child": {
      paddingBottom: n.spacingVars.xlarge
    },
    [n.breakpoints.down("sm")]: {
      padding: n.spacingVars.xxxmedium
    }
  },
  contentContainer: {
    borderBottom: "1px solid #D3D7DA",
    paddingBottom: n.spacingVars.small
  },
  cardContentText: {
    display: "flex",
    justifyContent: "center",
    color: n.colors.darkGray
  },
  stickyContainer: {
    backgroundColor: "#F9FAFA",
    position: "static",
    zIndex: "99999999999"
  },
  cardHeaderText: {
    fontSize: n.fontVars.xlarge,
    lineHeight: n.spacingVars.xlarge,
    fontFamily: n.fontFamily.bold,
    color: n.colors.charcoal,
    paddingBottom: n.spacingVars.xmedium
  },
  sectionHeaderText: {
    fontSize: n.fontVars.medium,
    fontFamily: n.fontFamily.bold,
    lineHeight: n.spacingVars.xxxmedium,
    color: n.colors.charcoal,
    paddingBottom: n.spacingVars.small,
    paddingTop: n.spacingVars.xmedium
  },
  primaryButton: {
    boxShadow: "none",
    background: n.colors.interactiveBlue,
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: n.colors.hoverBlue
    },
    fontSize: n.fontVars.medium,
    fontFamily: n.fontFamily.bold,
    color: n.colors.white,
    margin: "12px 16px 12px 0px",
    "&$disabled": {
      color: n.colors.white,
      background: n.colors.interactiveBlue
    },
    [n.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  buttonContainer: {
    paddingTop: n.spacingVars.xxmedium,
    textAlign: "end"
  },
  contentText: {
    fontSize: n.fontVars.small,
    color: n.colors.charcoal,
    lineHeight: n.spacingVars.xxmedium,
    paddingBottom: n.spacingVars.small
  },
  smallContainer: {
    paddingBottom: "8px"
  },
  disabled: {},
  imgContentContainer: {
    display: "flex"
  },
  imgContent: {
    paddingLeft: "9px",
    fontSize: n.fontVars.small,
    lineHeight: n.spacingVars.xxmedium,
    color: n.colors.charcoal
  }
})), _8 = ({ modalState: n, onClose: e, href: o, onClick: a }) => {
  const i = B8(), s = Zo(), c = Lu(s.breakpoints.only("xs")), u = () => {
    e();
  }, A = () => {
    o ? (u(), window.location.replace(o)) : (e(), a());
  }, b = C.useRef(null);
  return C.useEffect(() => {
    if (n) {
      const { current: h } = b;
      h !== null && h.focus();
    }
  }, [n]), /* @__PURE__ */ p.jsxs(
    Ku,
    {
      scroll: "paper",
      id: "education-modal",
      open: n,
      onClose: u,
      maxWidth: "sm",
      "aria-labelledby": "scroll-dialog-title",
      "aria-describedby": "scroll-dialog-description",
      "data-metrics-location": "PU",
      fullScreen: c,
      children: [
        /* @__PURE__ */ p.jsx(k4, { className: i.closeButton, id: "scroll-dialog-title", children: /* @__PURE__ */ p.jsx(
          n4,
          {
            disableRipple: !0,
            "aria-label": "close",
            onClick: u,
            id: "close-button",
            className: i.closeIcon,
            children: /* @__PURE__ */ p.jsx(sm, {})
          }
        ) }),
        /* @__PURE__ */ p.jsx(Pu, { className: i.content, children: /* @__PURE__ */ p.jsx("div", { className: i.details, children: /* @__PURE__ */ p.jsx("div", { className: i.cardContentText, children: /* @__PURE__ */ p.jsxs(w4, { tabIndex: -1, id: "scroll-dialog-description", children: [
          /* @__PURE__ */ p.jsx(cn, { component: "h5", variant: "h5", children: /* @__PURE__ */ p.jsx("div", { className: i.cardHeaderText, id: "education-title", children: "Have you experienced a major change or is it time for your annual check-in?" }) }),
          /* @__PURE__ */ p.jsxs("div", { className: i.contentContainer, id: "major-change-container", children: [
            /* @__PURE__ */ p.jsx("div", { className: i.sectionHeaderText, id: "major-change-header", children: "Examples of Major Changes" }),
            /* @__PURE__ */ p.jsx("div", { className: i.smallContainer, id: "recently-retired-container", children: /* @__PURE__ */ p.jsxs("div", { className: i.imgContentContainer, children: [
              /* @__PURE__ */ p.jsx(E8, { alt: "recently-retired", id: "retired-icon" }),
              /* @__PURE__ */ p.jsx("div", { className: i.imgContent, id: "recently-retired", children: "Recently Retired" })
            ] }) }),
            /* @__PURE__ */ p.jsx("div", { className: i.smallContainer, id: "birth-of-child-container", children: /* @__PURE__ */ p.jsxs("div", { className: i.imgContentContainer, children: [
              /* @__PURE__ */ p.jsx(k8, { alt: "brth-of-child-icon", id: "birth-of-child-icon" }),
              /* @__PURE__ */ p.jsx("div", { className: i.imgContent, id: "birth-of-child", children: "Birth of a child" })
            ] }) }),
            /* @__PURE__ */ p.jsx("div", { className: i.smallContainer, id: "job-change-container", children: /* @__PURE__ */ p.jsxs("div", { className: i.imgContentContainer, children: [
              /* @__PURE__ */ p.jsx(S8, { alt: "job-change-icon", id: "job-change-icon" }),
              /* @__PURE__ */ p.jsx("div", { className: i.imgContent, id: "job-change-child", children: "Job change" })
            ] }) }),
            /* @__PURE__ */ p.jsx("div", { className: i.smallContainer, id: "unpl-change-container", children: /* @__PURE__ */ p.jsxs("div", { className: i.imgContentContainer, children: [
              /* @__PURE__ */ p.jsx(R8, { alt: "unpl-change-icon", id: "unpl-change-icon" }),
              /* @__PURE__ */ p.jsx("div", { className: i.imgContent, id: "unpl-change-child", children: "Unplanned changes to your financial situation, such as a family inheritance or unexpected expenses" })
            ] }) })
          ] }),
          /* @__PURE__ */ p.jsxs("div", { className: i.contentContainer, id: "major-change-container", children: [
            /* @__PURE__ */ p.jsx("div", { className: i.sectionHeaderText, id: "annual-review-header", children: "Annual Review" }),
            /* @__PURE__ */ p.jsx("div", { className: i.contentText, id: "annual-review-content", children: "Your annual review allows us to make sure your plan is still aligned with your current situation. This evaluation requires accurate and up-to-date information about you, your time horizon, and your goals." })
          ] }),
          /* @__PURE__ */ p.jsxs("div", { className: i.contentContainer, id: "scenarios-container", children: [
            /* @__PURE__ */ p.jsx("div", { className: i.sectionHeaderText, id: "scenarios-header", children: "If either of these scenarios apply to you, please continue to the questionnaire." }),
            /* @__PURE__ */ p.jsxs("div", { className: i.contentText, id: "scenarios-content", children: [
              /* @__PURE__ */ p.jsx("div", { id: "scenarios-sub-1", style: { paddingTop: "8px", paddingBottom: "16px" }, children: "After completing the questionnaire:" }),
              /* @__PURE__ */ p.jsxs("div", { id: "scenarios-expl-container", children: [
                /* @__PURE__ */ p.jsx("div", { id: "scenario-1", children: "1. You can schedule an appointment with your advisor." }),
                /* @__PURE__ */ p.jsx("div", { id: "secario-2", children: "2. A CERTIFIED FINANCIAL PLANNER™ will review your updates." }),
                /* @__PURE__ */ p.jsx("div", { id: "scenario-3", children: "3. During your appointment you and your advisor will discuss your updates and any impacts." })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ p.jsxs("div", { className: i.contentContainer, id: "questions-container", children: [
            /* @__PURE__ */ p.jsx("div", { className: i.sectionHeaderText, id: "questions-header", children: "Questions?" }),
            /* @__PURE__ */ p.jsxs("div", { className: i.contentText, id: "questions-content", children: [
              /* @__PURE__ */ p.jsx("div", { id: "questions-sub-1", children: "Not all changes can be addressed through the questionnaire." }),
              /* @__PURE__ */ p.jsx("div", { id: "questions-sub-content", style: { paddingTop: "8px" }, children: "Do you have a new planning partner?  Should your financial plan now include only you? In situations like these or if you have other questions, we can help. Call us for assistance at 1-800-225-5132." })
            ] })
          ] })
        ] }) }) }) }),
        /* @__PURE__ */ p.jsx(Dh, { style: { backgroundColor: "#F9FAFA" }, children: /* @__PURE__ */ p.jsx(
          y8,
          {
            id: "continue-rt-review",
            className: i.primaryButton,
            type: "submit",
            size: "medium",
            noFullWidth: !0,
            color: "primary",
            variant: "contained",
            buttonText: "Continue",
            onClick: A
          }
        ) })
      ]
    }
  );
};
function sR({ modalState: n, onClose: e, onClick: o, href: a }) {
  return /* @__PURE__ */ p.jsx(_8, { modalState: n, onClose: e, onClick: o, href: a });
}
var Vi = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Vi.exports;
(function(n, e) {
  (function() {
    var o, a = "4.17.21", i = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", c = "Expected a function", u = "Invalid `variable` option passed into `_.template`", A = "__lodash_hash_undefined__", b = 500, h = "__lodash_placeholder__", m = 1, E = 2, y = 4, k = 1, w = 2, _ = 1, O = 2, F = 4, P = 8, M = 16, B = 32, D = 64, H = 128, X = 256, ce = 512, Ae = 30, se = "...", Be = 800, Pe = 16, ne = 1, J = 2, $ = 3, z = 1 / 0, q = 9007199254740991, de = 17976931348623157e292, U = NaN, L = 4294967295, oe = L - 1, re = L >>> 1, ie = [
      ["ary", H],
      ["bind", _],
      ["bindKey", O],
      ["curry", P],
      ["curryRight", M],
      ["flip", ce],
      ["partial", B],
      ["partialRight", D],
      ["rearg", X]
    ], fe = "[object Arguments]", ae = "[object Array]", be = "[object AsyncFunction]", pe = "[object Boolean]", le = "[object Date]", me = "[object DOMException]", ge = "[object Error]", G = "[object Function]", _e = "[object GeneratorFunction]", we = "[object Map]", He = "[object Number]", nn = "[object Null]", Ze = "[object Object]", Un = "[object Promise]", Mn = "[object Proxy]", Sn = "[object RegExp]", an = "[object Set]", pn = "[object String]", Xe = "[object Symbol]", An = "[object Undefined]", Fn = "[object WeakMap]", Eo = "[object WeakSet]", ko = "[object ArrayBuffer]", Rn = "[object DataView]", Zn = "[object Float32Array]", To = "[object Float64Array]", K = "[object Int8Array]", te = "[object Int16Array]", Z = "[object Int32Array]", Re = "[object Uint8Array]", qe = "[object Uint8ClampedArray]", Ve = "[object Uint16Array]", Ne = "[object Uint32Array]", Ue = /\b__p \+= '';/g, yn = /\b(__p \+=) '' \+/g, jn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Jn = /&(?:amp|lt|gt|quot|#39);/g, fn = /[&<>"']/g, xt = RegExp(Jn.source), ds = RegExp(fn.source), $n = /<%-([\s\S]+?)%>/g, Le = /<%([\s\S]+?)%>/g, xn = /<%=([\s\S]+?)%>/g, lm = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, um = /^\w*$/, Am = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, fs = /[\\^$.*+?()[\]{}|]/g, dm = RegExp(fs.source), bs = /^\s+/, fm = /\s/, bm = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, pm = /\{\n\/\* \[wrapped with (.+)\] \*/, hm = /,? & /, gm = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, mm = /[()=,{}\[\]\/\s]/, vm = /\\(\\)?/g, ym = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, eA = /\w*$/, xm = /^[-+]0x[0-9a-f]+$/i, Cm = /^0b[01]+$/i, wm = /^\[object .+?Constructor\]$/, Em = /^0o[0-7]+$/i, km = /^(?:0|[1-9]\d*)$/, Sm = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, _r = /($^)/, Rm = /['\n\r\u2028\u2029\\]/g, Fr = "\\ud800-\\udfff", Bm = "\\u0300-\\u036f", _m = "\\ufe20-\\ufe2f", Fm = "\\u20d0-\\u20ff", nA = Bm + _m + Fm, oA = "\\u2700-\\u27bf", tA = "a-z\\xdf-\\xf6\\xf8-\\xff", Im = "\\xac\\xb1\\xd7\\xf7", Tm = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Om = "\\u2000-\\u206f", Um = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", aA = "A-Z\\xc0-\\xd6\\xd8-\\xde", rA = "\\ufe0e\\ufe0f", iA = Im + Tm + Om + Um, ps = "['’]", Km = "[" + Fr + "]", sA = "[" + iA + "]", Ir = "[" + nA + "]", cA = "\\d+", Pm = "[" + oA + "]", lA = "[" + tA + "]", uA = "[^" + Fr + iA + cA + oA + tA + aA + "]", hs = "\\ud83c[\\udffb-\\udfff]", Dm = "(?:" + Ir + "|" + hs + ")", AA = "[^" + Fr + "]", gs = "(?:\\ud83c[\\udde6-\\uddff]){2}", ms = "[\\ud800-\\udbff][\\udc00-\\udfff]", Zt = "[" + aA + "]", dA = "\\u200d", fA = "(?:" + lA + "|" + uA + ")", Lm = "(?:" + Zt + "|" + uA + ")", bA = "(?:" + ps + "(?:d|ll|m|re|s|t|ve))?", pA = "(?:" + ps + "(?:D|LL|M|RE|S|T|VE))?", hA = Dm + "?", gA = "[" + rA + "]?", Nm = "(?:" + dA + "(?:" + [AA, gs, ms].join("|") + ")" + gA + hA + ")*", Mm = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", jm = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", mA = gA + hA + Nm, $m = "(?:" + [Pm, gs, ms].join("|") + ")" + mA, Qm = "(?:" + [AA + Ir + "?", Ir, gs, ms, Km].join("|") + ")", Hm = RegExp(ps, "g"), Vm = RegExp(Ir, "g"), vs = RegExp(hs + "(?=" + hs + ")|" + Qm + mA, "g"), qm = RegExp([
      Zt + "?" + lA + "+" + bA + "(?=" + [sA, Zt, "$"].join("|") + ")",
      Lm + "+" + pA + "(?=" + [sA, Zt + fA, "$"].join("|") + ")",
      Zt + "?" + fA + "+" + bA,
      Zt + "+" + pA,
      jm,
      Mm,
      cA,
      $m
    ].join("|"), "g"), Wm = RegExp("[" + dA + Fr + nA + rA + "]"), Ym = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, zm = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Gm = -1, sn = {};
    sn[Zn] = sn[To] = sn[K] = sn[te] = sn[Z] = sn[Re] = sn[qe] = sn[Ve] = sn[Ne] = !0, sn[fe] = sn[ae] = sn[ko] = sn[pe] = sn[Rn] = sn[le] = sn[ge] = sn[G] = sn[we] = sn[He] = sn[Ze] = sn[Sn] = sn[an] = sn[pn] = sn[Fn] = !1;
    var rn = {};
    rn[fe] = rn[ae] = rn[ko] = rn[Rn] = rn[pe] = rn[le] = rn[Zn] = rn[To] = rn[K] = rn[te] = rn[Z] = rn[we] = rn[He] = rn[Ze] = rn[Sn] = rn[an] = rn[pn] = rn[Xe] = rn[Re] = rn[qe] = rn[Ve] = rn[Ne] = !0, rn[ge] = rn[G] = rn[Fn] = !1;
    var Zm = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Jm = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Xm = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, e0 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, n0 = parseFloat, o0 = parseInt, vA = typeof dt == "object" && dt && dt.Object === Object && dt, t0 = typeof self == "object" && self && self.Object === Object && self, Bn = vA || t0 || Function("return this")(), ys = e && !e.nodeType && e, Ct = ys && !0 && n && !n.nodeType && n, yA = Ct && Ct.exports === ys, xs = yA && vA.process, uo = function() {
      try {
        var I = Ct && Ct.require && Ct.require("util").types;
        return I || xs && xs.binding && xs.binding("util");
      } catch {
      }
    }(), xA = uo && uo.isArrayBuffer, CA = uo && uo.isDate, wA = uo && uo.isMap, EA = uo && uo.isRegExp, kA = uo && uo.isSet, SA = uo && uo.isTypedArray;
    function Xn(I, Q, N) {
      switch (N.length) {
        case 0:
          return I.call(Q);
        case 1:
          return I.call(Q, N[0]);
        case 2:
          return I.call(Q, N[0], N[1]);
        case 3:
          return I.call(Q, N[0], N[1], N[2]);
      }
      return I.apply(Q, N);
    }
    function a0(I, Q, N, he) {
      for (var Fe = -1, We = I == null ? 0 : I.length; ++Fe < We; ) {
        var mn = I[Fe];
        Q(he, mn, N(mn), I);
      }
      return he;
    }
    function Ao(I, Q) {
      for (var N = -1, he = I == null ? 0 : I.length; ++N < he && Q(I[N], N, I) !== !1; )
        ;
      return I;
    }
    function r0(I, Q) {
      for (var N = I == null ? 0 : I.length; N-- && Q(I[N], N, I) !== !1; )
        ;
      return I;
    }
    function RA(I, Q) {
      for (var N = -1, he = I == null ? 0 : I.length; ++N < he; )
        if (!Q(I[N], N, I))
          return !1;
      return !0;
    }
    function Xo(I, Q) {
      for (var N = -1, he = I == null ? 0 : I.length, Fe = 0, We = []; ++N < he; ) {
        var mn = I[N];
        Q(mn, N, I) && (We[Fe++] = mn);
      }
      return We;
    }
    function Tr(I, Q) {
      var N = I == null ? 0 : I.length;
      return !!N && Jt(I, Q, 0) > -1;
    }
    function Cs(I, Q, N) {
      for (var he = -1, Fe = I == null ? 0 : I.length; ++he < Fe; )
        if (N(Q, I[he]))
          return !0;
      return !1;
    }
    function ln(I, Q) {
      for (var N = -1, he = I == null ? 0 : I.length, Fe = Array(he); ++N < he; )
        Fe[N] = Q(I[N], N, I);
      return Fe;
    }
    function et(I, Q) {
      for (var N = -1, he = Q.length, Fe = I.length; ++N < he; )
        I[Fe + N] = Q[N];
      return I;
    }
    function ws(I, Q, N, he) {
      var Fe = -1, We = I == null ? 0 : I.length;
      for (he && We && (N = I[++Fe]); ++Fe < We; )
        N = Q(N, I[Fe], Fe, I);
      return N;
    }
    function i0(I, Q, N, he) {
      var Fe = I == null ? 0 : I.length;
      for (he && Fe && (N = I[--Fe]); Fe--; )
        N = Q(N, I[Fe], Fe, I);
      return N;
    }
    function Es(I, Q) {
      for (var N = -1, he = I == null ? 0 : I.length; ++N < he; )
        if (Q(I[N], N, I))
          return !0;
      return !1;
    }
    var s0 = ks("length");
    function c0(I) {
      return I.split("");
    }
    function l0(I) {
      return I.match(gm) || [];
    }
    function BA(I, Q, N) {
      var he;
      return N(I, function(Fe, We, mn) {
        if (Q(Fe, We, mn))
          return he = We, !1;
      }), he;
    }
    function Or(I, Q, N, he) {
      for (var Fe = I.length, We = N + (he ? 1 : -1); he ? We-- : ++We < Fe; )
        if (Q(I[We], We, I))
          return We;
      return -1;
    }
    function Jt(I, Q, N) {
      return Q === Q ? x0(I, Q, N) : Or(I, _A, N);
    }
    function u0(I, Q, N, he) {
      for (var Fe = N - 1, We = I.length; ++Fe < We; )
        if (he(I[Fe], Q))
          return Fe;
      return -1;
    }
    function _A(I) {
      return I !== I;
    }
    function FA(I, Q) {
      var N = I == null ? 0 : I.length;
      return N ? Rs(I, Q) / N : U;
    }
    function ks(I) {
      return function(Q) {
        return Q == null ? o : Q[I];
      };
    }
    function Ss(I) {
      return function(Q) {
        return I == null ? o : I[Q];
      };
    }
    function IA(I, Q, N, he, Fe) {
      return Fe(I, function(We, mn, on) {
        N = he ? (he = !1, We) : Q(N, We, mn, on);
      }), N;
    }
    function A0(I, Q) {
      var N = I.length;
      for (I.sort(Q); N--; )
        I[N] = I[N].value;
      return I;
    }
    function Rs(I, Q) {
      for (var N, he = -1, Fe = I.length; ++he < Fe; ) {
        var We = Q(I[he]);
        We !== o && (N = N === o ? We : N + We);
      }
      return N;
    }
    function Bs(I, Q) {
      for (var N = -1, he = Array(I); ++N < I; )
        he[N] = Q(N);
      return he;
    }
    function d0(I, Q) {
      return ln(Q, function(N) {
        return [N, I[N]];
      });
    }
    function TA(I) {
      return I && I.slice(0, PA(I) + 1).replace(bs, "");
    }
    function eo(I) {
      return function(Q) {
        return I(Q);
      };
    }
    function _s(I, Q) {
      return ln(Q, function(N) {
        return I[N];
      });
    }
    function Ma(I, Q) {
      return I.has(Q);
    }
    function OA(I, Q) {
      for (var N = -1, he = I.length; ++N < he && Jt(Q, I[N], 0) > -1; )
        ;
      return N;
    }
    function UA(I, Q) {
      for (var N = I.length; N-- && Jt(Q, I[N], 0) > -1; )
        ;
      return N;
    }
    function f0(I, Q) {
      for (var N = I.length, he = 0; N--; )
        I[N] === Q && ++he;
      return he;
    }
    var b0 = Ss(Zm), p0 = Ss(Jm);
    function h0(I) {
      return "\\" + e0[I];
    }
    function g0(I, Q) {
      return I == null ? o : I[Q];
    }
    function Xt(I) {
      return Wm.test(I);
    }
    function m0(I) {
      return Ym.test(I);
    }
    function v0(I) {
      for (var Q, N = []; !(Q = I.next()).done; )
        N.push(Q.value);
      return N;
    }
    function Fs(I) {
      var Q = -1, N = Array(I.size);
      return I.forEach(function(he, Fe) {
        N[++Q] = [Fe, he];
      }), N;
    }
    function KA(I, Q) {
      return function(N) {
        return I(Q(N));
      };
    }
    function nt(I, Q) {
      for (var N = -1, he = I.length, Fe = 0, We = []; ++N < he; ) {
        var mn = I[N];
        (mn === Q || mn === h) && (I[N] = h, We[Fe++] = N);
      }
      return We;
    }
    function Ur(I) {
      var Q = -1, N = Array(I.size);
      return I.forEach(function(he) {
        N[++Q] = he;
      }), N;
    }
    function y0(I) {
      var Q = -1, N = Array(I.size);
      return I.forEach(function(he) {
        N[++Q] = [he, he];
      }), N;
    }
    function x0(I, Q, N) {
      for (var he = N - 1, Fe = I.length; ++he < Fe; )
        if (I[he] === Q)
          return he;
      return -1;
    }
    function C0(I, Q, N) {
      for (var he = N + 1; he--; )
        if (I[he] === Q)
          return he;
      return he;
    }
    function ea(I) {
      return Xt(I) ? E0(I) : s0(I);
    }
    function So(I) {
      return Xt(I) ? k0(I) : c0(I);
    }
    function PA(I) {
      for (var Q = I.length; Q-- && fm.test(I.charAt(Q)); )
        ;
      return Q;
    }
    var w0 = Ss(Xm);
    function E0(I) {
      for (var Q = vs.lastIndex = 0; vs.test(I); )
        ++Q;
      return Q;
    }
    function k0(I) {
      return I.match(vs) || [];
    }
    function S0(I) {
      return I.match(qm) || [];
    }
    var R0 = function I(Q) {
      Q = Q == null ? Bn : na.defaults(Bn.Object(), Q, na.pick(Bn, zm));
      var N = Q.Array, he = Q.Date, Fe = Q.Error, We = Q.Function, mn = Q.Math, on = Q.Object, Is = Q.RegExp, B0 = Q.String, fo = Q.TypeError, Kr = N.prototype, _0 = We.prototype, oa = on.prototype, Pr = Q["__core-js_shared__"], Dr = _0.toString, Je = oa.hasOwnProperty, F0 = 0, DA = function() {
        var t = /[^.]+$/.exec(Pr && Pr.keys && Pr.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), Lr = oa.toString, I0 = Dr.call(on), T0 = Bn._, O0 = Is(
        "^" + Dr.call(Je).replace(fs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Nr = yA ? Q.Buffer : o, ot = Q.Symbol, Mr = Q.Uint8Array, LA = Nr ? Nr.allocUnsafe : o, jr = KA(on.getPrototypeOf, on), NA = on.create, MA = oa.propertyIsEnumerable, $r = Kr.splice, jA = ot ? ot.isConcatSpreadable : o, ja = ot ? ot.iterator : o, wt = ot ? ot.toStringTag : o, Qr = function() {
        try {
          var t = Bt(on, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), U0 = Q.clearTimeout !== Bn.clearTimeout && Q.clearTimeout, K0 = he && he.now !== Bn.Date.now && he.now, P0 = Q.setTimeout !== Bn.setTimeout && Q.setTimeout, Hr = mn.ceil, Vr = mn.floor, Ts = on.getOwnPropertySymbols, D0 = Nr ? Nr.isBuffer : o, $A = Q.isFinite, L0 = Kr.join, N0 = KA(on.keys, on), vn = mn.max, In = mn.min, M0 = he.now, j0 = Q.parseInt, QA = mn.random, $0 = Kr.reverse, Os = Bt(Q, "DataView"), $a = Bt(Q, "Map"), Us = Bt(Q, "Promise"), ta = Bt(Q, "Set"), Qa = Bt(Q, "WeakMap"), Ha = Bt(on, "create"), qr = Qa && new Qa(), aa = {}, Q0 = _t(Os), H0 = _t($a), V0 = _t(Us), q0 = _t(ta), W0 = _t(Qa), Wr = ot ? ot.prototype : o, Va = Wr ? Wr.valueOf : o, HA = Wr ? Wr.toString : o;
      function v(t) {
        if (bn(t) && !Ie(t) && !(t instanceof je)) {
          if (t instanceof bo)
            return t;
          if (Je.call(t, "__wrapped__"))
            return Vd(t);
        }
        return new bo(t);
      }
      var ra = /* @__PURE__ */ function() {
        function t() {
        }
        return function(r) {
          if (!dn(r))
            return {};
          if (NA)
            return NA(r);
          t.prototype = r;
          var l = new t();
          return t.prototype = o, l;
        };
      }();
      function Yr() {
      }
      function bo(t, r) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = o;
      }
      v.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: $n,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Le,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: xn,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: v
        }
      }, v.prototype = Yr.prototype, v.prototype.constructor = v, bo.prototype = ra(Yr.prototype), bo.prototype.constructor = bo;
      function je(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = L, this.__views__ = [];
      }
      function Y0() {
        var t = new je(this.__wrapped__);
        return t.__actions__ = Qn(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = Qn(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = Qn(this.__views__), t;
      }
      function z0() {
        if (this.__filtered__) {
          var t = new je(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function G0() {
        var t = this.__wrapped__.value(), r = this.__dir__, l = Ie(t), d = r < 0, g = l ? t.length : 0, x = c1(0, g, this.__views__), S = x.start, R = x.end, T = R - S, W = d ? R : S - 1, Y = this.__iteratees__, ee = Y.length, ue = 0, ve = In(T, this.__takeCount__);
        if (!l || !d && g == T && ve == T)
          return bd(t, this.__actions__);
        var Ee = [];
        e:
          for (; T-- && ue < ve; ) {
            W += r;
            for (var Ke = -1, ke = t[W]; ++Ke < ee; ) {
              var Me = Y[Ke], Qe = Me.iteratee, to = Me.type, Dn = Qe(ke);
              if (to == J)
                ke = Dn;
              else if (!Dn) {
                if (to == ne)
                  continue e;
                break e;
              }
            }
            Ee[ue++] = ke;
          }
        return Ee;
      }
      je.prototype = ra(Yr.prototype), je.prototype.constructor = je;
      function Et(t) {
        var r = -1, l = t == null ? 0 : t.length;
        for (this.clear(); ++r < l; ) {
          var d = t[r];
          this.set(d[0], d[1]);
        }
      }
      function Z0() {
        this.__data__ = Ha ? Ha(null) : {}, this.size = 0;
      }
      function J0(t) {
        var r = this.has(t) && delete this.__data__[t];
        return this.size -= r ? 1 : 0, r;
      }
      function X0(t) {
        var r = this.__data__;
        if (Ha) {
          var l = r[t];
          return l === A ? o : l;
        }
        return Je.call(r, t) ? r[t] : o;
      }
      function ev(t) {
        var r = this.__data__;
        return Ha ? r[t] !== o : Je.call(r, t);
      }
      function nv(t, r) {
        var l = this.__data__;
        return this.size += this.has(t) ? 0 : 1, l[t] = Ha && r === o ? A : r, this;
      }
      Et.prototype.clear = Z0, Et.prototype.delete = J0, Et.prototype.get = X0, Et.prototype.has = ev, Et.prototype.set = nv;
      function Lo(t) {
        var r = -1, l = t == null ? 0 : t.length;
        for (this.clear(); ++r < l; ) {
          var d = t[r];
          this.set(d[0], d[1]);
        }
      }
      function ov() {
        this.__data__ = [], this.size = 0;
      }
      function tv(t) {
        var r = this.__data__, l = zr(r, t);
        if (l < 0)
          return !1;
        var d = r.length - 1;
        return l == d ? r.pop() : $r.call(r, l, 1), --this.size, !0;
      }
      function av(t) {
        var r = this.__data__, l = zr(r, t);
        return l < 0 ? o : r[l][1];
      }
      function rv(t) {
        return zr(this.__data__, t) > -1;
      }
      function iv(t, r) {
        var l = this.__data__, d = zr(l, t);
        return d < 0 ? (++this.size, l.push([t, r])) : l[d][1] = r, this;
      }
      Lo.prototype.clear = ov, Lo.prototype.delete = tv, Lo.prototype.get = av, Lo.prototype.has = rv, Lo.prototype.set = iv;
      function No(t) {
        var r = -1, l = t == null ? 0 : t.length;
        for (this.clear(); ++r < l; ) {
          var d = t[r];
          this.set(d[0], d[1]);
        }
      }
      function sv() {
        this.size = 0, this.__data__ = {
          hash: new Et(),
          map: new ($a || Lo)(),
          string: new Et()
        };
      }
      function cv(t) {
        var r = si(this, t).delete(t);
        return this.size -= r ? 1 : 0, r;
      }
      function lv(t) {
        return si(this, t).get(t);
      }
      function uv(t) {
        return si(this, t).has(t);
      }
      function Av(t, r) {
        var l = si(this, t), d = l.size;
        return l.set(t, r), this.size += l.size == d ? 0 : 1, this;
      }
      No.prototype.clear = sv, No.prototype.delete = cv, No.prototype.get = lv, No.prototype.has = uv, No.prototype.set = Av;
      function kt(t) {
        var r = -1, l = t == null ? 0 : t.length;
        for (this.__data__ = new No(); ++r < l; )
          this.add(t[r]);
      }
      function dv(t) {
        return this.__data__.set(t, A), this;
      }
      function fv(t) {
        return this.__data__.has(t);
      }
      kt.prototype.add = kt.prototype.push = dv, kt.prototype.has = fv;
      function Ro(t) {
        var r = this.__data__ = new Lo(t);
        this.size = r.size;
      }
      function bv() {
        this.__data__ = new Lo(), this.size = 0;
      }
      function pv(t) {
        var r = this.__data__, l = r.delete(t);
        return this.size = r.size, l;
      }
      function hv(t) {
        return this.__data__.get(t);
      }
      function gv(t) {
        return this.__data__.has(t);
      }
      function mv(t, r) {
        var l = this.__data__;
        if (l instanceof Lo) {
          var d = l.__data__;
          if (!$a || d.length < i - 1)
            return d.push([t, r]), this.size = ++l.size, this;
          l = this.__data__ = new No(d);
        }
        return l.set(t, r), this.size = l.size, this;
      }
      Ro.prototype.clear = bv, Ro.prototype.delete = pv, Ro.prototype.get = hv, Ro.prototype.has = gv, Ro.prototype.set = mv;
      function VA(t, r) {
        var l = Ie(t), d = !l && Ft(t), g = !l && !d && st(t), x = !l && !d && !g && la(t), S = l || d || g || x, R = S ? Bs(t.length, B0) : [], T = R.length;
        for (var W in t)
          (r || Je.call(t, W)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
          (W == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          g && (W == "offset" || W == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          x && (W == "buffer" || W == "byteLength" || W == "byteOffset") || // Skip index properties.
          Qo(W, T))) && R.push(W);
        return R;
      }
      function qA(t) {
        var r = t.length;
        return r ? t[Vs(0, r - 1)] : o;
      }
      function vv(t, r) {
        return ci(Qn(t), St(r, 0, t.length));
      }
      function yv(t) {
        return ci(Qn(t));
      }
      function Ks(t, r, l) {
        (l !== o && !Bo(t[r], l) || l === o && !(r in t)) && Mo(t, r, l);
      }
      function qa(t, r, l) {
        var d = t[r];
        (!(Je.call(t, r) && Bo(d, l)) || l === o && !(r in t)) && Mo(t, r, l);
      }
      function zr(t, r) {
        for (var l = t.length; l--; )
          if (Bo(t[l][0], r))
            return l;
        return -1;
      }
      function xv(t, r, l, d) {
        return tt(t, function(g, x, S) {
          r(d, g, l(g), S);
        }), d;
      }
      function WA(t, r) {
        return t && Uo(r, Cn(r), t);
      }
      function Cv(t, r) {
        return t && Uo(r, Vn(r), t);
      }
      function Mo(t, r, l) {
        r == "__proto__" && Qr ? Qr(t, r, {
          configurable: !0,
          enumerable: !0,
          value: l,
          writable: !0
        }) : t[r] = l;
      }
      function Ps(t, r) {
        for (var l = -1, d = r.length, g = N(d), x = t == null; ++l < d; )
          g[l] = x ? o : hc(t, r[l]);
        return g;
      }
      function St(t, r, l) {
        return t === t && (l !== o && (t = t <= l ? t : l), r !== o && (t = t >= r ? t : r)), t;
      }
      function po(t, r, l, d, g, x) {
        var S, R = r & m, T = r & E, W = r & y;
        if (l && (S = g ? l(t, d, g, x) : l(t)), S !== o)
          return S;
        if (!dn(t))
          return t;
        var Y = Ie(t);
        if (Y) {
          if (S = u1(t), !R)
            return Qn(t, S);
        } else {
          var ee = Tn(t), ue = ee == G || ee == _e;
          if (st(t))
            return gd(t, R);
          if (ee == Ze || ee == fe || ue && !g) {
            if (S = T || ue ? {} : Pd(t), !R)
              return T ? Xv(t, Cv(S, t)) : Jv(t, WA(S, t));
          } else {
            if (!rn[ee])
              return g ? t : {};
            S = A1(t, ee, R);
          }
        }
        x || (x = new Ro());
        var ve = x.get(t);
        if (ve)
          return ve;
        x.set(t, S), df(t) ? t.forEach(function(ke) {
          S.add(po(ke, r, l, ke, t, x));
        }) : uf(t) && t.forEach(function(ke, Me) {
          S.set(Me, po(ke, r, l, Me, t, x));
        });
        var Ee = W ? T ? oc : nc : T ? Vn : Cn, Ke = Y ? o : Ee(t);
        return Ao(Ke || t, function(ke, Me) {
          Ke && (Me = ke, ke = t[Me]), qa(S, Me, po(ke, r, l, Me, t, x));
        }), S;
      }
      function wv(t) {
        var r = Cn(t);
        return function(l) {
          return YA(l, t, r);
        };
      }
      function YA(t, r, l) {
        var d = l.length;
        if (t == null)
          return !d;
        for (t = on(t); d--; ) {
          var g = l[d], x = r[g], S = t[g];
          if (S === o && !(g in t) || !x(S))
            return !1;
        }
        return !0;
      }
      function zA(t, r, l) {
        if (typeof t != "function")
          throw new fo(c);
        return Xa(function() {
          t.apply(o, l);
        }, r);
      }
      function Wa(t, r, l, d) {
        var g = -1, x = Tr, S = !0, R = t.length, T = [], W = r.length;
        if (!R)
          return T;
        l && (r = ln(r, eo(l))), d ? (x = Cs, S = !1) : r.length >= i && (x = Ma, S = !1, r = new kt(r));
        e:
          for (; ++g < R; ) {
            var Y = t[g], ee = l == null ? Y : l(Y);
            if (Y = d || Y !== 0 ? Y : 0, S && ee === ee) {
              for (var ue = W; ue--; )
                if (r[ue] === ee)
                  continue e;
              T.push(Y);
            } else
              x(r, ee, d) || T.push(Y);
          }
        return T;
      }
      var tt = Cd(Oo), GA = Cd(Ls, !0);
      function Ev(t, r) {
        var l = !0;
        return tt(t, function(d, g, x) {
          return l = !!r(d, g, x), l;
        }), l;
      }
      function Gr(t, r, l) {
        for (var d = -1, g = t.length; ++d < g; ) {
          var x = t[d], S = r(x);
          if (S != null && (R === o ? S === S && !oo(S) : l(S, R)))
            var R = S, T = x;
        }
        return T;
      }
      function kv(t, r, l, d) {
        var g = t.length;
        for (l = Oe(l), l < 0 && (l = -l > g ? 0 : g + l), d = d === o || d > g ? g : Oe(d), d < 0 && (d += g), d = l > d ? 0 : bf(d); l < d; )
          t[l++] = r;
        return t;
      }
      function ZA(t, r) {
        var l = [];
        return tt(t, function(d, g, x) {
          r(d, g, x) && l.push(d);
        }), l;
      }
      function _n(t, r, l, d, g) {
        var x = -1, S = t.length;
        for (l || (l = f1), g || (g = []); ++x < S; ) {
          var R = t[x];
          r > 0 && l(R) ? r > 1 ? _n(R, r - 1, l, d, g) : et(g, R) : d || (g[g.length] = R);
        }
        return g;
      }
      var Ds = wd(), JA = wd(!0);
      function Oo(t, r) {
        return t && Ds(t, r, Cn);
      }
      function Ls(t, r) {
        return t && JA(t, r, Cn);
      }
      function Zr(t, r) {
        return Xo(r, function(l) {
          return Ho(t[l]);
        });
      }
      function Rt(t, r) {
        r = rt(r, t);
        for (var l = 0, d = r.length; t != null && l < d; )
          t = t[Ko(r[l++])];
        return l && l == d ? t : o;
      }
      function XA(t, r, l) {
        var d = r(t);
        return Ie(t) ? d : et(d, l(t));
      }
      function Kn(t) {
        return t == null ? t === o ? An : nn : wt && wt in on(t) ? s1(t) : y1(t);
      }
      function Ns(t, r) {
        return t > r;
      }
      function Sv(t, r) {
        return t != null && Je.call(t, r);
      }
      function Rv(t, r) {
        return t != null && r in on(t);
      }
      function Bv(t, r, l) {
        return t >= In(r, l) && t < vn(r, l);
      }
      function Ms(t, r, l) {
        for (var d = l ? Cs : Tr, g = t[0].length, x = t.length, S = x, R = N(x), T = 1 / 0, W = []; S--; ) {
          var Y = t[S];
          S && r && (Y = ln(Y, eo(r))), T = In(Y.length, T), R[S] = !l && (r || g >= 120 && Y.length >= 120) ? new kt(S && Y) : o;
        }
        Y = t[0];
        var ee = -1, ue = R[0];
        e:
          for (; ++ee < g && W.length < T; ) {
            var ve = Y[ee], Ee = r ? r(ve) : ve;
            if (ve = l || ve !== 0 ? ve : 0, !(ue ? Ma(ue, Ee) : d(W, Ee, l))) {
              for (S = x; --S; ) {
                var Ke = R[S];
                if (!(Ke ? Ma(Ke, Ee) : d(t[S], Ee, l)))
                  continue e;
              }
              ue && ue.push(Ee), W.push(ve);
            }
          }
        return W;
      }
      function _v(t, r, l, d) {
        return Oo(t, function(g, x, S) {
          r(d, l(g), x, S);
        }), d;
      }
      function Ya(t, r, l) {
        r = rt(r, t), t = Md(t, r);
        var d = t == null ? t : t[Ko(go(r))];
        return d == null ? o : Xn(d, t, l);
      }
      function ed(t) {
        return bn(t) && Kn(t) == fe;
      }
      function Fv(t) {
        return bn(t) && Kn(t) == ko;
      }
      function Iv(t) {
        return bn(t) && Kn(t) == le;
      }
      function za(t, r, l, d, g) {
        return t === r ? !0 : t == null || r == null || !bn(t) && !bn(r) ? t !== t && r !== r : Tv(t, r, l, d, za, g);
      }
      function Tv(t, r, l, d, g, x) {
        var S = Ie(t), R = Ie(r), T = S ? ae : Tn(t), W = R ? ae : Tn(r);
        T = T == fe ? Ze : T, W = W == fe ? Ze : W;
        var Y = T == Ze, ee = W == Ze, ue = T == W;
        if (ue && st(t)) {
          if (!st(r))
            return !1;
          S = !0, Y = !1;
        }
        if (ue && !Y)
          return x || (x = new Ro()), S || la(t) ? Od(t, r, l, d, g, x) : r1(t, r, T, l, d, g, x);
        if (!(l & k)) {
          var ve = Y && Je.call(t, "__wrapped__"), Ee = ee && Je.call(r, "__wrapped__");
          if (ve || Ee) {
            var Ke = ve ? t.value() : t, ke = Ee ? r.value() : r;
            return x || (x = new Ro()), g(Ke, ke, l, d, x);
          }
        }
        return ue ? (x || (x = new Ro()), i1(t, r, l, d, g, x)) : !1;
      }
      function Ov(t) {
        return bn(t) && Tn(t) == we;
      }
      function js(t, r, l, d) {
        var g = l.length, x = g, S = !d;
        if (t == null)
          return !x;
        for (t = on(t); g--; ) {
          var R = l[g];
          if (S && R[2] ? R[1] !== t[R[0]] : !(R[0] in t))
            return !1;
        }
        for (; ++g < x; ) {
          R = l[g];
          var T = R[0], W = t[T], Y = R[1];
          if (S && R[2]) {
            if (W === o && !(T in t))
              return !1;
          } else {
            var ee = new Ro();
            if (d)
              var ue = d(W, Y, T, t, r, ee);
            if (!(ue === o ? za(Y, W, k | w, d, ee) : ue))
              return !1;
          }
        }
        return !0;
      }
      function nd(t) {
        if (!dn(t) || p1(t))
          return !1;
        var r = Ho(t) ? O0 : wm;
        return r.test(_t(t));
      }
      function Uv(t) {
        return bn(t) && Kn(t) == Sn;
      }
      function Kv(t) {
        return bn(t) && Tn(t) == an;
      }
      function Pv(t) {
        return bn(t) && bi(t.length) && !!sn[Kn(t)];
      }
      function od(t) {
        return typeof t == "function" ? t : t == null ? qn : typeof t == "object" ? Ie(t) ? rd(t[0], t[1]) : ad(t) : kf(t);
      }
      function $s(t) {
        if (!Ja(t))
          return N0(t);
        var r = [];
        for (var l in on(t))
          Je.call(t, l) && l != "constructor" && r.push(l);
        return r;
      }
      function Dv(t) {
        if (!dn(t))
          return v1(t);
        var r = Ja(t), l = [];
        for (var d in t)
          d == "constructor" && (r || !Je.call(t, d)) || l.push(d);
        return l;
      }
      function Qs(t, r) {
        return t < r;
      }
      function td(t, r) {
        var l = -1, d = Hn(t) ? N(t.length) : [];
        return tt(t, function(g, x, S) {
          d[++l] = r(g, x, S);
        }), d;
      }
      function ad(t) {
        var r = ac(t);
        return r.length == 1 && r[0][2] ? Ld(r[0][0], r[0][1]) : function(l) {
          return l === t || js(l, t, r);
        };
      }
      function rd(t, r) {
        return ic(t) && Dd(r) ? Ld(Ko(t), r) : function(l) {
          var d = hc(l, t);
          return d === o && d === r ? gc(l, t) : za(r, d, k | w);
        };
      }
      function Jr(t, r, l, d, g) {
        t !== r && Ds(r, function(x, S) {
          if (g || (g = new Ro()), dn(x))
            Lv(t, r, S, l, Jr, d, g);
          else {
            var R = d ? d(cc(t, S), x, S + "", t, r, g) : o;
            R === o && (R = x), Ks(t, S, R);
          }
        }, Vn);
      }
      function Lv(t, r, l, d, g, x, S) {
        var R = cc(t, l), T = cc(r, l), W = S.get(T);
        if (W) {
          Ks(t, l, W);
          return;
        }
        var Y = x ? x(R, T, l + "", t, r, S) : o, ee = Y === o;
        if (ee) {
          var ue = Ie(T), ve = !ue && st(T), Ee = !ue && !ve && la(T);
          Y = T, ue || ve || Ee ? Ie(R) ? Y = R : hn(R) ? Y = Qn(R) : ve ? (ee = !1, Y = gd(T, !0)) : Ee ? (ee = !1, Y = md(T, !0)) : Y = [] : er(T) || Ft(T) ? (Y = R, Ft(R) ? Y = pf(R) : (!dn(R) || Ho(R)) && (Y = Pd(T))) : ee = !1;
        }
        ee && (S.set(T, Y), g(Y, T, d, x, S), S.delete(T)), Ks(t, l, Y);
      }
      function id(t, r) {
        var l = t.length;
        if (l)
          return r += r < 0 ? l : 0, Qo(r, l) ? t[r] : o;
      }
      function sd(t, r, l) {
        r.length ? r = ln(r, function(x) {
          return Ie(x) ? function(S) {
            return Rt(S, x.length === 1 ? x[0] : x);
          } : x;
        }) : r = [qn];
        var d = -1;
        r = ln(r, eo(ye()));
        var g = td(t, function(x, S, R) {
          var T = ln(r, function(W) {
            return W(x);
          });
          return { criteria: T, index: ++d, value: x };
        });
        return A0(g, function(x, S) {
          return Zv(x, S, l);
        });
      }
      function Nv(t, r) {
        return cd(t, r, function(l, d) {
          return gc(t, d);
        });
      }
      function cd(t, r, l) {
        for (var d = -1, g = r.length, x = {}; ++d < g; ) {
          var S = r[d], R = Rt(t, S);
          l(R, S) && Ga(x, rt(S, t), R);
        }
        return x;
      }
      function Mv(t) {
        return function(r) {
          return Rt(r, t);
        };
      }
      function Hs(t, r, l, d) {
        var g = d ? u0 : Jt, x = -1, S = r.length, R = t;
        for (t === r && (r = Qn(r)), l && (R = ln(t, eo(l))); ++x < S; )
          for (var T = 0, W = r[x], Y = l ? l(W) : W; (T = g(R, Y, T, d)) > -1; )
            R !== t && $r.call(R, T, 1), $r.call(t, T, 1);
        return t;
      }
      function ld(t, r) {
        for (var l = t ? r.length : 0, d = l - 1; l--; ) {
          var g = r[l];
          if (l == d || g !== x) {
            var x = g;
            Qo(g) ? $r.call(t, g, 1) : Ys(t, g);
          }
        }
        return t;
      }
      function Vs(t, r) {
        return t + Vr(QA() * (r - t + 1));
      }
      function jv(t, r, l, d) {
        for (var g = -1, x = vn(Hr((r - t) / (l || 1)), 0), S = N(x); x--; )
          S[d ? x : ++g] = t, t += l;
        return S;
      }
      function qs(t, r) {
        var l = "";
        if (!t || r < 1 || r > q)
          return l;
        do
          r % 2 && (l += t), r = Vr(r / 2), r && (t += t);
        while (r);
        return l;
      }
      function De(t, r) {
        return lc(Nd(t, r, qn), t + "");
      }
      function $v(t) {
        return qA(ua(t));
      }
      function Qv(t, r) {
        var l = ua(t);
        return ci(l, St(r, 0, l.length));
      }
      function Ga(t, r, l, d) {
        if (!dn(t))
          return t;
        r = rt(r, t);
        for (var g = -1, x = r.length, S = x - 1, R = t; R != null && ++g < x; ) {
          var T = Ko(r[g]), W = l;
          if (T === "__proto__" || T === "constructor" || T === "prototype")
            return t;
          if (g != S) {
            var Y = R[T];
            W = d ? d(Y, T, R) : o, W === o && (W = dn(Y) ? Y : Qo(r[g + 1]) ? [] : {});
          }
          qa(R, T, W), R = R[T];
        }
        return t;
      }
      var ud = qr ? function(t, r) {
        return qr.set(t, r), t;
      } : qn, Hv = Qr ? function(t, r) {
        return Qr(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: vc(r),
          writable: !0
        });
      } : qn;
      function Vv(t) {
        return ci(ua(t));
      }
      function ho(t, r, l) {
        var d = -1, g = t.length;
        r < 0 && (r = -r > g ? 0 : g + r), l = l > g ? g : l, l < 0 && (l += g), g = r > l ? 0 : l - r >>> 0, r >>>= 0;
        for (var x = N(g); ++d < g; )
          x[d] = t[d + r];
        return x;
      }
      function qv(t, r) {
        var l;
        return tt(t, function(d, g, x) {
          return l = r(d, g, x), !l;
        }), !!l;
      }
      function Xr(t, r, l) {
        var d = 0, g = t == null ? d : t.length;
        if (typeof r == "number" && r === r && g <= re) {
          for (; d < g; ) {
            var x = d + g >>> 1, S = t[x];
            S !== null && !oo(S) && (l ? S <= r : S < r) ? d = x + 1 : g = x;
          }
          return g;
        }
        return Ws(t, r, qn, l);
      }
      function Ws(t, r, l, d) {
        var g = 0, x = t == null ? 0 : t.length;
        if (x === 0)
          return 0;
        r = l(r);
        for (var S = r !== r, R = r === null, T = oo(r), W = r === o; g < x; ) {
          var Y = Vr((g + x) / 2), ee = l(t[Y]), ue = ee !== o, ve = ee === null, Ee = ee === ee, Ke = oo(ee);
          if (S)
            var ke = d || Ee;
          else
            W ? ke = Ee && (d || ue) : R ? ke = Ee && ue && (d || !ve) : T ? ke = Ee && ue && !ve && (d || !Ke) : ve || Ke ? ke = !1 : ke = d ? ee <= r : ee < r;
          ke ? g = Y + 1 : x = Y;
        }
        return In(x, oe);
      }
      function Ad(t, r) {
        for (var l = -1, d = t.length, g = 0, x = []; ++l < d; ) {
          var S = t[l], R = r ? r(S) : S;
          if (!l || !Bo(R, T)) {
            var T = R;
            x[g++] = S === 0 ? 0 : S;
          }
        }
        return x;
      }
      function dd(t) {
        return typeof t == "number" ? t : oo(t) ? U : +t;
      }
      function no(t) {
        if (typeof t == "string")
          return t;
        if (Ie(t))
          return ln(t, no) + "";
        if (oo(t))
          return HA ? HA.call(t) : "";
        var r = t + "";
        return r == "0" && 1 / t == -z ? "-0" : r;
      }
      function at(t, r, l) {
        var d = -1, g = Tr, x = t.length, S = !0, R = [], T = R;
        if (l)
          S = !1, g = Cs;
        else if (x >= i) {
          var W = r ? null : t1(t);
          if (W)
            return Ur(W);
          S = !1, g = Ma, T = new kt();
        } else
          T = r ? [] : R;
        e:
          for (; ++d < x; ) {
            var Y = t[d], ee = r ? r(Y) : Y;
            if (Y = l || Y !== 0 ? Y : 0, S && ee === ee) {
              for (var ue = T.length; ue--; )
                if (T[ue] === ee)
                  continue e;
              r && T.push(ee), R.push(Y);
            } else
              g(T, ee, l) || (T !== R && T.push(ee), R.push(Y));
          }
        return R;
      }
      function Ys(t, r) {
        return r = rt(r, t), t = Md(t, r), t == null || delete t[Ko(go(r))];
      }
      function fd(t, r, l, d) {
        return Ga(t, r, l(Rt(t, r)), d);
      }
      function ei(t, r, l, d) {
        for (var g = t.length, x = d ? g : -1; (d ? x-- : ++x < g) && r(t[x], x, t); )
          ;
        return l ? ho(t, d ? 0 : x, d ? x + 1 : g) : ho(t, d ? x + 1 : 0, d ? g : x);
      }
      function bd(t, r) {
        var l = t;
        return l instanceof je && (l = l.value()), ws(r, function(d, g) {
          return g.func.apply(g.thisArg, et([d], g.args));
        }, l);
      }
      function zs(t, r, l) {
        var d = t.length;
        if (d < 2)
          return d ? at(t[0]) : [];
        for (var g = -1, x = N(d); ++g < d; )
          for (var S = t[g], R = -1; ++R < d; )
            R != g && (x[g] = Wa(x[g] || S, t[R], r, l));
        return at(_n(x, 1), r, l);
      }
      function pd(t, r, l) {
        for (var d = -1, g = t.length, x = r.length, S = {}; ++d < g; ) {
          var R = d < x ? r[d] : o;
          l(S, t[d], R);
        }
        return S;
      }
      function Gs(t) {
        return hn(t) ? t : [];
      }
      function Zs(t) {
        return typeof t == "function" ? t : qn;
      }
      function rt(t, r) {
        return Ie(t) ? t : ic(t, r) ? [t] : Hd(Ye(t));
      }
      var Wv = De;
      function it(t, r, l) {
        var d = t.length;
        return l = l === o ? d : l, !r && l >= d ? t : ho(t, r, l);
      }
      var hd = U0 || function(t) {
        return Bn.clearTimeout(t);
      };
      function gd(t, r) {
        if (r)
          return t.slice();
        var l = t.length, d = LA ? LA(l) : new t.constructor(l);
        return t.copy(d), d;
      }
      function Js(t) {
        var r = new t.constructor(t.byteLength);
        return new Mr(r).set(new Mr(t)), r;
      }
      function Yv(t, r) {
        var l = r ? Js(t.buffer) : t.buffer;
        return new t.constructor(l, t.byteOffset, t.byteLength);
      }
      function zv(t) {
        var r = new t.constructor(t.source, eA.exec(t));
        return r.lastIndex = t.lastIndex, r;
      }
      function Gv(t) {
        return Va ? on(Va.call(t)) : {};
      }
      function md(t, r) {
        var l = r ? Js(t.buffer) : t.buffer;
        return new t.constructor(l, t.byteOffset, t.length);
      }
      function vd(t, r) {
        if (t !== r) {
          var l = t !== o, d = t === null, g = t === t, x = oo(t), S = r !== o, R = r === null, T = r === r, W = oo(r);
          if (!R && !W && !x && t > r || x && S && T && !R && !W || d && S && T || !l && T || !g)
            return 1;
          if (!d && !x && !W && t < r || W && l && g && !d && !x || R && l && g || !S && g || !T)
            return -1;
        }
        return 0;
      }
      function Zv(t, r, l) {
        for (var d = -1, g = t.criteria, x = r.criteria, S = g.length, R = l.length; ++d < S; ) {
          var T = vd(g[d], x[d]);
          if (T) {
            if (d >= R)
              return T;
            var W = l[d];
            return T * (W == "desc" ? -1 : 1);
          }
        }
        return t.index - r.index;
      }
      function yd(t, r, l, d) {
        for (var g = -1, x = t.length, S = l.length, R = -1, T = r.length, W = vn(x - S, 0), Y = N(T + W), ee = !d; ++R < T; )
          Y[R] = r[R];
        for (; ++g < S; )
          (ee || g < x) && (Y[l[g]] = t[g]);
        for (; W--; )
          Y[R++] = t[g++];
        return Y;
      }
      function xd(t, r, l, d) {
        for (var g = -1, x = t.length, S = -1, R = l.length, T = -1, W = r.length, Y = vn(x - R, 0), ee = N(Y + W), ue = !d; ++g < Y; )
          ee[g] = t[g];
        for (var ve = g; ++T < W; )
          ee[ve + T] = r[T];
        for (; ++S < R; )
          (ue || g < x) && (ee[ve + l[S]] = t[g++]);
        return ee;
      }
      function Qn(t, r) {
        var l = -1, d = t.length;
        for (r || (r = N(d)); ++l < d; )
          r[l] = t[l];
        return r;
      }
      function Uo(t, r, l, d) {
        var g = !l;
        l || (l = {});
        for (var x = -1, S = r.length; ++x < S; ) {
          var R = r[x], T = d ? d(l[R], t[R], R, l, t) : o;
          T === o && (T = t[R]), g ? Mo(l, R, T) : qa(l, R, T);
        }
        return l;
      }
      function Jv(t, r) {
        return Uo(t, rc(t), r);
      }
      function Xv(t, r) {
        return Uo(t, Ud(t), r);
      }
      function ni(t, r) {
        return function(l, d) {
          var g = Ie(l) ? a0 : xv, x = r ? r() : {};
          return g(l, t, ye(d, 2), x);
        };
      }
      function ia(t) {
        return De(function(r, l) {
          var d = -1, g = l.length, x = g > 1 ? l[g - 1] : o, S = g > 2 ? l[2] : o;
          for (x = t.length > 3 && typeof x == "function" ? (g--, x) : o, S && Pn(l[0], l[1], S) && (x = g < 3 ? o : x, g = 1), r = on(r); ++d < g; ) {
            var R = l[d];
            R && t(r, R, d, x);
          }
          return r;
        });
      }
      function Cd(t, r) {
        return function(l, d) {
          if (l == null)
            return l;
          if (!Hn(l))
            return t(l, d);
          for (var g = l.length, x = r ? g : -1, S = on(l); (r ? x-- : ++x < g) && d(S[x], x, S) !== !1; )
            ;
          return l;
        };
      }
      function wd(t) {
        return function(r, l, d) {
          for (var g = -1, x = on(r), S = d(r), R = S.length; R--; ) {
            var T = S[t ? R : ++g];
            if (l(x[T], T, x) === !1)
              break;
          }
          return r;
        };
      }
      function e1(t, r, l) {
        var d = r & _, g = Za(t);
        function x() {
          var S = this && this !== Bn && this instanceof x ? g : t;
          return S.apply(d ? l : this, arguments);
        }
        return x;
      }
      function Ed(t) {
        return function(r) {
          r = Ye(r);
          var l = Xt(r) ? So(r) : o, d = l ? l[0] : r.charAt(0), g = l ? it(l, 1).join("") : r.slice(1);
          return d[t]() + g;
        };
      }
      function sa(t) {
        return function(r) {
          return ws(wf(Cf(r).replace(Hm, "")), t, "");
        };
      }
      function Za(t) {
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return new t();
            case 1:
              return new t(r[0]);
            case 2:
              return new t(r[0], r[1]);
            case 3:
              return new t(r[0], r[1], r[2]);
            case 4:
              return new t(r[0], r[1], r[2], r[3]);
            case 5:
              return new t(r[0], r[1], r[2], r[3], r[4]);
            case 6:
              return new t(r[0], r[1], r[2], r[3], r[4], r[5]);
            case 7:
              return new t(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
          }
          var l = ra(t.prototype), d = t.apply(l, r);
          return dn(d) ? d : l;
        };
      }
      function n1(t, r, l) {
        var d = Za(t);
        function g() {
          for (var x = arguments.length, S = N(x), R = x, T = ca(g); R--; )
            S[R] = arguments[R];
          var W = x < 3 && S[0] !== T && S[x - 1] !== T ? [] : nt(S, T);
          if (x -= W.length, x < l)
            return _d(
              t,
              r,
              oi,
              g.placeholder,
              o,
              S,
              W,
              o,
              o,
              l - x
            );
          var Y = this && this !== Bn && this instanceof g ? d : t;
          return Xn(Y, this, S);
        }
        return g;
      }
      function kd(t) {
        return function(r, l, d) {
          var g = on(r);
          if (!Hn(r)) {
            var x = ye(l, 3);
            r = Cn(r), l = function(R) {
              return x(g[R], R, g);
            };
          }
          var S = t(r, l, d);
          return S > -1 ? g[x ? r[S] : S] : o;
        };
      }
      function Sd(t) {
        return $o(function(r) {
          var l = r.length, d = l, g = bo.prototype.thru;
          for (t && r.reverse(); d--; ) {
            var x = r[d];
            if (typeof x != "function")
              throw new fo(c);
            if (g && !S && ii(x) == "wrapper")
              var S = new bo([], !0);
          }
          for (d = S ? d : l; ++d < l; ) {
            x = r[d];
            var R = ii(x), T = R == "wrapper" ? tc(x) : o;
            T && sc(T[0]) && T[1] == (H | P | B | X) && !T[4].length && T[9] == 1 ? S = S[ii(T[0])].apply(S, T[3]) : S = x.length == 1 && sc(x) ? S[R]() : S.thru(x);
          }
          return function() {
            var W = arguments, Y = W[0];
            if (S && W.length == 1 && Ie(Y))
              return S.plant(Y).value();
            for (var ee = 0, ue = l ? r[ee].apply(this, W) : Y; ++ee < l; )
              ue = r[ee].call(this, ue);
            return ue;
          };
        });
      }
      function oi(t, r, l, d, g, x, S, R, T, W) {
        var Y = r & H, ee = r & _, ue = r & O, ve = r & (P | M), Ee = r & ce, Ke = ue ? o : Za(t);
        function ke() {
          for (var Me = arguments.length, Qe = N(Me), to = Me; to--; )
            Qe[to] = arguments[to];
          if (ve)
            var Dn = ca(ke), ao = f0(Qe, Dn);
          if (d && (Qe = yd(Qe, d, g, ve)), x && (Qe = xd(Qe, x, S, ve)), Me -= ao, ve && Me < W) {
            var gn = nt(Qe, Dn);
            return _d(
              t,
              r,
              oi,
              ke.placeholder,
              l,
              Qe,
              gn,
              R,
              T,
              W - Me
            );
          }
          var _o = ee ? l : this, qo = ue ? _o[t] : t;
          return Me = Qe.length, R ? Qe = x1(Qe, R) : Ee && Me > 1 && Qe.reverse(), Y && T < Me && (Qe.length = T), this && this !== Bn && this instanceof ke && (qo = Ke || Za(qo)), qo.apply(_o, Qe);
        }
        return ke;
      }
      function Rd(t, r) {
        return function(l, d) {
          return _v(l, t, r(d), {});
        };
      }
      function ti(t, r) {
        return function(l, d) {
          var g;
          if (l === o && d === o)
            return r;
          if (l !== o && (g = l), d !== o) {
            if (g === o)
              return d;
            typeof l == "string" || typeof d == "string" ? (l = no(l), d = no(d)) : (l = dd(l), d = dd(d)), g = t(l, d);
          }
          return g;
        };
      }
      function Xs(t) {
        return $o(function(r) {
          return r = ln(r, eo(ye())), De(function(l) {
            var d = this;
            return t(r, function(g) {
              return Xn(g, d, l);
            });
          });
        });
      }
      function ai(t, r) {
        r = r === o ? " " : no(r);
        var l = r.length;
        if (l < 2)
          return l ? qs(r, t) : r;
        var d = qs(r, Hr(t / ea(r)));
        return Xt(r) ? it(So(d), 0, t).join("") : d.slice(0, t);
      }
      function o1(t, r, l, d) {
        var g = r & _, x = Za(t);
        function S() {
          for (var R = -1, T = arguments.length, W = -1, Y = d.length, ee = N(Y + T), ue = this && this !== Bn && this instanceof S ? x : t; ++W < Y; )
            ee[W] = d[W];
          for (; T--; )
            ee[W++] = arguments[++R];
          return Xn(ue, g ? l : this, ee);
        }
        return S;
      }
      function Bd(t) {
        return function(r, l, d) {
          return d && typeof d != "number" && Pn(r, l, d) && (l = d = o), r = Vo(r), l === o ? (l = r, r = 0) : l = Vo(l), d = d === o ? r < l ? 1 : -1 : Vo(d), jv(r, l, d, t);
        };
      }
      function ri(t) {
        return function(r, l) {
          return typeof r == "string" && typeof l == "string" || (r = mo(r), l = mo(l)), t(r, l);
        };
      }
      function _d(t, r, l, d, g, x, S, R, T, W) {
        var Y = r & P, ee = Y ? S : o, ue = Y ? o : S, ve = Y ? x : o, Ee = Y ? o : x;
        r |= Y ? B : D, r &= ~(Y ? D : B), r & F || (r &= ~(_ | O));
        var Ke = [
          t,
          r,
          g,
          ve,
          ee,
          Ee,
          ue,
          R,
          T,
          W
        ], ke = l.apply(o, Ke);
        return sc(t) && jd(ke, Ke), ke.placeholder = d, $d(ke, t, r);
      }
      function ec(t) {
        var r = mn[t];
        return function(l, d) {
          if (l = mo(l), d = d == null ? 0 : In(Oe(d), 292), d && $A(l)) {
            var g = (Ye(l) + "e").split("e"), x = r(g[0] + "e" + (+g[1] + d));
            return g = (Ye(x) + "e").split("e"), +(g[0] + "e" + (+g[1] - d));
          }
          return r(l);
        };
      }
      var t1 = ta && 1 / Ur(new ta([, -0]))[1] == z ? function(t) {
        return new ta(t);
      } : Cc;
      function Fd(t) {
        return function(r) {
          var l = Tn(r);
          return l == we ? Fs(r) : l == an ? y0(r) : d0(r, t(r));
        };
      }
      function jo(t, r, l, d, g, x, S, R) {
        var T = r & O;
        if (!T && typeof t != "function")
          throw new fo(c);
        var W = d ? d.length : 0;
        if (W || (r &= ~(B | D), d = g = o), S = S === o ? S : vn(Oe(S), 0), R = R === o ? R : Oe(R), W -= g ? g.length : 0, r & D) {
          var Y = d, ee = g;
          d = g = o;
        }
        var ue = T ? o : tc(t), ve = [
          t,
          r,
          l,
          d,
          g,
          Y,
          ee,
          x,
          S,
          R
        ];
        if (ue && m1(ve, ue), t = ve[0], r = ve[1], l = ve[2], d = ve[3], g = ve[4], R = ve[9] = ve[9] === o ? T ? 0 : t.length : vn(ve[9] - W, 0), !R && r & (P | M) && (r &= ~(P | M)), !r || r == _)
          var Ee = e1(t, r, l);
        else
          r == P || r == M ? Ee = n1(t, r, R) : (r == B || r == (_ | B)) && !g.length ? Ee = o1(t, r, l, d) : Ee = oi.apply(o, ve);
        var Ke = ue ? ud : jd;
        return $d(Ke(Ee, ve), t, r);
      }
      function Id(t, r, l, d) {
        return t === o || Bo(t, oa[l]) && !Je.call(d, l) ? r : t;
      }
      function Td(t, r, l, d, g, x) {
        return dn(t) && dn(r) && (x.set(r, t), Jr(t, r, o, Td, x), x.delete(r)), t;
      }
      function a1(t) {
        return er(t) ? o : t;
      }
      function Od(t, r, l, d, g, x) {
        var S = l & k, R = t.length, T = r.length;
        if (R != T && !(S && T > R))
          return !1;
        var W = x.get(t), Y = x.get(r);
        if (W && Y)
          return W == r && Y == t;
        var ee = -1, ue = !0, ve = l & w ? new kt() : o;
        for (x.set(t, r), x.set(r, t); ++ee < R; ) {
          var Ee = t[ee], Ke = r[ee];
          if (d)
            var ke = S ? d(Ke, Ee, ee, r, t, x) : d(Ee, Ke, ee, t, r, x);
          if (ke !== o) {
            if (ke)
              continue;
            ue = !1;
            break;
          }
          if (ve) {
            if (!Es(r, function(Me, Qe) {
              if (!Ma(ve, Qe) && (Ee === Me || g(Ee, Me, l, d, x)))
                return ve.push(Qe);
            })) {
              ue = !1;
              break;
            }
          } else if (!(Ee === Ke || g(Ee, Ke, l, d, x))) {
            ue = !1;
            break;
          }
        }
        return x.delete(t), x.delete(r), ue;
      }
      function r1(t, r, l, d, g, x, S) {
        switch (l) {
          case Rn:
            if (t.byteLength != r.byteLength || t.byteOffset != r.byteOffset)
              return !1;
            t = t.buffer, r = r.buffer;
          case ko:
            return !(t.byteLength != r.byteLength || !x(new Mr(t), new Mr(r)));
          case pe:
          case le:
          case He:
            return Bo(+t, +r);
          case ge:
            return t.name == r.name && t.message == r.message;
          case Sn:
          case pn:
            return t == r + "";
          case we:
            var R = Fs;
          case an:
            var T = d & k;
            if (R || (R = Ur), t.size != r.size && !T)
              return !1;
            var W = S.get(t);
            if (W)
              return W == r;
            d |= w, S.set(t, r);
            var Y = Od(R(t), R(r), d, g, x, S);
            return S.delete(t), Y;
          case Xe:
            if (Va)
              return Va.call(t) == Va.call(r);
        }
        return !1;
      }
      function i1(t, r, l, d, g, x) {
        var S = l & k, R = nc(t), T = R.length, W = nc(r), Y = W.length;
        if (T != Y && !S)
          return !1;
        for (var ee = T; ee--; ) {
          var ue = R[ee];
          if (!(S ? ue in r : Je.call(r, ue)))
            return !1;
        }
        var ve = x.get(t), Ee = x.get(r);
        if (ve && Ee)
          return ve == r && Ee == t;
        var Ke = !0;
        x.set(t, r), x.set(r, t);
        for (var ke = S; ++ee < T; ) {
          ue = R[ee];
          var Me = t[ue], Qe = r[ue];
          if (d)
            var to = S ? d(Qe, Me, ue, r, t, x) : d(Me, Qe, ue, t, r, x);
          if (!(to === o ? Me === Qe || g(Me, Qe, l, d, x) : to)) {
            Ke = !1;
            break;
          }
          ke || (ke = ue == "constructor");
        }
        if (Ke && !ke) {
          var Dn = t.constructor, ao = r.constructor;
          Dn != ao && "constructor" in t && "constructor" in r && !(typeof Dn == "function" && Dn instanceof Dn && typeof ao == "function" && ao instanceof ao) && (Ke = !1);
        }
        return x.delete(t), x.delete(r), Ke;
      }
      function $o(t) {
        return lc(Nd(t, o, Yd), t + "");
      }
      function nc(t) {
        return XA(t, Cn, rc);
      }
      function oc(t) {
        return XA(t, Vn, Ud);
      }
      var tc = qr ? function(t) {
        return qr.get(t);
      } : Cc;
      function ii(t) {
        for (var r = t.name + "", l = aa[r], d = Je.call(aa, r) ? l.length : 0; d--; ) {
          var g = l[d], x = g.func;
          if (x == null || x == t)
            return g.name;
        }
        return r;
      }
      function ca(t) {
        var r = Je.call(v, "placeholder") ? v : t;
        return r.placeholder;
      }
      function ye() {
        var t = v.iteratee || yc;
        return t = t === yc ? od : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function si(t, r) {
        var l = t.__data__;
        return b1(r) ? l[typeof r == "string" ? "string" : "hash"] : l.map;
      }
      function ac(t) {
        for (var r = Cn(t), l = r.length; l--; ) {
          var d = r[l], g = t[d];
          r[l] = [d, g, Dd(g)];
        }
        return r;
      }
      function Bt(t, r) {
        var l = g0(t, r);
        return nd(l) ? l : o;
      }
      function s1(t) {
        var r = Je.call(t, wt), l = t[wt];
        try {
          t[wt] = o;
          var d = !0;
        } catch {
        }
        var g = Lr.call(t);
        return d && (r ? t[wt] = l : delete t[wt]), g;
      }
      var rc = Ts ? function(t) {
        return t == null ? [] : (t = on(t), Xo(Ts(t), function(r) {
          return MA.call(t, r);
        }));
      } : wc, Ud = Ts ? function(t) {
        for (var r = []; t; )
          et(r, rc(t)), t = jr(t);
        return r;
      } : wc, Tn = Kn;
      (Os && Tn(new Os(new ArrayBuffer(1))) != Rn || $a && Tn(new $a()) != we || Us && Tn(Us.resolve()) != Un || ta && Tn(new ta()) != an || Qa && Tn(new Qa()) != Fn) && (Tn = function(t) {
        var r = Kn(t), l = r == Ze ? t.constructor : o, d = l ? _t(l) : "";
        if (d)
          switch (d) {
            case Q0:
              return Rn;
            case H0:
              return we;
            case V0:
              return Un;
            case q0:
              return an;
            case W0:
              return Fn;
          }
        return r;
      });
      function c1(t, r, l) {
        for (var d = -1, g = l.length; ++d < g; ) {
          var x = l[d], S = x.size;
          switch (x.type) {
            case "drop":
              t += S;
              break;
            case "dropRight":
              r -= S;
              break;
            case "take":
              r = In(r, t + S);
              break;
            case "takeRight":
              t = vn(t, r - S);
              break;
          }
        }
        return { start: t, end: r };
      }
      function l1(t) {
        var r = t.match(pm);
        return r ? r[1].split(hm) : [];
      }
      function Kd(t, r, l) {
        r = rt(r, t);
        for (var d = -1, g = r.length, x = !1; ++d < g; ) {
          var S = Ko(r[d]);
          if (!(x = t != null && l(t, S)))
            break;
          t = t[S];
        }
        return x || ++d != g ? x : (g = t == null ? 0 : t.length, !!g && bi(g) && Qo(S, g) && (Ie(t) || Ft(t)));
      }
      function u1(t) {
        var r = t.length, l = new t.constructor(r);
        return r && typeof t[0] == "string" && Je.call(t, "index") && (l.index = t.index, l.input = t.input), l;
      }
      function Pd(t) {
        return typeof t.constructor == "function" && !Ja(t) ? ra(jr(t)) : {};
      }
      function A1(t, r, l) {
        var d = t.constructor;
        switch (r) {
          case ko:
            return Js(t);
          case pe:
          case le:
            return new d(+t);
          case Rn:
            return Yv(t, l);
          case Zn:
          case To:
          case K:
          case te:
          case Z:
          case Re:
          case qe:
          case Ve:
          case Ne:
            return md(t, l);
          case we:
            return new d();
          case He:
          case pn:
            return new d(t);
          case Sn:
            return zv(t);
          case an:
            return new d();
          case Xe:
            return Gv(t);
        }
      }
      function d1(t, r) {
        var l = r.length;
        if (!l)
          return t;
        var d = l - 1;
        return r[d] = (l > 1 ? "& " : "") + r[d], r = r.join(l > 2 ? ", " : " "), t.replace(bm, `{
/* [wrapped with ` + r + `] */
`);
      }
      function f1(t) {
        return Ie(t) || Ft(t) || !!(jA && t && t[jA]);
      }
      function Qo(t, r) {
        var l = typeof t;
        return r = r ?? q, !!r && (l == "number" || l != "symbol" && km.test(t)) && t > -1 && t % 1 == 0 && t < r;
      }
      function Pn(t, r, l) {
        if (!dn(l))
          return !1;
        var d = typeof r;
        return (d == "number" ? Hn(l) && Qo(r, l.length) : d == "string" && r in l) ? Bo(l[r], t) : !1;
      }
      function ic(t, r) {
        if (Ie(t))
          return !1;
        var l = typeof t;
        return l == "number" || l == "symbol" || l == "boolean" || t == null || oo(t) ? !0 : um.test(t) || !lm.test(t) || r != null && t in on(r);
      }
      function b1(t) {
        var r = typeof t;
        return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
      }
      function sc(t) {
        var r = ii(t), l = v[r];
        if (typeof l != "function" || !(r in je.prototype))
          return !1;
        if (t === l)
          return !0;
        var d = tc(l);
        return !!d && t === d[0];
      }
      function p1(t) {
        return !!DA && DA in t;
      }
      var h1 = Pr ? Ho : Ec;
      function Ja(t) {
        var r = t && t.constructor, l = typeof r == "function" && r.prototype || oa;
        return t === l;
      }
      function Dd(t) {
        return t === t && !dn(t);
      }
      function Ld(t, r) {
        return function(l) {
          return l == null ? !1 : l[t] === r && (r !== o || t in on(l));
        };
      }
      function g1(t) {
        var r = di(t, function(d) {
          return l.size === b && l.clear(), d;
        }), l = r.cache;
        return r;
      }
      function m1(t, r) {
        var l = t[1], d = r[1], g = l | d, x = g < (_ | O | H), S = d == H && l == P || d == H && l == X && t[7].length <= r[8] || d == (H | X) && r[7].length <= r[8] && l == P;
        if (!(x || S))
          return t;
        d & _ && (t[2] = r[2], g |= l & _ ? 0 : F);
        var R = r[3];
        if (R) {
          var T = t[3];
          t[3] = T ? yd(T, R, r[4]) : R, t[4] = T ? nt(t[3], h) : r[4];
        }
        return R = r[5], R && (T = t[5], t[5] = T ? xd(T, R, r[6]) : R, t[6] = T ? nt(t[5], h) : r[6]), R = r[7], R && (t[7] = R), d & H && (t[8] = t[8] == null ? r[8] : In(t[8], r[8])), t[9] == null && (t[9] = r[9]), t[0] = r[0], t[1] = g, t;
      }
      function v1(t) {
        var r = [];
        if (t != null)
          for (var l in on(t))
            r.push(l);
        return r;
      }
      function y1(t) {
        return Lr.call(t);
      }
      function Nd(t, r, l) {
        return r = vn(r === o ? t.length - 1 : r, 0), function() {
          for (var d = arguments, g = -1, x = vn(d.length - r, 0), S = N(x); ++g < x; )
            S[g] = d[r + g];
          g = -1;
          for (var R = N(r + 1); ++g < r; )
            R[g] = d[g];
          return R[r] = l(S), Xn(t, this, R);
        };
      }
      function Md(t, r) {
        return r.length < 2 ? t : Rt(t, ho(r, 0, -1));
      }
      function x1(t, r) {
        for (var l = t.length, d = In(r.length, l), g = Qn(t); d--; ) {
          var x = r[d];
          t[d] = Qo(x, l) ? g[x] : o;
        }
        return t;
      }
      function cc(t, r) {
        if (!(r === "constructor" && typeof t[r] == "function") && r != "__proto__")
          return t[r];
      }
      var jd = Qd(ud), Xa = P0 || function(t, r) {
        return Bn.setTimeout(t, r);
      }, lc = Qd(Hv);
      function $d(t, r, l) {
        var d = r + "";
        return lc(t, d1(d, C1(l1(d), l)));
      }
      function Qd(t) {
        var r = 0, l = 0;
        return function() {
          var d = M0(), g = Pe - (d - l);
          if (l = d, g > 0) {
            if (++r >= Be)
              return arguments[0];
          } else
            r = 0;
          return t.apply(o, arguments);
        };
      }
      function ci(t, r) {
        var l = -1, d = t.length, g = d - 1;
        for (r = r === o ? d : r; ++l < r; ) {
          var x = Vs(l, g), S = t[x];
          t[x] = t[l], t[l] = S;
        }
        return t.length = r, t;
      }
      var Hd = g1(function(t) {
        var r = [];
        return t.charCodeAt(0) === 46 && r.push(""), t.replace(Am, function(l, d, g, x) {
          r.push(g ? x.replace(vm, "$1") : d || l);
        }), r;
      });
      function Ko(t) {
        if (typeof t == "string" || oo(t))
          return t;
        var r = t + "";
        return r == "0" && 1 / t == -z ? "-0" : r;
      }
      function _t(t) {
        if (t != null) {
          try {
            return Dr.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function C1(t, r) {
        return Ao(ie, function(l) {
          var d = "_." + l[0];
          r & l[1] && !Tr(t, d) && t.push(d);
        }), t.sort();
      }
      function Vd(t) {
        if (t instanceof je)
          return t.clone();
        var r = new bo(t.__wrapped__, t.__chain__);
        return r.__actions__ = Qn(t.__actions__), r.__index__ = t.__index__, r.__values__ = t.__values__, r;
      }
      function w1(t, r, l) {
        (l ? Pn(t, r, l) : r === o) ? r = 1 : r = vn(Oe(r), 0);
        var d = t == null ? 0 : t.length;
        if (!d || r < 1)
          return [];
        for (var g = 0, x = 0, S = N(Hr(d / r)); g < d; )
          S[x++] = ho(t, g, g += r);
        return S;
      }
      function E1(t) {
        for (var r = -1, l = t == null ? 0 : t.length, d = 0, g = []; ++r < l; ) {
          var x = t[r];
          x && (g[d++] = x);
        }
        return g;
      }
      function k1() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var r = N(t - 1), l = arguments[0], d = t; d--; )
          r[d - 1] = arguments[d];
        return et(Ie(l) ? Qn(l) : [l], _n(r, 1));
      }
      var S1 = De(function(t, r) {
        return hn(t) ? Wa(t, _n(r, 1, hn, !0)) : [];
      }), R1 = De(function(t, r) {
        var l = go(r);
        return hn(l) && (l = o), hn(t) ? Wa(t, _n(r, 1, hn, !0), ye(l, 2)) : [];
      }), B1 = De(function(t, r) {
        var l = go(r);
        return hn(l) && (l = o), hn(t) ? Wa(t, _n(r, 1, hn, !0), o, l) : [];
      });
      function _1(t, r, l) {
        var d = t == null ? 0 : t.length;
        return d ? (r = l || r === o ? 1 : Oe(r), ho(t, r < 0 ? 0 : r, d)) : [];
      }
      function F1(t, r, l) {
        var d = t == null ? 0 : t.length;
        return d ? (r = l || r === o ? 1 : Oe(r), r = d - r, ho(t, 0, r < 0 ? 0 : r)) : [];
      }
      function I1(t, r) {
        return t && t.length ? ei(t, ye(r, 3), !0, !0) : [];
      }
      function T1(t, r) {
        return t && t.length ? ei(t, ye(r, 3), !0) : [];
      }
      function O1(t, r, l, d) {
        var g = t == null ? 0 : t.length;
        return g ? (l && typeof l != "number" && Pn(t, r, l) && (l = 0, d = g), kv(t, r, l, d)) : [];
      }
      function qd(t, r, l) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = l == null ? 0 : Oe(l);
        return g < 0 && (g = vn(d + g, 0)), Or(t, ye(r, 3), g);
      }
      function Wd(t, r, l) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = d - 1;
        return l !== o && (g = Oe(l), g = l < 0 ? vn(d + g, 0) : In(g, d - 1)), Or(t, ye(r, 3), g, !0);
      }
      function Yd(t) {
        var r = t == null ? 0 : t.length;
        return r ? _n(t, 1) : [];
      }
      function U1(t) {
        var r = t == null ? 0 : t.length;
        return r ? _n(t, z) : [];
      }
      function K1(t, r) {
        var l = t == null ? 0 : t.length;
        return l ? (r = r === o ? 1 : Oe(r), _n(t, r)) : [];
      }
      function P1(t) {
        for (var r = -1, l = t == null ? 0 : t.length, d = {}; ++r < l; ) {
          var g = t[r];
          d[g[0]] = g[1];
        }
        return d;
      }
      function zd(t) {
        return t && t.length ? t[0] : o;
      }
      function D1(t, r, l) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = l == null ? 0 : Oe(l);
        return g < 0 && (g = vn(d + g, 0)), Jt(t, r, g);
      }
      function L1(t) {
        var r = t == null ? 0 : t.length;
        return r ? ho(t, 0, -1) : [];
      }
      var N1 = De(function(t) {
        var r = ln(t, Gs);
        return r.length && r[0] === t[0] ? Ms(r) : [];
      }), M1 = De(function(t) {
        var r = go(t), l = ln(t, Gs);
        return r === go(l) ? r = o : l.pop(), l.length && l[0] === t[0] ? Ms(l, ye(r, 2)) : [];
      }), j1 = De(function(t) {
        var r = go(t), l = ln(t, Gs);
        return r = typeof r == "function" ? r : o, r && l.pop(), l.length && l[0] === t[0] ? Ms(l, o, r) : [];
      });
      function $1(t, r) {
        return t == null ? "" : L0.call(t, r);
      }
      function go(t) {
        var r = t == null ? 0 : t.length;
        return r ? t[r - 1] : o;
      }
      function Q1(t, r, l) {
        var d = t == null ? 0 : t.length;
        if (!d)
          return -1;
        var g = d;
        return l !== o && (g = Oe(l), g = g < 0 ? vn(d + g, 0) : In(g, d - 1)), r === r ? C0(t, r, g) : Or(t, _A, g, !0);
      }
      function H1(t, r) {
        return t && t.length ? id(t, Oe(r)) : o;
      }
      var V1 = De(Gd);
      function Gd(t, r) {
        return t && t.length && r && r.length ? Hs(t, r) : t;
      }
      function q1(t, r, l) {
        return t && t.length && r && r.length ? Hs(t, r, ye(l, 2)) : t;
      }
      function W1(t, r, l) {
        return t && t.length && r && r.length ? Hs(t, r, o, l) : t;
      }
      var Y1 = $o(function(t, r) {
        var l = t == null ? 0 : t.length, d = Ps(t, r);
        return ld(t, ln(r, function(g) {
          return Qo(g, l) ? +g : g;
        }).sort(vd)), d;
      });
      function z1(t, r) {
        var l = [];
        if (!(t && t.length))
          return l;
        var d = -1, g = [], x = t.length;
        for (r = ye(r, 3); ++d < x; ) {
          var S = t[d];
          r(S, d, t) && (l.push(S), g.push(d));
        }
        return ld(t, g), l;
      }
      function uc(t) {
        return t == null ? t : $0.call(t);
      }
      function G1(t, r, l) {
        var d = t == null ? 0 : t.length;
        return d ? (l && typeof l != "number" && Pn(t, r, l) ? (r = 0, l = d) : (r = r == null ? 0 : Oe(r), l = l === o ? d : Oe(l)), ho(t, r, l)) : [];
      }
      function Z1(t, r) {
        return Xr(t, r);
      }
      function J1(t, r, l) {
        return Ws(t, r, ye(l, 2));
      }
      function X1(t, r) {
        var l = t == null ? 0 : t.length;
        if (l) {
          var d = Xr(t, r);
          if (d < l && Bo(t[d], r))
            return d;
        }
        return -1;
      }
      function e2(t, r) {
        return Xr(t, r, !0);
      }
      function n2(t, r, l) {
        return Ws(t, r, ye(l, 2), !0);
      }
      function o2(t, r) {
        var l = t == null ? 0 : t.length;
        if (l) {
          var d = Xr(t, r, !0) - 1;
          if (Bo(t[d], r))
            return d;
        }
        return -1;
      }
      function t2(t) {
        return t && t.length ? Ad(t) : [];
      }
      function a2(t, r) {
        return t && t.length ? Ad(t, ye(r, 2)) : [];
      }
      function r2(t) {
        var r = t == null ? 0 : t.length;
        return r ? ho(t, 1, r) : [];
      }
      function i2(t, r, l) {
        return t && t.length ? (r = l || r === o ? 1 : Oe(r), ho(t, 0, r < 0 ? 0 : r)) : [];
      }
      function s2(t, r, l) {
        var d = t == null ? 0 : t.length;
        return d ? (r = l || r === o ? 1 : Oe(r), r = d - r, ho(t, r < 0 ? 0 : r, d)) : [];
      }
      function c2(t, r) {
        return t && t.length ? ei(t, ye(r, 3), !1, !0) : [];
      }
      function l2(t, r) {
        return t && t.length ? ei(t, ye(r, 3)) : [];
      }
      var u2 = De(function(t) {
        return at(_n(t, 1, hn, !0));
      }), A2 = De(function(t) {
        var r = go(t);
        return hn(r) && (r = o), at(_n(t, 1, hn, !0), ye(r, 2));
      }), d2 = De(function(t) {
        var r = go(t);
        return r = typeof r == "function" ? r : o, at(_n(t, 1, hn, !0), o, r);
      });
      function f2(t) {
        return t && t.length ? at(t) : [];
      }
      function b2(t, r) {
        return t && t.length ? at(t, ye(r, 2)) : [];
      }
      function p2(t, r) {
        return r = typeof r == "function" ? r : o, t && t.length ? at(t, o, r) : [];
      }
      function Ac(t) {
        if (!(t && t.length))
          return [];
        var r = 0;
        return t = Xo(t, function(l) {
          if (hn(l))
            return r = vn(l.length, r), !0;
        }), Bs(r, function(l) {
          return ln(t, ks(l));
        });
      }
      function Zd(t, r) {
        if (!(t && t.length))
          return [];
        var l = Ac(t);
        return r == null ? l : ln(l, function(d) {
          return Xn(r, o, d);
        });
      }
      var h2 = De(function(t, r) {
        return hn(t) ? Wa(t, r) : [];
      }), g2 = De(function(t) {
        return zs(Xo(t, hn));
      }), m2 = De(function(t) {
        var r = go(t);
        return hn(r) && (r = o), zs(Xo(t, hn), ye(r, 2));
      }), v2 = De(function(t) {
        var r = go(t);
        return r = typeof r == "function" ? r : o, zs(Xo(t, hn), o, r);
      }), y2 = De(Ac);
      function x2(t, r) {
        return pd(t || [], r || [], qa);
      }
      function C2(t, r) {
        return pd(t || [], r || [], Ga);
      }
      var w2 = De(function(t) {
        var r = t.length, l = r > 1 ? t[r - 1] : o;
        return l = typeof l == "function" ? (t.pop(), l) : o, Zd(t, l);
      });
      function Jd(t) {
        var r = v(t);
        return r.__chain__ = !0, r;
      }
      function E2(t, r) {
        return r(t), t;
      }
      function li(t, r) {
        return r(t);
      }
      var k2 = $o(function(t) {
        var r = t.length, l = r ? t[0] : 0, d = this.__wrapped__, g = function(x) {
          return Ps(x, t);
        };
        return r > 1 || this.__actions__.length || !(d instanceof je) || !Qo(l) ? this.thru(g) : (d = d.slice(l, +l + (r ? 1 : 0)), d.__actions__.push({
          func: li,
          args: [g],
          thisArg: o
        }), new bo(d, this.__chain__).thru(function(x) {
          return r && !x.length && x.push(o), x;
        }));
      });
      function S2() {
        return Jd(this);
      }
      function R2() {
        return new bo(this.value(), this.__chain__);
      }
      function B2() {
        this.__values__ === o && (this.__values__ = ff(this.value()));
        var t = this.__index__ >= this.__values__.length, r = t ? o : this.__values__[this.__index__++];
        return { done: t, value: r };
      }
      function _2() {
        return this;
      }
      function F2(t) {
        for (var r, l = this; l instanceof Yr; ) {
          var d = Vd(l);
          d.__index__ = 0, d.__values__ = o, r ? g.__wrapped__ = d : r = d;
          var g = d;
          l = l.__wrapped__;
        }
        return g.__wrapped__ = t, r;
      }
      function I2() {
        var t = this.__wrapped__;
        if (t instanceof je) {
          var r = t;
          return this.__actions__.length && (r = new je(this)), r = r.reverse(), r.__actions__.push({
            func: li,
            args: [uc],
            thisArg: o
          }), new bo(r, this.__chain__);
        }
        return this.thru(uc);
      }
      function T2() {
        return bd(this.__wrapped__, this.__actions__);
      }
      var O2 = ni(function(t, r, l) {
        Je.call(t, l) ? ++t[l] : Mo(t, l, 1);
      });
      function U2(t, r, l) {
        var d = Ie(t) ? RA : Ev;
        return l && Pn(t, r, l) && (r = o), d(t, ye(r, 3));
      }
      function K2(t, r) {
        var l = Ie(t) ? Xo : ZA;
        return l(t, ye(r, 3));
      }
      var P2 = kd(qd), D2 = kd(Wd);
      function L2(t, r) {
        return _n(ui(t, r), 1);
      }
      function N2(t, r) {
        return _n(ui(t, r), z);
      }
      function M2(t, r, l) {
        return l = l === o ? 1 : Oe(l), _n(ui(t, r), l);
      }
      function Xd(t, r) {
        var l = Ie(t) ? Ao : tt;
        return l(t, ye(r, 3));
      }
      function ef(t, r) {
        var l = Ie(t) ? r0 : GA;
        return l(t, ye(r, 3));
      }
      var j2 = ni(function(t, r, l) {
        Je.call(t, l) ? t[l].push(r) : Mo(t, l, [r]);
      });
      function $2(t, r, l, d) {
        t = Hn(t) ? t : ua(t), l = l && !d ? Oe(l) : 0;
        var g = t.length;
        return l < 0 && (l = vn(g + l, 0)), pi(t) ? l <= g && t.indexOf(r, l) > -1 : !!g && Jt(t, r, l) > -1;
      }
      var Q2 = De(function(t, r, l) {
        var d = -1, g = typeof r == "function", x = Hn(t) ? N(t.length) : [];
        return tt(t, function(S) {
          x[++d] = g ? Xn(r, S, l) : Ya(S, r, l);
        }), x;
      }), H2 = ni(function(t, r, l) {
        Mo(t, l, r);
      });
      function ui(t, r) {
        var l = Ie(t) ? ln : td;
        return l(t, ye(r, 3));
      }
      function V2(t, r, l, d) {
        return t == null ? [] : (Ie(r) || (r = r == null ? [] : [r]), l = d ? o : l, Ie(l) || (l = l == null ? [] : [l]), sd(t, r, l));
      }
      var q2 = ni(function(t, r, l) {
        t[l ? 0 : 1].push(r);
      }, function() {
        return [[], []];
      });
      function W2(t, r, l) {
        var d = Ie(t) ? ws : IA, g = arguments.length < 3;
        return d(t, ye(r, 4), l, g, tt);
      }
      function Y2(t, r, l) {
        var d = Ie(t) ? i0 : IA, g = arguments.length < 3;
        return d(t, ye(r, 4), l, g, GA);
      }
      function z2(t, r) {
        var l = Ie(t) ? Xo : ZA;
        return l(t, fi(ye(r, 3)));
      }
      function G2(t) {
        var r = Ie(t) ? qA : $v;
        return r(t);
      }
      function Z2(t, r, l) {
        (l ? Pn(t, r, l) : r === o) ? r = 1 : r = Oe(r);
        var d = Ie(t) ? vv : Qv;
        return d(t, r);
      }
      function J2(t) {
        var r = Ie(t) ? yv : Vv;
        return r(t);
      }
      function X2(t) {
        if (t == null)
          return 0;
        if (Hn(t))
          return pi(t) ? ea(t) : t.length;
        var r = Tn(t);
        return r == we || r == an ? t.size : $s(t).length;
      }
      function ey(t, r, l) {
        var d = Ie(t) ? Es : qv;
        return l && Pn(t, r, l) && (r = o), d(t, ye(r, 3));
      }
      var ny = De(function(t, r) {
        if (t == null)
          return [];
        var l = r.length;
        return l > 1 && Pn(t, r[0], r[1]) ? r = [] : l > 2 && Pn(r[0], r[1], r[2]) && (r = [r[0]]), sd(t, _n(r, 1), []);
      }), Ai = K0 || function() {
        return Bn.Date.now();
      };
      function oy(t, r) {
        if (typeof r != "function")
          throw new fo(c);
        return t = Oe(t), function() {
          if (--t < 1)
            return r.apply(this, arguments);
        };
      }
      function nf(t, r, l) {
        return r = l ? o : r, r = t && r == null ? t.length : r, jo(t, H, o, o, o, o, r);
      }
      function of(t, r) {
        var l;
        if (typeof r != "function")
          throw new fo(c);
        return t = Oe(t), function() {
          return --t > 0 && (l = r.apply(this, arguments)), t <= 1 && (r = o), l;
        };
      }
      var dc = De(function(t, r, l) {
        var d = _;
        if (l.length) {
          var g = nt(l, ca(dc));
          d |= B;
        }
        return jo(t, d, r, l, g);
      }), tf = De(function(t, r, l) {
        var d = _ | O;
        if (l.length) {
          var g = nt(l, ca(tf));
          d |= B;
        }
        return jo(r, d, t, l, g);
      });
      function af(t, r, l) {
        r = l ? o : r;
        var d = jo(t, P, o, o, o, o, o, r);
        return d.placeholder = af.placeholder, d;
      }
      function rf(t, r, l) {
        r = l ? o : r;
        var d = jo(t, M, o, o, o, o, o, r);
        return d.placeholder = rf.placeholder, d;
      }
      function sf(t, r, l) {
        var d, g, x, S, R, T, W = 0, Y = !1, ee = !1, ue = !0;
        if (typeof t != "function")
          throw new fo(c);
        r = mo(r) || 0, dn(l) && (Y = !!l.leading, ee = "maxWait" in l, x = ee ? vn(mo(l.maxWait) || 0, r) : x, ue = "trailing" in l ? !!l.trailing : ue);
        function ve(gn) {
          var _o = d, qo = g;
          return d = g = o, W = gn, S = t.apply(qo, _o), S;
        }
        function Ee(gn) {
          return W = gn, R = Xa(Me, r), Y ? ve(gn) : S;
        }
        function Ke(gn) {
          var _o = gn - T, qo = gn - W, Sf = r - _o;
          return ee ? In(Sf, x - qo) : Sf;
        }
        function ke(gn) {
          var _o = gn - T, qo = gn - W;
          return T === o || _o >= r || _o < 0 || ee && qo >= x;
        }
        function Me() {
          var gn = Ai();
          if (ke(gn))
            return Qe(gn);
          R = Xa(Me, Ke(gn));
        }
        function Qe(gn) {
          return R = o, ue && d ? ve(gn) : (d = g = o, S);
        }
        function to() {
          R !== o && hd(R), W = 0, d = T = g = R = o;
        }
        function Dn() {
          return R === o ? S : Qe(Ai());
        }
        function ao() {
          var gn = Ai(), _o = ke(gn);
          if (d = arguments, g = this, T = gn, _o) {
            if (R === o)
              return Ee(T);
            if (ee)
              return hd(R), R = Xa(Me, r), ve(T);
          }
          return R === o && (R = Xa(Me, r)), S;
        }
        return ao.cancel = to, ao.flush = Dn, ao;
      }
      var ty = De(function(t, r) {
        return zA(t, 1, r);
      }), ay = De(function(t, r, l) {
        return zA(t, mo(r) || 0, l);
      });
      function ry(t) {
        return jo(t, ce);
      }
      function di(t, r) {
        if (typeof t != "function" || r != null && typeof r != "function")
          throw new fo(c);
        var l = function() {
          var d = arguments, g = r ? r.apply(this, d) : d[0], x = l.cache;
          if (x.has(g))
            return x.get(g);
          var S = t.apply(this, d);
          return l.cache = x.set(g, S) || x, S;
        };
        return l.cache = new (di.Cache || No)(), l;
      }
      di.Cache = No;
      function fi(t) {
        if (typeof t != "function")
          throw new fo(c);
        return function() {
          var r = arguments;
          switch (r.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, r[0]);
            case 2:
              return !t.call(this, r[0], r[1]);
            case 3:
              return !t.call(this, r[0], r[1], r[2]);
          }
          return !t.apply(this, r);
        };
      }
      function iy(t) {
        return of(2, t);
      }
      var sy = Wv(function(t, r) {
        r = r.length == 1 && Ie(r[0]) ? ln(r[0], eo(ye())) : ln(_n(r, 1), eo(ye()));
        var l = r.length;
        return De(function(d) {
          for (var g = -1, x = In(d.length, l); ++g < x; )
            d[g] = r[g].call(this, d[g]);
          return Xn(t, this, d);
        });
      }), fc = De(function(t, r) {
        var l = nt(r, ca(fc));
        return jo(t, B, o, r, l);
      }), cf = De(function(t, r) {
        var l = nt(r, ca(cf));
        return jo(t, D, o, r, l);
      }), cy = $o(function(t, r) {
        return jo(t, X, o, o, o, r);
      });
      function ly(t, r) {
        if (typeof t != "function")
          throw new fo(c);
        return r = r === o ? r : Oe(r), De(t, r);
      }
      function uy(t, r) {
        if (typeof t != "function")
          throw new fo(c);
        return r = r == null ? 0 : vn(Oe(r), 0), De(function(l) {
          var d = l[r], g = it(l, 0, r);
          return d && et(g, d), Xn(t, this, g);
        });
      }
      function Ay(t, r, l) {
        var d = !0, g = !0;
        if (typeof t != "function")
          throw new fo(c);
        return dn(l) && (d = "leading" in l ? !!l.leading : d, g = "trailing" in l ? !!l.trailing : g), sf(t, r, {
          leading: d,
          maxWait: r,
          trailing: g
        });
      }
      function dy(t) {
        return nf(t, 1);
      }
      function fy(t, r) {
        return fc(Zs(r), t);
      }
      function by() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return Ie(t) ? t : [t];
      }
      function py(t) {
        return po(t, y);
      }
      function hy(t, r) {
        return r = typeof r == "function" ? r : o, po(t, y, r);
      }
      function gy(t) {
        return po(t, m | y);
      }
      function my(t, r) {
        return r = typeof r == "function" ? r : o, po(t, m | y, r);
      }
      function vy(t, r) {
        return r == null || YA(t, r, Cn(r));
      }
      function Bo(t, r) {
        return t === r || t !== t && r !== r;
      }
      var yy = ri(Ns), xy = ri(function(t, r) {
        return t >= r;
      }), Ft = ed(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ed : function(t) {
        return bn(t) && Je.call(t, "callee") && !MA.call(t, "callee");
      }, Ie = N.isArray, Cy = xA ? eo(xA) : Fv;
      function Hn(t) {
        return t != null && bi(t.length) && !Ho(t);
      }
      function hn(t) {
        return bn(t) && Hn(t);
      }
      function wy(t) {
        return t === !0 || t === !1 || bn(t) && Kn(t) == pe;
      }
      var st = D0 || Ec, Ey = CA ? eo(CA) : Iv;
      function ky(t) {
        return bn(t) && t.nodeType === 1 && !er(t);
      }
      function Sy(t) {
        if (t == null)
          return !0;
        if (Hn(t) && (Ie(t) || typeof t == "string" || typeof t.splice == "function" || st(t) || la(t) || Ft(t)))
          return !t.length;
        var r = Tn(t);
        if (r == we || r == an)
          return !t.size;
        if (Ja(t))
          return !$s(t).length;
        for (var l in t)
          if (Je.call(t, l))
            return !1;
        return !0;
      }
      function Ry(t, r) {
        return za(t, r);
      }
      function By(t, r, l) {
        l = typeof l == "function" ? l : o;
        var d = l ? l(t, r) : o;
        return d === o ? za(t, r, o, l) : !!d;
      }
      function bc(t) {
        if (!bn(t))
          return !1;
        var r = Kn(t);
        return r == ge || r == me || typeof t.message == "string" && typeof t.name == "string" && !er(t);
      }
      function _y(t) {
        return typeof t == "number" && $A(t);
      }
      function Ho(t) {
        if (!dn(t))
          return !1;
        var r = Kn(t);
        return r == G || r == _e || r == be || r == Mn;
      }
      function lf(t) {
        return typeof t == "number" && t == Oe(t);
      }
      function bi(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= q;
      }
      function dn(t) {
        var r = typeof t;
        return t != null && (r == "object" || r == "function");
      }
      function bn(t) {
        return t != null && typeof t == "object";
      }
      var uf = wA ? eo(wA) : Ov;
      function Fy(t, r) {
        return t === r || js(t, r, ac(r));
      }
      function Iy(t, r, l) {
        return l = typeof l == "function" ? l : o, js(t, r, ac(r), l);
      }
      function Ty(t) {
        return Af(t) && t != +t;
      }
      function Oy(t) {
        if (h1(t))
          throw new Fe(s);
        return nd(t);
      }
      function Uy(t) {
        return t === null;
      }
      function Ky(t) {
        return t == null;
      }
      function Af(t) {
        return typeof t == "number" || bn(t) && Kn(t) == He;
      }
      function er(t) {
        if (!bn(t) || Kn(t) != Ze)
          return !1;
        var r = jr(t);
        if (r === null)
          return !0;
        var l = Je.call(r, "constructor") && r.constructor;
        return typeof l == "function" && l instanceof l && Dr.call(l) == I0;
      }
      var pc = EA ? eo(EA) : Uv;
      function Py(t) {
        return lf(t) && t >= -q && t <= q;
      }
      var df = kA ? eo(kA) : Kv;
      function pi(t) {
        return typeof t == "string" || !Ie(t) && bn(t) && Kn(t) == pn;
      }
      function oo(t) {
        return typeof t == "symbol" || bn(t) && Kn(t) == Xe;
      }
      var la = SA ? eo(SA) : Pv;
      function Dy(t) {
        return t === o;
      }
      function Ly(t) {
        return bn(t) && Tn(t) == Fn;
      }
      function Ny(t) {
        return bn(t) && Kn(t) == Eo;
      }
      var My = ri(Qs), jy = ri(function(t, r) {
        return t <= r;
      });
      function ff(t) {
        if (!t)
          return [];
        if (Hn(t))
          return pi(t) ? So(t) : Qn(t);
        if (ja && t[ja])
          return v0(t[ja]());
        var r = Tn(t), l = r == we ? Fs : r == an ? Ur : ua;
        return l(t);
      }
      function Vo(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = mo(t), t === z || t === -z) {
          var r = t < 0 ? -1 : 1;
          return r * de;
        }
        return t === t ? t : 0;
      }
      function Oe(t) {
        var r = Vo(t), l = r % 1;
        return r === r ? l ? r - l : r : 0;
      }
      function bf(t) {
        return t ? St(Oe(t), 0, L) : 0;
      }
      function mo(t) {
        if (typeof t == "number")
          return t;
        if (oo(t))
          return U;
        if (dn(t)) {
          var r = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = dn(r) ? r + "" : r;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = TA(t);
        var l = Cm.test(t);
        return l || Em.test(t) ? o0(t.slice(2), l ? 2 : 8) : xm.test(t) ? U : +t;
      }
      function pf(t) {
        return Uo(t, Vn(t));
      }
      function $y(t) {
        return t ? St(Oe(t), -q, q) : t === 0 ? t : 0;
      }
      function Ye(t) {
        return t == null ? "" : no(t);
      }
      var Qy = ia(function(t, r) {
        if (Ja(r) || Hn(r)) {
          Uo(r, Cn(r), t);
          return;
        }
        for (var l in r)
          Je.call(r, l) && qa(t, l, r[l]);
      }), hf = ia(function(t, r) {
        Uo(r, Vn(r), t);
      }), hi = ia(function(t, r, l, d) {
        Uo(r, Vn(r), t, d);
      }), Hy = ia(function(t, r, l, d) {
        Uo(r, Cn(r), t, d);
      }), Vy = $o(Ps);
      function qy(t, r) {
        var l = ra(t);
        return r == null ? l : WA(l, r);
      }
      var Wy = De(function(t, r) {
        t = on(t);
        var l = -1, d = r.length, g = d > 2 ? r[2] : o;
        for (g && Pn(r[0], r[1], g) && (d = 1); ++l < d; )
          for (var x = r[l], S = Vn(x), R = -1, T = S.length; ++R < T; ) {
            var W = S[R], Y = t[W];
            (Y === o || Bo(Y, oa[W]) && !Je.call(t, W)) && (t[W] = x[W]);
          }
        return t;
      }), Yy = De(function(t) {
        return t.push(o, Td), Xn(gf, o, t);
      });
      function zy(t, r) {
        return BA(t, ye(r, 3), Oo);
      }
      function Gy(t, r) {
        return BA(t, ye(r, 3), Ls);
      }
      function Zy(t, r) {
        return t == null ? t : Ds(t, ye(r, 3), Vn);
      }
      function Jy(t, r) {
        return t == null ? t : JA(t, ye(r, 3), Vn);
      }
      function Xy(t, r) {
        return t && Oo(t, ye(r, 3));
      }
      function e3(t, r) {
        return t && Ls(t, ye(r, 3));
      }
      function n3(t) {
        return t == null ? [] : Zr(t, Cn(t));
      }
      function o3(t) {
        return t == null ? [] : Zr(t, Vn(t));
      }
      function hc(t, r, l) {
        var d = t == null ? o : Rt(t, r);
        return d === o ? l : d;
      }
      function t3(t, r) {
        return t != null && Kd(t, r, Sv);
      }
      function gc(t, r) {
        return t != null && Kd(t, r, Rv);
      }
      var a3 = Rd(function(t, r, l) {
        r != null && typeof r.toString != "function" && (r = Lr.call(r)), t[r] = l;
      }, vc(qn)), r3 = Rd(function(t, r, l) {
        r != null && typeof r.toString != "function" && (r = Lr.call(r)), Je.call(t, r) ? t[r].push(l) : t[r] = [l];
      }, ye), i3 = De(Ya);
      function Cn(t) {
        return Hn(t) ? VA(t) : $s(t);
      }
      function Vn(t) {
        return Hn(t) ? VA(t, !0) : Dv(t);
      }
      function s3(t, r) {
        var l = {};
        return r = ye(r, 3), Oo(t, function(d, g, x) {
          Mo(l, r(d, g, x), d);
        }), l;
      }
      function c3(t, r) {
        var l = {};
        return r = ye(r, 3), Oo(t, function(d, g, x) {
          Mo(l, g, r(d, g, x));
        }), l;
      }
      var l3 = ia(function(t, r, l) {
        Jr(t, r, l);
      }), gf = ia(function(t, r, l, d) {
        Jr(t, r, l, d);
      }), u3 = $o(function(t, r) {
        var l = {};
        if (t == null)
          return l;
        var d = !1;
        r = ln(r, function(x) {
          return x = rt(x, t), d || (d = x.length > 1), x;
        }), Uo(t, oc(t), l), d && (l = po(l, m | E | y, a1));
        for (var g = r.length; g--; )
          Ys(l, r[g]);
        return l;
      });
      function A3(t, r) {
        return mf(t, fi(ye(r)));
      }
      var d3 = $o(function(t, r) {
        return t == null ? {} : Nv(t, r);
      });
      function mf(t, r) {
        if (t == null)
          return {};
        var l = ln(oc(t), function(d) {
          return [d];
        });
        return r = ye(r), cd(t, l, function(d, g) {
          return r(d, g[0]);
        });
      }
      function f3(t, r, l) {
        r = rt(r, t);
        var d = -1, g = r.length;
        for (g || (g = 1, t = o); ++d < g; ) {
          var x = t == null ? o : t[Ko(r[d])];
          x === o && (d = g, x = l), t = Ho(x) ? x.call(t) : x;
        }
        return t;
      }
      function b3(t, r, l) {
        return t == null ? t : Ga(t, r, l);
      }
      function p3(t, r, l, d) {
        return d = typeof d == "function" ? d : o, t == null ? t : Ga(t, r, l, d);
      }
      var vf = Fd(Cn), yf = Fd(Vn);
      function h3(t, r, l) {
        var d = Ie(t), g = d || st(t) || la(t);
        if (r = ye(r, 4), l == null) {
          var x = t && t.constructor;
          g ? l = d ? new x() : [] : dn(t) ? l = Ho(x) ? ra(jr(t)) : {} : l = {};
        }
        return (g ? Ao : Oo)(t, function(S, R, T) {
          return r(l, S, R, T);
        }), l;
      }
      function g3(t, r) {
        return t == null ? !0 : Ys(t, r);
      }
      function m3(t, r, l) {
        return t == null ? t : fd(t, r, Zs(l));
      }
      function v3(t, r, l, d) {
        return d = typeof d == "function" ? d : o, t == null ? t : fd(t, r, Zs(l), d);
      }
      function ua(t) {
        return t == null ? [] : _s(t, Cn(t));
      }
      function y3(t) {
        return t == null ? [] : _s(t, Vn(t));
      }
      function x3(t, r, l) {
        return l === o && (l = r, r = o), l !== o && (l = mo(l), l = l === l ? l : 0), r !== o && (r = mo(r), r = r === r ? r : 0), St(mo(t), r, l);
      }
      function C3(t, r, l) {
        return r = Vo(r), l === o ? (l = r, r = 0) : l = Vo(l), t = mo(t), Bv(t, r, l);
      }
      function w3(t, r, l) {
        if (l && typeof l != "boolean" && Pn(t, r, l) && (r = l = o), l === o && (typeof r == "boolean" ? (l = r, r = o) : typeof t == "boolean" && (l = t, t = o)), t === o && r === o ? (t = 0, r = 1) : (t = Vo(t), r === o ? (r = t, t = 0) : r = Vo(r)), t > r) {
          var d = t;
          t = r, r = d;
        }
        if (l || t % 1 || r % 1) {
          var g = QA();
          return In(t + g * (r - t + n0("1e-" + ((g + "").length - 1))), r);
        }
        return Vs(t, r);
      }
      var E3 = sa(function(t, r, l) {
        return r = r.toLowerCase(), t + (l ? xf(r) : r);
      });
      function xf(t) {
        return mc(Ye(t).toLowerCase());
      }
      function Cf(t) {
        return t = Ye(t), t && t.replace(Sm, b0).replace(Vm, "");
      }
      function k3(t, r, l) {
        t = Ye(t), r = no(r);
        var d = t.length;
        l = l === o ? d : St(Oe(l), 0, d);
        var g = l;
        return l -= r.length, l >= 0 && t.slice(l, g) == r;
      }
      function S3(t) {
        return t = Ye(t), t && ds.test(t) ? t.replace(fn, p0) : t;
      }
      function R3(t) {
        return t = Ye(t), t && dm.test(t) ? t.replace(fs, "\\$&") : t;
      }
      var B3 = sa(function(t, r, l) {
        return t + (l ? "-" : "") + r.toLowerCase();
      }), _3 = sa(function(t, r, l) {
        return t + (l ? " " : "") + r.toLowerCase();
      }), F3 = Ed("toLowerCase");
      function I3(t, r, l) {
        t = Ye(t), r = Oe(r);
        var d = r ? ea(t) : 0;
        if (!r || d >= r)
          return t;
        var g = (r - d) / 2;
        return ai(Vr(g), l) + t + ai(Hr(g), l);
      }
      function T3(t, r, l) {
        t = Ye(t), r = Oe(r);
        var d = r ? ea(t) : 0;
        return r && d < r ? t + ai(r - d, l) : t;
      }
      function O3(t, r, l) {
        t = Ye(t), r = Oe(r);
        var d = r ? ea(t) : 0;
        return r && d < r ? ai(r - d, l) + t : t;
      }
      function U3(t, r, l) {
        return l || r == null ? r = 0 : r && (r = +r), j0(Ye(t).replace(bs, ""), r || 0);
      }
      function K3(t, r, l) {
        return (l ? Pn(t, r, l) : r === o) ? r = 1 : r = Oe(r), qs(Ye(t), r);
      }
      function P3() {
        var t = arguments, r = Ye(t[0]);
        return t.length < 3 ? r : r.replace(t[1], t[2]);
      }
      var D3 = sa(function(t, r, l) {
        return t + (l ? "_" : "") + r.toLowerCase();
      });
      function L3(t, r, l) {
        return l && typeof l != "number" && Pn(t, r, l) && (r = l = o), l = l === o ? L : l >>> 0, l ? (t = Ye(t), t && (typeof r == "string" || r != null && !pc(r)) && (r = no(r), !r && Xt(t)) ? it(So(t), 0, l) : t.split(r, l)) : [];
      }
      var N3 = sa(function(t, r, l) {
        return t + (l ? " " : "") + mc(r);
      });
      function M3(t, r, l) {
        return t = Ye(t), l = l == null ? 0 : St(Oe(l), 0, t.length), r = no(r), t.slice(l, l + r.length) == r;
      }
      function j3(t, r, l) {
        var d = v.templateSettings;
        l && Pn(t, r, l) && (r = o), t = Ye(t), r = hi({}, r, d, Id);
        var g = hi({}, r.imports, d.imports, Id), x = Cn(g), S = _s(g, x), R, T, W = 0, Y = r.interpolate || _r, ee = "__p += '", ue = Is(
          (r.escape || _r).source + "|" + Y.source + "|" + (Y === xn ? ym : _r).source + "|" + (r.evaluate || _r).source + "|$",
          "g"
        ), ve = "//# sourceURL=" + (Je.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Gm + "]") + `
`;
        t.replace(ue, function(ke, Me, Qe, to, Dn, ao) {
          return Qe || (Qe = to), ee += t.slice(W, ao).replace(Rm, h0), Me && (R = !0, ee += `' +
__e(` + Me + `) +
'`), Dn && (T = !0, ee += `';
` + Dn + `;
__p += '`), Qe && (ee += `' +
((__t = (` + Qe + `)) == null ? '' : __t) +
'`), W = ao + ke.length, ke;
        }), ee += `';
`;
        var Ee = Je.call(r, "variable") && r.variable;
        if (!Ee)
          ee = `with (obj) {
` + ee + `
}
`;
        else if (mm.test(Ee))
          throw new Fe(u);
        ee = (T ? ee.replace(Ue, "") : ee).replace(yn, "$1").replace(jn, "$1;"), ee = "function(" + (Ee || "obj") + `) {
` + (Ee ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (R ? ", __e = _.escape" : "") + (T ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ee + `return __p
}`;
        var Ke = Ef(function() {
          return We(x, ve + "return " + ee).apply(o, S);
        });
        if (Ke.source = ee, bc(Ke))
          throw Ke;
        return Ke;
      }
      function $3(t) {
        return Ye(t).toLowerCase();
      }
      function Q3(t) {
        return Ye(t).toUpperCase();
      }
      function H3(t, r, l) {
        if (t = Ye(t), t && (l || r === o))
          return TA(t);
        if (!t || !(r = no(r)))
          return t;
        var d = So(t), g = So(r), x = OA(d, g), S = UA(d, g) + 1;
        return it(d, x, S).join("");
      }
      function V3(t, r, l) {
        if (t = Ye(t), t && (l || r === o))
          return t.slice(0, PA(t) + 1);
        if (!t || !(r = no(r)))
          return t;
        var d = So(t), g = UA(d, So(r)) + 1;
        return it(d, 0, g).join("");
      }
      function q3(t, r, l) {
        if (t = Ye(t), t && (l || r === o))
          return t.replace(bs, "");
        if (!t || !(r = no(r)))
          return t;
        var d = So(t), g = OA(d, So(r));
        return it(d, g).join("");
      }
      function W3(t, r) {
        var l = Ae, d = se;
        if (dn(r)) {
          var g = "separator" in r ? r.separator : g;
          l = "length" in r ? Oe(r.length) : l, d = "omission" in r ? no(r.omission) : d;
        }
        t = Ye(t);
        var x = t.length;
        if (Xt(t)) {
          var S = So(t);
          x = S.length;
        }
        if (l >= x)
          return t;
        var R = l - ea(d);
        if (R < 1)
          return d;
        var T = S ? it(S, 0, R).join("") : t.slice(0, R);
        if (g === o)
          return T + d;
        if (S && (R += T.length - R), pc(g)) {
          if (t.slice(R).search(g)) {
            var W, Y = T;
            for (g.global || (g = Is(g.source, Ye(eA.exec(g)) + "g")), g.lastIndex = 0; W = g.exec(Y); )
              var ee = W.index;
            T = T.slice(0, ee === o ? R : ee);
          }
        } else if (t.indexOf(no(g), R) != R) {
          var ue = T.lastIndexOf(g);
          ue > -1 && (T = T.slice(0, ue));
        }
        return T + d;
      }
      function Y3(t) {
        return t = Ye(t), t && xt.test(t) ? t.replace(Jn, w0) : t;
      }
      var z3 = sa(function(t, r, l) {
        return t + (l ? " " : "") + r.toUpperCase();
      }), mc = Ed("toUpperCase");
      function wf(t, r, l) {
        return t = Ye(t), r = l ? o : r, r === o ? m0(t) ? S0(t) : l0(t) : t.match(r) || [];
      }
      var Ef = De(function(t, r) {
        try {
          return Xn(t, o, r);
        } catch (l) {
          return bc(l) ? l : new Fe(l);
        }
      }), G3 = $o(function(t, r) {
        return Ao(r, function(l) {
          l = Ko(l), Mo(t, l, dc(t[l], t));
        }), t;
      });
      function Z3(t) {
        var r = t == null ? 0 : t.length, l = ye();
        return t = r ? ln(t, function(d) {
          if (typeof d[1] != "function")
            throw new fo(c);
          return [l(d[0]), d[1]];
        }) : [], De(function(d) {
          for (var g = -1; ++g < r; ) {
            var x = t[g];
            if (Xn(x[0], this, d))
              return Xn(x[1], this, d);
          }
        });
      }
      function J3(t) {
        return wv(po(t, m));
      }
      function vc(t) {
        return function() {
          return t;
        };
      }
      function X3(t, r) {
        return t == null || t !== t ? r : t;
      }
      var ex = Sd(), nx = Sd(!0);
      function qn(t) {
        return t;
      }
      function yc(t) {
        return od(typeof t == "function" ? t : po(t, m));
      }
      function ox(t) {
        return ad(po(t, m));
      }
      function tx(t, r) {
        return rd(t, po(r, m));
      }
      var ax = De(function(t, r) {
        return function(l) {
          return Ya(l, t, r);
        };
      }), rx = De(function(t, r) {
        return function(l) {
          return Ya(t, l, r);
        };
      });
      function xc(t, r, l) {
        var d = Cn(r), g = Zr(r, d);
        l == null && !(dn(r) && (g.length || !d.length)) && (l = r, r = t, t = this, g = Zr(r, Cn(r)));
        var x = !(dn(l) && "chain" in l) || !!l.chain, S = Ho(t);
        return Ao(g, function(R) {
          var T = r[R];
          t[R] = T, S && (t.prototype[R] = function() {
            var W = this.__chain__;
            if (x || W) {
              var Y = t(this.__wrapped__), ee = Y.__actions__ = Qn(this.__actions__);
              return ee.push({ func: T, args: arguments, thisArg: t }), Y.__chain__ = W, Y;
            }
            return T.apply(t, et([this.value()], arguments));
          });
        }), t;
      }
      function ix() {
        return Bn._ === this && (Bn._ = T0), this;
      }
      function Cc() {
      }
      function sx(t) {
        return t = Oe(t), De(function(r) {
          return id(r, t);
        });
      }
      var cx = Xs(ln), lx = Xs(RA), ux = Xs(Es);
      function kf(t) {
        return ic(t) ? ks(Ko(t)) : Mv(t);
      }
      function Ax(t) {
        return function(r) {
          return t == null ? o : Rt(t, r);
        };
      }
      var dx = Bd(), fx = Bd(!0);
      function wc() {
        return [];
      }
      function Ec() {
        return !1;
      }
      function bx() {
        return {};
      }
      function px() {
        return "";
      }
      function hx() {
        return !0;
      }
      function gx(t, r) {
        if (t = Oe(t), t < 1 || t > q)
          return [];
        var l = L, d = In(t, L);
        r = ye(r), t -= L;
        for (var g = Bs(d, r); ++l < t; )
          r(l);
        return g;
      }
      function mx(t) {
        return Ie(t) ? ln(t, Ko) : oo(t) ? [t] : Qn(Hd(Ye(t)));
      }
      function vx(t) {
        var r = ++F0;
        return Ye(t) + r;
      }
      var yx = ti(function(t, r) {
        return t + r;
      }, 0), xx = ec("ceil"), Cx = ti(function(t, r) {
        return t / r;
      }, 1), wx = ec("floor");
      function Ex(t) {
        return t && t.length ? Gr(t, qn, Ns) : o;
      }
      function kx(t, r) {
        return t && t.length ? Gr(t, ye(r, 2), Ns) : o;
      }
      function Sx(t) {
        return FA(t, qn);
      }
      function Rx(t, r) {
        return FA(t, ye(r, 2));
      }
      function Bx(t) {
        return t && t.length ? Gr(t, qn, Qs) : o;
      }
      function _x(t, r) {
        return t && t.length ? Gr(t, ye(r, 2), Qs) : o;
      }
      var Fx = ti(function(t, r) {
        return t * r;
      }, 1), Ix = ec("round"), Tx = ti(function(t, r) {
        return t - r;
      }, 0);
      function Ox(t) {
        return t && t.length ? Rs(t, qn) : 0;
      }
      function Ux(t, r) {
        return t && t.length ? Rs(t, ye(r, 2)) : 0;
      }
      return v.after = oy, v.ary = nf, v.assign = Qy, v.assignIn = hf, v.assignInWith = hi, v.assignWith = Hy, v.at = Vy, v.before = of, v.bind = dc, v.bindAll = G3, v.bindKey = tf, v.castArray = by, v.chain = Jd, v.chunk = w1, v.compact = E1, v.concat = k1, v.cond = Z3, v.conforms = J3, v.constant = vc, v.countBy = O2, v.create = qy, v.curry = af, v.curryRight = rf, v.debounce = sf, v.defaults = Wy, v.defaultsDeep = Yy, v.defer = ty, v.delay = ay, v.difference = S1, v.differenceBy = R1, v.differenceWith = B1, v.drop = _1, v.dropRight = F1, v.dropRightWhile = I1, v.dropWhile = T1, v.fill = O1, v.filter = K2, v.flatMap = L2, v.flatMapDeep = N2, v.flatMapDepth = M2, v.flatten = Yd, v.flattenDeep = U1, v.flattenDepth = K1, v.flip = ry, v.flow = ex, v.flowRight = nx, v.fromPairs = P1, v.functions = n3, v.functionsIn = o3, v.groupBy = j2, v.initial = L1, v.intersection = N1, v.intersectionBy = M1, v.intersectionWith = j1, v.invert = a3, v.invertBy = r3, v.invokeMap = Q2, v.iteratee = yc, v.keyBy = H2, v.keys = Cn, v.keysIn = Vn, v.map = ui, v.mapKeys = s3, v.mapValues = c3, v.matches = ox, v.matchesProperty = tx, v.memoize = di, v.merge = l3, v.mergeWith = gf, v.method = ax, v.methodOf = rx, v.mixin = xc, v.negate = fi, v.nthArg = sx, v.omit = u3, v.omitBy = A3, v.once = iy, v.orderBy = V2, v.over = cx, v.overArgs = sy, v.overEvery = lx, v.overSome = ux, v.partial = fc, v.partialRight = cf, v.partition = q2, v.pick = d3, v.pickBy = mf, v.property = kf, v.propertyOf = Ax, v.pull = V1, v.pullAll = Gd, v.pullAllBy = q1, v.pullAllWith = W1, v.pullAt = Y1, v.range = dx, v.rangeRight = fx, v.rearg = cy, v.reject = z2, v.remove = z1, v.rest = ly, v.reverse = uc, v.sampleSize = Z2, v.set = b3, v.setWith = p3, v.shuffle = J2, v.slice = G1, v.sortBy = ny, v.sortedUniq = t2, v.sortedUniqBy = a2, v.split = L3, v.spread = uy, v.tail = r2, v.take = i2, v.takeRight = s2, v.takeRightWhile = c2, v.takeWhile = l2, v.tap = E2, v.throttle = Ay, v.thru = li, v.toArray = ff, v.toPairs = vf, v.toPairsIn = yf, v.toPath = mx, v.toPlainObject = pf, v.transform = h3, v.unary = dy, v.union = u2, v.unionBy = A2, v.unionWith = d2, v.uniq = f2, v.uniqBy = b2, v.uniqWith = p2, v.unset = g3, v.unzip = Ac, v.unzipWith = Zd, v.update = m3, v.updateWith = v3, v.values = ua, v.valuesIn = y3, v.without = h2, v.words = wf, v.wrap = fy, v.xor = g2, v.xorBy = m2, v.xorWith = v2, v.zip = y2, v.zipObject = x2, v.zipObjectDeep = C2, v.zipWith = w2, v.entries = vf, v.entriesIn = yf, v.extend = hf, v.extendWith = hi, xc(v, v), v.add = yx, v.attempt = Ef, v.camelCase = E3, v.capitalize = xf, v.ceil = xx, v.clamp = x3, v.clone = py, v.cloneDeep = gy, v.cloneDeepWith = my, v.cloneWith = hy, v.conformsTo = vy, v.deburr = Cf, v.defaultTo = X3, v.divide = Cx, v.endsWith = k3, v.eq = Bo, v.escape = S3, v.escapeRegExp = R3, v.every = U2, v.find = P2, v.findIndex = qd, v.findKey = zy, v.findLast = D2, v.findLastIndex = Wd, v.findLastKey = Gy, v.floor = wx, v.forEach = Xd, v.forEachRight = ef, v.forIn = Zy, v.forInRight = Jy, v.forOwn = Xy, v.forOwnRight = e3, v.get = hc, v.gt = yy, v.gte = xy, v.has = t3, v.hasIn = gc, v.head = zd, v.identity = qn, v.includes = $2, v.indexOf = D1, v.inRange = C3, v.invoke = i3, v.isArguments = Ft, v.isArray = Ie, v.isArrayBuffer = Cy, v.isArrayLike = Hn, v.isArrayLikeObject = hn, v.isBoolean = wy, v.isBuffer = st, v.isDate = Ey, v.isElement = ky, v.isEmpty = Sy, v.isEqual = Ry, v.isEqualWith = By, v.isError = bc, v.isFinite = _y, v.isFunction = Ho, v.isInteger = lf, v.isLength = bi, v.isMap = uf, v.isMatch = Fy, v.isMatchWith = Iy, v.isNaN = Ty, v.isNative = Oy, v.isNil = Ky, v.isNull = Uy, v.isNumber = Af, v.isObject = dn, v.isObjectLike = bn, v.isPlainObject = er, v.isRegExp = pc, v.isSafeInteger = Py, v.isSet = df, v.isString = pi, v.isSymbol = oo, v.isTypedArray = la, v.isUndefined = Dy, v.isWeakMap = Ly, v.isWeakSet = Ny, v.join = $1, v.kebabCase = B3, v.last = go, v.lastIndexOf = Q1, v.lowerCase = _3, v.lowerFirst = F3, v.lt = My, v.lte = jy, v.max = Ex, v.maxBy = kx, v.mean = Sx, v.meanBy = Rx, v.min = Bx, v.minBy = _x, v.stubArray = wc, v.stubFalse = Ec, v.stubObject = bx, v.stubString = px, v.stubTrue = hx, v.multiply = Fx, v.nth = H1, v.noConflict = ix, v.noop = Cc, v.now = Ai, v.pad = I3, v.padEnd = T3, v.padStart = O3, v.parseInt = U3, v.random = w3, v.reduce = W2, v.reduceRight = Y2, v.repeat = K3, v.replace = P3, v.result = f3, v.round = Ix, v.runInContext = I, v.sample = G2, v.size = X2, v.snakeCase = D3, v.some = ey, v.sortedIndex = Z1, v.sortedIndexBy = J1, v.sortedIndexOf = X1, v.sortedLastIndex = e2, v.sortedLastIndexBy = n2, v.sortedLastIndexOf = o2, v.startCase = N3, v.startsWith = M3, v.subtract = Tx, v.sum = Ox, v.sumBy = Ux, v.template = j3, v.times = gx, v.toFinite = Vo, v.toInteger = Oe, v.toLength = bf, v.toLower = $3, v.toNumber = mo, v.toSafeInteger = $y, v.toString = Ye, v.toUpper = Q3, v.trim = H3, v.trimEnd = V3, v.trimStart = q3, v.truncate = W3, v.unescape = Y3, v.uniqueId = vx, v.upperCase = z3, v.upperFirst = mc, v.each = Xd, v.eachRight = ef, v.first = zd, xc(v, function() {
        var t = {};
        return Oo(v, function(r, l) {
          Je.call(v.prototype, l) || (t[l] = r);
        }), t;
      }(), { chain: !1 }), v.VERSION = a, Ao(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        v[t].placeholder = v;
      }), Ao(["drop", "take"], function(t, r) {
        je.prototype[t] = function(l) {
          l = l === o ? 1 : vn(Oe(l), 0);
          var d = this.__filtered__ && !r ? new je(this) : this.clone();
          return d.__filtered__ ? d.__takeCount__ = In(l, d.__takeCount__) : d.__views__.push({
            size: In(l, L),
            type: t + (d.__dir__ < 0 ? "Right" : "")
          }), d;
        }, je.prototype[t + "Right"] = function(l) {
          return this.reverse()[t](l).reverse();
        };
      }), Ao(["filter", "map", "takeWhile"], function(t, r) {
        var l = r + 1, d = l == ne || l == $;
        je.prototype[t] = function(g) {
          var x = this.clone();
          return x.__iteratees__.push({
            iteratee: ye(g, 3),
            type: l
          }), x.__filtered__ = x.__filtered__ || d, x;
        };
      }), Ao(["head", "last"], function(t, r) {
        var l = "take" + (r ? "Right" : "");
        je.prototype[t] = function() {
          return this[l](1).value()[0];
        };
      }), Ao(["initial", "tail"], function(t, r) {
        var l = "drop" + (r ? "" : "Right");
        je.prototype[t] = function() {
          return this.__filtered__ ? new je(this) : this[l](1);
        };
      }), je.prototype.compact = function() {
        return this.filter(qn);
      }, je.prototype.find = function(t) {
        return this.filter(t).head();
      }, je.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, je.prototype.invokeMap = De(function(t, r) {
        return typeof t == "function" ? new je(this) : this.map(function(l) {
          return Ya(l, t, r);
        });
      }), je.prototype.reject = function(t) {
        return this.filter(fi(ye(t)));
      }, je.prototype.slice = function(t, r) {
        t = Oe(t);
        var l = this;
        return l.__filtered__ && (t > 0 || r < 0) ? new je(l) : (t < 0 ? l = l.takeRight(-t) : t && (l = l.drop(t)), r !== o && (r = Oe(r), l = r < 0 ? l.dropRight(-r) : l.take(r - t)), l);
      }, je.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, je.prototype.toArray = function() {
        return this.take(L);
      }, Oo(je.prototype, function(t, r) {
        var l = /^(?:filter|find|map|reject)|While$/.test(r), d = /^(?:head|last)$/.test(r), g = v[d ? "take" + (r == "last" ? "Right" : "") : r], x = d || /^find/.test(r);
        g && (v.prototype[r] = function() {
          var S = this.__wrapped__, R = d ? [1] : arguments, T = S instanceof je, W = R[0], Y = T || Ie(S), ee = function(Me) {
            var Qe = g.apply(v, et([Me], R));
            return d && ue ? Qe[0] : Qe;
          };
          Y && l && typeof W == "function" && W.length != 1 && (T = Y = !1);
          var ue = this.__chain__, ve = !!this.__actions__.length, Ee = x && !ue, Ke = T && !ve;
          if (!x && Y) {
            S = Ke ? S : new je(this);
            var ke = t.apply(S, R);
            return ke.__actions__.push({ func: li, args: [ee], thisArg: o }), new bo(ke, ue);
          }
          return Ee && Ke ? t.apply(this, R) : (ke = this.thru(ee), Ee ? d ? ke.value()[0] : ke.value() : ke);
        });
      }), Ao(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var r = Kr[t], l = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", d = /^(?:pop|shift)$/.test(t);
        v.prototype[t] = function() {
          var g = arguments;
          if (d && !this.__chain__) {
            var x = this.value();
            return r.apply(Ie(x) ? x : [], g);
          }
          return this[l](function(S) {
            return r.apply(Ie(S) ? S : [], g);
          });
        };
      }), Oo(je.prototype, function(t, r) {
        var l = v[r];
        if (l) {
          var d = l.name + "";
          Je.call(aa, d) || (aa[d] = []), aa[d].push({ name: r, func: l });
        }
      }), aa[oi(o, O).name] = [{
        name: "wrapper",
        func: o
      }], je.prototype.clone = Y0, je.prototype.reverse = z0, je.prototype.value = G0, v.prototype.at = k2, v.prototype.chain = S2, v.prototype.commit = R2, v.prototype.next = B2, v.prototype.plant = F2, v.prototype.reverse = I2, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = T2, v.prototype.first = v.prototype.head, ja && (v.prototype[ja] = _2), v;
    }, na = R0();
    Ct ? ((Ct.exports = na)._ = na, ys._ = na) : Bn._ = na;
  }).call(dt);
})(Vi, Vi.exports);
var F8 = Vi.exports;
const I8 = (n, e, o) => {
  let a = {};
  if (!n)
    throw new Error("A root content key is required to parse CMS data");
  if (!e)
    throw new Error(
      "Data from a CMS system must be passed in order to format data for use"
    );
  return typeof e == "object" && (a = cm(e, n)), o ? o(a) : F8.isEmpty(a) ? null : a;
}, Sp = (n) => !!(n && typeof n == "object" && !Array.isArray(n));
function cm(n, e) {
  let o = null;
  return Sp(n) && Object.entries(n).forEach((i) => {
    const [s, c] = i;
    if (s === e)
      o = c;
    else if (Sp(c)) {
      const u = cm(c, e);
      u !== null && (o = u);
    }
  }), o;
}
const T8 = { id: "genericpage-a19bd7bc73", designPath: "/etc/designs/iinvestor", title: "Paperless", brandSlug: "", lastModifiedDate: 1689260374568, templateName: "api-endpoint", htmlPageItems: [], cssClassNames: "genericpage page basicpage", language: "en", ":itemsOrder": ["root"], ":items": { root: { columnClassNames: { contentfragment: "aem-GridColumn aem-GridColumn--default--12" }, gridClassNames: "aem-Grid aem-Grid--12 aem-Grid--default--12", columnCount: 12, allowedComponents: { components: [{ path: "/content/iinvestor/en/terms-and-conditions/paperless/jcr:content/root/pi-web/components/content/contentfragment", title: "Content Fragment" }, { path: "/content/iinvestor/en/terms-and-conditions/paperless/jcr:content/root/pi-web/components/content/contentfragmentlist", title: "Content Fragment List" }], applicable: !1 }, ":itemsOrder": ["contentfragment"], ":items": { contentfragment: { id: "contentfragment-68c36a8739", description: "", title: "Paperless", ":type": "pi-web/components/content/contentfragment", ":itemsOrder": [], ":items": {}, elementsOrder: ["main"], elements: { main: { dataType: "string", title: "main", value: `<h2 style="text-align: center;"><b>Electronic Consent to Paperless Services</b></h2>
<h2 style="text-align: center;"><b>Terms and Conditions</b></h2>
<p>By electing to receive some or all of the following categories of documents electronically instead of via a paper copy, you are subscribing to T. Rowe Price Paperless Services (“Paperless Services”) and agreeing to these terms and conditions. Your consent will apply to all existing mutual fund, Brokerage, and/or college savings plan accounts (as applicable) on which you are the primary account holder or authorized party, subject to certain conditions outlined below. (Paperless Services may not be available for certain accounts where a minor is the account holder, such as an UTMA account.)&nbsp; Once you consent to electronic delivery (“e-delivery”), when your documents become available, we will send you an email alerting you that the documents are ready online to view, print and/or download. You may need to access some documents securely by logging into your account online. You may change your e-delivery preferences or revoke your consent to receive documents electronically at any time by logging into your account. All of the documents available via Paperless Services are in portable document format (PDF). You must have PDF viewing software, such as Adobe® Acrobat® Reader (available for download at no cost at adobe.com), installed on your computer in order to view documents available via Paperless Services. For compliance, business, or security reasons, or because certain documents may not be available for e-delivery, we may continue to send paper copies of certain documents to you. In the future, as additional documents become available for e-delivery, you may begin to receive them in accordance with these terms and conditions and the scope of your consent.</p>
<h3><b>I. T. ROWE PRICE MUTUAL FUND ACCOUNTS</b></h3>
<p>You may request a paper copy of any of the following documents free of charge at any time by calling <a href="tel:1-800-225-5132">1-800-225-5132</a>. For mutual funds and ETFs (exchange traded funds) held through a T. Rowe Price Brokerage account (“Brokerage Account”), see the T. Rowe Price Brokerage Accounts section, below.</p>
<ol>
<li><b>Statements</b>. This category includes statements and any disclosures included with your statement, such as our privacy policy and certain other disclosures related to your statement and/or account. If you also hold a Brokerage Account(s), your mutual fund and Brokerage statements are delivered together, so e-delivery of one requires e-delivery of the other.</li>
<li><b>Confirmations. </b>This category includes confirmations for transactions in your account(s) and confirmations of certain account maintenance changes. However, to help protect against fraud, we may also send a paper confirmation of certain account maintenance changes to your address of record. As a condition of receiving mutual fund confirmations electronically, you must also consent to receive prospectuses and shareholder reports electronically (if available) in lieu of paper copies. If you choose to unsubscribe from e-delivery of prospectuses/shareholder reports, you will be automatically unsubscribed from e- delivery of T. Rowe Price mutual fund and T. Rowe Price Brokerage account confirmations as well. If you also hold a Brokerage Account(s), e-delivery of your mutual fund confirmations requires e-delivery of your Brokerage confirmations.</li>
<li><b>Prospectuses and Shareholder Reports. </b>This category includes T. Rowe Price mutual fund prospectuses, prospectus supplements and shareholder reports. You also may receive other critical communications regarding the T. Rowe Price mutual funds electronically.</li>
<li><b>Proxy Materials</b>. This category includes proxy materials for T. Rowe Price mutual funds.</li>
<li><b>Tax Forms. </b>This category includes tax forms that we are required to deliver and are permitted to do so via e-delivery including, but not limited to, IRS Form 1099-DIV, IRS Form 1099-B, IRS Form 1099-R, IRS Form 5498, etc.</li>
<li><b>Client Communications. </b>This category includes, but is not limited to, any legal, regulatory, or other disclosures or documentation associated with an account not otherwise described in other categories, including, but not limited to, Customer Relationship Summaries (also known as “Forms CRS”), agreements, terms and conditions, authorizations, updates, notices, etc.</li>
</ol>
<h3><b>II. T. ROWE PRICE BROKERAGE ACCOUNTS</b></h3>
<ol>
<li><b>Statements. </b>This category includes statements and any disclosures included with your statement, such as our privacy policy and certain other disclosures related to your statement and/or Brokerage Account. If you also hold a mutual fund account(s), your Brokerage and mutual fund statements are delivered together, so e-delivery of one requires e-delivery of the other.</li>
<li><b>Confirmations. </b>This category includes Brokerage confirmations for transactions in your account(s) and confirmations of certain Brokerage account maintenance changes. However, to help protect against fraud, we may also send a paper confirmation of certain Brokerage account maintenance changes to your address of record. As a condition of receiving Brokerage confirmations electronically, you must also consent to receive T. Rowe Price mutual fund prospectuses and shareholder reports electronically (if available) in lieu of paper copies. If you choose to unsubscribe from e-delivery of prospectuses/shareholder reports, you will be automatically unsubscribed from e-delivery of T. Rowe Price Brokerage and T. Rowe Price mutual fund account confirmations as well. If you also hold a mutual fund account(s), e-delivery of your Brokerage confirmations requires e-delivery of your mutual fund confirmations.</li>
<li><b>Prospectuses. </b>This category includes prospectuses for ETFs, mutual funds, and UITs held within your Brokerage account.</li>
<li><b>Proxy / Shareholder Communications. </b>This category includes proxies, annual reports, annual prospectuses and other communications sent by a security issuer. These communications are generally regulatory in nature and sent by the issuer to security holders as of a specified date.</li>
<li><b>Tax Forms. </b>This category includes tax forms that we are required to deliver and are permitted to do so via e-delivery including, but not limited to, IRS Form 1099-DIV, IRS Form 1099-B, IRS Form 1099-R, IRS Form 5498, etc.</li>
<li><b>Client Communications. </b>This category includes, but is not limited to, any legal, regulatory, or other disclosures or documentation associated with an account not otherwise described in other categories, including, but not limited to, Customer Relationship Summaries (also known as “Forms CRS”), corporate action materials, agreements, terms and conditions, authorizations, updates, notices, etc.</li>
</ol>
<p>T. Rowe Price Brokerage is a division of T. Rowe Price Investment Services, Inc., member FINRA/SIPC. Accounts are carried by Pershing LLC, a BNY Mellon company, member NYSE/ FINRA/SIPC.</p>
<h3><b>III.&nbsp;T. ROWE PRICE ADVISORY ACCOUNTS&nbsp; - T. Rowe Price® ActivePlus Portfolios® Program and T. Rowe Price® Retirement Advisory Service™ Accounts</b></h3>
<h4><b>All Client Communications, Documents and Disclosures</b></h4>
<p>E-delivery is required for all T. Rowe Price® ActivePlus Portfolios® Program (Program) and T. Rowe Price® Retirement Advisory Service™ (Service) accounts and therefore your account may be terminated if you do not maintain an accurate and up-to-date e-mail address with the Program/Service. You have the right to request in writing, free of charge, a copy of the ADV Brochure and certain documents required to be delivered under the Internal Revenue Code, and any such request does not negate your consent to e-delivery.</p>
<h3><b>IV.&nbsp;COLLEGE SAVINGS PLAN ACCOUNTS</b></h3>
<ol>
<li><b>Statements. </b>This category includes statements and any disclosures included with your statement, such as annual Municipal Securities Rulemaking Board (“MSRB”) notifications.</li>
<li><b>Confirmations. </b>This category includes confirmations for transactions in your account(s) and confirmations of certain account maintenance changes. However, to help protect against fraud, we may also send a paper confirmation of certain account maintenance changes to your address of record.</li>
<li><b>Plan Disclosure Documents / Plan Disclosure Statements. </b>This category includes annual Plan Disclosure Documents or Statements as well as any supplements to Plan Disclosure Documents or Statements.</li>
<li><b>Tax Forms</b>. This category includes tax forms that we are required to deliver and permitted to do so via e-delivery including IRS Form 1099-Q. Only tax forms reported under the Social Security Number of the account holder are available for e-delivery. Tax forms reported under the Social Security Number of the beneficiary of the college savings plan account will continue to be mailed to the beneficiary, even if the account holder has elected e-delivery of tax forms.</li>
<li><b>Client Communications</b>. This category includes, but is not limited to, any legal, regulatory, or other disclosures or documentation associated with an account not otherwise described in other categories, including, but not limited to, account updates, account servicing communications, agreements, terms and conditions, authorizations, updates, notices, etc.</li>
</ol>
<p><b>Important Information</b><br>
If you do not have the ability to access, print, and retain PDF files, do not subscribe to Paperless Services. If you need technical assistance, please call <a href="https://www.troweprice.com/personal-investing/help/technical-support.html" target="_blank">T. Rowe Price Technical Support</a> (for T. Rowe Price mutual fund and T. Rowe Price Brokerage account holders) or the appropriate College Savings Plan representative (for College Savings Plan account holders).</p>
<p>For security purposes, we also require that customers have 128-bit encryption when gaining access to accounts online. Although most Internet Service Providers allow unlimited usage, some may charge or have usage limits, and you are responsible for additional charges incurred.</p>
<p><b>We generally make several attempts to email you when a document becomes available online. If these attempts fail, we will unsubscribe you from Paperless Services and automatically deliver the paper version of the document to your address of record for this mailing and all future mailings until you successfully re-subscribe to Paperless Services, and you also may be subject to an annual account service fee (as applicable). If your e-mail address changes, please update your e-mail address promptly on the contact information page in the Profile section of Account Access. We reserve the right to unsubscribe you from Paperless Services at any time without notice except with regard to any T. Rowe Price® ActivePlus Portfolios® or T. Rowe Price® Retirement Advisory Service™ account held by you.</b></p>
<p>Your consent applies to all of your current accounts as well as any future accounts you open online via the T. Rowe Price website (or a website for a college savings plan for which T. Rowe Price is program manager) and for which you are the primary account holder or authorized party. For purposes of these Paperless Services, T. Rowe Price offers the following “account types” – T. Rowe Price mutual fund accounts, T. Rowe Price Brokerage accounts, and T. Rowe Price college savings plan accounts (including the Maryland College Investment Plan, Alaska 529 and T. Rowe Price College Savings Plans). Your consent applies to all of your existing T. Rowe Price mutual fund, Brokerage, and college savings plan accounts, as applicable. If you do not currently hold one of these account types but open one or more in the future online via the T. Rowe Price website (or a website for a college savings plan for which T. Rowe Price is program manager), your consent will extend to these new account types. Your consent will <u>not</u> apply to any future account types opened via a paper new account application (except for mutual fund/Brokerage account statements and confirmations, which share the same delivery method).</p>
<p>In the case of accounts with multiple owners, you represent that you have the authority to act on behalf of all owners and consent to Paperless Services on behalf of all owners and for all documents (except account statements and tax forms) to be sent to the e-mail address you have designated. Account statements are provided to each owner of the account individually, so individual account owners can select how statements are delivered to them whether in paper or by e-delivery. Tax forms are issued and sent to the person whose social security number or tax identification number is identified as the owner, for tax reporting purposes, on the account. Consent to e-delivery of all other documents (confirmations, prospectuses, etc.) is governed by the paperless preferences of the primary account holder or authorized party.</p>
<p>Your consent is effective until revocation by you, unless you are unsubscribed from Paperless Services by T. Rowe Price as described above. Except with regard to any T. Rowe Price® ActivePlus Portfolios® or T. Rowe Price® Retirement Advisory Service™ account you may hold, you always have the option to revoke your consent and unsubscribe from Paperless Services at any time. You may unsubscribe by going to the Paperless Preferences page in the Profile section of Account Access. If you change your delivery preferences close to a document delivery date, you may receive the materials via your previous chosen delivery method or both&nbsp;electronically and in paper.</p>
<p>Educational materials or marketing for T. Rowe Price products or services are not covered by these Paperless Terms; to opt in or out of receiving these materials, please go to the Subscriptions page in the Profile section of Account Access.</p>
<p>If you have any questions, or if you would like paper copies of any of the above-referenced documents at no charge, please <a href="https://www.troweprice.com/personal-investing/help/contact/index.html" target="_blank">contact us</a>.</p>
`, ":type": "text/html", multiValue: !1 } }, model: "iinvestor/PI-CF-Models/models/pi-simple-cf-model" } }, ":type": "wcm/foundation/components/responsivegrid" } }, ":type": "pi-web/components/structure/genericpage" }, O8 = rs.create({
  headers: {
    "Application-Type": "application/json"
  }
}), U8 = async () => {
  let n;
  if (process.env.REACT_APP_MOCK)
    n = T8;
  else {
    const e = window.location.href.split("troweprice.com")[0];
    try {
      n = await O8.get(`${e}troweprice.com/personal-investing/terms-and-conditions/paperless.model.json`);
    } catch {
      return "<div><strong>Error: please try again later</strong><br /><br /></div>";
    }
  }
  return I8(
    "main",
    n,
    (e) => e.value
  );
}, cR = () => {
  const [n, e] = va(!1), [o, a] = va(!1);
  return U8().then((i) => a(i)), /* @__PURE__ */ p.jsxs(Fp, { children: [
    /* @__PURE__ */ p.jsx(
      Ku,
      {
        open: n,
        onClose: () => e(!1),
        fullWidth: !0,
        maxWidth: "md",
        "data-metrics-location": "PU",
        children: /* @__PURE__ */ p.jsx(Pu, { children: /* @__PURE__ */ p.jsx(
          "div",
          {
            dangerouslySetInnerHTML: {
              __html: o
            }
          }
        ) })
      }
    ),
    /* @__PURE__ */ p.jsx(
      Io,
      {
        onClick: () => e(!0),
        style: { cursor: "pointer", textDecoration: "underline", color: "#086EA1" },
        children: "Electronic Consent to Paperless Services Terms and Conditions"
      }
    )
  ] });
}, K8 = "/aps-services/service/client/v2/document/latest?allEngagements=false&docType=FINANCIAL_PLAN", P8 = "application/json", D8 = 15e3, L8 = 100, N8 = rs.create({
  withCredentials: !0,
  timeout: D8,
  headers: {
    "Cache-Control": "no-cache",
    Accept: P8,
    "X-TRP-Requested-With": "XMLHttpRequest"
  }
}), lR = async (n) => {
  try {
    const e = await N8.get(K8, {
      baseURL: n.serviceHost,
      responseType: "arraybuffer",
      headers: {
        apikey: n.apiKey,
        Accept: "application/pdf"
      }
    });
    if (e) {
      const { data: o } = e;
      if (o !== void 0) {
        const a = new Blob([o], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob)
          window.navigator.msSaveOrOpenBlob(a, `Personalized_Plan_${Fa(n.documentDate).format("MM-DD-YYYY")}.pdf`);
        else
          try {
            const i = document.createElement("a");
            return i.href = window.URL.createObjectURL(a), i.download = `Personalized_Plan_${Fa(n.documentDate).format("MM-DD-YYYY")}.pdf`, i.click(), setTimeout(() => {
              window.URL.revokeObjectURL(o);
            }, L8), "success";
          } catch (i) {
            console.log(i);
          }
      }
    }
  } catch (e) {
    console.log(e);
  }
}, M8 = {
  fontFamily: {
    reg: "Nimbus Sans Reg",
    bold: "Nimbus Sans Bold",
    light: "Nimbus Sans Light"
  },
  fontVars: {
    xxsmall: "10px",
    xsmall: "12px",
    small: "14px",
    medium: "16px",
    mediumLH: "22px",
    xmedium: "18px",
    large: "20px",
    xlarge: "24px",
    xxlarge: "36px",
    xxxlarge: "48px",
    titleFont: "18px",
    labelSupFont: "100%",
    h1Font: "56px",
    h2Font: "48px",
    h3Font: "40px",
    h4Font: "32px",
    h4FontLH: "38px",
    h5Font: "24px",
    h6Font: "20px",
    title: "40px",
    subtitle1: "16px",
    body1: "16px",
    body2: "12px",
    caption: "12px",
    p1Font: "16px",
    p2Font: "14px",
    h1FontMobile: "40px",
    h2FontMobile: "32px",
    h3FontMobile: "32px",
    h4FontMobile: "24px",
    h5FontMobile: "24px"
  },
  gutterFPS: 4,
  spacingVars: {
    small: "8px",
    medium: "12px",
    xmedium: "16px",
    xxmedium: "20px",
    xxxmedium: "24px",
    large: "28px",
    xlarge: "32px",
    xxlarge: "48px"
  },
  palette: {
    interactiveBlue: "#086EA1",
    white: "#FFFFFF",
    background: {
      default: "#FFFFFF"
    },
    darkBlue: "#054C70",
    charcoal: "#3B4B59",
    paleBlue: "#CEE0E8",
    hoverBlue: "#043954",
    brightBlue: "#05C3DE",
    lightGray: "#EBEBEB ",
    cardFooterGray: "#F0F3F5",
    gray: "#C4C4C4",
    mediumGray: "#898989",
    darkGray: "#3B3B3B",
    successGreen: "#7D9845",
    warningOrange: "#E17A17",
    errorRed: "#D82C26",
    appBarGradient: "radial-gradient(farthest-corner at 20% -100%, #05C3DE -25%, #054C70 60%, #063046 105%)"
  },
  boxShadow: "0px 0px 8px rgba(59, 59, 59, 0.12), 0px 6px 4px rgba(59, 59, 59, 0.05), 0px 3px 3px rgba(59, 59, 59, 0.05)",
  boxShadowHover: "0px 2px 15px rgba(59, 59, 59, 0.1), 0px 10px 15px rgba(0, 0, 0, 0.12), 0px 4px 3px rgba(0, 0, 0, 0.04)",
  boxShadowError: " 0px 8px 8px rgba(45, 57, 64, 0.075), 0px 0px 4px rgba(45, 57, 64, 0.075)",
  boxShadowErrorHover: "0px 24px 24px rgba(45, 57, 64, 0.075), 0px 0px 12px rgba(45, 57, 64, 0.075)",
  colors: {
    darkBlue: "#054C70",
    paleBlue: "#CEE0E8",
    hoverBlue: "#043954",
    brightBlue: "#05C3DE",
    charcoal: "#3B4B59",
    lightGray: "#EBEBEB ",
    gray: "#C4C4C4",
    interactiveBlue: "#086EA1",
    mediumGray: "#898989",
    darkGray: "#3B3B3B",
    successGreen: "#7D9845",
    warningOrange: "#E17A17",
    white: "#FFFFFF",
    errorRed: "#D82C26"
  },
  typography: {
    fontFamily: ["Nimbus Sans Reg", "Nimbus Sans Light", "Nimbus Sans Bold"],
    caption: {
      letterSpacing: "0.03333em"
    },
    body1: {
      letterSpacing: "0.00938em"
    },
    h4: {
      letterSpacing: "0.00735em"
    },
    h1Font: "56px",
    h2Font: "48px",
    h3Font: "40px",
    h4Font: "32px",
    h5Font: "24px",
    h6Font: "20px",
    title: "40px",
    subtitle1: "16px",
    body2: "12px",
    p1Font: "16px",
    p2Font: "14px",
    h1FontMobile: "40px",
    h2FontMobile: "32px",
    h3FontMobile: "32px",
    h4FontMobile: "24px",
    h5FontMobile: "24px"
  },
  overrides: {
    MuiGrid: {
      root: {
        maxWidth: "1234px",
        margin: "0 auto"
      },
      item: {
        padding: "0 !important"
      }
    },
    MuiButton: {
      label: {
        whiteSpace: "nowrap"
      }
    },
    MuiCssBaseline: {
      "@global": {
        "@font-face": [
          {
            fontFamily: "Nimbus Sans Reg",
            src: `
                        url('../fonts/75144806-5cb9-4743-95cf-40b7f3df5dda.eot'),
                        url('../fonts/75144806-5cb9-4743-95cf-40b7f3df5dda.eot?#iefix') format('eot'),
                        url('../fonts/4e93482e-40f7-4349-a9c2-f8882f15a93b.woff') format('woff'),
                        url('../fonts/55bc1387-86c7-452b-ae79-2721ea3b0645.ttf') format('truetype'),
                        url('../fonts/b5edab57-23a8-4bc5-bab3-df39a838bd75.svg#b5edab57-23a8-4bc5-bab3-df39a838bd75') format('svg')
                        `
          },
          {
            fontFamily: "Nimbus Sans Bold",
            src: `
                        url('../fonts/9dca25dd-18d2-4ec8-a997-ef28c2f4f136.eot?#iefix'),
                        url('../fonts/9dca25dd-18d2-4ec8-a997-ef28c2f4f136.eot?#iefix?#iefix') format('eot'),
                        url('../fonts/ce398c7a-fb54-4409-89f7-241065e2af3d.woff') format('woff'),
                        url('../fonts/fd862b64-8bf7-47e5-81d6-ee4cc1ac851f.ttf') format('truetype'),
                        url('../fonts/75896f69-6e33-4f29-97b1-1a105d9d6396.svg#75896f69-6e33-4f29-97b1-1a105d9d6396') format('svg');
                        `
          },
          {
            fontFamily: "Nimbus Sans Light",
            src: `
                        url('../fonts/5838f40c-4590-4e32-b164-c2971fcef883.eot?#iefix'),
                        url('../fonts/5838f40c-4590-4e32-b164-c2971fcef883.eot?#iefix') format('eot'),
                        url('../fonts/0735b4aa-4513-4002-8c4d-1b5dd2f43b74.woff2') format('woff2'),
                        url('../fonts/5fe27aff-ba5a-4022-adaf-b8fa6f8642cb.woff') format('woff'),
                        url('../fonts/50c13c0a-595a-4cca-b4cc-2edcd6eb67aa.ttf') format('truetype')
                        `
          }
        ]
      }
    },
    "& .arrow-icon": {
      "&:hover": {
        backgroundColor: "initial",
        color: "initial",
        border: "none"
      }
    }
  }
}, j8 = {
  darkBlue: "#054C70",
  paleBlue: "#CEE0E8",
  hoverBlue: "#043954",
  brightBlue: "#05C3DE",
  lightGray: "#EBEBEB ",
  gray: "#C4C4C4",
  mediumGray: "#898989",
  darkGray: "#3B3B3B",
  successGreen: "#7D9845",
  warningOrange: "#E17A17",
  errorRed: "#D82C26",
  interactiveBlue: "#086EA1"
}, $8 = {
  xxsmall: "10px",
  xsmall: "12px",
  small: "14px",
  medium: "16px",
  xmedium: "18px",
  large: "20px",
  xlarge: "24px",
  xxlarge: "36px",
  xxxlarge: "48px",
  titleFont: "18px",
  labelSupFont: "100%",
  h1Font: "56px",
  h2Font: "48px",
  h3Font: "40px",
  h4Font: "32px",
  h5Font: "24px",
  h6Font: "20px",
  title: "40px",
  subtitle1: "16px",
  body1: "16px",
  body2: "12px",
  caption: "12px",
  p1Font: "16px",
  p2Font: "14px",
  h1FontMobile: "40px",
  h2FontMobile: "32px",
  h3FontMobile: "32px",
  h4FontMobile: "24px",
  h5FontMobile: "24px"
}, Q8 = fu(M8), uR = ({ children: n }) => /* @__PURE__ */ p.jsx(pr, { theme: { ...Q8, ...j8, ...$8 }, children: /* @__PURE__ */ p.jsx("div", { className: "mgpWrapper", children: n }) });
export {
  rR as AdviceFooter,
  Vu as AuthStatusContext,
  q8 as AuthStatusWrapper,
  W8 as BlueBanner,
  y8 as ButtonFPS,
  z8 as CardAction,
  Y8 as CardWithMedia,
  sR as EducationModal,
  uR as FPSThemeWrapper,
  G8 as Footer,
  Xb as Loading,
  cR as PaperlessModal,
  b8 as ProbabilityCharts,
  iR as ProbabilityChartsCard,
  W9 as Session,
  V9 as SessionContext,
  j9 as errorRedirect,
  $8 as fontVars,
  j8 as fpsColors,
  X9 as getCurrentStatus,
  Tg as request,
  lR as retrievePlan,
  M8 as theme
};
